(function () {
  'use strict';

  angular
    .module('app.core',
      [
        'ngAnimate',
        'ngAria',
        'ngCookies',
        'ngMessages',
        'ngResource',
        'ngSanitize',
        'ngMaterial',
        'pascalprecht.translate',
        'ui.router',
        'app.orHashen',
        'vcRecaptcha',
        'moment-picker',
        'ezplus',
        //'bootstrapLightbox',
        'imageViewer',
        'ngFileUpload'

      ]);
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('CopyInsuraceDialogController', CopyInsuraceDialogController);

  /** @ngInject */
  function CopyInsuraceDialogController($mdDialog, Copy, ListCopys, msUtils, $filter) {
    var vm = this;

    vm.title = 'EDIT_CONTACT';


    vm.newContact = false;
    vm.allFields = false;
    vm.copy = Copy;
    vm.ListCopys = ListCopys;
    vm.default_avatar = 'assets/images/avatars/profile.jpg';


    // Methods


    //////////


    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }

    function submit() {
      vm.copy.active = true;

      var item = $filter('filter')(ListCopys, {PhotoListID: vm.copy.CopyID}, true)[0];

      vm.copy.Name = item.Name;
      $mdDialog.hide(vm.copy);
    }

    function sumupdate(afterTax) {
      if (afterTax) {
        if (!vm.copy.sumInclude) {
          vm.copy.sum = 0;
          return;
        }
        var TAX = msUtils.TAX;
        vm.copy.sum= ((vm.copy.sumInclude  * 100)/(100+TAX)).toFixed(2);
      } else {
        if (!vm.copy.sum) {
          vm.copy.sumInclude = 0;
          return;
        }
        var TAX = msUtils.TAX / 100 + 1;
        vm.copy.sumInclude = (vm.copy.sum * TAX).toFixed(2);
      }
    }

    vm.closeDialog = closeDialog;
    vm.submit = submit;
    vm.sumupdate = sumupdate;

  }
})();

(function () {
  'use strict';

  /**
   * Main module of the Fuse
   */
  angular
    .module('fuse', [

      // Core
      'app.core',

      // Navigation
      'app.navigation',

      // Toolbar
      'app.toolbar',

      // Quick panel
      'app.quick-panel',

      // Sample
      'app.sample',
      'app.contacts',
      'app.newclient',
      'app.profile',
      'app.support',
      'app.docs',
      'app.pages',
      'app.reports',
      'app.invoice',
      'app.notes',
      'app.shipping',
      'app.bid',
      //'app.insurance',
      'app.employee_report',
      'app.calendar',
      'app.insurance_report',
      'app.reports_view',
      'app.reports_multy_view',
      'app.reffering_list',
      'app.referring',
      'app.inventories'
    ]);
})();

/**
 * Created by itzik on 23/11/2017.
 */

(function () {
  'use strict';

  angular
    .module('fuse')
    .controller('UploadController', UploadController);

  /** @ngInject */
  function UploadController($mdDialog, orContacts, Profile, Upload, $timeout, $filter, orUserAccount) {
    var vm = this;
    vm.profile = Profile;
    vm.photoID = 0;
    vm.validate = function (file) {
      vm.error_image = false;
      console.log(file);
      var stringOk = Profile.ClientName.split(" ");
      stringOk.push(Profile.TZ);
      for (var i = 0; i < stringOk.length; i++) {
        if (file.name.indexOf(stringOk[i]) != -1) {
          return true;
        }
      }
      vm.error_image = true;
      return false;

    }
    vm.upload = function (file) {
      if (!file.length)
        return;
      vm.uploadProccess = 'טוען';
      var filename = '';
      if (vm.photoID > 0) {
        filename = $filter('filter')(vm.profile.PhotosArr, {PhotoID: vm.photoID}, true)[0];
        if (filename)
          filename = filename.Name;
      } else if (vm.photoID == -1) {
        filename = 'הפניה'
      }
      else if (vm.photoID == -2) {
        filename = 'אחר'
      }
      console.log("file", file);

      Upload.upload({
        url: orUserAccount.API_UPLOAD() + 'upload/' + Profile.ClientID + '?photo_id=' + vm.photoID + '&filename=' + filename,
        // url: 'http://localhost:4900/documents/upload/' + Profile.ClientID + '?photo_id=' + vm.photoID + '&filename=' + filename,
        data: {
          file: file,
          'username': '$scope.username',
          filename: filename
        }
      }).then(function (resp) {
        //console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
        vm.uploadProccess = 'טעינת קובץ הושלמה. אנא המתן...';
        clearProccessUpload();
        /*$timeout(function () {
         vm.uploadProccess = 'מעדכן נתונים...';
         clearProccessUpload();
         }, 1200)*/
        $timeout(function () {

          vm.uploadProccess = 'מעדכן נתונים...';
          reloadDocuments(vm.profile.Documents.length);
        }, 5000)

      }, function (resp) {
        //console.log('Error status: ' + resp.status);
        vm.uploadProccess = 'ארעה שגיאה בטעינת קובץ';
        clearProccessUpload();
      }, function (evt) {
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
        console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
        vm.uploadProccess = 'מעלה ' + progressPercentage + '% ';
      });
    };

    var clearProccessUpload = function () {
      $timeout(function () {
        vm.uploadProccess = undefined;
      }, 3000)
    }
    var reloadDocuments = function (lastLength) {
      console.log('reloadDocuments');
      console.log(lastLength);
      orContacts.LoadDocuments(Profile).then(function (r) {
        // if (lastLength == vm.profile.Documents.length) {
        //   $timeout(function () {
        //     vm.uploadProccess = 'מעדכן נתונים...';
        //     reloadDocuments(vm.profile.Documents.length)
        //   });
        // } else {
        vm.uploadProccess = 'הושלם!';
        clearProccessUpload()
        $timeout(function () {
          $mdDialog.hide(true);
        }, 3000)
        // }

      });

    }

    vm.close = function () {
      $mdDialog.hide(vm.date)
    }
    vm.print = function () {
      window.print();
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.profile', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    $stateProvider.state('app.profile', {
      url: '/profile/:id',
      views: {
        'content@app': {
          templateUrl: 'app/main/profile/profile.html',
          controller: 'ProfileController as vm'
        }
      },
      resolve: {
        Profile: function ($stateParams, orContacts) {
         return orContacts.Profile($stateParams.id);
        },
        Timeline: function ($stateParams, msApi) {
          return msApi.resolve('profile.timeline@get');
        },
        About: function (msApi) {
          return msApi.resolve('profile.about@get');
        },
        PhotosVideos: function (msApi) {
          return msApi.resolve('profile.photosVideos@get');
        }
      },
      bodyClass: 'profile'
    }).state('app.profile.allowedit', {
      url: '/:allowedit'
    })
    ;


    // Translation
    $translatePartialLoaderProvider.addPart('app/main/profile');

    // Api
    msApiProvider.register('profile.timeline', ['app/data/profile/timeline.json']);
    msApiProvider.register('profile.about', ['app/data/profile/about.json']);
    msApiProvider.register('profile.photosVideos', ['app/data/profile/photos-videos.json']);

    // Navigation
    msNavigationServiceProvider.saveItem('fuse.profile', {
      title: 'כרטיס לקוח',
      icon: 'icon-account-box',
      state: 'app.profile',
      weight: 6
    });
  }

})();

/**
 * Created by itzik on 23/11/2017.
 */

(function () {
  'use strict';

  angular
    .module('app.profile')
    .controller('SippingDetailsController', SippingDetailsController)
    .controller('MultySippingDetailsController', MultySippingDetailsController);

  /** @ngInject */
  function SippingDetailsController($mdDialog, client, Place, Doctor) {
    var vm = this;
    vm.client = client;
    vm.place = Place;
    if (typeof Doctor === "function")
      Doctor().then(function (result) {
        vm.doctor = result
      });
    else
      vm.doctor = Doctor
    console.log('Doctor')
    console.log(Doctor)
    vm.dateNow = new Date();
    vm.close = function () {
      $mdDialog.hide(vm.date)
    }
    vm.print = function () {
      window.print();
    }

  }

  /** @ngInject */
  function MultySippingDetailsController($mdDialog, orContacts, Place, ship_id) {

    var vm = this;
    vm.multy = true;
    orContacts.ShippingCertificate(ship_id).then(function (result) {
      vm.endLoader = true;
      vm.data = result.data;
    })
    vm.place = Place;
    vm.dateNow = new Date();
    vm.close = function () {
      $mdDialog.hide(vm.date)
    }
    vm.print = function () {
      PrintElem("invoice");
    }
    function PrintElem(elem) {
      var mywindow = window.open('', 'PRINT', 'height=400,width=600');

      mywindow.document.write('<html><head><title>' + document.title + '</title><style  rel="stylwsheet">.text-right{text-align: right;} img{width:180px} button{display: none}.pagebreak { page-break-before: always; }</style> ');
      mywindow.document.write('</head><body >');
      //mywindow.document.write('<h1>' + document.title  + '</h1>');
      mywindow.document.write(document.getElementById(elem).innerHTML);
      mywindow.document.write('</body></html>');

      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/

      setTimeout(function () {
        mywindow.print();
        mywindow.close();
      }, 1000);


      return true;
    }
  }
})();

/**
 * Created by itzik on 12/12/2017.
 */
(function () {
  'use strict';

  angular
    .module('app.profile')
    .controller('EditCopiesController', EditCopiesController);

  /** @ngInject */
  function EditCopiesController(Doctor, Copies, $mdDialog) {
    var vm = this;
    vm.copies = Copies;
    var OldCopies = [];
    vm.countCopies = {count: 0, sum: 0}
    angular.copy(Copies, OldCopies);
    // if (typeof Doctor === "function")
    //   Doctor().then(function (result) {
    //     vm.doctor = result
    //   });
    // else
    vm.doctor = Doctor;

    var updateDoctorPrices = function () {

      $mdDialog.hide({copies: vm.copies, doctor: vm.doctor,countCopies:vm.countCopies});
    }
    var close = function () {

      vm.copies.splice(0, vm.copies.length);
      for (var ind in OldCopies) {
        vm.copies.push(OldCopies[ind]);
      }

      $mdDialog.hide();
    }
    vm.updateDoctorPrices = updateDoctorPrices;
    vm.close = close;

  }
})();

/**
 * Created by itzik on 14/01/2018.
 */


(function () {
  'use strict';

  angular
    .module('fuse')
    .controller('ShowDocumentController', ShowDocumentController);

  /** @ngInject */
  function ShowDocumentController($mdDialog, $sce,orContacts, Doc) {
    var vm = this;
    vm.doc = Doc;

    vm.close = function () {
      $mdDialog.hide()
    }
    // orContacts.DownloadDocument(Doc.docName).then(function (result) {
    //
    //   vm.filesrc=result;
    // })
   vm.filesrc = $sce.trustAsResourceUrl(orContacts.LinkUrlDownloadDocument(Doc.docName));

    vm.print = function () {
      window.print();
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.profile')
    .controller('CreditDialogController', CreditDialogController);

  /** @ngInject */
  function CreditDialogController($mdDialog, $rootScope, $timeout, max, lastcach, Client, IsRefund, orContacts, Place) {
    var vm = this;
    vm.cardauto = '';
    console.log('Place', Place)
    focusAutoCard();
    /**
     * Close dialog
     */
    vm.closeDialog = closeDialog;
    vm.cancel = cancel;
    vm.updateAmount = updateAmount;
    vm.manualPay = manualPay;
    //vm.pelecardCheckPay = pelecardCheckPay;
    vm.pelecardCheckPayAndClose = function () {
      pelecardCheckPay(true);
    };
    if (!IsRefund)
      pelecardCheckPay();
    vm.IsRefund = IsRefund;
    vm.sumByCredit = lastcach || max;
    var mainMsg = 'לחץ להפעלת המסוף';

    vm.cardLeft = cardLeft;
    // vm.strstatus = 'העבר כרטיס אשראי';
    vm.strstatus = mainMsg;
    vm.paymentsNumber = 1;
    vm.statusOK = false;
    var today = new Date();
    vm.year = today.getFullYear();
    vm.card = {expired: {month: 1, year: vm.year}, number: ''};
    vm.manual = true;
    if (Place.shopNumber) {
      vm.manual = false;
      vm.smartActive = true;
    } else {
      vm.strstatus = 'לא קיים מסוף חכם לסניף זה';
      vm.smartActive = false;
      vm.manual = true;
    }
//TEMP:
//     vm.card.number = 455744041004812;
//     vm.card.expired.month = 5;
//     vm.card.expired.year = 2019;
    function updateAmount(ev) {
      vm.sumByCredit = parseInt(vm.sumByCredit);
      if (isNaN(vm.sumByCredit) || vm.sumByCredit > max) {
        $mdDialog.show(
          $mdDialog.alert()
            .clickOutsideToClose(true)
            .title('שגיאה')
            .textContent('מחיר לא תקין! - סכום מקסימלי ' + max)
            .ariaLabel('Alert Dialog Demo')
            .ok('סגור')
            .targetEvent(ev)
        );
      } else {


        vm.editamount = false;
        focusAutoCard();
      }
    }

    function cancel() {
      $mdDialog.hide();
      //$state.go('app.contacts')

    }

    function smartPay(event) {
      vm.strstatus = 'הצמד או העבר כרטיס במסוף';
      vm.smartActive = false;


      orContacts.pelecardPay(Client, {
        auto: true,
        shopNumber: Place.shopNumber,
        amount: vm.sumByCredit,
        paymentsNumber: vm.paymentsNumber
      }).then(function (result) {
        console.log('result-success', result)
        if (result.pelecard) {

          vm.strstatus = result.pelecard.ErrorMessage + ' (' + result.pelecard.StatusCode + ')';
          pelecardDetails = result.pelecard;
          vm.smartActive = true;

          if (result.status) {
            gtag('event', 'card result: ' + result.pelecard.StatusCode, {
              'event_category': 'pelecard',
              'event_label': Client.ClientID
            });
            vm.statusOK = result.pelecard.StatusCode == '000';//true;
            if (vm.statusOK) {
              vm.strstatus = 'אושר! אנא המתן...';
              vm.smartActive = true;
              $timeout(closeDialog, 1000);
            } else {
              pelecardIsWorking = false;
            }
            // $mdDialog.hide(result.pelecard);
          }
        }else{
          vm.strstatus = 'ארעה שגיאה.. נסה שנית';
          vm.smartActive = true;
          pelecardIsWorking = false;
          //pelecardCheckPay();
          $rootScope.$$phase || $rootScope.$apply();
        }
      }, function (err) {
        console.log('errrrr', err)
        vm.strstatus = 'ארעה שגיאה.. נסה שנית';
        vm.smartActive = true;
        pelecardIsWorking = false;
        pelecardCheckPay();
        $rootScope.$$phase || $rootScope.$apply();
      })

    }

    vm.smartPay = smartPay;
    function focusAutoCard() {
      setTimeout(function () {
        $("#cardAuto").focus();
      }, 1000);
    }

    var intervalCheck;

    function cardLeft() {
      if (intervalCheck)
        clearTimeout(intervalCheck);
      intervalCheck = setTimeout(autoPay, 500);
    }

    var pelecardDetails;
    var pelecardIsWorking = false;

    function autoPay() {
      if (pelecardIsWorking) {
        gtag('event', 'passed again', {
          'event_category': 'pelecard',
          'event_label': Client.ClientID
        });
        return;
      }
      if (IsRefund) {
        vm.sumByCredit *= -1;
        if (vm.sumByCredit > 0) {
          alert("err");
          return;
        }
      }
      console.log(vm.cardauto)
      console.log('------')
      vm.strstatus = 'בודק'
      if (vm.cardauto && vm.cardauto.length > 4) {
        pelecardIsWorking = true;

        gtag('event', 'card passed', {
          'event_category': 'pelecard',
          'event_label': Client.ClientID
        });
        orContacts.pelecardPay(Client, {
          auto: true,
          value: vm.cardauto,
          amount: vm.sumByCredit,
          paymentsNumber: vm.paymentsNumber
        }).then(function (result) {
          vm.strstatus = result.pelecard.ErrorMessage + ' (' + result.pelecard.StatusCode + ')';
          pelecardDetails = result.pelecard;
          vm.cardauto = '';

          if (result.status) {
            gtag('event', 'card result: ' + result.pelecard.StatusCode, {
              'event_category': 'pelecard',
              'event_label': Client.ClientID
            });
            vm.statusOK = result.pelecard.StatusCode == '000';//true;
            if (vm.statusOK) {
              vm.strstatus = 'אושר! אנא המתן...';
              $timeout(closeDialog, 1000);
            } else {
              pelecardIsWorking = false;
            }
            // $mdDialog.hide(result.pelecard);
          }
        }, function (err) {
          vm.strstatus = 'ארעה שגיאה.. נסה שנית';
          vm.cardauto = '';
          pelecardIsWorking = false;
          pelecardCheckPay();
          $rootScope.$$phase || $rootScope.$apply();
        })
      }
      else {
        vm.strstatus = 'לא תקין - העבר שנית';
        vm.cardauto = '';
        $rootScope.$$phase || $rootScope.$apply();
      }
    }

    function manualPay() {
      if (IsRefund) {
        vm.sumByCredit *= -1;
        if (vm.sumByCredit > 0) {
          alert("err");
          return;
        }
      }
      vm.proccessManual = true;
      orContacts.pelecardPay(Client, {
        auto: false,
        value: vm.card,
        amount: vm.sumByCredit,
        paymentsNumber: vm.paymentsNumber
      }).then(function (result) {
        vm.proccessManual = false;
        vm.strstatus = result.pelecard.ErrorMessage + ' (' + result.pelecard.StatusCode + ')';
        pelecardDetails = result.pelecard;
        vm.cardauto = '';

        if (result.status) {
          vm.statusOK = result.pelecard.StatusCode == '000';//true;
          if (vm.statusOK) {
            vm.strstatus = 'אושר! אנא המתן...';
            $timeout(closeDialog, 1000);
          }
          // $mdDialog.hide(result.pelecard);
        }
      })
    }

    function pelecardCheckPay(autoClose) {
      if (vm.strstatus == 'בודק') {
        return;
      }
      console.log('------')
      vm.strstatus = 'בודק'
      orContacts.pelecardCheckPay(Client).then(function (result) {
        vm.statusOK = result.pelecard.StatusCode === '000';
        pelecardDetails = result.pelecard;
        if (vm.statusOK) {
          var sumPaid = parseFloat((pelecardDetails.ResultData.DebitTotal / 100).toFixed(2));

          if (autoClose && sumPaid == vm.sumByCredit) {
            vm.strstatus = 'חיוב אושר! אנא המתן...';
            $timeout(closeDialog, 1000);
          } else {
            vm.strstatus = 'חיוב אשראי בוצע כבר בסך ' + (pelecardDetails.ResultData.DebitTotal / 100).toFixed(2) + ' ש"ח ';
            vm.allowReset = true;
            vm.statusOK = false;
          }

        } else if (result.pelecard.StatusCode === '510') {
          vm.strstatus = 'לא נמצאו חיובים ללקוח';
          if (!autoClose)
            vm.strstatus = mainMsg;//'העבר כרטיס אשראי';
        } else {
          vm.strstatus = result.pelecard.ErrorMessage + ' (' + result.pelecard.StatusCode + ')';
        }
      })
    }

    vm.reset = function () {
      pelecardDetails = undefined;
      vm.strstatus = mainMsg;
      if (!Place.shopNumber) {
        vm.strstatus = 'לא קיים מסוף חכם לסניף זה';
      }
      vm.allowReset = false;
      vm.statusOK = false;

    }
    vm.continueAndClose = function () {
      //alert("להפקת חשבונית על עסקה קיימת  - אנא פנה לתמיכה!");
      //pelecardDetails = undefined;
      closeDialog();
    }
    function closeDialog() {

      if (pelecardDetails)
        $mdDialog.hide(pelecardDetails);

    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.profile')
    .controller('ChecksDialogController', ChecksDialogController);

  /** @ngInject */
  function ChecksDialogController($mdDialog, max, checksArr) {
    var vm = this;


    /**
     * Close dialog
     */
    vm.closeDialog = closeDialog;
    vm.cancel = cancel;
    vm.checksArr = checksArr;
    vm.addCheck = function () {
      if (vm.checksArr.length < 4) {
        var Ac = vm.checksArr[vm.checksArr.length - 1];
        var d = new Date(Ac.date);
        d.setMonth(parseInt(d.getMonth()) + 1)
        var newCheck = {
          date: d,
          bank: Ac.bank,
          branch: Ac.branch,
          account: Ac.account,
          number: parseInt(Ac.number) + 1,
          amount: Ac.amount
        }
        vm.checksArr.push(newCheck);
      }

    }
    vm.removeCheck = function (check, index) {
      vm.checksArr.splice(index, 1);
      var sum = 0;
      vm.checksArr.forEach(function (element) {
        if (element.amount)
          sum += parseFloat(element.amount);
      });

    }
    function closeDialog() {
      var sum = 0;
      vm.checksArr.forEach(function (element) {
        if (element.amount)
          sum += parseFloat(element.amount);
      });

      if (!vm.checksArr.length)
        alert('לא הוזנו שיקים')
      else if (parseFloat(sum) <= 0)
        alert('לא הזון סכום');
      else if (parseFloat(sum) > max)
        alert('סכום לתשלום: ' + max);
      else {
        $mdDialog.hide(vm.checksArr);
      }
    }

    function cancel() {
      $mdDialog.hide();
      //$state.go('app.contacts')

    }


  }
})();

/**
 * Created by itzik on 23/11/2017.
 */

(function () {
  'use strict';

  angular
    .module('fuse')
    .controller('ClientDetailsController', ClientDetailsController);

  /** @ngInject */
  function ClientDetailsController($mdDialog, client, Place,orContacts) {
    var vm = this;
    vm.client = client;
    vm.place = Place;
    // Doctor().then(function (result) {
    //   vm.doctor=result
    // });
    if (!client.PhotosArr) {
      orContacts.LoadPhotos(client);
    }
    vm.dateNow = new Date();
    if (client.ClientBirthDate && typeof client.ClientBirthDate === 'string')
      client.ClientBirthDate = new Date(client.ClientBirthDate);
    vm.close = function () {
      $mdDialog.hide(vm.date)
    }
    vm.print = function () {
      window.print();
    }

  }
})();

/**
 * Created by itzik on 23/11/2017.
 */

(function () {
  'use strict';

  angular
    .module('fuse')
    .controller('AcceptVisitController', AcceptVisitController);

  /** @ngInject */
  function AcceptVisitController($mdDialog, client, Place) {
    var vm = this;
    vm.client = client;
    vm.place = Place;
    vm.dateNow = new Date();
    vm.close = function () {
      $mdDialog.hide(vm.date)
    }
    vm.print=function () {
      window.print();
    }

  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.error-500', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-500', {
            url      : '/pages/errors/error-500',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-500': {
                    templateUrl: 'app/main/pages/errors/500/error-500.html',
                    controller : 'Error500Controller as vm'
                }
            },
            bodyClass: 'error-500'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/errors/500');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.errors.error-500', {
            title : '500',
            state : 'app.pages_errors_error-500',
            weight: 2
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-500')
        .controller('Error500Controller', Error500Controller);

    /** @ngInject */
    function Error500Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-404', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-404', {
            url      : '/pages/errors/error-404',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-404': {
                    templateUrl: 'app/main/pages/errors/404/error-404.html',
                    controller : 'Error404Controller as vm'
                }
            },
            bodyClass: 'error-404'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/errors/404');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.errors', {
            title : 'Errors',
            icon  : 'icon-alert',
            weight: 3
        });

        msNavigationServiceProvider.saveItem('pages.errors.error-404', {
            title : '404',
            state : 'app.pages_errors_error-404',
            weight: 1
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-404')
        .controller('Error404Controller', Error404Controller);

    /** @ngInject */
    function Error404Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function () {
  'use strict';

  angular
    .module('app.pages.auth.login-v2', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider) {
    // State
    $stateProvider.state('app.pages_auth_login-v2', {
      url: '/pages/auth/login-v2',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.pages_auth_login-v2': {
          templateUrl: 'app/main/pages/auth/login-v2/login-v2.html',
          controller: 'LoginV2Controller as vm'
        }
      },
      bodyClass: 'login-v2'
    }).state('app.pages_auth_login-v2.logout', {
      url: '/:logout'
    }).state('app.pages_auth_login-v2.itzik', {
      url: '/code/:code', resolve: {
        Code: function ($cookies, $stateParams) {
          $cookies.put('placeorlogin', $stateParams.code);
        }
      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/pages/auth/login-v2');
    // Navigation
    // msNavigationServiceProvider.saveItem('pages.auth.login-v2', {
    //     title : 'Login v2',
    //     state : 'app.pages_auth_login-v2',
    //     weight: 2
    // });
  }

})();

(function () {
  'use strict';

  angular
    .module('app.pages.auth.login-v2')
    .controller('LoginV2Controller', LoginV2Controller);

  /** @ngInject */
  function LoginV2Controller($state, $rootScope, $timeout, $cookies, orUserAccount, orContacts) {
    // Data
    var vm = this;
    vm.proccess=false;
    vm.form = {};

    var placeor = $cookies.get('placeorlogin');

    if(!placeor||placeor!='or147852369or')
      $state.go('app.pages_auth_lock');

    // Methods
    if ($state.params.logout) {
      // alert('Log out');
      orUserAccount.LogOut();
      orContacts.clearContacts();
    }

    vm.login = function () {
      vm.proccess=true;
      console.log(vm.form);
      vm.error = '';
      // $state.go('app.contacts', {});
      orUserAccount.Login(vm.form).then(function (result) {
        console.log(result);
        // window.href = 'contacts';
        $state.go('app.contacts', {}, {reload: true});
        // $state.go('app.notes', {}, { reload: true });

        // $location.url('contacts');
        // $rootScope.$$phase || $rootScope.$apply();
        $timeout(function () {
          // $state.reload();
          //  console.log('reload')
          //  $state.go('app.contacts', {}, { reload: true });
        }, 1500)


      }, function (err) {
        vm.error = err.err.code == 401 ? 'הזיהוי נכשל' : err.err;
        vm.proccess=false;
        setTimeout(function () {
          grecaptcha.reset();
        }, 1)
      });

    }
    //////////
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_login', {
            url      : '/pages/auth/login',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_login': {
                    templateUrl: 'app/main/pages/auth/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/login');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth', {
            title : 'Authentication',
            icon  : 'icon-lock',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('pages.auth.login', {
            title : 'Login',
            state : 'app.pages_auth_login',
            weight: 1
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.lock', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_lock', {
            url      : '/pages/auth/lock',
            views    : {
                'main@'                      : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_lock': {
                    templateUrl: 'app/main/pages/auth/lock/lock.html',
                    controller : 'LockController as vm'
                }
            },
            bodyClass: 'lock'
        });
/*
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/lock');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.lock', {
            title : 'Lock Screen',
            state : 'app.pages_auth_lock',
            weight: 7
        });*/
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.lock')
        .controller('LockController', LockController);

    /** @ngInject */
    function LockController()
    {
        var vm = this;

        // Data
        vm.form = {
            username: 'Jane Doe'
        };

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.notes', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        $stateProvider.state('app.notes', {
            url    : '/notes',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/notes/notes.html',
                    controller : 'NotesController as vm'
                }
            },
            resolve: {
                Notes : function (NotesService)
                {
                    return NotesService.getData();
                },
                Labels: function (LabelsService)
                {
                    return LabelsService.getData();
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/notes');

        // Api
        msApiProvider.register('notes.notes', ['app/data/notes/notes.json']);
        msApiProvider.register('notes.labels', ['app/data/notes/labels.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('fuse.notes', {
            title : 'לוח הערות',
            icon  : 'icon-lightbulb',
            state : 'app.notes',
            weight: 11
        });

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.notes')
        .controller('msNoteItemController', msNoteItemController)
        .directive('msNoteItem', msNoteItemDirective);

    /** @ngInject */
    function msNoteItemController($document)
    {
        var vm = this;
        var fontSizes = {
            '1': {
                fontSize  : 14,
                lineHeight: 19
            },
            '2': {
                fontSize  : 18,
                lineHeight: 28
            },
            '3': {
                fontSize  : 24,
                lineHeight: 36
            },
            '4': {
                fontSize  : 36,
                lineHeight: 48
            },
            '5': {
                fontSize  : 48,
                lineHeight: 60
            }
        };

        vm.element = [];
        vm.noFontResize = false;

        // Methods
        vm.updateDescriptionFontSize = updateDescriptionFontSize;

        //////

        function updateDescriptionFontSize()
        {
            if ( vm.noFontResize || !vm.note.description || vm.note.description === '' )
            {
                return;
            }

            var fontSize = '';
            var descWidth = Math.floor(vm.columnWidth - 52); // 48px paddings, + 4px tolerance
            var tmp = angular.element('<div style="visibility:hidden; font-size:10px;line-height: 10px;position:absolute;z-index:-1;white-space:pre-wrap;word-wrap: break-word;"></div>');
            tmp.appendTo($document.find('body'));

            fontSize = checkLineCount(sizeFromMaxWordCount());

            angular.element(vm.element).find('md-description').attr('font-size', fontSize);

            tmp.remove();

            function sizeFromMaxWordCount()
            {
                var words = vm.note.description.split(' ');

                var wordLengths = words.map(function (word)
                {
                    return tmp.text(word)[0].clientWidth;
                });

                var maxWordLength = Math.max.apply(Math, wordLengths);

                var maxPx = Math.floor((descWidth * 10) / maxWordLength);

                if ( maxPx < 18 )
                {
                    fontSize = 1;
                }
                else if ( 18 <= maxPx && maxPx < 24 )
                {
                    fontSize = 2;
                }
                else if ( 24 <= maxPx && maxPx < 36 )
                {
                    fontSize = 3;
                }
                else if ( 36 <= maxPx && maxPx < 48 )
                {
                    fontSize = 4;

                }
                else if ( maxPx >= 48 )
                {
                    fontSize = 5;
                }
                return fontSize;
            }

            function checkLineCount(sizeFromMaxWord)
            {
                var size = fontSizes[sizeFromMaxWord];
                var result;

                tmp.text(vm.note.description);
                tmp.width(descWidth);
                tmp.css({
                    'line-height': size.lineHeight + 'px',
                    'font-size'  : size.fontSize + 'px'
                });

                var lineCount = tmp[0].clientHeight / size.lineHeight;

                if ( 4 < lineCount && lineCount < 6 )
                {
                    result = 4;
                }
                else if ( 6 <= lineCount && lineCount < 9 )
                {
                    result = 3;
                }
                else if ( 9 <= lineCount && lineCount < 11 )
                {
                    result = 2;
                }
                else if ( 11 <= lineCount )
                {
                    result = 1;
                }
                else
                {
                    result = sizeFromMaxWord;
                }
                return result;
            }
        }
    }

    /** @ngInject */
    function msNoteItemDirective()
    {
        return {
            restrict        : 'A',
            controller      : 'msNoteItemController as MsNoteItem',
            templateUrl     : 'app/main/notes/directives/ms-note-item/ms-note-item.html',
            require         : ['msNoteItem', '^msMasonry'],
            bindToController: {
                msNoteItem: '='
            },
            link            : function (scope, element, attributes, controllers)
            {

                var MsNoteItem = controllers[0];
                var msMasonry = controllers[1];

                MsNoteItem.element = element;
                MsNoteItem.note = MsNoteItem.msNoteItem;


                if ( angular.isDefined(attributes.noFontResize) )
                {
                    MsNoteItem.noFontResize = true;
                }

                scope.$watch('MsNoteItem.msNoteItem', function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        MsNoteItem.note = newVal;
                    }
                });

                scope.$on('msMasonryItem:startReLayout', function ()
                {
                    if ( MsNoteItem.noFontResize || MsNoteItem.columnWidth === msMasonry.columnWidth )
                    {
                        return;
                    }

                    MsNoteItem.columnWidth = msMasonry.columnWidth;

                    MsNoteItem.updateDescriptionFontSize();
                });
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.notes')
        .controller('msNoteFormController', msNoteFormController)
        .directive('msNoteForm', msNoteFormDirective);

    /** @ngInject */
    function msNoteFormController($scope, NotesService, msUtils, $mdDialog, $timeout, LabelsService)
    {
        var MsNoteForm = this;
        var notes = NotesService.data;

        //Data
        MsNoteForm.type = '';
        MsNoteForm.defaultNote = {
            'id'         : '',
            'title'      : '',
            'description': '',
            'archive'    : false,
            'image'      : '',
            'color'      : '',
            'time'       : new Date().toISOString(),
            'reminder'   : null,
            'checklist'  : [],
            'labels'     : []
        };
        MsNoteForm.noteId = '';
        MsNoteForm.editNode = {};
        MsNoteForm.newCheckListItem = '';
        MsNoteForm.checkListForm = false;
        MsNoteForm.labels = LabelsService.data;

        MsNoteForm.ngFlowOptions = {
            singleFile: true
            // You can configure the ngFlow from here
            /*target                   : 'api/media/image',
             chunkSize                : 15 * 1024 * 1024,
             maxChunkRetries          : 1,
             simultaneousUploads      : 1,
             testChunks               : false,
             progressCallbacksInterval: 1000*/
        };
        MsNoteForm.ngFlow = {
            // ng-flow will be injected into here through its directive
            flow: {}
        };

        //Methods
        MsNoteForm.init = init;
        MsNoteForm.submit = submit;
        MsNoteForm.isNotValid = isNotValid;
        MsNoteForm.deleteNote = deleteNote;
        MsNoteForm.deleteImage = deleteImage;
        MsNoteForm.addChecklistItem = addChecklistItem;
        MsNoteForm.checklistFormToggle = checklistFormToggle;
        MsNoteForm.deleteCheckItem = deleteCheckItem;
        MsNoteForm.toggleArchive = toggleArchive;
        MsNoteForm.toggleInArray = msUtils.toggleInArray;
        MsNoteForm.exists = msUtils.exists;
        MsNoteForm.upload = upload;
        MsNoteForm.imageSuccess = imageSuccess;

        //////

        /**
         * Initialize
         */
        function init()
        {
            // If form type edit
            if ( MsNoteForm.type === 'edit' )
            {
                MsNoteForm.editNode = notes.getById(MsNoteForm.noteId);
                MsNoteForm.note = angular.copy(MsNoteForm.editNode);
            }
            // If form type new
            else
            {
                resetForm();
            }
        }

        /**
         * Watch New Note Form, reset form if it is closed
         */
        $scope.$on('MsNewNote:closed', function ()
        {
            resetForm();
        });

        /**
         * Reset Form
         */
        function resetForm()
        {
            $scope.$evalAsync(function ()
            {
                MsNoteForm.note = angular.copy(MsNoteForm.defaultNote);
                MsNoteForm.checkListForm = false;
            });
        }

        /**
         * Submit Form
         */
        function submit()
        {
            if ( MsNoteForm.type === 'new' )
            {
                add();
            }
            else if ( MsNoteForm.type === 'edit' )
            {
                save();
            }
        }

        /**
         * Add new note
         */
        function add()
        {
            if ( isNotValid() )
            {
                return;
            }

            MsNoteForm.note.id = msUtils.guidGenerator();
            MsNoteForm.note.time = new Date().toISOString();

            NotesService.addNote(angular.copy(MsNoteForm.note));

            MsNoteForm.note = angular.copy(MsNoteForm.defaultNote);

            $scope.$emit('MsNewNote:close');
        }

        /**
         * Save Note
         */
        function save()
        {
            if ( isNotValid() )
            {
                return;
            }
            NotesService.updateNote(MsNoteForm.note);
            $mdDialog.hide();
        }

        /**
         * Delete Note Image
         */
        function deleteImage()
        {
            MsNoteForm.note.image = '';
        }

        /**
         * Toggle Archive State
         */
        function toggleArchive()
        {
            if ( MsNoteForm.type === 'new' )
            {
                MsNoteForm.note.archive = true;
                submit();
            }
            else if ( MsNoteForm.type === 'edit' )
            {
                MsNoteForm.note.archive = !MsNoteForm.note.archive;
                save();
            }
        }

        /**
         * One of the image, title, description, checklist inputs are should be exist.
         * @returns {boolean}
         */
        function isNotValid()
        {
            return MsNoteForm.note.image === '' && MsNoteForm.note.title === '' && MsNoteForm.note.description === '' && MsNoteForm.note.checklist.length === 0;
        }

        /**
         * Delete Note
         * @param ev
         */
        function deleteNote(ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the note?')
                .htmlContent('the note will be deleted permanently.')
                .ariaLabel('delete note')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {
                NotesService.deleteNote(MsNoteForm.note);
            });
        }

        /**
         * Add Checklist Item
         */
        function addChecklistItem()
        {
            if ( MsNoteForm.newCheckListItem === '' )
            {
                return;
            }

            MsNoteForm.note.checklist.push({
                checked: false,
                text   : MsNoteForm.newCheckListItem
            });

            MsNoteForm.newCheckListItem = '';

            focusChecklistInput();
        }

        /**
         * Checklist form toggle
         */
        function checklistFormToggle()
        {
            $scope.$evalAsync(function ()
            {
                MsNoteForm.checkListForm = !MsNoteForm.checkListForm;

                $timeout(function ()
                {
                    focusChecklistInput();
                });
            });
        }

        /**
         * Delete check item
         * @param item
         */
        function deleteCheckItem(item)
        {
            MsNoteForm.note.checklist.splice(MsNoteForm.note.checklist.indexOf(item), 1);
            focusChecklistInput();
        }

        /**
         * Focus checklist input
         */
        function focusChecklistInput()
        {
            angular.element('#new-checklist-item-input').focus();
        }

        /**
         * Upload
         */
        function upload()
        {
            // Set headers
            MsNoteForm.ngFlow.flow.opts.headers = {
                'X-Requested-With': 'XMLHttpRequest',
                //'X-XSRF-TOKEN'    : $cookies.get('XSRF-TOKEN')
            };

            MsNoteForm.ngFlow.flow.upload();
        }

        /**
         * Image Success
         * @param file
         * @param message
         */
        function imageSuccess(file, message)
        {
            var fileReader = new FileReader();

            fileReader.readAsDataURL(file.file);

            fileReader.onload = function (event)
            {
                file.url = event.target.result;

                $scope.$evalAsync(function ()
                {
                    MsNoteForm.note.image = file.url;
                });
            };

            file.type = 'image';
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };

    }

    /** @ngInject */
    function msNoteFormDirective()
    {
        return {
            restrict    : 'EA',
            controller  : 'msNoteFormController',
            controllerAs: 'MsNoteForm',
            scope       : {
                noteType: '=',
                noteId  : '='
            },
            templateUrl : 'app/main/notes/directives/ms-note-form/ms-note-form.html',
            link        : function (scope, element, attributes, MsNoteForm)
            {
                // Type
                MsNoteForm.type = scope.noteType;

                // Note id
                if ( angular.isDefined(scope.noteId) )
                {
                    MsNoteForm.noteId = scope.noteId;
                }

                MsNoteForm.init();

            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.notes')
        .controller('msNewNoteController', msNewNoteController)
        .directive('msNewNoteButton', msNewNoteButtonDirective)
        .directive('msNewNote', msNewNoteDirective);

    /** @ngInject */
    function msNewNoteController($scope, $document)
    {
        var MsNewNote = this;

        //Data
        MsNewNote.formVisible = false;
        MsNewNote.form = {
            title      : '',
            description: ''
        };

        //Methods
        MsNewNote.open = open;
        MsNewNote.close = close;
        MsNewNote.element = [];

        //////

        /**
         * Close Trigger
         */
        $scope.$on('MsNewNote:close', function ()
        {
            close();
        });

        /**
         * Open new note form
         */
        function open()
        {
            MsNewNote.element.addClass('form-visible');
            MsNewNote.element.find('textarea').focus();
            $document.on('click', outSideClick);
        }

        /**
         * Close new note form
         */
        function close()
        {
            MsNewNote.element.removeClass('form-visible');
            $scope.$broadcast('MsNewNote:closed');

            $document.off('click', outSideClick);
        }

        /**
         * Click Outside Event Handler
         * @param event
         */
        function outSideClick(event)
        {
            var isChild = MsNewNote.element.has(event.target).length > 0;
            var isSelf = MsNewNote.element[0] === event.target;
            var isMenu = angular.element(event.target).closest('md-menu-content').length > 0;
            var isCalendar = angular.element(event.target).closest('md-calendar').length > 0 || angular.element(event.target).closest('.md-datepicker-calendar-pane').length > 0 || angular.element(event.target).hasClass('md-scroll-mask');

            var isInside = isChild || isSelf || isMenu || isCalendar;

            if ( !isInside )
            {
                close();
            }
        }
    }

    /** @ngInject */
    function msNewNoteDirective()
    {
        return {
            restrict    : 'E',
            controller  : 'msNewNoteController',
            controllerAs: 'MsNewNote',
            templateUrl : 'app/main/notes/directives/ms-new-note/ms-new-note.html',
            link        : function (scope, element, attributes, MsNewNote)
            {
                MsNewNote.element = element;
            }
        };
    }

    /** @ngInject */
    function msNewNoteButtonDirective()
    {
        return {
            restrict: 'EA',
            require : '^msNewNote',
            link    : function (scope, element, attributes, msNewNote)
            {
                element.on('click', function ()
                {
                    msNewNote.open();
                });
            }
        };
    }
})();

(function () {
  'use strict';

  angular
    .module('app.contacts', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    $stateProvider.state('app.contacts', {
      url: '/contacts',
      views: {
        'content@app': {
          templateUrl: 'app/main/contacts/contacts.html',
          controller: 'ContactsController as vm'
        }
      },
      resolve: {

        orClients: function (msApi, orContacts) {
          return orContacts.resolveClients();
        },
        ConfigureDefault: function (NotesService) {
          return NotesService.getDefaultSettings();
        }

      }
    });
    $stateProvider.state('app.contacts.shipping', {
      url: '/contacts/shipping/:id',
      views: {
        'content@app': {
          templateUrl: 'app/main/contacts/contacts.html',
          controller: 'ContactsController as vm'
        }
      },
      resolve: {

        orClients: function ($stateParams, orContacts) {
          return orContacts.searchClients({MishloachID: $stateParams.id, allPlaces: true});
        },
        ConfigureDefault: function (NotesService) {
          return NotesService.getDefaultSettings();
        }


      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/contacts');

    msNavigationServiceProvider.saveItem('fuse.contacts', {
      title: 'פציינטים',
      icon: 'icon-account-multiple',
      state: 'app.contacts',
      /*stateParams: {
       'param1': 'page'
       },*/
      // translate: 'SAMPLE.CONTACTS',
      weight: 2
    });

    // Api

    var API = 'http://localhost:4900/';
    API = 'https://or-api.azurewebsites.net/';

    //API = 'https://pano-api-test.azurewebsites.net/';

    msApiProvider.register('or.clients', [API + 'clients']);
    msApiProvider.register('or.clients.search', [API + 'clients/search']);
    // msApiProvider.register('or.clients.single', ['app/data/contacts/singlecontact.json']);
    msApiProvider.register('or.clients.single', [API + 'client/:clientid']);
    msApiProvider.register('or.clients.delete', [API + 'client/delete']);
    msApiProvider.register('or.client.insuranse_status', [API + 'client/insurancestatus/:clientid/:insuranceid']);
    msApiProvider.register('or.client.insurance_sendclaim', [API + 'insurance/sendclaim']);
    // msApiProvider.register('or.client.copies', ['app/data/contacts/copiesclient.json']);
    msApiProvider.register('or.client.copies', [API + 'photosclient/:clientid']);
    msApiProvider.register('or.client.receipts', [API + 'receipts/:clientid']);
    msApiProvider.register('or.client.documents', [API + 'documents/:clientid']);
    msApiProvider.register('or.client.documents.name', [API + 'documents/download/:docname']);
    msApiProvider.register('or.client.documents.delete', [API + 'documents/delete']);
    msApiProvider.register('or.client.checkReferenceExist', [API + 'checkReferenceExist']);
    msApiProvider.register('or.employees', [API + 'getEmployees']);
    msApiProvider.register('or.doctors', [API + 'getDoctors']);
    msApiProvider.register('or.doctor.detail', [API + 'doctors/:doctorid']);
    msApiProvider.register('or.doctor.copies', [API + 'doctors/copies/:doctorid']);
    msApiProvider.register('or.factorPays', [API + 'factorpays']);
    msApiProvider.register('or.clients.new', [API + 'clients']);
    msApiProvider.register('or.clients.employee', [API + 'clients/employee']);
    msApiProvider.register('or.clients.left', [API + 'clients/left']);
    msApiProvider.register('or.clients.insurance', [API + 'client/insurance/update']);
    msApiProvider.register('or.clients.copies', [API + 'client/copies/update']);
    msApiProvider.register('or.client.files.send', [API + 'client/copies/sendtoemail']);

    //pelecard
    msApiProvider.register('or.billing.pelecard', [API + 'billing/pay']);
    msApiProvider.register('or.billing.pelecard.check', [API + 'billing/checkpelecardpaid']);
    msApiProvider.register('or.billing.invoice', [API + 'billing/createinvoice']);
    msApiProvider.register('or.billing.invoice.customer', [API + 'billing/invoice/:id']);
    msApiProvider.register('or.billing.invoice.permissioncredit', [API + 'billing/checkcreditpermission']);
    msApiProvider.register('or.billing.invoice.discountpermission', [API + 'billing/checkdiscountpermission']);

    //Employees
    msApiProvider.register('or.employees.entry', [API + 'employees/entry']);
    msApiProvider.register('or.employees.report', [API + 'employees/report']);
    msApiProvider.register('or.employees.details', [API + 'employees/details/:card']);

    //Reports
    msApiProvider.register('or.reports.daily', [API + 'reports/daily']);

    //shipping
    msApiProvider.register('or.shipping.report', [API + 'shipping']);
    msApiProvider.register('or.shipping.delivery', [API + 'shipping/delivery']);
    msApiProvider.register('or.shipping.certificate', [API + 'shipping/certificate/:ship_id']);

    //insurance
    msApiProvider.register('or.insurance.prices', [API + 'insurance/prices']);
    msApiProvider.register('or.insurance.listofcopies', [API + 'insurance/listofcopies']);
    msApiProvider.register('or.insurance.prices.delete', [API + 'insurance/prices/delete']);
    msApiProvider.register('or.insurance.reportplace', [API + 'insurance/reportplace']);
    msApiProvider.register('or.insurance.statusphoto', [API + 'insurance/status']);

    //calander
    msApiProvider.register('or.calander', [API + 'calander']);
//Login
    msApiProvider.register('or.auth.login', [API + 'login']);

    //Login
    msApiProvider.register('or.version', [API + 'version']);


    msApiProvider.register('or.report.indebt', [API + 'reports/indebt']);
    msApiProvider.register('or.report.deposit', [API + 'reports/deposit']);
    msApiProvider.register('or.report.alert_report', [API + 'reports/alert_report']);

    msApiProvider.register('or.referringdoctors', [API + 'referringdoctors']);
    msApiProvider.register('or.references', [API + 'references']);
    msApiProvider.register('or.copies_list', [API + 'doctor_service/prescription_photos']);


    msApiProvider.register('or.deposits', [API + 'billing/deposit/:clientid']);
    msApiProvider.register('or.deposits.add', [API + 'billing/deposit']);
    msApiProvider.register('or.deposits.del', [API + 'billing/deposit/del']);
    //msApiProvider.register('or.prescription_copies', [API + 'prescription_copies']);

    //Inventories
    msApiProvider.register('or.inventories.orders', [API + 'inventories/orders']);
    msApiProvider.register('or.inventories.orderdetails', [API + 'inventories/orders/:orderid']);
    msApiProvider.register('or.inventories.editorderdetails', [API + 'inventories/orders/edit/:orderid']);
    msApiProvider.register('or.inventories.edit_status', [API + 'inventories/orders/status/update']);
    msApiProvider.register('or.inventories.items', [API + 'inventories/items']);
    msApiProvider.register('or.inventories.tracking', [API + 'inventories/tracking']);
    msApiProvider.register('or.inventories.tracking.history', [API + 'inventories/tracking_history']);
    msApiProvider.register('or.smsin', [API + 'sms/in']);
  }

})();

(function () {
  'use strict';

  angular
    .module('app.contacts')
    .controller('ContactDialogController', ContactDialogController);

  /** @ngInject */
  function ContactDialogController($mdDialog, SearchAllPlaces, msUtils, $filter) {
    var vm = this;

    vm.title = 'EDIT_CONTACT';


    vm.newContact = false;
    vm.allFields = false;
    vm.default_avatar = 'assets/images/avatars/profile.jpg';
    vm.contact = {allPlaces: SearchAllPlaces};

    // Methods


    //////////


    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }
    function submit() {
      $mdDialog.hide(vm.contact);
    }

    vm.closeDialog = closeDialog;
    vm.submit = submit;

  }
})();

(function () {
  'use strict';
  angular
    .module('app.contacts')
    .directive('onReadFile', function ($parse) {
      return {
        restrict: 'A',
        scope: false,
        link: function (scope, element, attrs) {
          var fn = $parse(attrs.onReadFile);

          element.on('change', function (onChangeEvent) {
            var reader = new FileReader();

            reader.onload = function (onLoadEvent) {
              scope.$apply(function () {
                fn(scope, {$fileContent: onLoadEvent.target.result});
              });
            };

            reader.readAsText((onChangeEvent.srcElement || onChangeEvent.target).files[0]);
          });
        }
      };
    })
    .directive('ngCsvImport', function () {
      return {
        restrict: 'E',
        transclude: true,
        replace: true,
        scope: {
          content: '=?',
          header: '=?',
          headerVisible: '=?',
          separator: '=?',
          separatorVisible: '=?',
          result: '=?',
          encoding: '=?',
          encodingVisible: '=?',
          accept: '=?',
          acceptSize: '=?',
          acceptSizeExceedCallback: '=?',
          callback: '=?',
          mdButtonClass: '@?',
          mdInputClass: '@?',
          mdButtonTitle: '@?',
          mdSvgIcon: '@?',
          uploadButtonLabel: '='
        },
        template: function (element, attrs) {
          var material = angular.isDefined(attrs.material);
          var multiple = angular.isDefined(attrs.multiple);
          return '<div  class="ng-csv-import">' +
            '<div ng-show="headerVisible"><div class="label">Header</div>' +
            (material ? '<input type="checkbox" ng-model="header"></div>' :
              '<md-switch class="ng-csv-import-header-switch" ng-model="header"></md-switch>') +
            '<div ng-show="encodingVisible"><div class="label">Encoding</div><span>{{encoding}}</span></div>' +
            '<div ng-show="separatorVisible">' +
            '<div class="label">Seperator</div>' +
            '<span><input class="separator-input ' + (material ? '_md md-input' : '') + ' " type="text" ng-change="changeSeparator" ng-model="separator"><span>' +
            '</div>' +
            '<div>' +
            '<input ng-show="false" class="btn cta gray" upload-button-label="{{uploadButtonLabel}}" type="file" ' + (multiple ? 'multiple' : '') + ' accept=".csv"/>' +
            (material ? '<md-button  ng-click="onClick($event)" class="_md md-button md-primary {{mdButtonClass}}">' +
            '<img src="assets/images/crm/csv.png"/>' +
            ' </md-button>' +
            '<md-input-container ng-show="false">' +
            '<input type="text" class="_md md-input-readable md-input {{mdInputClass}}" ng-click="onClick($event)" ng-model="filename"></md-input-container>' : '') +
            '</div>' +
            '</div>';
        },
        link: function (scope, element, attrs) {
          scope.separatorVisible = !!scope.separatorVisible;
          scope.headerVisible = !!scope.headerVisible;
          scope.acceptSize = scope.acceptSize || Number.POSITIVE_INFINITY;
          scope.material = angular.isDefined(attrs.material);
          scope.multiple = angular.isDefined(attrs.multiple);
          if (scope.multiple) {
            throw new Error("Multiple attribute is not supported yet.");
          }
          var input = angular.element(element[0].querySelector('input[type="file"]'));
          var inputContainer = angular.element(element[0].querySelector('md-input-container'));

          if (scope.material && input) {
            input.removeClass("ng-show");
            input.addClass("ng-hide");
            if (inputContainer) {
              var errorSpacer = angular.element(inputContainer[0].querySelector('div.md-errors-spacer'));
              if (errorSpacer) {
                errorSpacer.remove();
              }
            }
            scope.onClick = function () {
              input.click();
            };
          }

          angular.element(element[0].querySelector('.separator-input')).on('keyup', function (e) {
            if (scope.content != null) {
              var content = {
                csv: scope.content,
                header: scope.header,
                separator: e.target.value,
                encoding: scope.encoding
              };
              scope.result = csvToJSON(content);
              scope.$apply();
              if (typeof scope.callback === 'function') {
                if (scope.callback != null) {
                  scope.callback(e);
                }
              }
            }
          });

          element.on('change', function (onChangeEvent) {
            if (!onChangeEvent.target.files.length) {
              return;
            }

            if (onChangeEvent.target.files[0].size > scope.acceptSize) {
              if (typeof scope.acceptSizeExceedCallback === 'function') {
                scope.acceptSizeExceedCallback(onChangeEvent.target.files[0]);
              }
              return;
            }
            if ("application/vnd.ms-excel" != onChangeEvent.target.files[0].type && "text/plain" != onChangeEvent.target.files[0].type)
              return;
            scope.filename = onChangeEvent.target.files[0].name;

            var reader = new FileReader();
            reader.onload = function (onLoadEvent) {
              scope.$apply(function () {
                var content = {
                  csv: onLoadEvent.target.result.replace(/\r\n|\r/g, '\n'),
                  header: scope.header,
                  separator: scope.separator
                };
                scope.content = content.csv;
                scope.result = csvToJSON(content);
                scope.result.filename = scope.filename;
                scope.$$postDigest(function () {
                  if (typeof scope.callback === 'function') {
                    if (scope.callback != null) {
                      scope.callback(onChangeEvent);
                    }
                  }
                });
              });
            };

            if ((onChangeEvent.target.type === "file") && (onChangeEvent.target.files != null || onChangeEvent.srcElement.files != null)) {
              reader.readAsText((onChangeEvent.srcElement || onChangeEvent.target).files[0], scope.encoding);
            } else {
              if (scope.content != null) {
                var content = {
                  csv: scope.content,
                  header: !scope.header,
                  separator: scope.separator
                };
                scope.result = csvToJSON(content);
                scope.$$postDigest(function () {
                  if (typeof scope.callback === 'function') {
                    if (scope.callback != null) {
                      scope.callback(onChangeEvent);
                    }
                  }
                });
              }
            }
          });

          var csvToJSON = function (content) {
            var lines = content.csv.split(new RegExp('\n(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)'));
            var result = [];
            var start = 0;
            var columnCount = lines[0].split(content.separator).length;

            var headers = [];
            if (content.header) {
              headers = lines[0].split(content.separator);
              start = 1;
            }

            for (var i = start; i < lines.length; i++) {
              var obj = {};
              var currentline = lines[i].split(new RegExp(content.separator + '(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)'));
              if (currentline.length === columnCount) {
                if (content.header) {
                  for (var j = 0; j < headers.length; j++) {
                    obj[headers[j]] = cleanCsvValue(currentline[j]);
                  }
                } else {
                  for (var k = 0; k < currentline.length; k++) {
                    obj[k] = cleanCsvValue(currentline[k]);
                  }
                }
                result.push(obj);
              }
            }
            return result;
          };

          var cleanCsvValue = function (value) {
            return value
              .replace(/^\s*|\s*$/g, "") // remove leading & trailing space
              .replace(/^"|"$/g, "") // remove " on the beginning and end
              .replace(/""/g, '"'); // replace "" with "
          };
        }
      };
    })
    .controller('importContacts', importContacts);

  function importContacts($mdDialog, bon_Contacts, msUtils, $filter, Subscription, $scope, DTOptionsBuilder, $mdToast, IntegrationsSer, agent, msApi, key) {
    var vm = this;
    vm.seperator = ',';
    vm.fields = [];
    vm.contactsArray = [];
    vm.isLoading = true;
    vm.fielsConvert = {
      fnameField: "",
      lnameField: '',
      emailField: "",
      phoneField: "",
      companyField: "",
      notesField: ""
    };
    vm.steps = ['load', 'fields', 'validate'];
    vm.step = 'load';
    vm.integrationTypes;
    vm.contactsDemo = [
      {name: "", last_name: "", email: "", phone: "", notes: ""},
      {name: "", last_name: "", email: "", phone: "", notes: ""},
      {name: "", last_name: "", email: "", phone: "", notes: ""},
      {name: "", last_name: "", email: "", phone: "", notes: ""}
    ];

    //shopify
    agent.getShopByCustomer(function (res) {
      vm.shopName = res;
    });
    if (key) {
      bon_Contacts.shopifyContacts(key).then(function (res) {
        vm.isIntegration = true;
        vm.initShopifyContacts(res.customers);
      })
      if (key == 'error') {
        var message =  $filter('translate')('GLOBAL.ACTION_ERROR');
        //toast
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
          hideDelay: 5000,
          position: 'top right',
          parent: '#contactslist'
        });
      }
    }
    //ZOHO
    IntegrationsSer.Integrations().then(function (result) {
        vm.integrationTypes = result;
        var Zoho = $filter('filter')(vm.integrationTypes, {name: 'zoho'});
        vm.isZoho = Zoho[0] && Zoho[0].isAdded;
      }
    );
    //FUNCTIONS
    vm.initFields = function (res) {
      vm.contactsArray = [];
      vm.fields=[];
      vm.fielsConvert = {
        fnameField: "",
        lnameField: '',
        emailField: "",
        phoneField: "",
        companyField: "",
        notesField: ""
      };
      vm.isIntegration = false;
      if (!vm.resultCsv.length || !vm.resultCsv[0])
        return;
      vm.fields = Object.keys(vm.resultCsv[0]);
      vm.step = vm.fields.length ? 'fields' : 'load';
      vm.isLoading = false;
      $('input[type="file"]').val(null);
    }
    vm.initContactsArray = function () {
      vm.contactsArray = [];
      vm.resultCsv.forEach(function (obj) {
        var contactJson = {};
        //first name
        contactJson.name = vm.fielsConvert.fnameField ? obj[vm.fielsConvert.fnameField] : "";
        //last name
        contactJson.last_name = vm.fielsConvert.lnameField ? (obj[vm.fielsConvert.lnameField]) : "";
        //email
        contactJson.email = vm.fielsConvert.emailField ? (obj[vm.fielsConvert.emailField]) : "";
        //phone
        contactJson.phone = vm.fielsConvert.phoneField ? (obj[vm.fielsConvert.phoneField]) : "";
        //company
        contactJson.company = vm.fielsConvert.companyField ? (obj[vm.fielsConvert.companyField]) : "";
        //company
        contactJson.notes = vm.fielsConvert.notesField ? (obj[vm.fielsConvert.notesField]) : "";
        //contactJson.isAdd=true;
        vm.contactsArray.push(contactJson);
      });
    }
    vm.validateData = function () {
      vm.step = 'validate';
      if (!vm.contactsArray || !vm.contactsArray.length)
        return;
      vm.contactsArray.forEach(function (obj) {
        var ponePattern = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/;
        var emailPattern = /^.+@.+\..+$/;
        obj.status = true;
        if (obj.phone && !ponePattern.test(obj.phone))
          obj.status = false;
        if (!obj.email || (obj.email && !emailPattern.test(obj.email)))
          obj.status = false;
        obj.isAdd = obj.status;
      });
      vm.sumValid = $filter('filter')(vm.contactsArray, {status: true}).length;
      vm.sumNotValid = vm.contactsArray.length - vm.sumValid;
    }
    vm.importZohoContacts = function () {
      vm.contactsArray = [];
      bon_Contacts.importIntegrationContacts('zoho').then(function (res) {
        console.log(res)
        if (!res.status)
          return;
        res.data.forEach(function (obj) {
          if (!obj || !obj.Email)
            return;
          var contactJson = {};
          //first name
          contactJson.name = obj["First Name"]
          //last name
          contactJson.last_name = obj["Last Name"];
          //email
          contactJson.email = obj.Email;
          //phone
          contactJson.phone = obj.Phone ? (obj.Phone) : "";
          //notes
          contactJson.notes = obj.Note? (obj.Note) : "";
          vm.contactsArray.push(contactJson);
        })
        vm.isLoading = false;
        vm.validateData();
      });

    }
    vm.initShopifyContacts = function (customers) {
      vm.contactsArray = [];
      if(!customers)
        return;
      customers.forEach(function (obj) {
        if (!obj || !obj.email)
          return;
        var contactJson = {};
        //first name
        contactJson.name = obj.first_name ? obj.first_name : ""
        //last name
        contactJson.last_name = obj.last_name ? obj.last_name : "";
        //email
        contactJson.email = obj.email ? obj.email : "";
        //phone
        contactJson.phone = obj.phone ? (obj.phone) : "";
        //note
        contactJson.notes = obj.note ? (obj.note) : "";
        vm.contactsArray.push(contactJson);
      });
      vm.isLoading = false;
      vm.validateData();

    }
    vm.importContacts = function (name) {
      vm.isIntegration = true;
      switch (name) {
        case 'zoho':
          vm.importZohoContacts();
          break;


      }
    }
    vm.addContacts = function () {
      var validContacts = $filter('filter')(vm.contactsArray, {status: true, isAdd: true});
      bon_Contacts.addContactsList(validContacts).then(function (res) {
        //close
        $mdDialog.hide();
        var message = res.status ? "Contacts were successfully saved" : $filter('translate')('GLOBAL.ACTION_ERROR');
        //toast
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
          hideDelay: 5000,
          position: 'top right',
          parent: '#contactslist'
        });
      })
    }
    vm.getSumValid = function () {
      if (!vm.contactsArray || !vm.contactsArray.length)
        return "";
      var validContacts = $filter('filter')(vm.contactsArray, {status: true, isAdd: true});
      return validContacts.length ? validContacts.length : "";
    }
    vm.closeDialog = function () {
      $mdDialog.hide();
    }
    vm.getShopifyUrl = function () {
      if (key || !vm.shopName)
        return "";
      return bontactServers.shopify_api + 'getContactsList?shop=' + vm.shopName;
    }
    vm.toastNotIntegrate=function (name) {
      var message =  name=="zoho"?"Integration to Zoho was not detected":"Shopify client was not detected";
      //toast
      $mdToast.show({
        template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
        hideDelay: 5000,
        position: 'top right',
        parent: '#importContacts'
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.calendar', [
      'ui.calendar'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.calendar', {
      url: '/calendar',
      views: {
        'content@app': {
          templateUrl: 'app/main/calendar/calendar.html',
          controller: 'CalendarController as vm'
        }
      },
      bodyClass: 'calendar',
      resolve: {
        CalanderEvents:function (orContacts) {

          return orContacts.calanderEvents();
        }
      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/calendar');

    // Navigation
    msNavigationServiceProvider.saveItem('fuse.calendar', {
      title: 'לוח שנה',
      icon: 'icon-calendar-today',
      state: 'app.calendar',
      weight: 2
    });
  }
})();

(function () {
  'use strict';

  angular.module('app.calendar')
    .controller('EventDetailDialogController', EventDetailDialogController);

  /** @ngInject */
  function EventDetailDialogController($mdDialog,orUserAccount, calendarEvent, showEventFormDialog, event) {
    var vm = this;

    // Data
    vm.calendarEvent = calendarEvent;
    vm.placeName = orUserAccount.Place.Name;
    // Methods
    vm.editEvent = editEvent;
    vm.closeDialog = closeDialog;

    //////////

    function closeDialog() {
      $mdDialog.hide();
    }

    function editEvent(calendarEvent) {
      showEventFormDialog('edit', calendarEvent, false, false, event);
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.calendar')
    .controller('EventFormDialogController', EventFormDialogController);

  /** @ngInject */
  function EventFormDialogController($mdDialog, dialogData) {
    var vm = this;

    // Data
    vm.dialogData = dialogData;
    vm.notifications = ['15 minutes before', '30 minutes before', '1 hour before'];

    // Methods
    vm.saveEvent = saveEvent;
    vm.deleteEvent = deleteEvent;
    vm.closeDialog = closeDialog;

    init();

    //////////

    /**
     * Initialize
     */
    function init() {
      vm.dialogTitle = (vm.dialogData.type === 'add' ? 'הוספת תור' : 'עריכת תור');

      // Edit
      if (vm.dialogData.calendarEvent) {
        // Clone the calendarEvent object before doing anything
        // to make sure we are not going to brake the Full Calendar
        vm.calendarEvent = angular.copy(vm.dialogData.calendarEvent);

        // Convert moment.js dates to javascript date object
        if (moment.isMoment(vm.calendarEvent.start)) {
          vm.calendarEvent.start = vm.calendarEvent.start.toDate();
        }

        if (moment.isMoment(vm.calendarEvent.end)) {
          vm.calendarEvent.end = vm.calendarEvent.end.toDate();
        }
        //alert(vm.calendarEvent.end);
        if (!vm.calendarEvent.end)
          vm.calendarEvent.end =  angular.copy(vm.calendarEvent.start);

      }
      // Add
      else {
        // Convert moment.js dates to javascript date object

        if (moment.isMoment(vm.dialogData.start)) {
          vm.dialogData.start = vm.dialogData.start.toDate();
        }

        if (moment.isMoment(vm.dialogData.end)) {
          vm.dialogData.end = vm.dialogData.end.toDate();
        }

        vm.calendarEvent = {
          start: vm.dialogData.start,
          end: vm.dialogData.end,
          notes: vm.dialogData.notes,
          notifications: []
        };
      }
    }

    function saveEvent() {
      var response = {
        type: vm.dialogData.type,
        calendarEvent: vm.calendarEvent
      };

      $mdDialog.hide(response);
    }
    function deleteEvent() {
      var response = {
        type: 'delete',
        calendarEvent: vm.calendarEvent
      };
      $mdDialog.hide(response);
    }

    /**
     * Close the dialog
     */
    function closeDialog() {
      $mdDialog.cancel();
    }
  }
})();

/**
 * Created by itzik on 07/01/2018.
 */
(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('tableReportEditDialogController', tableReportEditDialogController);

  /** @ngInject */
  function tableReportEditDialogController(Item, Feilds, AllowRemove, isNew,$mdDialog, msUtils, $filter) {
    var vm = this;

    vm.title = 'EDIT_CONTACT';
    vm.item = angular.copy(Item);
    vm.keys = Feilds;//Object.keys(Feilds);
    vm.isNew = isNew;

    vm.AllowRemove = AllowRemove;//Object.keys(Feilds);

    vm.newContact = false;
    vm.allFields = false;
    vm.default_avatar = 'assets/images/avatars/profile.jpg';
    vm.keys.map(function (item) {
      if(item.type=='date')
        vm.item[item.key]=new Date(vm.item[item.key]);
    })

    // Methods


    //////////


    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }

    function submit() {
      $mdDialog.hide(vm.item);
    }

    vm.closeDialog = closeDialog;
    vm.submit = submit;
    vm.remove = function () {
      vm.item._action = 'remove';
      $mdDialog.hide(vm.item);
    }


  }
})();

/**
 * Created by itzik on 23/11/2017.
 */

(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('DateDialogController', DateDialogController);

  /** @ngInject */
  function DateDialogController($mdDialog, $filter, Dates) {
    var vm = this;
    vm.date = Dates.start || new Date();
    vm.dateend = Dates.end || new Date();
    vm.re_select = 0;
    vm.close = function () {
      $mdDialog.hide({start: vm.date, end: vm.dateend})
    }
    vm.range = [];

    for (var i = 1; i <= 5; i++) {
      var datesO = {start: moment().add(-i, 'month').date(1), end: moment().add(-i, 'month').endOf('month')};
      vm.range.push({
        dates: datesO,
        name: moment().add(-i, 'month').format('MMMM - YY'),
        id: i
      })
      if (moment(vm.date).format('DDMMYY') == datesO.start.format('DDMMYY') && moment(vm.dateend).format('DDMMYY') == datesO.end.format('DDMMYY'))
        vm.re_select = i;
    }
    vm.changeMonth = function () {
      if (vm.re_select) {
        var item = $filter('filter')(vm.range, {id: vm.re_select}, true)[0];
        if (item) {
          vm.date = item.dates.start.toDate();
          vm.dateend = item.dates.end.toDate();
        }

      }
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.profile')
    .controller('ProfileDialogController', ProfileDialogController);

  /** @ngInject */
  function ProfileDialogController($mdDialog, $state, copyrators, employee) {
    var vm = this;


    /**
     * Close dialog
     */
   // vm.closeDialog = closeDialog;
    vm.cancel = cancel;
    vm.copyrators = copyrators;
    vm.copyratorselect = copyrators[0].id;
    vm.search=employee;
    // function closeDialog() {
    //   $mdDialog.hide(vm.copyratorselect);
    // }

    vm.selectEmployee = function (employeeId) {
      $mdDialog.hide(employeeId);
    }
    function cancel() {
      $mdDialog.hide();
      // if (!employee)
      //   $state.go('app.contacts')

    }


  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.timeline', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pages_timeline', {
                url      : '/pages/timeline',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/timeline/timeline.html',
                        controller : 'TimelineController as vm'
                    }
                },
                resolve  : {
                    Timeline: function (msApi)
                    {
                        return msApi.resolve('timeline.page1@get');
                    }
                },
                bodyClass: 'timeline'
            })
            .state('app.pages_timeline_left', {
                url      : '/pages/timeline-left',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/timeline/timeline-left.html',
                        controller : 'TimelineController as vm'
                    }
                },
                resolve  : {
                    Timeline: function (msApi)
                    {
                        return msApi.resolve('timeline.page1@get');
                    }
                },
                bodyClass: 'timeline-left'
            })
            .state('app.pages_timeline_right', {
                url      : '/pages/timeline-right',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/timeline/timeline-right.html',
                        controller : 'TimelineController as vm'
                    }
                },
                resolve  : {
                    Timeline: function (msApi)
                    {
                        return msApi.resolve('timeline.page1@get');
                    }
                },
                bodyClass: 'timeline-right'
            });

        // API
        msApiProvider.register('timeline.page1', ['app/data/timeline/page-1.json']);
        msApiProvider.register('timeline.page2', ['app/data/timeline/page-2.json']);
        msApiProvider.register('timeline.page3', ['app/data/timeline/page-3.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('pages.timeline', {
            title : 'Timeline',
            icon  : 'icon-view-stream',
            weight: 8
        });

        msNavigationServiceProvider.saveItem('pages.timeline.default', {
            title: 'Default',
            state: 'app.pages_timeline'
        });

        msNavigationServiceProvider.saveItem('pages.timeline.left-aligned', {
            title: 'Left Aligned',
            state: 'app.pages_timeline_left'
        });

        msNavigationServiceProvider.saveItem('pages.timeline.right-aligned', {
            title: 'Right Aligned',
            state: 'app.pages_timeline_right'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.timeline')
        .controller('TimelineController', TimelineController);

    /** @ngInject */
    function TimelineController($q, msApi, Timeline)
    {
        var vm = this;

        // Data
        vm.timeline = Timeline.data;
        vm.timelineOptions = {
            scrollEl: '#content'
        };
        vm.currentPage = 1;
        vm.totalPages = 3;
        vm.pauseScroll = false;

        // Methods
        vm.loadNextPage = loadNextPage;

        //////////

        /**
         * Load next page
         * @returns promise
         */
        function loadNextPage()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            // Increase the current page number
            vm.currentPage = vm.currentPage + 1;

            // Check if we still have pages that we can load
            if ( vm.currentPage > vm.totalPages )
            {
                // Reject the promise
                deferred.reject('No more pages');
            }
            else
            {
                // Emulate the api call and load new timeline items in
                var pageName = 'timeline.page' + vm.currentPage + '@get';

                msApi.request(pageName, {},

                    // SUCCESS
                    function (response)
                    {
                        for ( var i = 0; i < response.data.length; i++ )
                        {
                            vm.timeline.push(response.data[i]);
                        }

                        // Resolve the promise
                        deferred.resolve(response);
                    },

                    // ERROR
                    function (response)
                    {
                        // Reject the promise
                        deferred.reject(response);
                    }
                );
            }

            return deferred.promise;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.search', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_search', {
            url      : '/pages/search',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/search/search.html',
                    controller : 'SearchController as vm'
                }
            },
            resolve  : {
                Classic : function (msApi)
                {
                    return msApi.resolve('search.classic@get');
                },
                Mails   : function (msApi)
                {
                    return msApi.resolve('search.mails@get');
                },
                Users   : function (msApi)
                {
                    return msApi.resolve('search.users@get');
                },
                Contacts: function (msApi)
                {
                    return msApi.resolve('search.contacts@get');
                }
            },
            bodyClass: 'search'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/search');

        // Api
        msApiProvider.register('search.classic', ['app/data/search/classic.json']);
        msApiProvider.register('search.mails', ['app/data/search/mails.json']);
        msApiProvider.register('search.users', ['app/data/search/users.json']);
        msApiProvider.register('search.contacts', ['app/data/search/contacts.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('pages.search', {
            title : 'Search',
            icon  : 'icon-magnify',
            state : 'app.pages_search',
            weight: 7
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.search')
        .controller('SearchController', SearchController);

    /** @ngInject */
    function SearchController(Classic, Mails, Users, Contacts)
    {
        var vm = this;

        // Data
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];

        vm.classic = Classic.data;
        vm.mails = Mails.data;
        vm.users = Users.data;
        vm.contacts = Contacts.data;

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.maintenance', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_maintenance', {
            url      : '/pages/maintenance',
            views    : {
                'main@'                        : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_maintenance': {
                    templateUrl: 'app/main/pages/maintenance/maintenance.html',
                    controller : 'MaintenanceController as vm'
                }
            },
            bodyClass: 'maintenance'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/maintenance');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.maintenance', {
            title : 'Maintenance',
            icon  : 'icon-oil',
            state : 'app.pages_maintenance',
            weight: 5
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.maintenance')
        .controller('MaintenanceController', MaintenanceController);

    /** @ngInject */
    function MaintenanceController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.invoice', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pages_invoice_modern', {
                url      : '/pages/invoice/modern',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/invoice/views/modern/modern.html',
                        controller : 'InvoiceController as vm'
                    }
                },
                resolve  : {
                    Invoice: function (msApi)
                    {
                        return msApi.resolve('invoice@get');
                    }
                },
                bodyClass: 'invoice printable'
            })
            .state('app.pages_invoice_compact', {
                url      : '/pages/invoice/compact',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/invoice/views/compact/compact.html',
                        controller : 'InvoiceController as vm'
                    }
                },
                resolve  : {
                    Invoice: function (msApi)
                    {
                        return msApi.resolve('invoice@get');
                    }
                },
                bodyClass: 'invoice printable'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/invoice');

        // Api
        msApiProvider.register('invoice', ['app/data/invoice/invoice.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('pages.invoice', {
            title : 'Invoice',
            icon  : 'icon-receipt',
            weight: 4
        });

        msNavigationServiceProvider.saveItem('pages.invoice.modern', {
            title : 'Modern',
            state : 'app.pages_invoice_modern'
        });

        msNavigationServiceProvider.saveItem('pages.invoice.compact', {
            title : 'Compact',
            state : 'app.pages_invoice_compact'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.invoice')
        .controller('InvoiceController', InvoiceController);

    /** @ngInject */
    function InvoiceController(Invoice)
    {
        var vm = this;

        // Data
        vm.invoice = Invoice.data;

        // Methods

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.coming-soon', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_coming-soon', {
            url      : '/pages/coming-soon',
            views    : {
                'main@'                        : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_coming-soon': {
                    templateUrl: 'app/main/pages/coming-soon/coming-soon.html',
                    controller : 'ComingSoonController as vm'
                }
            },
            bodyClass: 'coming-soon'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/coming-soon');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.coming-soon', {
            title : 'Coming Soon',
            icon  : 'icon-alarm-check',
            state : 'app.pages_coming-soon',
            weight: 2
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.coming-soon')
        .controller('ComingSoonController', ComingSoonController);

    /** @ngInject */
    function ComingSoonController()
    {
        var vm = this;

        // Data
        vm.endTime = 1472975790000;

        // Methods

        //////////
    }
})();
(function () {
  'use strict';

  angular
    .module('app.notes')
    .factory('NotesService', NotesService);

  /** @ngInject */
  function NotesService(msApi, $q, $filter) {
    var service = {
      data: [],
      addNote: addNote,
      updateNote: updateNote,
      deleteNote: deleteNote,
      getData: getData,
      getDefaultSettings: getDefaultSettings
    };

    /**
     * Add Note
     * @param note
     */
    function addNote(note) {
      service.data.push(note);
      saveLocal();
    }

    /**
     * Update Note
     * @param note
     */
    function updateNote(note) {
      for (var i = 0; i < service.data.length; i++) {
        if (service.data[i].id === note.id) {
          service.data[i] = note;
        }
      }
      saveLocal();
    }

    /**
     * Delete Note
     * @param note
     */
    function deleteNote(note) {
      for (var i = 0; i < service.data.length; i++) {
        if (service.data[i].id === note.id) {
          service.data.splice(i, 1);
        }
      }
      saveLocal();
    }

    /**
     * Get service data
     * @returns {Array}
     */
    function getData() {
      // Create a new deferred object
      var deferred = $q.defer();

      if (window.localStorage["notes"] !== undefined) {
        service.data = JSON.parse(window.localStorage["notes"]);
        var item = $filter('filter')(service.data, {id: "5739d1fb4d27bc5341fd3322"}, true)[0];
        if (!item) {
          addConfigureDefaultSettings();
        }
        if (item.checklist.length < 2) {
          item.checklist.push({
              "checked": false,
              "key": 2,
              "text": "חיפוש בכל הסניפים"
            })
          saveLocal();
        }

        deferred.resolve(service);
      } else {
        msApi.request('notes.notes@get', {},
          // SUCCESS
          function (response) {
            // Attach the data
            service.data = response.data;
            saveLocal();
            // Resolve the promise
            deferred.resolve(response);
          },

          // ERROR
          function (response) {
            // Reject the promise
            deferred.reject(response);
          }
        );
      }
      return deferred.promise;
    }

    function getDefaultSettings() {
      var deferred = $q.defer();
      getData().then(function () {
        var item = $filter('filter')(service.data, {id: "5739d1fb4d27bc5341fd3322"}, true)[0];
        deferred.resolve(item);
      })
      return deferred.promise;
    }

    var saveLocal = function () {
      window.localStorage["notes"] = JSON.stringify(service.data);
    }

    function addConfigureDefaultSettings() {
      var json = {
        "id": "5739d1fb4d27bc5341fd3322",
        "title": "הגדרות ברירת מחדל",
        "description": "",
        "archive": false,
        "image": "",
        "color": "md-orange-50-bg",
        "time": "2016-01-21T22:46:48.587Z",
        "reminder": "2016-05-14T06:47:19.587Z",
        "checklist": [
          {
            "checked": false,
            "key": 1,
            "text": "סמן משלוח אוטומטי לפציינט"
          },
          {
            "checked": false,
            "key": 2,
            "text": "חיפוש בכל הסניפים"
          }
        ],
        "labels": [
          "5725a6809fdd915739187ed5",
          "5725a68031fdbb1db2c1af47"
        ]
      };
      service.data.push(json);
      saveLocal();
    }

    return service;

  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.notes')
        .factory('LabelsService', LabelsService);

    /** @ngInject */
    function LabelsService(msUtils, NotesService, msApi, $q)
    {
        var service = {
            data       : [],
            addLabel   : addLabel,
            updateLabel: updateLabel,
            deleteLabel: deleteLabel,
            getData    : getData
        };

        /**
         * Add label
         * @param newLabel
         */
        function addLabel(newLabel)
        {
            if ( newLabel.name === '' )
            {
                return;
            }

            service.data.push({
                id   : msUtils.guidGenerator(),
                name : newLabel.name,
                color: newLabel.color || ''
            });
        }

        /**
         * Update Label
         * @param note
         */
        function updateLabel(note)
        {
            for ( var i = 0; i < service.data.length; i++ )
            {
                if ( service.data[i].id === note.id )
                {
                    service.data[i] = note;
                }
            }
        }

        /**
         * Delete Label
         * @param label
         */
        function deleteLabel(label)
        {
            var notes = NotesService.data;

            // Look for all notes if they have the labels
            for ( var j = 0; j < notes.length; j++ )
            {
                if ( notes[j].labels.indexOf(label.id) > -1 )
                {
                    notes[j].labels.splice(notes[j].labels.indexOf(label.id), 1);
                }
            }

            // Delete label from service data
            for ( var i = 0; i < service.data.length; i++ )
            {
                if ( service.data[i].id === label.id )
                {
                    service.data.splice(i, 1);
                }
            }

        }

        /**
         * Get service data
         * @returns {Array}
         */
        function getData()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            msApi.request('notes.labels@get', {},
                // SUCCESS
                function (response)
                {
                    // Attach the data
                    service.data = response.data;

                    // Resolve the promise
                    deferred.resolve(response);
                },

                // ERROR
                function (response)
                {
                    // Reject the promise
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        return service;

    }
})();
(function () {
  'use strict';

  angular
    .module('app.inventories', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    $stateProvider.state('app.inventories', {
      url: '/inventories',
      views: {
        'content@app': {
          templateUrl: 'app/main/inventories/inventories.html',
          controller: 'InventoriesController as vm'
        }
      },
      resolve: {

        Inventories: function (inventoriesService) {
          return inventoriesService.Orders();
        }

      }
    });
    $stateProvider.state('app.inventories_order', {
      url: '/inventories/order/:order',
      views: {
        'content@app': {
          templateUrl: 'app/main/inventories/order/inventories_order.html',
          controller: 'InventoriesOrderController as vm'
        }
      },
      resolve: {

        Order: function ($stateParams, inventoriesService) {
          return inventoriesService.OrderDetails($stateParams.order||0);
        },
        Products: function (inventoriesService) {
          return inventoriesService.GetAllItemsProducts();
        }

      }
    });
    $stateProvider.state('app.inventories_edit_order', {
      url: '/inventories/order/edit/:order',
      views: {
        'content@app': {
          templateUrl: 'app/main/inventories/edit_order/edit_order.html',
          controller: 'Edit_orderController as vm'
        }
      },
      resolve: {

        Order: function ($stateParams, inventoriesService) {
          if ($stateParams.order&&$stateParams.order!=0)
            return inventoriesService.Order($stateParams.order);
          return {isnew: true}
        },
        Items: function ($stateParams, inventoriesService) {
          return inventoriesService.GetOrderDetailsForEdit($stateParams.order);
        }

      }
    });
    $stateProvider.state('app.inventories_traking', {
      url: '/inventories/tracking',
      views: {
        'content@app': {
          templateUrl: 'app/main/inventories/tracking/tracking.html',
          controller: 'TrackingController as vm'
        }
      },
      resolve: {
        Tracking: function (inventoriesService) {
          return inventoriesService.Tracking();
        }

      }
    });


    msNavigationServiceProvider.saveItem('other.investory', {
      title: 'מלאי',
      icon: 'icon-barcode',
      weight: 1
    });
    msNavigationServiceProvider.saveItem('other.investory.inventories_traking', {
      title: 'מעקב מלאי',
      icon: 'icon-cart',
      state: 'app.inventories_traking',
      weight: 1
    });
    msNavigationServiceProvider.saveItem('other.investory.inventories', {
      title: 'הזמנות מלאי',
      icon: 'icon-cart',
      state: 'app.inventories',
      weight: 1
    });
    msNavigationServiceProvider.saveItem('other.investory.inventories_edit_order', {
      title: 'הצג הזמנה',
      icon: 'icon-book-open',
      state: 'app.inventories_order',
      weight: 2
    });
    msNavigationServiceProvider.saveItem('other.investory.inventories_item', {
      title: 'צור הזמנה',
      icon: 'icon-pencil-box-outline',
      state: 'app.inventories_edit_order({order:0})',
      weight: 3
    });

  }

})();

(function () {
  'use strict';

  angular
    .module('app.inventories')
    .controller('TrackingController', TrackingController);

  /** @ngInject */
  function TrackingController(Tracking, inventoriesService, $mdDialog, $document) {

    var vm = this;
    // data
    vm.inventories_tracking = Tracking;


    vm.clientsSearch;

    vm.feilds = [
      //{key: 'ClientID', name: 'קוד לקוח'},
      {key: 'item_id', name: 'מזהה מוצר'},
      {key: 'product_name', name: 'שם מוצר'},
      {key: 'balance', name: 'יתרה'}

    ];
    vm.config = {
      rowClickFunction: function (item) {
        auth_user(item)

      }
      // rowClick: {
      //   type: 'ref',
      //   ui_serf: 'app.inventories_order',
      //   params: [{key: 'order', value: 'ID'}]
      // }
    }
    vm.EmployeeAuth;
    function auth_user(item) {
      var confirm = $mdDialog.prompt()
        .title('זיהוי עובד')
        .textContent('לצורך שינוי וביצוע הזמנה נדרש אימות עובד')
        .placeholder('הקש אן העבר כאן כרטיס עובד')
        .ariaLabel('Dog name')
        //.initialValue()
        //  .targetEvent(ev)
        //.required(true)
        .ok('המשך')
        .cancel('ביטול');

      $mdDialog.show(confirm).then(function (result) {
          console.log("result", result);
          if (!result)
            return
          vm.proccess = true
          inventoriesService.GetEmployeeDetails(result).then(function (resultEmp) {
            console.log(resultEmp);
            vm.proccess = false;

            if (resultEmp) {
              var confirm = $mdDialog.confirm()
                .title(item.product_name)
                .textContent(resultEmp.Name + ", האם להסיר יחידה אחת מהמלאי? יתרה כעת היא " + item.balance)
                .ariaLabel('Lucky day')
                //.targetEvent(ev)
                .ok('כן')
                .cancel('לא, ביטול');

              $mdDialog.show(confirm).then(function () {
                inventoriesService.UpdateTrackingData(item, resultEmp);
                item.balance--;
              });
            }
            else {
              $mdDialog.show(
                $mdDialog.confirm()
                  .clickOutsideToClose(true)
                  .title("לא זוהה עובד")
                  .textContent("נסה שנית")
                  .ariaLabel('Alert Dialog Demo')
                  .ok('נסה שנית')
                  .cancel('סגור')
                // .targetEvent(ev)
              ).then(function (again) {
                if (again)
                  auth_user(item);
              })
            }

          });
        }
      );
    }

    vm.showHistory = function () {
      var feilds = [
        {key: 'date', name: 'תאריך', type: "date"},
        {key: 'item_name', name: 'שם מוצר'},
        {key: 'count', name: 'כמות'},
        {key: 'employee_name', name: 'עובד'},
        {key: 'admin_name', name: 'מחסן'}
      ]
      inventoriesService.TrackingHistory().then(function (data) {
        console.log("data", data)
        $mdDialog.show({
          controller: 'tableDialogController',
          controllerAs: 'vm',
          templateUrl: 'app/main/inventories/table-dialog/table-dialog.html',
          parent: angular.element($document.find('#content-container')),
          //targetEvent: ev,
          clickOutsideToClose: true,
          escapeToClose: true,
          locals: {Title: 'היסטוריית פעולות', Data: {data: data, feilds: feilds}}
        }).then(function (id) {

        });
      })

    }
    vm.refresh = function (reload) {
      vm.clientsSearch = undefined;
      vm.proccess = true;
      inventoriesService.Tracking(vm.search, reload).then(function () {
        vm.proccess = false;
        vm.search = '';
        vm.inventories_tracking = Tracking;
      });
      vm.isCustomSearch = false;

    }
    var intervalCheck;
    vm.typeSearch = function () {
      if (intervalCheck)
        clearTimeout(intervalCheck);
      intervalCheck = setTimeout(deepSearch, 500);
    }
    var deepSearch = function () {
      if (vm.search.length < 3 || vm.proccess)
        return;

      vm.refresh();

    }

    vm.clear = function () {
      // Refferings.splice(0, Refferings.length);
      // vm.clients = ReferringPlaceList.data;
    }
    vm.refreshAll = function () {
      vm.proccess = true;
      // orContacts.ReferringPlaceList().then(function () {
      //   vm.proccess = false;
      //   vm.clients = ReferringPlaceList.data;
      // });
    }

  }

})();

/**
 * Created by itzik on 20/11/2017.
 */
(function () {
  'use strict';

  angular
    .module('app.inventories')
    .controller('tableDialogController', tableDialogController);

  /** @ngInject */
  function tableDialogController($mdDialog, $rootScope, Title, Data) {
    var vm = this;
    vm.title = Title;
    // vm.subTitle = SubTitle;
    vm.data = Data.data;
    vm.feilds = Data.feilds;
    vm.close = function () {
      $mdDialog.cancel();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.inventories')
    .controller('InventoriesOrderController', InventoriesOrderController);

  /** @ngInject */
  function InventoriesOrderController(Order, Products, inventoriesService, $state, $mdDialog) {

    var vm = this;
    // data
    vm.order = Order;

    if (!Order) {
      $state.go('app.inventories');
      return;
    }
    vm.clientsSearch;

    vm.feilds = [
      //{key: 'ClientID', name: 'קוד לקוח'},
      // {key: 'ID', name: 'מספר'},
      {key: 'itemName', name: 'מוצר'},
      {key: 'count', name: 'כמות להזמנה'},
      {key: 'count_in_package', name: 'יחידות באריזה'},
      {key: 'status', name: 'סטאטוס', type: 'bool'},
      {key: 'note', name: 'הערה'},
      {key: 'adminConfirmation', name: 'מנהל מאשר'}

    ];
    // vm.feildsedit = [
    //   {key: 'itemName', name: 'מוצר', readOnly: true},
    //   {key: 'count', name: 'כמות', type: "number", required: true, min: "min_per_order", max: "max_per_order"},
    //   {
    //     key: 'item_id', name: 'בחר מוצר', required: true, showgroup: true,
    //     select: {
    //       data: Products, key: 'ID', value: 'nameWithSupplier'
    //     }
    //   }
    // ],
    vm.config = {
      // rowClick: {
      //   type: 'ref',
      //   ui_serf: 'app.inventories.order',
      //   params: [{key: 'order', value: 'ID'}]
      // }
    }
    vm.remove = function () {

    }
    vm.refresh = function () {
      vm.clientsSearch = undefined;
      vm.proccess = true;
      inventoriesService.Orders(vm.search).then(function () {
        vm.proccess = false;
        vm.search = '';
        vm.inventories = Inventories;
      });
      vm.isCustomSearch = false;

    }
    var intervalCheck;
    vm.typeSearch = function () {
      if (intervalCheck)
        clearTimeout(intervalCheck);
      intervalCheck = setTimeout(deepSearch, 500);
    }
    var deepSearch = function () {
      if (vm.search.length < 3 || vm.proccess)
        return;

      vm.refresh();

    }

    vm.clear = function () {
      // Refferings.splice(0, Refferings.length);
      // vm.clients = ReferringPlaceList.data;
    }
    vm.refreshAll = function () {
      vm.proccess = true;
      // orContacts.ReferringPlaceList().then(function () {
      //   vm.proccess = false;
      //   vm.clients = ReferringPlaceList.data;
      // });
    }
    vm.sendOrder = function (cancel) {
      vm.proccess = true;
      Order.status_old = Order.status;
      Order.status_name_old = Order.status_name;
      inventoriesService.ChangeStatusInventory(Order, {cancelled: cancel}).then(function (result) {
        vm.proccess = false;
        var msg = 'הזמנה נשלחה', content = 'ההזמנה תטופל בהקדם';
        if (cancel)
          msg = 'הזמנה בוטלה', content = 'תוכל לעדכן ולשלוח בעתיד';
        console.log("status status", result);
        if (!result.status) {
          msg = 'ארעה שגיאה', content = 'נסה שנית';
          Order.status = Order.status_old;//Send
          Order.status_name = Order.status_name_old;
        }
        $mdDialog.show(
          $mdDialog.alert()
            .clickOutsideToClose(true)
            .title(msg)
            .textContent(content)
            .ariaLabel('Alert Dialog Demo')
            .ok('סגור')
          // .targetEvent(ev)
        );
      });

    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.inventories')
    .controller('Edit_orderController', Edit_orderController);

  /** @ngInject */
  function Edit_orderController(Order, Items, inventoriesService, orContacts, $state, $mdDialog) {

    var vm = this;
    // data
    vm.order = Order;
    vm.items = Items;
    if (!Order) {
      $state.go('app.inventories');
      return;
    }

    if (Order.status > 2) {
      $state.go('app.inventories_order', ({order: Order.ID}));
    }
    vm.clientsSearch;
    vm.Sub = function (item) {
      if (item.count && item.count > item.min_per_order)
        item.count--;

    }
    vm.Add = function (item) {
      if (item.permission && !item.admin_confirmation) {
        // alert("Hello")
        prompAdminPermission(item);
        return;
      }
      if (item.count && item.count < item.max_per_order)
        item.count++;
      else if (!item.count)
        item.count = item.min_per_order;
    }
    vm.Remove = function (item) {
      item.count = null;
    }
    vm.SaveInventory = function () {
      var dataSave = angular.copy(vm.order);
      dataSave.items = Items;
      vm.proccess = true;
      inventoriesService.SaveInventory(dataSave).then(function (result) {
        vm.proccess = false;
        $state.go('app.inventories_order', ({order: result.ID}));
      })
    }
    vm.CancelInventory = function () {
      var confirm = $mdDialog.confirm()
        .title('מחיקת הזמנה')
        .textContent('האם למחוק הזמנה זו, לא תוכל\י לשחזר פעולה זו')
        //.placeholder('לחץ על אישור')
        .ariaLabel('Dog name')
        //.initialValue()
        //  .targetEvent(ev)
        //.required(true)
        .ok('אישור')
        .cancel('ביטול');

      $mdDialog.show(confirm).then(function (result) {
        console.log("result", result);
        Order.status_old = Order.status;
        Order.status_name_old = Order.status_name;
        inventoriesService.ChangeStatusInventory(Order, {removed: true}).then(function (result) {
          vm.proccess = false;
        });
      });
    }
    vm.enterEmployeeId = function () {
      if (vm.order.employee_card) {
        if (intervalCheck)
          clearTimeout(intervalCheck);
        intervalCheck = setTimeout(function () {
          // vm.order.name = "David"
          cardLeft();
        }, 500);
      }
    }
    var intervalCheck;

    function prompAdminPermission(itemOfOrder) {
      var confirm = $mdDialog.prompt()
        .title('אישור מנהל')
        .textContent('להוספת פריט זה להזמנה - נא להקיש קוד אישור מנהל. נא לפנות למולי')
        .placeholder('הקש קוד מנהל')
        .ariaLabel('Dog name')
        //.initialValue()
        //  .targetEvent(ev)
        //.required(true)
        .ok('אישור')
        .cancel('ביטול');

      $mdDialog.show(confirm).then(function (result) {
        console.log("result", result);
        if (isNaN(parseInt(result))) {
          alertDialog('מספר אישור לא תקין!', 'שגיאה');
        } else {
          var nPermission = parseInt(result);
          orContacts.CheckDiscountPermission(nPermission).then(function (result) {
            console.log(result);
            if(result.status) {
              itemOfOrder.admin_confirmation = result.data.admin_user_id;
              vm.Add(itemOfOrder);
            }else{
              alertDialog('מספר אישור לא תקין!', 'שגיאה');
            }
          });
        }

        //inventoriesService.ChangeStatusInventory(Order, {removed: true}).then(function (result) {
        //  vm.proccess = false;
        //});
      });

    }

    function focusAutoCard() {
      setTimeout(function () {
        console.log("focusAutoCard")
        $("#emloyee_employee_card").focus();
      }, 1500);
    }

    function cardLeft() {
      vm.proccess = true;

      inventoriesService.GetEmployeeDetails(vm.order.employee_card).then((function (result) {
        console.log(result);
        vm.proccess = false;

        if (result) {
          vm.order.name = result.Name;
          vm.order.employee_id = result.OvedID;
          $('#emloyee_employee_card').blur()

        }
      }))
    }

    function alertDialog(MSG, title) {
      $mdDialog.show(
        $mdDialog.alert()
        //.parent(angular.element(document.querySelector('#popupContainer')))
          .clickOutsideToClose(true)
          .title(title || 'שגיאה')
          .textContent(MSG)
          .ariaLabel('Alert Dialog Demo')
          .ok('סגור')
        //.targetEvent(ev)
      );
    }

    focusAutoCard();

    vm.EmployeeAuth;
    function auth_user() {
      var confirm = $mdDialog.prompt()
        .title('זיהוי עובד')
        .textContent('לצורך שינוי וביצוע הזמנה נדרש אימות עובד')
        .placeholder('הקש אן העבר כאן כרטיס עובד')
        .ariaLabel('Dog name')
        //.initialValue()
        //  .targetEvent(ev)
        //.required(true)
        .ok('המשך')
        .cancel('ביטול');

      $mdDialog.show(confirm).then(function (result) {
          console.log("result", result);
          vm.proccess = true
          inventoriesService.GetEmployeeDetails(result).then(function (resultEmp) {
            console.log(resultEmp);
            vm.proccess = false;

            if (resultEmp && Order.isnew) {
              vm.EmployeeAuth = {name: resultEmp.Name, employee_id: resultEmp.OvedID}
              vm.order.name = resultEmp.Name;
              vm.order.employee_id = resultEmp.OvedID;
            }
            else if (resultEmp) {
              if (vm.order.employee_id == resultEmp.OvedID) {
                vm.EmployeeAuth = {name: resultEmp.Name, employee_id: resultEmp.OvedID}
              } else {
                $mdDialog.show(
                  $mdDialog.confirm()
                    .clickOutsideToClose(true)
                    .textContent("רק " + vm.order.name + " רשאי לערוך הזמנה זו")
                    .title("הרשאה חסומה")
                    .ariaLabel('Alert Dialog Demo')
                    .ok('נסה שנית')
                    .cancel('סגור')
                  // .targetEvent(ev)
                ).then(function (again) {
                  if (again)
                    auth_user();
                });
              }
            }
            else {
              $mdDialog.show(
                $mdDialog.confirm()
                  .clickOutsideToClose(true)
                  .title("לא זוהה עובד")
                  .textContent("נסה שנית")
                  .ariaLabel('Alert Dialog Demo')
                  .ok('נסה שנית')
                  .cancel('סגור')
                // .targetEvent(ev)
              ).then(function (again) {
                if (again)
                  auth_user();
              })
            }

          });
        }
      );
    }

    vm.auth_user = auth_user;
    setTimeout(auth_user, 1000);
  }
})
();

/**
 * Created by itzik on 23/11/2017.
 */

(function () {
  'use strict';

  angular
    .module('fuse')
    .controller('XXDateDialogController', XXDateDialogController);

  /** @ngInject */
  function XXDateDialogController($mdDialog, Date) {
    var vm = this;
    vm.date = Date || new Date();
    vm.close = function () {
      $mdDialog.hide(vm.date)
    }

  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('tableReport', tableReportDirective)
    .controller('orTableReportController', orTableReportController)
    .filter('orTableFilter', orTableFilter)
    .filter('sumByKey', sumByKey);

  /** @ngInject */
  function tableReportDirective($document) {
    return {
      restrict: 'E',
      scope: {
        feilds: '=',
        editfeilds: '=?',
        data: '=',
        orderDefault: '@',
        filter: '=?',
        config: '=?',
        filterInput: '=?',
        onEditItem: '=',
        onInsertItem: '=',
        onRemoveItem: '='
      },
      //transclude: true,
      templateUrl: 'app/core/directives/or-table-report/table-report.html',
      controller: 'orTableReportController as vm',
      link: function (scope, iElement) {
        // console.log(scope.data);
        // console.log(scope.insuranceId);

        /**
         * Remove the info bar
         */


      }
    };
  }

  function orTableReportController(orUserAccount, orContacts, insuranceService, $mdToast, $mdDialog, $state, $filter, $scope, $document, $mdMedia) {
    var vm = this;
    console.log('$scope.data');
    console.log($scope.data);
    console.log($scope.feilds);
    $scope.$mdMedia = function (data) {
      if (!data)
        return true;
      return $mdMedia(data)
    };
    if (typeof ($scope.filterInput) === 'object')
      $scope.filterCustom = $scope.filterInput;
    $scope.$watch('filterInput', function (old, newval) {
      //console.log(old);
      if (typeof ($scope.filterInput) === 'object')
        $scope.filterCustom = $scope.filterInput;
    })
    $scope.asFilter = function (item) {
      return item[feild.type]
    }
    vm.changeSort = function (feild) {
      if ($scope.orderDefault == feild) {
        if ($scope.orderDefault.indexOf('-') == 0)
          $scope.orderDefault = feild;
        else {
          $scope.orderDefault = '-' + feild;
        }
      } else {
        $scope.orderDefault = feild;
      }
    }
    vm.filterParams = [];
    vm.setFilter = function (key, value) {
      var exsist = $filter('filter')(vm.filterParams, {key: key}, true)[0];
      var feild = $filter('filter')($scope.feilds, {key: key}, true)[0];
      if (value && value != '') {
        if (exsist)
          exsist.value = value;
        else
          vm.filterParams.push({key: key, value: value});
        feild.filtered = true;
      } else if (exsist) {
        var ind;
        vm.filterParams.map(function (item, indx) {
          if (item.key == key)
            ind = indx;
        })
        if (ind !== 'undefined')
          vm.filterParams.splice(ind, 1);
        feild.filtered = false;
      }
      console.log(vm.filterParams);
    }
    vm.clickRow = function (item) {
      if ($scope.config.rowClickFunction) {
        $scope.config.rowClickFunction(item);
      }
      else if ($scope.config.rowClick) {
        var it = $scope.config.rowClick;
        var params = {};
        it.params.map(function (quer) {
          var key = it.params[0].key;
          var value = item[it.params[0].value];
          params[key] = value;
        })

        $state.go(it.ui_serf, params);
      }
    }

    vm.editItem = function (ev, item, isNew) {
      console.log("editfeilds", $scope.editfeilds)
      if (!$scope.editfeilds)
        return;

      $mdDialog.show({
        controller: 'tableReportEditDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/core/directives/or-table-report/dialog/edit-dialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          Item: item,
          Feilds: $scope.editfeilds,
          isNew: isNew,
          AllowRemove: $scope.onRemoveItem !== undefined
        }
      }).then(function (itemEdited) {
        if (itemEdited) {
          if (itemEdited._action == 'remove' && $scope.onRemoveItem)
            $scope.onRemoveItem(itemEdited);
          else if (isNew && $scope.onInsertItem)
            $scope.onInsertItem(itemEdited)
          else if (!isNew && $scope.onEditItem)
            $scope.onEditItem(itemEdited)
        }

      });
    }

  }

  function orTableFilter() {
    return function (input, option) {

      var output = [];
      // console.log(option);
      // return input;


      // Do filter work here
      if ((!option || option == 0))
        return input;
      else {
        for (var idx in input) {

          var item = input[idx];
          var allow = true;
          for (var x in option) {
            var filt = option[x];
            if (item[filt.key] != filt.value)
              allow = false;
          }
          if (allow)
            output.push(item);
        }
      }
      return output;

    }
  }

  function sumByKey() {
    return function (data, key) {
      if (typeof(data) === 'undefined' || typeof(key) === 'undefined') {
        return 0;
      }

      var sum = 0;
      for (var i = data.length - 1; i >= 0; i--) {
        //var exsist = $filter('filter')(filterParams, {key: key}, true)[0];
        if (data[i][key])
          sum += parseFloat(data[i][key]);
      }

      return sum;
    };
  }
})
();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('orInsurance', orInsuranceDirective)
    .controller('orInsuranceController', orInsuranceController);

  /** @ngInject */
  function orInsuranceDirective($document) {
    return {
      restrict: 'E',
      scope: {
        data: '=',
        insuranceId: '=',
        countCopies: '='
        //vm          : '=viewModel'
      },
      //transclude: true,
      templateUrl: 'app/core/directives/or-insurance/or-insurance.html',
      controller: 'orInsuranceController as vm',
      link: function (scope, iElement) {
        // console.log(scope.data);
        // console.log(scope.insuranceId);

        /**
         * Remove the info bar
         */
        function removeInfoBar() {
          //body.removeClass(bodyClass);
          iElement.remove();
          scope.$destroy();
        }

        // Expose functions
        scope.removeInfoBar = removeInfoBar;
      }
    };
  }

  function orInsuranceController(orUserAccount, orContacts, insuranceService, $mdToast, $mdDialog, $document, $filter, $scope) {
    var vm = this;


    vm.data = $scope.data;
    vm.insuranceId = $scope.insuranceId;
    insuranceService.GetListofCopies().then(function (copiesList) {
      vm.copiesList = copiesList;
    });
    // vm.copiesList=[
    //   {CopyID:1,Name:'aaaaaa'},
    //   {CopyID:2,Name:'bbb'},
    //   {CopyID:3,Name:'cccc'},
    //   {CopyID:4,Name:'dddd'},
    //   {CopyID:5,Name:'eee'}
    // ];
    var edit = function (copy, ev) {
      $mdDialog.show({
        controller: 'CopyInsuraceDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/core/directives/or-insurance/dialog/copy/copy-dialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          Copy: copy,
          Place: {}
        }
      }).then(function (dataSearch) {
        if (!dataSearch)
          return;
        if (!dataSearch.TZ && !dataSearch.ClientName && !dataSearch.Tel && !dataSearch.KDate && !dataSearch.HeshbonitID && !dataSearch.MishloachID && !dataSearch.DoctorName) {
          var message = 'לא ניתן לבצע חיפוש. השלם לפחות שדה אחת';
          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
            hideDelay: 3000,
            position: 'top right',
            parent: '#content'
          });
        } else {
          orContacts.searchClients(dataSearch);
          vm.isCustomSearch = true;
        }

      });
    };

    var Add = function (ev) {
      $mdDialog.show({
        controller: 'CopyInsuraceDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/core/directives/or-insurance/dialog/copy/copy-dialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          Copy: {InsuranceID: vm.insuranceId},
          ListCopys: vm.copiesList,
          Place: {}
        }
      }).then(function (newCopy) {
        if (!newCopy)
          return;

        var exsist = $filter('filter')(vm.data, {CopyID: newCopy.CopyID, InsuranceID: newCopy.InsuranceID}, true)[0];
        if (exsist)
          $mdToast.show(
            $mdToast.simple()
              .textContent('צילום כבר קיים - לא ניתן להוסיף שנית')
              .position('top right')
              .hideDelay(3000)
          );
        else {
          vm.data.push(newCopy);
          console.log(exsist);
          insuranceService.InsertPrice(newCopy).then(function (success) {
            $mdToast.show(
              $mdToast.simple()
                .textContent(success ? 'בוצע' : 'שגיאה')
                .position('top right')
                .hideDelay(3000)
            );
          })
        }
      });
    };
    var Remove = function (copy) {
      insuranceService.RemoveCopie(copy).then(function (result) {
        console.log(result);
        //TODO will be refresh!
      });
    }
    vm.edit = edit;
    vm.add = Add;
    vm.remove = Remove;

  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element   : element,
                scope     : scope,
                form      : form,
                stepNumber: scope.step || (vm.steps.length + 1),
                stepTitle : scope.stepTitle
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?',
                hideStep    : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?',
                hideStep    : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('msPricesDoctors', msPricesDoctorsDirective)
    .controller('msPricesDoctorsController', msPricesDoctorsController)
    .filter('filterMultyWords', filterMultyWords);

  /** @ngInject */
  function msPricesDoctorsDirective($document) {
    return {
      restrict: 'E',
      scope: {
        copies: '=',
        doctor: '=',
        countCopies: '=',
        hideSelect: '=',
        bituahId: '=?',
        client: '=?',
        standrdInsurances: '=?'
        //vm          : '=viewModel'
      },
      //transclude: true,
      templateUrl: 'app/core/directives/ms-prices-doctors/ms-prices-doctors.html',
      controller: 'msPricesDoctorsController as vm',
      link: function (scope, iElement) {
        //console.log(scope.copies);

        /**
         * Remove the info bar
         */
        function removeInfoBar() {
          //body.removeClass(bodyClass);
          iElement.remove();
          scope.$destroy();
        }

        // Expose functions
        scope.removeInfoBar = removeInfoBar;
      }
    };
  }

  function msPricesDoctorsController(orUserAccount, orContacts, $mdDialog, $filter, $scope, $document, $timeout, msUtils) {
    var vm = this;
    //console.log($scope.copies);
    //console.log($scope.doctor);
    const INSURANCES = {KLALIT: 14, MACABI: 20, MEUCHEDET: 21};
    vm.copies = [];

    vm.places = [orUserAccount.Place];
    vm.placeSelcted = orUserAccount.Place.placeId;
    $scope.$watch("bituahId", function (newValue, oldValue) {
      //This gets called when data changes.
      if (oldValue != newValue && newValue != undefined) {
        vm.formWizard.BituahID = newValue;
        selectInsurance();
      }
    });
    $scope.$watch("doctor", function (newValue, oldValue) {
      //This gets called when data changes.
      if (oldValue == undefined && newValue != undefined) {
        selectDoctor(newValue, true);
        selectInsurance();
      }

    });
    var selectInsurance = function () {
      if (vm.factorPays) {
        var item = $filter('filter')(vm.factorPays, {BituahID: vm.formWizard.BituahID}, true)[0];
        if (item) {
          $scope.bituahId = item.BituahID || 0;
          vm.formWizard.BituahName = item.Name;
          vm.formWizard.isInsurances = item.isInsurances;
          vm.agreementOnly = item.BituahID != 1;
        }
      }
    }
    var selectDoctor = function (doctor, autoSelect) {
      console.log('selectDoctor');
      var AllowChange = true;
      if ($scope.doctor && $scope.doctor.DoctorID == doctor.DoctorID) {
        AllowChange = false;
      }
      /* debugger
       vm.formWizard.DoctorID = doctor.DoctorID;
       vm.formWizard.doctorName = doctor.Name;
       vm.formWizard.Sale = doctor.Sale;
       return;
       }*/
      if (!$scope.doctor)
        $scope.doctor = {};
      msUtils.setJsonObj($scope.doctor, doctor);
      vm.formWizard.DoctorID = doctor.DoctorID;
      vm.formWizard.doctorName = doctor.Name;
      vm.formWizard.Sale = doctor.Sale;

      // if (doctor.KategoriaID == 2)
      //   vm.formWizard.BituahID = 2;
      if (doctor.LastAgreementID)
        doctor.agreementID = doctor.LastAgreementID;
      else
        doctor.LastAgreementID = doctor.agreementID;
      if (doctor.agreementID && vm.formWizard.isInsurances && vm.formWizard.BituahID == 1) {
        vm.formWizard.BituahID = doctor.agreementID;
        vm.standrdInsurances = false;

      } else if (AllowChange) {
        if (!vm.standrdInsurances)
          vm.formWizard.BituahID = 1;
        vm.standrdInsurances = true;
      }

      selectInsurance();
      //if (vm.formWizard.BituahID > 2)
      if (doctor.agreementID)
        doctor.agreementID = vm.formWizard.BituahID;
      $scope.standrdInsurances = vm.standrdInsurances;

      //vm.DoctorNoteIN = doctor.NoteIN
      vm.DoctorNoteOUT = doctor.NoteOUT
      LoadCopiesDoctor(doctor, autoSelect);
      setTimeout(function () {
        vm.copmiesMode = true;
        $scope.$apply();
      }, 500)


    }
    var ResetDoctor = function () {
      vm.formWizard.DoctorID = undefined;
      vm.formWizard.doctorName = undefined;
      vm.copmiesMode = false;
      if (!vm.standrdInsurances) {
        vm.standrdInsurances = true;
        vm.formWizard.BituahID = 0;
        selectInsurance();
      }
      orContacts.GetDoctors().then(function (doctors) {
        vm.doctors = doctors;
      });
    }
    vm.selectedCopy = function (copy) {
      //console.log(copy.selected);
      if (copy.selected) {
        $scope.copies.push(copy);
        if (copy.priceFor == 'agreement') {
          vm.editDeductible(copy);
        }

      } else {
        for (var ind in $scope.copies) {
          if ($scope.copies[ind].PhotoListID == copy.PhotoListID)
            $scope.copies.splice(ind, 1);
        }

      }
    }
    var intervalCheck;
    vm.searchDoctor = function () {
      if (intervalCheck)
        clearTimeout(intervalCheck);
      intervalCheck = setTimeout(deepSearch, 500);
    };
    vm.alertAgreementInfo = function (e) {
      alertDialog(" שים/י לב! בחירת צילום שלא תחת הסכם אינו משולם על ידי הביטוח/מרפאה (גם אם תאפס/י את המחיר ל0) אלא החיוב צריך לחול על הפציינט ", "הסכם ביטוח/מרפאה")
      e.stopPropagation()
    }
    var deepSearch = function (dates) {
      if (vm.search.length < 3 || vm.proccess)
        return;
      vm.proccess = true;

      orContacts.GetDoctors(vm.search).then(function () {
        vm.proccess = false;
      });

    }
    var LoadCopiesDoctor = function (doctor, autoSelect) {
      if (!vm.formWizard.DoctorID)
        return;
      orContacts.LoadPhotosDoctor(doctor, vm.formWizard.BituahID).then(function (copies) {
        vm.copies = copies;
        if ((!autoSelect) && $scope.copies)
          $scope.copies.splice(0, $scope.copies.length);
        for (var ind in $scope.copies) {
          var x = $filter('filter')(vm.copies, {PhotoListID: $scope.copies[ind].PhotoID}, true)[0];
          if (x) {
            x.customfixprice = $scope.copies[ind].InsuranceID == 1;
            x.selected = true;
            //x.main_fixprice = x.fixprice;
            x.fixprice = $scope.copies[ind].fixprice;//321321
            x.discountAdminID = $scope.copies[ind].discountAdminID;
            x.reference = $scope.copies[ind].reference;
            if (x.priceFor == 'agreement') {
              //x.insuranceprice = $scope.copies[ind].insuranceprice;
              x.Deductible = $scope.copies[ind].Deductible;

              x.InsuranceAccept = $scope.copies[ind].InsuranceID != 1;
              $scope.copies[ind].InsuranceAccept = x.InsuranceAccept;
            }
          }
          if (!autoSelect) {
            msUtils.setJsonObj($scope.copies[ind], x);
          }
        }
      })
    }
    //vm.countCopies = {count: 0};
    if (!$scope.countCopies)
      $scope.countCopies = {count: 0, sum: 0};

    vm.countCopies = $scope.countCopies;
    vm.hideSelect = $scope.hideSelect;

    vm.standrdInsurances = true;
    vm.formWizard = {BituahID: $scope.bituahId};
    vm.countselected = function () {
      // console.log('ss')
      var fil = vm.copies.filter(function (copy) {
        // console.log(copy)
        return copy.selected;
      });
      vm.countCopies.count = fil.length;
      vm.sumPrice = 0;
      vm.countCopies.str = '';
      var sumAll = 0;
      for (var item in fil) {
        vm.sumPrice += parseFloat(fil[item].fixprice);
        if (fil[item].Deductible)
          vm.sumPrice += parseFloat(fil[item].Deductible);
        vm.countCopies.str += fil[item].Name + ', ';

        var photo = fil[item];

        //console.log(photo)
        if (photo.priceFor == "agreement" && photo.InsuranceAccept) {
          sumAll += parseFloat(photo.Deductible);
        }
        else if (photo.priceFor == "agreement") {
          sumAll += parseFloat(photo.fixprice || photo.doctorPrice || photo.basePrice);
        }
        else {
          sumAll += (photo.fixprice !== 'undefined' ? parseFloat(photo.fixprice) : parseFloat(photo.Price));
        }
      }
      vm.countCopies.sum = vm.sumPrice;
      if (!$scope.client)
        $scope.client = {};
      if (!$scope.client.sumAll)
        $scope.client.sumAll = {};
      $scope.client.sumAll.topay = sumAll;

      return fil.length;
    }


    vm.selectDoctor = selectDoctor;

    vm.editPrice = function (copy, ev) {
      //copy.fixprice -= 10;

      // Appending dialog to document.body to cover sidenav in docs app
      var confirm = $mdDialog.prompt()
        .title('עדכן מחיר לצילום ' + copy.Name)
        .textContent('מחיר קודם: ' + copy.fixprice)
        .placeholder('הזן מחיר')
        .ariaLabel('Dog name')
        .initialValue(copy.fixprice)
        .targetEvent(ev)
        //.required(true)
        .ok('אישור')
        .cancel('ביטול');
//321321
      $mdDialog.show(confirm).then(function (result) {
        if (isNaN(parseInt(result))) {
          alertDialog('מחיר לא תקין! - ניתן להזין מספר בלבד', 'שגיאה');
        } else if (parseInt(result) <= (copy.fixprice / 2)) {
          promtMenagerCode(copy, parseInt(result), ev);
          //alertDialog(' שים לב, במידה ויש ביטוח, יש לבחור צילום שמוגדר בסוג תשלום "ביטוח" ולא מחיר רגיל.', 'לא ניתן לאפס מחיר.');
        } else {
          copy.fixprice = parseInt(result);
          copy.Deductible = undefined;
          copy.customfixprice = true;
          var it = $filter('filter')($scope.copies, {PhotoListID: copy.PhotoListID}, true)[0];
          if (it) {
            it.fixprice = copy.fixprice;
            it.Deductible = copy.Deductible;
            it.customfixprice = copy.customfixprice;
          }

        }
      }, function () {
//        $scope.status = 'You didn\'t name your dog.';
      });

    }
    function dialogPlatinum(copy, ev) {
      var confirm = $mdDialog.confirm()
        .title('ביטוח ש.ל.ה.')
        .textContent('נא לסמן האם צילום זה מופנה דרך כללית פלטינום או מושלם')
        .ariaLabel('Lucky day')
        .targetEvent(ev)
        .ok('פלטינום')
        .cancel('מושלם');

      $mdDialog.show(confirm).then(function () {
        copy.reference = (copy.reference == 'מושלם' ? '' : copy.reference );
      }, function () {
        copy.reference = 'מושלם';
        var it = $filter('filter')($scope.copies, {PhotoListID: copy.PhotoListID}, true)[0];
        if (it) {
          it.reference = copy.reference;
        }
      });
    }

    var promtMenagerCode = function (copy, newPrice, ev) {

      var confirm = $mdDialog.prompt()
        .title(' עדכון מחיר ל' + newPrice)
        .textContent('נא לפנות למנהל לצורך אישור הנחה')
        .placeholder('הקש קוד אישור מנהל')
        .ariaLabel('Dog name')
        //.initialValue(max)
        .targetEvent(ev)
        //.required(true)
        .ok('אישור')
        .cancel('ביטול');

      $mdDialog.show(confirm).then(function (result) {
        if (isNaN(parseInt(result))) {
          alertDialog('מספר אישור לא תקין!', 'שגיאה');
        } else {
          var nPermission = parseInt(result);
          orContacts.CheckDiscountPermission(nPermission).then(function (result) {
            console.log(result);
            if (result.status) {
              copy.fixprice = newPrice;
              copy.customfixprice = true;
              copy.discountAdminID = result.data.admin_user_id;
              var it = $filter('filter')($scope.copies, {PhotoListID: copy.PhotoListID}, true)[0];
              if (it) {
                it.fixprice = copy.fixprice;
                it.customfixprice = copy.customfixprice;
                it.discountAdminID = copy.discountAdminID;
              }
            } else
              alertDialog('קוד הרשאה שגוי', 'הרשאה חסומה');
          })


          //RefundStatus(Receipt);
        }
      }, function () {

      });
    }
    vm.editHasmahta = function (copy, ev) {
      //copy.fixprice -= 10;

      // Appending dialog to document.body to cover sidenav in docs app
      var confirm = $mdDialog.prompt()
        .title('הוסף מספר אסמכתא ' + copy.Name)
        //.textContent('מחיר קודם: ' + copy.fixprice)
        .placeholder('מספר אסמכתא')
        .ariaLabel('Dog name')
        .initialValue(copy.Hasmahta)
        .targetEvent(ev)
        //.required(true)
        .ok('אישור')
        .cancel('ביטול');

      $mdDialog.show(confirm).then(function (result) {
        if (isNaN(parseInt(result))) {
          $mdDialog.show(
            $mdDialog.alert()
            //.parent(angular.element(document.querySelector('#popupContainer')))
              .clickOutsideToClose(true)
              .title('שגיאה')
              .textContent('מספר לא תקין! - ניתן להזין מספר בלבד')
              .ariaLabel('Alert Dialog Demo')
              .ok('סגור')
              .targetEvent(ev)
          );
        } else {
          copy.Hasmahta = parseInt(result);
          copy.reference = parseInt(result);
          var it = $filter('filter')($scope.copies, {PhotoListID: copy.PhotoListID}, true)[0];
          if (it) {
            it.Hasmahta = copy.Hasmahta;
            it.reference = copy.reference;
          }
        }
      }, function () {
//        $scope.status = 'You didn\'t name your dog.';
      });

    }
    function AddReferrer(copy, ev) {


      var dialogCustom = {
        // parent: parentEl,
        targetEvent: ev,
        template: '<md-dialog role="dialog" ><md-dialog-content ><h2 class="md-title ng-binding">הזן מספר אסמכתא - {{copy.Name}}</h2>' +
        '<md-input-container class="md-prompt-input-container md-input-has-placeholder md-default-theme" >' +
        '<input  md-autofocus="" ng-model="input" placeholder="הקש מספר אסמכתא" /></md-input-container>' +
        '</md-dialog-content><md-dialog-actions>' +
        '<button class="md-primary md-button" type="button" ng-click="cancel()" ><span class="ng-binding ng-scope">ביטול</span></button>' +
        '<button class="md-accent md-button" type="button" ng-click="ok2()" ><span class="ng-binding ng-scope">כללית מושלם</span></button>' +
        '<button class="md-primary md-raised md-button" type="button" ng-click="ok()" ><span class="ng-binding ng-scope">אישור</span></button></md-dialog-actions></md-dialog>',
        controllerAs: 'dialog',
        locals: {copy: copy},
        controller: ['$scope', '$mdDialog', 'copy', function ($scope, $mdDialog, copy) {
          $scope.input = copy.reference;
          $scope.copy = copy;
          $scope.closeDialog = function () {
            $mdDialog.hide();
          }
          $scope.ok = function () {
            $mdDialog.hide($scope.input);
          }
          $scope.ok2 = function () {
            $mdDialog.hide(0);
          }
          $scope.cancel = function () {
            $mdDialog.cancel();
          }
        }],
        bindToController: true,
        clickOutsideToClose: true,
        escapeToClose: true
      }
      $mdDialog.show(dialogCustom).then(function (result) {
          if (isNaN(parseInt(result)) && result != 'מושלם') {
            $mdDialog.show(
              $mdDialog.alert()
              //.parent(angular.element(document.querySelector('#popupContainer')))
                .clickOutsideToClose(true)
                .title('שגיאה')
                .textContent('מספר לא תקין! - ניתן להזין מספר בלבד')
                .ariaLabel('Alert Dialog Demo')
                .ok('סגור')
                .targetEvent(ev)
            );
          } else if (parseInt(result) == 0 || result == 'מושלם') {
            copy.reference = 'מושלם';
            var it = $filter('filter')($scope.copies, {PhotoListID: copy.PhotoListID}, true)[0];
            if (it) {
              it.reference = 'מושלם';
            }
          } else {
            copy.reference = parseInt(result);
            var it = $filter('filter')($scope.copies, {PhotoListID: copy.PhotoListID}, true)[0];
            if (it) {
              it.reference = copy.reference;
            }
          }
        },
        function () {

        });
    }

    vm.editDeductible = function (copy, ev) {
      //copy.fixprice -= 10;
      // Appending dialog to document.body to cover sidenav in docs app
      var confirm = $mdDialog.prompt()
        .title('השתתפות עצמית לצילום: ' + copy.Name)
        //  .textContent(textContent)
        .placeholder('סכום - הקש 0  או אנטר במידה ואין השתתפות')
        .ariaLabel('Dog name')
        .initialValue(copy.Deductible)
        .targetEvent(ev)
        //.required(true)
        .ok('אישור')
        .cancel('אין זכאות');

      if (vm.formWizard.BituahID == INSURANCES.MACABI || vm.formWizard.BituahID == INSURANCES.MEUCHEDET) {
        confirm = $mdDialog.confirm()
          .title('זכאות ביטוח')
          .textContent('נא לסמן האם יש זכאות לצילום זה. במידה ולא, ניתן אח"כ לעדכן מחיר')
          .ariaLabel('Lucky day')
          .targetEvent(ev)
          .ok('זכאי/ת')
          .cancel('אין זכאות');
      }
      else if (vm.formWizard.BituahID == INSURANCES.KLALIT) {
        confirm = $mdDialog.prompt()
          .title('קוד הפניה לצילום: ' + copy.Name)
          //  .textContent(textContent)
          .placeholder('הזן קוד הפניה')
          .ariaLabel('Dog name')
          .initialValue(copy.reference)
          .targetEvent(ev)
          .ok('אישור')
          .cancel('אין זכאות - תשלום פרטי');
      }
      $mdDialog.show(confirm).then(function (result) {
          if (isNaN(parseFloat(result))) {
            result = 0;
          } //else {

          if (vm.formWizard.BituahID == INSURANCES.KLALIT) {
            const codeReference = parseFloat(result);
            if (!codeReference || codeReference.toString().length < 8) {
              alertDialog('קוד הפניה שגוי!', 'שגיאה', function () {
                vm.editDeductible(copy, ev);
              })
              return
            }
            const otherSelectedCopies = $filter('filter')(vm.copies, {selected: true, reference: codeReference}, true);
            console.log('otherSelectedCopies', otherSelectedCopies)
            if (otherSelectedCopies.length) {
              alertDialog('קוד הפניה קיים כבר (' + otherSelectedCopies[0].Name + ')!', 'שגיאה', function () {
                vm.editDeductible(copy, ev);
              })
              return
            }
            //check exists in server.
            orContacts.checkReferenceExist(codeReference).then(function (result) {
              console.log(result);
              if (result.status) {
                copy.reference = codeReference;
                copy.Deductible = 0;

              } else {
                const clientIdExists = result.photo.ClientID;
                alertDialog(' (' + clientIdExists + ') קוד הפניה קיים כבר!', 'שגיאה', function () {
                  vm.editDeductible(copy, ev);
                })
              }
            });

          } else {
            copy.Deductible = parseFloat(result);
          }
          copy.InsuranceAccept = true;
          copy.customfixprice = false;
          copy.fixprice = 0;
          var it = $filter('filter')($scope.copies, {PhotoListID: copy.PhotoListID}, true)[0];
          if (it) {
            it.Deductible = copy.Deductible;
            it.InsuranceAccept = copy.InsuranceAccept;
            it.fixprice = copy.fixprice;

          }
          //if (vm.formWizard.BituahID == 14)
          //  dialogPlatinum(copy, ev);

          //}
        }, function () {
          copy.Deductible = copy.doctorPrice;
          copy.InsuranceAccept = false;
          var it = $filter('filter')($scope.copies, {PhotoListID: copy.PhotoListID}, true)[0];
          if (it) {
            it.Deductible = copy.doctorPrice || copy.basePrice;
            it.InsuranceAccept = copy.InsuranceAccept;
            //$scope.status = 'You didn\'t name your dog.';
          }
          //if (vm.formWizard.BituahID == 14)
          //  dialogPlatinum(copy, ev);
        }
      );

    }
    vm.cancelDiscount = function (copy) {
      if (copy.main_fixprice) {
        copy.fixprice = copy.main_fixprice;
        copy.discountAdminID = undefined;
        var it = $filter('filter')($scope.copies, {PhotoListID: copy.PhotoListID}, true)[0];
        if (it) {
          it.fixprice = copy.fixprice;
          it.customfixprice = false;
          it.discountAdminID = copy.discountAdminID;
        }
      }
    }
    vm.resetDoctor = ResetDoctor;
    vm.PriceForStr = function (copy) {
      if (copy.discountAdminID)
        return 'הנחת מנהל';
      if (copy.priceFor == 'doctor')
        return 'מחיר לרופא';
      if (copy.priceFor == 'regular')
        return 'מחיר רגיל';
      if (copy.priceFor == 'agreement') {
        if (!copy.Deductible && !copy.customfixprice)
          return 'ביטוח';
        if (copy.Deductible && copy.InsuranceAccept)
          return 'ביטוח + השתתפות';
        else
          return 'מחיר ללא זכאות'
      }

    }
    if ($scope.doctor)
      selectDoctor($scope.doctor, true);
    else {
      ResetDoctor();
    }
    orContacts.GetFactorPays().then(function (factorPays) {
      vm.factorPays = factorPays;
      selectInsurance();
    });

    vm.printDetails = function (doctor, ev) {
      $mdDialog.show({
        controller: 'SippingDetailsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/profile/dialog/shippingDetails/shippingDetails.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          client: {},
          Doctor: doctor,
          Place: orUserAccount.Place
        }
      }).then(function (id) {

      });
    }
    vm.selectInsurance = selectInsurance;
    vm.AddReferrer = AddReferrer;
    function alertDialog(MSG, title, cb) {
      $mdDialog.show(
        $mdDialog.alert()
        //.parent(angular.element(document.querySelector('#popupContainer')))
          .clickOutsideToClose(true)
          .title(title || 'שגיאה')
          .textContent(MSG)
          .ariaLabel('Alert Dialog Demo')
          .ok('סגור')
        //.targetEvent(ev)
      ).then(cb);
    }

    vm.focusSearch = function () {
      console.log('a')
      $timeout(function () {
        console.log('aaa')
        $('#s_search').focus();
      }, 500);
    }
    window.mdSelectOnKeyDownOverride = function (event) {
      event.stopPropagation();
      // NOTE: hack until this is fixed...
    };
  }

  function filterMultyWords() {
    return function (input, option) {
      var output = [];
      // console.log(option);
      // return input;
      // Do filter work here
      if ((!option || option == 0))
        return input;
      else {
        for (var idx in input) {
          var item = input[idx];
          var key = Object.keys(option)[0];
          var valueOfArray = (item[key]);
          var valueSearchs = [];
          if (option[key])
            valueSearchs = option[key].split(' ');
          //console.log(valueOfArray);

          var allow = true;
          for (var x in valueSearchs) {
            if (valueOfArray.indexOf(valueSearchs[x]) == -1)
              allow = false;
          }
          if (allow)
            output.push(item);
        }
      }
      return output;
    };
  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

              setTimeout(function () {

                tElement.find('input:text').eq(0).focus();
              },1000)
                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {

        // Default configuration
        var defaultConfiguration = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }
                var offset = moment(val).utcOffset();
                var date = new Date(moment(val).add(offset, 'm'));
                return date;
            }
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            return defaultConfiguration;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require: 'ngModel',
            link   : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.unshift(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.unshift(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
/**
 * Created by itzik on 15/01/2018.
 */
/**
 * @Angular Image Vieer Directive
 *
 * @Author      : Ranjithprabhu K
 *
 * @Module Name  :  imageViewer
 *
 * @Directive Name  :  image-viewer [in DOM]
 *
 * @Description:  This handles the image viewer with image zoom-in, zoom-out, rotate-left, rotate-right options.
 *
 */

(function () {
  "use strict";
  angular.module('imageViewer', []).directive('imageViewer', function ($sce) {

    return {
      restrict: 'EA',
      templateUrl: 'app/core/directives/image-viewer/image-viewer.html',
      /*template: '<div style="padding:10px;">\
       <button id="girardir" class="btn btn-primary btn-lg" ng-disabled="noImage"><span class="glyphicon glyphicon-menu-left"> </span> Rotate to Left</button>\
       <button id="giraresq" class="btn btn-primary btn-lg" ng-disabled="noImage">Rotate to Right <span class="glyphicon glyphicon-menu-right"> </span></button>\
       <button id="zoomIn" class="btn btn-info btn-lg" ng-disabled="noImage"><span class="glyphicon glyphicon-zoom-in"> </span> Zoom In</button>\
       <button id="zoomOut" class="btn btn-info btn-lg" ng-disabled="noImage"><span class="glyphicon glyphicon-zoom-out"> </span> Zoom Out</button>\
       <button id="carregar" class="btn btn-warning btn-lg" ng-disabled="noImage"><span class="fa fa-arrow-left"> </span> Reset</button>\
       </div>\
       <div id="image-zoom" style="padding:10px;">\
       <h2 class="text-center text-danger" id="error-message" style="border:1px solid #000;display:none;padding:20px">Image Not Available</h2>\
       <canvas id="canvas" height="650" data-girar="0" style="border:1px solid #000;z-index:555555;cursor:grab;">sdsd</canvas>\
       <img ng-src="{{image}}" id="image" style="display:none" /> </div>',*/
      link: function (scope, element, attr) {
        scope.image = attr.src;
        scope.noImage = false;
        scope.file = $sce.trustAsResourceUrl(attr.src);
        //options for the zoom and rotate
        var canvas = document.getElementById('canvas');
        var image = document.getElementById('image');
        var element = canvas.getContext("2d");
        var angleInDegrees = 0;
        var zoomDelta = 0.1;
        var currentScale = 1;
        var currentAngle = 0;
        var canvasWidth = 600;
        var novosDadosTRBL;
        var novosDadosWH;
        var novosDadosW;
        var novosDadosH;
        var startX, startY, isDown = false;
        scope.flag = 1;


        //set the width of the canvas
        setTimeout(function () {
          // canvas.width = angular.element('#image-zoom').width();
          canvas.width = angular.element('body').width();
          angular.element('#image-viewr-pdf-file').width(canvas.width / 2);
          //append the image in canvas
          // initilize();
          //document.getElementById('carregar').click();
        }, 0);
        initilize();
        //method to reset the image to its original position
        angular.element('#carregar').click(function () {
          resetImage();
          //check the image load

          /*angular.element('#image').on('load', resetImage())

           //if the image is not loaded
           .on('error', function () {
           //hide the canvas
           angular.element('#canvas').hide();

           //disable the buttons
           scope.noImage = true;

           //display the image not loaded text
           angular.element('#error-message').show();
           console.log("error loading image");
           });*/

        });
        function initilize() {
          angular.element('#image-viewr-pdf-file').bind('load', function () {
            console.log('image-viewr-pdf-file is loaded');
            //resetImage();
          });
          angular.element('#image').bind('load', function () {
            console.log('image is loaded');
            resetImage();
          });

          angular.element('#image').bind('error', function () {
            console.log('error');
            angular.element('#canvas').hide();
            angular.element("#image-viewr-loader-message").hide();
            angular.element("#image-viewr-pdf-file").attr('src', scope.file);
            //disable the buttons
            scope.noImage = true;

            //display the image not loaded text
            angular.element('#error-message').show();
            angular.element('#image-viewr-pdf-file').show();
            console.log("error loading image");
          });

        }

        //method to reset the image
        function resetImage() {
          console.log('resetImage');
          //alert('load')
          //load the  image in canvas if the image is loaded successfully
          angular.element("#image-viewr-loader-message").hide();
          angular.element("#canvas").show();
          image = document.getElementById('image');
          element = canvas.getContext("2d");
          angleInDegrees = 0;
          currentScale = 1;
          currentAngle = 0;

          //for initial loading
          if (scope.flag) {
            scope.flag = 0;
            drawImage();
            element.translate(canvas.width / 2, canvas.height / 2);
            setTimeout(function () {
              angular.element('#canvas').attr('data-girar', 0);
              drawImage();
            }, 1000);
          }
          else {
            element.translate(0, 0);
            angular.element('#canvas').attr('data-girar', 0);
            drawImage();
          }
        };

        //method to rotate the image in clockwise
        angular.element('#giraresq').click(function () {
          //set the rotate angle for clockwise rotation
          angleInDegrees = 5;
          currentAngle += angleInDegrees;
          drawImage();
        });


        //method to rotate the image in anti clockwise
        angular.element('#girardir').click(function () {
          //set the rotate angle for anti clockwise rotation
          angleInDegrees = -5;
          currentAngle += angleInDegrees;
          drawImage();
        });


        //method to zoom in the image
        angular.element('#zoomIn').click(function () {
          currentScale += zoomDelta;
          drawImage();
        });


        //method to zoom in and zoom out the image on mouse wheel scroll
        angular.element('#canvas').bind('mousewheel DOMMouseScroll', function (event) {
          if (event.originalEvent.wheelDelta > 0 || event.originalEvent.detail < 0) {
            // scroll up
            currentScale += zoomDelta;
            drawImage();
          }
          else {
            // scroll down
            if (currentScale - zoomDelta - 0.1 > 0) {
              currentScale -= zoomDelta;
              drawImage();
            }
          }
        });

        //method to zoom out the image
        angular.element('#zoomOut').click(function () {
          currentScale -= zoomDelta;
          drawImage();
        });

        //method to get the mouse position when mouse button is down
        canvas.onmousedown = function (e) {
          var pos = getMousePos(canvas, e);
          startX = pos.x;
          startY = pos.y;
          isDown = true;
        }

        //method to update the image position in the canvas when it is dragged
        canvas.onmousemove = function (e) {
          if (isDown === true) {
            var pos = getMousePos(canvas, e);
            var x = pos.x;
            var y = pos.y;

            element.translate(x - startX, y - startY);
            drawImage();

            startX = x;
            startY = y;
          }
        }

        //method to detect the mouse up for image dragging
        window.onmouseup = function (e) {
          isDown = false;
        }

        //method to draw the image in the canvas from image element
        function drawImage() {
          clear();
          element.save();
          element.scale(currentScale, currentScale);
          element.rotate(currentAngle * Math.PI / 180);
          element.drawImage(image, -image.width / 2, -image.height / 2);
          element.restore();
        }

        //method to clear the canvas
        function clear() {
          element.clearRect(-2000, -2000, 5000, 5000);
        }

        //method to get the mouse position
        function getMousePos(canvas, evt) {
          var rect = canvas.getBoundingClientRect();
          return {
            x: evt.clientX - rect.left,
            y: evt.clientY - rect.top
          };
        }


      }
    }
  });

})();

/**
 * Created by itzik on 27/12/2017.
 */
(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('orDateBetweenButtons', orDateBetweenButtonsDirective)
    .controller('orDateBetweenButtonsController', orDateBetweenButtonsController);

  /** @ngInject */
  function orDateBetweenButtonsDirective($document) {
    return {
      restrict: 'E',
      scope: {
        onChange: '&',
        dates: '=',
        rangeMode: '=?',
        mode: '=?',
        todayYesterdayOnly: '=?'

        //vm          : '=viewModel'
      },
      //transclude: true,
      templateUrl: 'app/core/directives/date-between-buttons/date-between-buttons.html',
      controller: 'orDateBetweenButtonsController as vm',
      link: function (scope, iElement) {
        // console.log(scope.data);
        // console.log(scope.insuranceId);

        /**
         * Remove the info bar
         */


      }
    };
  }

  function orDateBetweenButtonsController($mdDialog, $document, $filter, $timeout, $scope) {
    var vm = this;
    if (!$scope.dates)
      $scope.dates = {};
    vm.currentDate = new Date();
    // alert(moment().subtract(1, 'day').format('E'))
    vm.MODESDATE = [
      {key: 'TODAY', value: 'היום'},
      {key: 'YESTERDAY', value: 'אתמול', disable: moment().subtract(1, 'day').format('E') == 6},
      {key: 'WEEK', value: 'שבוע', disable: $scope.todayYesterdayOnly ? true : false},
      {key: 'MONTH', value: 'חודש', disable: $scope.todayYesterdayOnly ? true : false},
      {key: 'CUSTOM', value: 'מותאם אישית', disable: $scope.todayYesterdayOnly ? true : false}
    ];
    vm.MODESDATERANGE = [
      {
        key: 'THISMONTH', value: moment().format("MM/YYYY") + ' = ' + moment().subtract(1, 'year').format("MM/YYYY"),
        start: moment().day(1),
        end: moment().add('months', 1).date(0)
      },
      {
        key: 'LASTMONTH',
        value: moment().day(1).subtract(1, 'month').format("MM/YYYY") + ' = ' + moment().subtract(1, 'month').subtract(1, 'year').format("MM/YYYY"),
        start: moment().day(1).subtract(1, 'month'),
        end: moment().date(0)
      },
      {
        key: 'YEAR',
        value: moment().format("YYYY") + ' = ' + moment().subtract(1, 'year').format("YYYY"),
        start: moment().day(1).month(0),
        end: moment().day(31).month(11).hours(23)
      },
      {
        key: 'LASTYEAR',
        value: moment().subtract(1, 'year').format("YYYY") + ' = ' + moment().subtract(2, 'year').format("YYYY"),
        start: moment().day(1).month(0).subtract(1, 'year'),
        end: moment().day(31).month(11).subtract(1, 'year'),

      },
      // {key: 'CUSTOM', value: 'מותאם אישית'}
    ];
    vm.MODESDATE = $scope.rangeMode ? vm.MODESDATERANGE : vm.MODESDATE;
    vm.Mode = vm.MODESDATE[0].key;
    if ($scope.mode)
      vm.Mode = $scope.mode;
    vm.classActiveMode = function (mode) {
      return (mode == vm.Mode);
    }
    vm.selectMode = function (mode, event) {
      /*if (mode.key == 'CUSTOM') {
       customDate(event)
       vm.Mode = mode.key;
       vm.endDate = undefined;
       }*/
      if (vm.Mode == mode)
        return;
      vm.Mode = mode.key;
      console.log(vm.Mode.key);
      var Today = new Date();
      if ($scope.rangeMode) {
        $scope.dates = {start: mode.start.toDate(), end: mode.end.toDate()};
      }
      else {
        switch (mode.key) {
          case 'TODAY':
            vm.currentDate = Today;
            vm.endDate = undefined;
            break;
          case 'YESTERDAY':
            Today.setDate(Today.getDate() - 1);
            vm.currentDate = Today;
            vm.endDate = undefined;
            break;
          case 'WEEK':
            Today.setDate(Today.getDate() - 7);
            vm.currentDate = Today;
            vm.endDate = new Date();
            break;
          case 'MONTH':
            Today.setDate(Today.getDate() - 30);
            vm.currentDate = Today;
            vm.endDate = new Date();
            break;
          case 'CUSTOM':
            customDate(event)
            vm.endDate = undefined;
            break;
        }
        $scope.dates = {start: vm.currentDate, end: vm.endDate};
      }
      if (mode.key != 'CUSTOM')
        $timeout($scope.onChange, 500);
      // if (mode != 'CUSTOM')
      //   GetReport();

    }

    var customDate = function (ev) {
      $mdDialog.show({
        controller: 'DateDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/core/directives/date-between-buttons/date/date.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          Dates: $scope.dates//vm.currentDate
        }
      }).then(function (newDate) {
        if (newDate) {
          vm.currentDate = newDate.start;
          $scope.dates = {start: newDate.start, end: newDate.end};
          $timeout($scope.onChange, 500);
        }
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.shipping', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    $stateProvider.state('app.shipping', {
      url: '/reports/shipping',
      views: {
        'content@app': {
          templateUrl: 'app/main/shipping/shipping.html',
          controller: 'ShippingController as vm'
        }
      },
      resolve: {
        ReportDaily: function (orReportsService) {
          return orReportsService.ReportDaily;
        }
      }
    })


    msNavigationServiceProvider.saveItem('other.reports.shipping', {
      title: 'משלוחים',
      icon: 'icon-wallet-travel',
      state: 'app.shipping',
      weight: 2
    });

    // Api


  }

})();

/**
 * Created by itzik on 16/11/2017.
 */
(function () {
  'use strict';

  angular
    .module('app.shipping')
    .controller('ShippingController', ShippingController);

  /** @ngInject */
  function ShippingController(orContacts, $filter, ReportDaily, $mdDialog, $document, orUserAccount, msUtils, $mdToast, $state) {
    var vm = this;

    //vm.currentDate = orReportsService.dateReport();
    vm.report = ReportDaily;
    vm.place = orUserAccount.Place;
    vm.currentDate = new Date();
    vm.endDate;
    vm.dates = {
      start: moment().toDate(),
      end: moment().toDate()
    }
    vm.Reports = {Shipping: [], Shipped: []};


    vm.classActiveMode = function (mode) {
      return (mode == vm.Mode);
    }
    //function.


    var GetReport = function () {
      vm.proccess=true;
      orContacts.ShippingReport(vm.dates).then(function (result) {
        vm.proccess=false;
        console.log('Shipping');
        console.log(result);
        vm.Reports.Shipping.splice(0)
        vm.Reports.Shipped.splice(0)
        msUtils.setJsonObj(vm.Reports.Shipping, result.data.Shipping);
        msUtils.setJsonObj(vm.Reports.Shipped, result.data.Shipped);
      })
    }
    GetReport();

    var filterSelected = function () {
      if (vm.Reports && vm.Reports.Shipping)
        return $filter('filter')(vm.Reports.Shipping, {selected: true}).length;
      return false;
    }

    var DialogDelivery = function (ev) {
      var count = filterSelected();
      var confirm = $mdDialog.prompt()
        .title('הוצאת שליח עבור ' + count + ' צילומים')
        .textContent('נא לעדכן שם השליח')
        .placeholder('שם שליח')
        .ariaLabel('Dog name')
        //.initialValue()
        .targetEvent(ev)
        //.required(true)
        .ok('אישור')
        .cancel('ביטול');

      $mdDialog.show(confirm).then(function (deliver_name) {
        // if (!deliver_name) {
        //   $mdDialog.show(
        //     $mdDialog.alert()
        //     //.parent(angular.element(document.querySelector('#popupContainer')))
        //       .clickOutsideToClose(true)
        //       .title('שגיאה')
        //       .textContent('לא הוזן שם')
        //       .ariaLabel('Alert Dialog Demo')
        //       .ok('סגור')
        //       .targetEvent(ev)
        //   );
        // } else {
        if (!deliver_name)
          deliver_name = '';
        var selected = $filter('filter')(vm.Reports.Shipping, {selected: true});
        orContacts.DeliveryNow(selected, deliver_name).then(function (result) {
          if (result.status) {
            $mdToast.show(
              $mdToast.simple()
                .textContent('פרטי משלוח עודכנו בהצלחה')
                .position('top right')
                .hideDelay(3000)
            );
            console.log(result);
            vm.showCertificateShipping(result.data.lastId);
            GetReport();
          }
          console.log('DeliveryNow');
          console.log(result);
        })
        //alert(result)
        // }
      }, function () {
//        $scope.status = 'You didn\'t name your dog.';
      });
    }


    vm.filterSelected = filterSelected;
    vm.DialogDelivery = DialogDelivery;
    vm.refresh = function () {
      GetReport();
    }
    vm.showCertificateShipping = function (id) {
      $mdDialog.show({
        controller: 'MultySippingDetailsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/profile/dialog/shippingDetails/shippingDetails.html',
        parent: angular.element($document.find('#content-container')),
        //targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          ship_id: id,
          Place: orUserAccount.Place
        }
      }).then(function (id) {

      });
    }

  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.sample', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.sample', {
                url    : '/sample',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/sample/sample.html',
                        controller : 'SampleController as vm'
                    }
                },
                resolve: {
                    SampleData: function (msApi)
                    {
                        return msApi.resolve('sample@get');
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/sample');

        // Api
        msApiProvider.register('sample', ['app/data/sample/sample.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('fuse', {
            title : 'פציינטים',
            group : true,
            weight: 1
        });

        // msNavigationServiceProvider.saveItem('fuse.sample', {
        //     title    : 'Sample',
        //     icon     : 'icon-tile-four',
        //     state    : 'app.sample',
        //     /*stateParams: {
        //         'param1': 'page'
        //      },*/
        //     translate: 'SAMPLE.SAMPLE_NAV',
        //     weight   : 1
        // });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.sample')
        .controller('SampleController', SampleController);

    /** @ngInject */
    function SampleController(SampleData)
    {
        var vm = this;

        // Data
        vm.helloText = SampleData.data.helloText;

        // Methods

        //////////
    }
})();

(function () {
  'use strict';

  angular
    .module('app.reports_view', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    $stateProvider.state('app.reports_view', {


    }).state('app.reports_view.indebt', {
      views: {
        'content@app': {
          templateUrl: 'app/main/reports_view/reports_view.html',
          controller: 'Reports_viewController as vm'
        }
      },
      url: '/reports/indebt',
      resolve: {
        Report: function (msApi) {
          return msApi.resolve('data.reports.indebt@get');
        },
        Data: function (orReportsService) {
          return orReportsService.All_Reports('indept');
        }
      }
    }).state('app.reports_view.deposit', {
      views: {
        'content@app': {
          templateUrl: 'app/main/reports_view/reports_view.html',
          controller: 'Reports_viewController as vm'
        }
      },
      url: '/reports/deposit',
      resolve: {
        Report: function (msApi) {
          return msApi.resolve('data.reports.deposit@get');
        },
        Data: function (orReportsService) {
          return orReportsService.All_Reports('deposit');
        }
      }
    });
    msApiProvider.register('data.reports.indebt', ['app/data/reports/indebt.json']);
    msApiProvider.register('data.reports.deposit', ['app/data/reports/deposit.json']);


    msNavigationServiceProvider.saveItem('other.reports.indebt', {
      title: 'חובות פציינטים',
      rule: 1,
      icon: 'icon-currency-usd',
      state: 'app.reports_view.indebt',
      weight: 5
    });
    msNavigationServiceProvider.saveItem('other.reports.deposit', {
      title: 'פקדונות פציינטים',
      rule: 1,
      icon: 'icon-folder-lock',
      state: 'app.reports_view.deposit',
      weight: 5
    });
    // Api


  }

})();

(function () {
  'use strict';

  angular
    .module('app.reports_view')
    .controller('Reports_viewController', Reports_viewController);

  /** @ngInject */
  function Reports_viewController(Report, msUtils, $mdDialog, $mdToast, Data, $filter, orReportsService) {

    var vm = this;
    // data
    vm.Report = Report;

    Report.config.data = Data;
    vm.re_select = 1;
    vm.dates = {
      start: moment().toDate(),
      end: moment().toDate()
    };
    vm.reportType = 0;
    vm.table = Report.config;
    vm.strDate = moment(vm.dates.start).format('MMMM - YYYY');

    vm.refresh = function (dates) {
      vm.strDate = moment(vm.dates.start).format('MMMM - YYYY');
      console.log(dates);
      vm.submit();
    }
    vm.submit = function () {
      vm.proccess = true;
      orReportsService.All_Reports(Report.name, vm.dates).then(function (data) {
        console.log(data);
        Report.config.data = data;
        vm.proccess = false;
      });

    }


    var intervalCheck;
    vm.change = function () {
      if (intervalCheck)
        clearTimeout(intervalCheck);
      intervalCheck = setTimeout(deepSearch, 500);
    }

    var deepSearch = function (dates) {
      if (vm.search.length < 2 || vm.proccess)
        return;
      vm.proccess = true;

      // orAdminService.GetEmployessList(vm.search).then(function () {
      //   vm.proccess = false;
      // });

    }


  }

})();

(function () {
  'use strict';

  angular
    .module('app.reports_multy_view', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    $stateProvider.state('app.reports_multy_view', {}).state('app.reports_multy_view.alerts', {
      views: {
        'content@app': {
          templateUrl: 'app/main/reports_multy_view/reports_multy_view.html',
          controller: 'ReportsMulty_viewController as vm'
        }
      },
      url: '/reports/alerts',
      resolve: {

      }
    });


    msNavigationServiceProvider.saveItem('other.reports.alerts', {
      title: 'התראות',
      rule: 1,
      icon: 'icon-currency-usd',
      state: 'app.reports_multy_view.alerts',
      weight: 5
    });


  }

})();

(function () {
  'use strict';

  angular
    .module('app.reports_multy_view')
    .controller('ReportsMulty_viewController', ReportsMulty_viewController);

  /** @ngInject */
  function ReportsMulty_viewController( msUtils, $mdDialog, $mdToast, $filter, orReportsService) {

    var vm = this;
    // data

    //vm.Reports;

    // angular.forEach(vm.Reports, function (repo) {
    //   repo.config.data = [];
    // })
    vm.re_select = 1;
    vm.dates = {
      end: moment().toDate(),
      start: moment().add(-1, 'month').toDate()
    };
    vm.proccess = true;
    orReportsService.Alert_Reports(vm.dates).then(function (result) {
      vm.Reports = result;
      vm.proccess = false;
      vm.all_is_good = true;
      angular.forEach(result, function (item) {
        if (item.data.length) {
          vm.all_is_good = false;
          return;
        }
      })

    });
    vm.reportType = 0;
    // vm.table = Reports.config;
    vm.strDate = moment(vm.dates.start).format('MMMM - YYYY');

    vm.refresh = function (dates) {
      vm.strDate = moment(vm.dates.start).format('MMMM - YYYY');
      console.log(dates);
      vm.submit();
    }
    vm.submit = function () {
      vm.proccess = true;
      vm.all_is_good = false;
      orReportsService.Alert_Reports(vm.dates).then(function (result) {
        vm.proccess = false;
        vm.Reports = result;
        vm.all_is_good = true;
        angular.forEach(result, function (item) {
          if (item.data.length) {
            vm.all_is_good = false;
          }
          console.log("vm.all_is_good ", vm.all_is_good)
        })
      });

    }


    var intervalCheck;
    vm.change = function () {
      if (intervalCheck)
        clearTimeout(intervalCheck);
      intervalCheck = setTimeout(deepSearch, 500);
    }

    var deepSearch = function (dates) {
      if (vm.search.length < 2 || vm.proccess)
        return;
      vm.proccess = true;

      // orAdminService.GetEmployessList(vm.search).then(function () {
      //   vm.proccess = false;
      // });

    }


  }

})();

(function () {
  'use strict';

  angular
    .module('app.reports', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    $stateProvider.state('app.reports_daily', {
      url: '/reports/daily',
      views: {
        'content@app': {
          templateUrl: 'app/main/reports/reports.html',
          controller: 'ReportsController as vm'
        }
      },
      resolve: {
        ReportDaily: function (orReportsService) {
          return orReportsService.ReportDaily;
        }
      }
    })

    msNavigationServiceProvider.saveItem('other', {
      title: 'שונות',
      group: true,
      weight: 3
    });
    msNavigationServiceProvider.saveItem('other.reports', {
      title: 'דוחות',
      group: false,
      weight: 2
    });
    msNavigationServiceProvider.saveItem('other.reports.daily', {
      title: 'דוח יומי',
      icon: 'icon-cog',
      state: 'app.reports_daily',
      weight: 1
    });

    // Api


  }

})();

/**
 * Created by itzik on 16/11/2017.
 */
(function () {
  'use strict';

  angular
    .module('app.reports')
    .controller('ReportsController', ReportsController);

  /** @ngInject */
  function ReportsController(orReportsService, ReportDaily, orUserAccount) {
    var vm = this;

    vm.currentDate = orReportsService.dateReport();
    vm.report = ReportDaily;
    vm.place = orUserAccount.Place;
    vm.dates = {
      start: moment().toDate(),
      //end: moment().toDate()
    }
    //function.
    var changedate = function () {
      vm.proccess=true;
      orReportsService.RunReport(vm.dates).then(function (result) {
        vm.proccess=false;
        console.log('vm.report');
        console.log(vm.report);
      })
    }
    var printDaily = function () {
      printElement('dailyreport');
    }
    vm.ChangeDateReport = changedate
    vm.printDaily = printDaily
    orReportsService.RunReport(vm.dates).then(function (result) {
      //vm.report = result;
      console.log('vm.report');
      console.log(vm.report);
    })
    var printSection;

    function printElement(elem) {
      // // clones the element you want to print
      // var printSection = document.getElementById('printSection');
      // if (!printSection) {
      //   printSection = document.createElement('div');
      //   printSection.id = 'printSection';
      //   document.body.appendChild(printSection);
      // }
      // var domClone = elem.cloneNode(true);
      // printSection.innerHTML = '';
      // printSection.appendChild(domClone);
      window.print();
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.reffering_list', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    $stateProvider.state('app.reffering_list', {
      url: '/reffering_list',
      views: {
        'content@app': {
          templateUrl: 'app/main/reffering-list/reffering-list.html',
          controller: 'Reffering_listController as vm'
        }
      },
      resolve: {

        Refferings: function (orContacts) {
          return orContacts.ReferringList();
        },
        ReferringPlaceList: function (orContacts) {
          return orContacts.ReferringPlaceList();
        }


      }
    });


    msNavigationServiceProvider.saveItem('fuse.reffering_list', {
      title: 'הפניות רופאים',
      icon: 'icon-run',
      state: 'app.reffering_list',
      /*stateParams: {
       'param1': 'page'
       },*/
      // translate: 'SAMPLE.CONTACTS',
      weight: 6
    });





  }

})();

(function () {
  'use strict';

  angular
    .module('app.reffering_list')
    .controller('Reffering_listController', Reffering_listController);

  /** @ngInject */
  function Reffering_listController(Refferings, ReferringPlaceList, orContacts) {

    var vm = this;
    // data
    vm.ReferringPlaceList = ReferringPlaceList;
    vm.clients = ReferringPlaceList.data;
    console.log(ReferringPlaceList);
    vm.clientsSearch;

    vm.feilds = [
      //{key: 'ClientID', name: 'קוד לקוח'},
      {key: 'id', name: 'מספר הפניה'},
      {key: 'tz', name: 'מס זהות'},
      {key: 'fname', name: 'שם פרטי'},
      {key: 'lname', name: 'שם משפחה'},
      {key: 'phone', name: 'טלפון'},
      {key: 'date', name: 'תאריך', type: 'date'},
      {key: 'DoctorName', name: 'רופא'},
      {key: 'ClientID', name: 'מומש', type: "icon", icon: 'icon-check-circle', hideNull: true, class:'green-fg'}

    ];
    vm.config = {
      rowClick: {
        type: 'ref',
        ui_serf: 'app.newclient.prescription',
        params: [{key: 'prescription', value: 'id'}, {key: 'DoctorName', value: 'DoctorName'}]
      }
    }

    vm.refresh = function () {
      vm.clientsSearch = undefined;
      vm.proccess = true;
      orContacts.ReferringList(vm.search).then(function () {
        vm.proccess = false;
        vm.search = '';
        vm.clients = Refferings;
      });
      vm.isCustomSearch = false;

    }
    var intervalCheck;
    vm.typeSearch = function () {
      if (intervalCheck)
        clearTimeout(intervalCheck);
      intervalCheck = setTimeout(deepSearch, 500);
    }
    var deepSearch = function () {
      if (vm.search.length < 3 || vm.proccess)
        return;

      vm.refresh();

    }

    vm.clear = function () {
      Refferings.splice(0, Refferings.length);
      vm.clients = ReferringPlaceList.data;
    }
    vm.refreshAll = function () {
      vm.proccess = true;
      orContacts.ReferringPlaceList().then(function () {
        vm.proccess = false;
        vm.clients = ReferringPlaceList.data;
      });
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('app.contacts')
    .controller('ReferenceDialogController', ReferenceDialogController);

  /** @ngInject */
  function ReferenceDialogController($mdDialog, orContacts, Client, disabled) {
    var vm = this;

    vm.title = 'EDIT_CONTACT';
    vm.client = Client;
    vm.disabledOptions = disabled;
    vm.newContact = false;
    vm.allFields = false;
    vm.default_avatar = 'assets/images/avatars/profile.jpg';
    vm.contact = {};
    if (!vm.client.BituahID)
      vm.client.BituahID = 14;
    // Methods


    //////////
    vm.referenceList = [{reference_id: 'PO3445556', name: 'שלמה דוד'}, {reference_id: 'PO3445557', name: 'חדוה יוספה'},
      {reference_id: 'PO3445558', name: 'מירה ישראלי'}, {reference_id: 'PO3445547', name: 'שרית כהן'},
      {reference_id: 'PO3445559', name: 'הודיה דוד'}, {reference_id: 'PO3445527', name: 'חדוה לוי'}
    ];

    function loadReferenceMaccbi() {
      orContacts.References(vm.client.ClientName).then(function (result) {
        vm.referenceList = result;
      });
      //or.references
    }

    //loadReferenceMaccbi();
    function selectItem(item) {
      vm.client.HafnayaNumber = item.reference_id;
      closeDialog();
    }

    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }

    function submit() {
      $mdDialog.hide(vm.client);
    }

    vm.closeDialog = closeDialog;
    vm.selectItem = selectItem;
    vm.submit = submit;

  }
})();

(function () {
  'use strict';

  angular
    .module('app.referring', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.referring', {
        url: '/referring/:id',
        views: {
          'content@app': {
            templateUrl: 'app/main/referring/referring.html',
            controller: 'ReferringController as vm'
          }
        },
        resolve: {

          Referring: function (orContacts,$stateParams,$cookies) {
            var doctor_refID = $stateParams.id || $cookies.get('doctor_refID') || 1;
            $cookies.put('doctor_refID', doctor_refID);
            return orContacts.ReferringList(undefined,doctor_refID);
          },

          // Copies: function (msApi) {
          //   return msApi.resolve('or.referring.copies@get');
          // },
          CopiesList:function (orContacts) {
            return  orContacts.Prescription_photos();
          }
        }
      });


    // Navigation


    /*msNavigationServiceProvider.saveItem('refs.referring', {
      title: 'הפנייה',
      icon: 'icon-file-document',
      state: 'app.referring',

      weight: 2
    });*/
  }
})();

(function () {
  'use strict';

  angular
    .module('app.referring')
    .controller('ReferringController', ReferringController);

  /** @ngInject */
  function ReferringController(CopiesList,  Referring, $mdDialog, $filter, $mdToast, $state, $timeout) {
    var vm = this;

    //vm.doctor = AdminAccount;
    console.log('Referring');
    console.log(Referring);
    if (!Referring || !Referring.id) {
      $state.go('app.newclient');
      return;
    }
    vm.Referring = Referring;
    console.log('Copies');
    // console.log(Copies.data);
    // Copies = Copies.data;
    var photoesSelected = Referring.photos.split(',');
    photoesSelected.map(function (val, idx) {
      var ID = parseInt(val);
      var mainID = ID;
      if (ID > 100) {
        mainID =(parseInt(ID/100))
      }
      var it = $filter('filter')(CopiesList, {ID: mainID}, true)[0];
      console.log(it);
      if (it) {
        it.selected = true;
        if (it.radioOptions) {
          var x = $filter('filter')(it.radioOptions.options, {key: ID}, true)[0]
          it.option = (x ? x.value : undefined);
        }
      }
    });
    vm.Copies = CopiesList;
    vm.print = function () {
      window.print();
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.profile')
    .controller('ProfileController', ProfileController);

  /** @ngInject */
  function ProfileController(Profile, $mdToast, orContacts, Timeline, About, PhotosVideos, $mdDialog, $document, $timeout, $filter, $state, orUserAccount, Upload, insuranceService) {
    var vm = this;

    vm.profile = Profile;
    vm.anotherPlace = Profile.PlaceID != orUserAccount.Place.PlaceID;
    vm.isCurrentDay = moment(vm.profile.KDate).format('YYMMDD') == moment().format('YYMMDD');
    vm.copies = [];
    if (vm.profile.HafnayaDate)
      vm.profile.HafnayaDate = new Date(vm.profile.HafnayaDate);
    if ($state.params.allowedit && $state.params.allowedit == 'allowedit132')
      vm.adminstatus = true;
    if (!Profile || Profile.name == 'ERROR') {
      $timeout(function () {
        $state.go('app.contacts');
      }, 500)
      return;
    }
    vm.editprofile = false;
    //vm.countCopies = {count: 0, sum: 0}

    if (Profile.ClientBirthDate)
      vm.profile.ClientBirthDate = new Date(vm.profile.ClientBirthDate);
    if (!Profile.PhotosArr) {
      orContacts.LoadPhotos(Profile);
    }
    if (!Profile.Receipts) {
      orContacts.LoadReceipts(Profile);
    }
    if (!Profile.Deposits) {
      orContacts.LoadDeposits(Profile);
    }

    if (!Profile.Documents) {
      orContacts.LoadDocuments(Profile);
    }

    if (!Profile.Doctor) {

      orContacts.GetDoctorDetails(Profile.DoctorID).then(function (doctor) {
        Profile.Doctor = doctor;
      });
    }
    if (!Profile.InsuranseStatus) {
      orContacts.clientInsuranseStatus(Profile).then(function (result) {
        console.log("result", result)
      });
    }
    orContacts.GetEmployees().then(function (employees) {
      vm.employees = employees;

      if (!Profile.OvedID) {
        $timeout(function () {
          openDialogEmployee();
        }, 1600)

      }
    })

    vm.editProfileClick = function () {
      // if (Profile.PlaceID != orUserAccount.Place.PlaceID)
      //   showToast('לא ניתן לערוך , נא פנה לסניף בו בוצע הצילום')
      // else
      vm.editprofile = !vm.editprofile;

    }
    orContacts.GetFactorPays().then(function (factorPays) {
      console.log(factorPays);
      vm.factorPays = factorPays;
    });

    vm.updateClientDetails = function () {
      if (Profile.ClientBirthDate)
        Profile.ClientBirthDate = Profile.ClientBirthDate.getFullYear() + '-' + (Profile.ClientBirthDate.getMonth() + 1) + '-' + Profile.ClientBirthDate.getDate();

      orContacts.updateClientDetails(Profile).then(function (status) {
        var msg = status ? 'נשמר בהצלחה!' : 'ארעה תקלה. נסה לרענן ולבצע שנית';
        $mdToast.show(
          $mdToast.simple()
            .textContent(msg)
            .position('bottom right')
            .hideDelay(3000)
        );
      })
    }


    vm.payments = {sumCashPrice: 0, sumChekPrice: 0, sumCreditCardPrice: 0};

    vm.checksArr = [{date: new Date()}];


    // vm.sumChecks = function () {
    //   var sum = 0;
    //   vm.checksArr.forEach(function (element) {
    //     if (element.amount)
    //       sum += parseFloat(element.amount);
    //   });
    //   vm.payments.checks = sum;
    //   vm.payments.sumall = parseFloat(vm.payments.checks) + parseFloat(vm.payments.creditcard) + parseFloat(vm.payments.cash);
    //   return sum;
    //
    // }

    vm.payBycardOptions = {CLOSED: 0, AUTO: 1, MANUAL: 2}
    vm.payBycardStatus = vm.payBycardOptions.CLOSED;

    // Data
    vm.posts = Timeline.posts;
    vm.activities = Timeline.activities;
    vm.about = About.data;
    vm.photosVideos = PhotosVideos.data;

    // Methods
    vm.createInvoice = createInvoice;
    vm.openDialogEmployee = openDialogEmployee;
    vm.openCashDialog = openCashDialog;
    vm.openChecksDialog = openChecksDialog;
    vm.openCreditCardDialog = openCreditCardDialog;
    vm.updateInsurance = UpdateInsurance;
    vm.AllowEditInsurance = AllowEditInsurance;
    vm.RefundStatus = PreRefundStatus;
    vm.updateDoctorPrices = updateDoctorPrices;
    vm.editCopies = editCopies;
    vm.sendToInsuranse = sendToInsuranse;
    vm.closeCopyMode = closeCopyMode;
    vm.UpdateCopiesAndDoctor = UpdateCopiesAndDoctor;
    var confirm;
    vm.clientLeft = function (ev) {
      var msg = (Profile.ShulamSW ? 'האם ' + Profile.ClientName + ' עזב?' : 'ללקוח - ' + Profile.ClientName + ' קיים חוב! האם לשחרר בכל זאת?');
      //if (!Profile.ShulamSW) {
      confirm = $mdDialog.confirm()
        .title('שחרור לקוח')
        .textContent(msg)
        .ariaLabel('Lucky day')
        .targetEvent(ev)
        .ok('כן, שחרר לקוח')
        .cancel('לא, אני מתחרט');

      $mdDialog.show(confirm).then(function () {
        $mdToast.show(
          $mdToast.simple()
            .textContent('עודכן בהצלחה')
            .position('top right')
            .hideDelay(4000)
        );
        Profile.ZulamStatus = 5;
        Profile.TimeOUT = new Date();
        orContacts.updateClientLeft(Profile);
        $state.go('app.contacts');
      }, function () {
        //False
      }).finally(function () {
        confirm = undefined;
      });

      //}
    }

    vm.AcceptVisit = function (ev) {

      $mdDialog.show({
        controller: 'AcceptVisitController',
        controllerAs: 'vm',
        templateUrl: 'app/main/profile/dialog/acceptVisit/acceptVisit.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          client: Profile,
          Place: orUserAccount.Place
        }
      }).then(function (id) {

      });

    }
    vm.sendDocsToEmail = function (ev) {
      var confirm = $mdDialog.prompt()
        .title('שלח צילומים')
        .textContent('הזן כתובת מייל')
        .placeholder('לא זוהה כתובת מייל של הרופא, אנא הזן אותה כעת')
        .ariaLabel('Dog name')
        .initialValue(Profile.Doctor.Email1)
        .targetEvent(ev)
        //.required(true)
        .ok('שלח')
        .cancel('ביטול');

      $mdDialog.show(confirm).then(function (result) {
        orContacts.sendDocsToEmail(Profile.ClientID, Profile.TZ, Profile.ClientName, result);
        alertDialog("הצילומים נשלחו אל " + result, "Success")
      });
    }
    vm.OpenDocument = function (ev, doc) {

      $mdDialog.show({
        controller: 'ShowDocumentController',
        controllerAs: 'vm',
        templateUrl: 'app/main/profile/dialog/document/document.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        fullscreen: true,
        locals: {
          Doc: doc
        }
      }).then(function (id) {

      });

    }
    vm.OpenUploadDialog = function (ev) {

      $mdDialog.show({
        controller: 'UploadController',
        controllerAs: 'vm',
        templateUrl: 'app/main/profile/dialog/upload/upload.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        fullscreen: true,
        locals: {
          Profile: Profile
        }
      }).then(function (status) {

      });

    }
    vm.AddDocument = function (ev) {
      alertDialog('פעולה זו תתאפשר בקרוב', 'הוספת מסמך')
    }
    vm.SippingDetails = function (ev) {
      if (!Profile.MishloahID) {
        $mdToast.show(
          $mdToast.simple()
            .textContent('אין משלוח לפציינט זה.')
            .position('bottom right')
            .hideDelay(3000)
        );
        return;
      }
      $mdDialog.show({
        controller: 'SippingDetailsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/profile/dialog/shippingDetails/shippingDetails.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          client: Profile,
          Doctor: function () {
            return orContacts.GetDoctorDetails(Profile.DoctorID);
          },
          Place: orUserAccount.Place
        }
      }).then(function (id) {

      });

    }
    vm.RemoveClient = function (ev) {
      var msg;
      if (Profile.TimeOUT) {
        $mdToast.show(
          $mdToast.simple()
            .textContent('לא ניתן למחוק פציינט זה.')
            .position('top right')
            .hideDelay(3000)
        );
        return;
      }
      if (Profile.Receipts && Profile.Receipts.data.length) {
        $mdToast.show(
          $mdToast.simple()
            .textContent('לא ניתן למחוק פציינט לאחר קבלת תשלום.')
            .position('top right')
            .hideDelay(3000)
        );
        return;
      }
      if (Profile.Documents.length) {
        $mdToast.show(
          $mdToast.simple()
            .textContent('צילומים כבר שמורים לפציינט זה. עליך להסיר תחילה את הצילומים.')
            .position('top right')
            .hideDelay(3000)
        );
        return;
      }

      if (!Profile.ShulamSW) {
        msg = 'ללקוח - ' + Profile.ClientName + ' קיים חוב! האם למחוק בכל זאת?';
      } else {
        msg = 'ללקוח - האם למחוק את ' + Profile.ClientName + '  ?';
      }
      //if (!Profile.ShulamSW) {
      confirm = $mdDialog.confirm()
        .title('מחיקת לקוח')
        .textContent(msg)
        .ariaLabel('Lucky day')
        .targetEvent(ev)
        .ok('כן, מחק לקוח')
        .cancel('לא, ביטול');

      $mdDialog.show(confirm).then(function () {

        orContacts.removeClient(Profile).then(function (result) {
          var d = new Date();
          orContacts.resolveClients(d, true);
          console.log(result);
          $mdToast.show(
            $mdToast.simple()
              .textContent('עודכן בהצלחה')
              .position('top right')
              .hideDelay(4000)
          );
        });
        $state.go('app.contacts');
      }, function () {
        //False
      }).finally(function () {
        confirm = undefined;
      });

      //}
    }

    vm.printDetails = function (ev) {

      $mdDialog.show({
        controller: 'ClientDetailsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/profile/dialog/bonClient/bonClient.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          client: Profile,
          // Doctor: function () {
          //   return orContacts.GetDoctorDetails(Profile.DoctorID);
          // },
          Place: orUserAccount.Place
        }
      }).then(function (id) {
      });

    }
    vm.depositDialog = function (ev) {
      //321321
      var confirm = $mdDialog.prompt()
        .title('קבלת פיקדון')
        .textContent('הקש סכום שנתקבל פיקדון')
        .placeholder('הזן מחיר')
        .ariaLabel('Dog name')
        //.initialValue(max)
        .targetEvent(ev)
        //.required(true)
        .ok('אישור')
        .cancel('ביטול');

      $mdDialog.show(confirm).then(function (result) {
        if (isNaN(parseInt(result))) {
          alertDialog('שגיאה', 'מחיר לא תקין! - ניתן להזין מספר בלבד');
        } else {
          orContacts.AddDeposits(Profile, parseInt(result));

        }
      }, function () {
//        $scope.status = 'You didn\'t name your dog.';
      });
    }
    vm.depositCancelDialog = function (ev) {
      //321321
      var Dep = Profile.Deposits[Profile.Deposits.length - 1]
      confirm = $mdDialog.confirm()
        .title('שחרור פיקדון')
        .textContent('האם לשחרר פיקדון - ע"ס ' + Dep.sum + ' ש"ח? במידה והסכום מיועד לתשלום נא לבצע קבלת תשלום ')
        .ariaLabel('Lucky day')
        //.targetEvent(ev)
        .ok('אישור')
        .cancel('ביטול');

      $mdDialog.show(confirm).then(function () {
        orContacts.DelDeposits(Profile);
        //vm.profile.Deposits.splice(0, vm.profile.Deposits.length);
      });
    }
    function openDialogEmployee(ev) {
      /*if (Profile.ZulamStatus > 2) {
       $mdToast.show(
       $mdToast.simple()
       .textContent('לא ניתן לעדכן פציינט זה.')
       .position('bottom left')
       .hideDelay(3000)
       );
       return;
       }*/
      $mdDialog.show({
        controller: 'ProfileDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/profile/dialog/register_copyrator.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: false,
        escapeToClose: false,
        locals: {
          copyrators: vm.employees,
          employee: Profile.ovedName
        }
      }).then(function (id) {
        if (id) {
          var selected = $filter('filter')(vm.employees, {OvedID: id}, true)[0];
          Profile.OvedID = selected.OvedID;
          Profile.ovedName = selected.Name;
          Profile.ZulamStatus = (Profile.ZulamStatus < 2 ? 2 : Profile.ZulamStatus);
          orContacts.updateEmployeeOnClient(Profile);
        }// vm.copyrators
        // alert(data);
      });
    }

    function openCashDialog(ev) {
      calculateReceipt();
      gtag('event', 'click: add cache', {
        'event_category': 'billing',
        'event_label': Profile.ClientID
      });

      var max = (vm.refund ? vm.payments.RefundAmount : Profile.sumAll.topay - Profile.sumPaid)

      var confirm = $mdDialog.prompt()
        .title('קבלת מזומן')
        .textContent('הקש סכום שנתקבל במזומן ולחץ על אישור')
        .placeholder('הזן מחיר')
        .ariaLabel('Dog name')
        .initialValue(max)
        .targetEvent(ev)
        //.required(true)
        .ok('אישור')
        .cancel('ביטול');

      $mdDialog.show(confirm).then(function (result) {
        if (isNaN(parseInt(result))) {
          $mdDialog.show(
            $mdDialog.alert()
            //.parent(angular.element(document.querySelector('#popupContainer')))
              .clickOutsideToClose(true)
              .title('שגיאה')
              .textContent('מחיר לא תקין! - ניתן להזין מספר בלבד')
              .ariaLabel('Alert Dialog Demo')
              .ok('סגור')
              .targetEvent(ev)
          );
        } else {
          //Profile.Receipts.sumCashPrice = parseInt(result);
          vm.payments.sumCashPrice = parseInt(result);
          if (vm.refund)
            vm.payments.sumCashPrice *= -1;
          calculateReceipt();
        }
      }, function () {
//        $scope.status = 'You didn\'t name your dog.';
      });
    }

    function calculateReceipt() {
      //Profile.Receipts.sumAllRecepts = Profile.Receipts.sumCashPrice + Profile.Receipts.sumChekPrice + Profile.Receipts.sumCreditCardPrice;
      vm.payments.sumAllRecepts = vm.payments.sumCashPrice + vm.payments.sumChekPrice + vm.payments.sumCreditCardPrice;
    }

    function openChecksDialog(ev) {
      gtag('event', 'click: add checks', {
        'event_category': 'billing',
        'event_label': Profile.ClientID
      });
      var max = (vm.refund ? vm.payments.RefundAmount : Profile.sumAll.topay - Profile.sumPaid)
      calculateReceipt();
      $mdDialog.show({
        controller: 'ChecksDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/profile/dialog/checks/checks.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: false,
        escapeToClose: false,
        locals: {
          max: max,
          checksArr: vm.checksArr
        }
      }).then(function (checks) {
        if (checks) {
          vm.checksArr = checks;
          vm.payments.checks = checks
        }
        //Profile.Receipts.sumChekPrice = 0;
        var sumChecks = 0;
        for (var check in vm.payments.checks) {
          // Profile.Receipts.sumChekPrice += parseInt(vm.payments.checks[check].amount);
          sumChecks += parseInt(vm.payments.checks[check].amount);
        }
        vm.payments.sumChekPrice = sumChecks;
        if (vm.refund)
          vm.payments.sumChekPrice *= -1;
        calculateReceipt();

      });
    }

    function openCreditCardDialog(ev) {
      gtag('event', 'click: add creditCard', {
        'event_category': 'billing',
        'event_label': Profile.ClientID
      });
      calculateReceipt();
      var max = (vm.refund ? vm.payments.RefundAmount : Profile.sumAll.topay - Profile.sumPaid - vm.payments.sumAllRecepts)
      if (isNaN(max) || max == 0) {
        alertDialog(' לא ניתן לחייב סכום 0 ! ייתכן ועליך לאפס קבלת מזומנים. או נסה שנית', 'שגיאה');
        return;
      }
      $mdDialog.show({
        controller: 'CreditDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/profile/dialog/creditcard/creditcard.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: false,
        escapeToClose: false,
        locals: {
          max: max,
          lastcach: vm.payments.creditcard,
          Client: Profile,
          IsRefund: vm.refund,
          Place: orUserAccount.Place
        }
      }).then(function (pelecardDetails) {
        if (pelecardDetails) {
          vm.payments.pelecardDetails = pelecardDetails;
          // Profile.Receipts.sumCreditCardPrice = parseFloat(pelecardDetails.ResultData.DebitTotal) / 100;
          //debugger
          vm.payments.sumCreditCardPrice = parseFloat(pelecardDetails.ResultData.DebitTotal) / 100;
          if (vm.refund)
            vm.payments.sumCreditCardPrice *= -1;
          calculateReceipt();

          //if (vm.payments.sumAllRecepts == Profile.Receipts.firstToPay) {
          createInvoice(true);
          //}

        }
      });
    }


    function createInvoice(auto) {
      const eve = 'createInvoice ' + (auto ? 'AUTO' : 'CLICK');
      gtag('event', eve, {
        'event_category': 'billing',
        'event_label': Profile.ClientID
      });

      vm.proccess = true;
      orContacts.createInvoice(Profile, vm.payments).then(function (result) {
        console.log(result);
        if (result.status) {
          if (result.data.paidAll)
            Profile.ShulamSW = true;
          orContacts.LoadReceipts(Profile);
          $mdToast.show(
            $mdToast.simple()
              .textContent('החשבונית נוצרה. אנא המתן\י בעת מעבר להדפסת חשבונית')
              .position('top right')
              .hideDelay(3000)
          );
          //vm.proccess = false;
          $state.go('app.invoice_client.original', {id: result.data.receiptId, original: true})
        } else {
          vm.proccess = false;
          alertDialog("נסה שנית. אם תשלום הועבר באמצעות כרטיס אשראי אין להעביר שנית", "חשבונית לא נוצרה")
          /* $mdToast.show(
           $mdToast.simple()
           .textContent('שגיאה ביצירת חשבונית')
           .position('top right')
           .hideDelay(3000)
           );*/
        }
      });
    }

    function alertDialog(MSG, title) {
      $mdDialog.show(
        $mdDialog.alert()
        //.parent(angular.element(document.querySelector('#popupContainer')))
          .clickOutsideToClose(true)
          .title(title || 'שגיאה')
          .textContent(MSG)
          .ariaLabel('Alert Dialog Demo')
          .ok('סגור')
        //.targetEvent(ev)
      );
    }

    function showToast(MSG) {
      $mdToast.show(
        $mdToast.simple()
          .textContent(MSG)
          .position('bottom right')
          .hideDelay(3000)
      );
    }

    function AllowEditInsurance() {
      return;
      /*
       if (vm.editBituach) {
       vm.editBituach = false;
       return;
       }
       if (vm.profile.ShulamSW) {
       showToast('לא ניתן לעדכן לאחר קבלת תשלום')
       return;
       }
       vm.profile.BituahID_T = vm.profile.BituahID;
       vm.profile.HishtatfutPrice_T = vm.profile.HishtatfutPrice;
       if (vm.profile.BituahID == 1)
       vm.profile.HovotPhotosPrice_T = vm.profile.PhotosPrice;
       else
       vm.profile.HovotPhotosPrice_T = vm.profile.HovotPhotosPrice;
       vm.editBituach = true;
       */
    }

    function UpdateInsurance() {
      if (vm.profile.ShulamSW) {
        showToast('לא ניתן לעדכן לאחר קבלת תשלום')
        return;
      }


      var it = $filter('filter')(vm.factorPays, {BituahID: vm.profile.BituahID_T}, true)[0];
      if (it) {
        var oldIsInsurase = vm.profile.BituahID != 1;
        var newIsInsurase = vm.profile.BituahID_T != 1;
        if (oldIsInsurase != newIsInsurase) {
          if (vm.profile.BituahID == 1) {//old insure
            var s = vm.profile.PhotosPrice;
            vm.profile.HovotPhotosPrice = s;
            vm.profile.PhotosPrice = 0;
            vm.profile.HishtatfutPrice = vm.profile.HishtatfutPrice_T;
          } else {
            var s = vm.profile.HovotPhotosPrice;
            vm.profile.PhotosPrice = s;
            vm.profile.HovotPhotosPrice = 0;
            vm.profile.HishtatfutPrice = 0;
          }
        } else {
          vm.profile.HishtatfutPrice = vm.profile.HishtatfutPrice_T;
        }
        vm.profile.changeInsurance = (oldIsInsurase != newIsInsurase);
        vm.profile.bituachName = it.Name;
        vm.profile.BituahID = it.BituahID;

        //console.log(vm.profile);

        //firstToPay -> get new data from API.

      }
      vm.editBituach = false;
      orContacts.UpdateInsurance(vm.profile).then(function (result) {

        console.log(result);
        vm.profile.Receipts.firstToPay = (vm.profile.PhotosPrice + vm.profile.HishtatfutPrice ) - vm.profile.Receipts.sumAllRecepts;
        if (result.status)
          showToast('נשמר!');
        else
          showToast('ארעה שגיאה!');

      })


      // }


    }

    function PreRefundStatus(Receipt) {
      if (!Receipt)
        RefundStatus();
      else if (Profile.PlaceID != orUserAccount.Place.PlaceID)
        showToast('לא ניתן לערוך , נא פנה לסניף בו בוצע הצילום')
      else {
        var confirm = $mdDialog.prompt()
          .title('זיכוי לקוח')
          .textContent('נא לפנות למנהל לצורך אישור פעולת זיכוי')
          .placeholder('הקש קוד אישור מנהל')
          .ariaLabel('Dog name')
          //.initialValue(max)
          //.targetEvent(ev)
          //.required(true)
          .ok('אישור')
          .cancel('ביטול');

        $mdDialog.show(confirm).then(function (result) {
          if (isNaN(parseInt(result))) {
            alertDialog('מספר אישור לא תקין!', 'שגיאה');
          } else {
            vm.proccess = true;
            orContacts.CheckCreditPermission(Receipt, result).then(function (res) {
              vm.proccess = false;
              if (res.data)
                RefundStatus(Receipt);
              else
                alertDialog('קוד הרשאה שגוי', 'הרשאה חסומה');
            })
            //RefundStatus(Receipt);
          }
        }, function () {

        });
      }
    }

    function RefundStatus(Receipt) {
      vm.payments.sumCashPrice = 0;
      vm.payments.sumChekPrice = 0;
      vm.payments.sumCreditCardPrice = 0;

      calculateReceipt();

      if (Receipt) {
        vm.refund = true;
        vm.payments.RefundHeshbonitID = Receipt.HeshbonitID;
        vm.payments.RefundKabalaID = Receipt.KabalaID;
        vm.payments.RefundAmount = Receipt.sumAll;
      } else {
        vm.refund = false;
        vm.payments.RefundHeshbonitID = undefined;
        vm.payments.RefundKabalaID = undefined;
        vm.payments.RefundAmount = undefined;
      }
    }

    var OldCopies = [];

    function editCopies(ev) {

      if (Profile.PlaceID != orUserAccount.Place.PlaceID)
        showToast('לא ניתן לערוך , נא פנה לסניף בו בוצע הצילום')
      else {
        vm.editCopyMode = true;
        angular.copy(Profile.PhotosArr, OldCopies);
      }

    }

    function sendToInsuranse(ev) {

      const sendNow = function () {
        vm.proccess = true;
        orContacts.SendClaimToInsurance(Profile).then(function (status) {
          //showToast("status: " + status.data);
          alertDialog(status.status === true ? "הושלם בהצלחה" : (status.data && status.data.msg ? status.data.msg : "ארעה שגיאה"), "סטטוס הגשת צילום/תביעה")

          if (status) {
            orContacts.clientInsuranseStatus(Profile).then(function (result) {
              vm.proccess = false;
            });
          }
        })
      }
      console.log(Profile);
      if (Profile.InsuranseStatus.statusCode == 200) {
        confirm = $mdDialog.confirm()
          .title('שידור תביעה')
          .textContent("הצילומים הוגשו כבר! האם לשלוח שנית?")
          .ariaLabel('Lucky day')
          .targetEvent(ev)
          .ok('כן')
          .cancel('לא, בטל');

        $mdDialog.show(confirm).then(function () {
          sendNow();
        })
      } else
        sendNow();

      //showToast('פעולה זו אינה זמינה כרגע. - בקרוב...')
      return true;
    }

    function updateDoctorPrices() {
      console.log(vm.copies)
      console.log(vm.doctor)
    }

    function closeCopyMode() {
      vm.editCopyMode = false;
      Profile.PhotosArr.splice(0, Profile.PhotosArr.length);
      for (var ind in OldCopies) {
        Profile.PhotosArr.push(OldCopies[ind]);
      }
    }

    function UpdateCopiesAndDoctor() {
      vm.editCopyMode = false;
      if (vm.profile.ClientBirthDate)
        vm.profile.ClientBirthDate = vm.profile.ClientBirthDate.getFullYear() + '-' + (vm.profile.ClientBirthDate.getMonth() + 1) + '-' + vm.profile.ClientBirthDate.getDate();

      orContacts.UpdateCopiesAndDoctor(vm.profile).then(function (res) {
        console.log("result");
        console.log(res);

        //if (res.status) {
        showToast('הפרטים עודכנו בהצלחה')
        orContacts.LoadPhotos(Profile);
        orContacts.LoadReceipts(Profile);
        /*orContacts.LoadReceipts(vm.profile).then(function () {
         console.log('!!!')
         });*/
        // }else


      }, function (err) {
        showToast('שגיאה בעת עדכון נתונים')
      });
    }


    vm.documents = [
      {ID: 1, docName: 'abc', name: 'צילום נשך', date: '2018-01-14', PhotoID: 52},
      {ID: 2, docName: 'abc', name: 'הפנייה', date: '2018-01-14'},
      {ID: 3, docName: 'abc', name: 'המלצות רופא', date: '2018-01-14'}
    ];

    vm.upload = function (file) {
      if (!file.length)
        return;
      vm.uploadProccess = 'טוען';
      Upload.upload({

        url: orUserAccount.API_UPLOAD() + 'upload/' + Profile.ClientID,
        data: {file: file, 'username': '$scope.username'}
      }).then(function (resp) {
        console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
        vm.uploadProccess = 'טעינת קובץ הושלמה. אנא המתן...';
        clearProccessUpload();
        /*$timeout(function () {
         vm.uploadProccess = 'מעדכן נתונים...';
         clearProccessUpload();
         }, 1200)*/
        $timeout(function () {

          vm.uploadProccess = 'מעדכן נתונים...';
          reloadDocuments(vm.profile.Documents.length);
        }, 5000)

      }, function (resp) {
        console.log('Error status: ' + resp.status);
        vm.uploadProccess = 'ארעה שגיאה בטעינת קובץ';
        clearProccessUpload();
      }, function (evt) {
        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
        console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
        vm.uploadProccess = 'מעלה ' + progressPercentage + '% ';
      });
    };
    var clearProccessUpload = function () {
      $timeout(function () {
        vm.uploadProccess = undefined;
      }, 3000)
    }
    var reloadDocuments = function (lastLength) {
      console.log('reloadDocuments');
      console.log(lastLength);
      orContacts.LoadDocuments(Profile).then(function (r) {
        if (lastLength == vm.profile.Documents.length) {
          $timeout(function () {
            vm.uploadProccess = 'מעדכן נתונים...';
            reloadDocuments(vm.profile.Documents.length)
          });
        } else {
          vm.uploadProccess = 'הושלם!';
          clearProccessUpload()
        }

      });

    }
    vm.refresh = function () {
      orContacts.LoadPhotos(Profile);
      orContacts.LoadReceipts(Profile);
      orContacts.LoadDocuments(Profile);
      orContacts.GetDoctorDetails(Profile.DoctorID).then(function (doctor) {
        Profile.Doctor = doctor;
      });

    }
    vm.deleteDocument = function (Doc) {

      confirm = $mdDialog.confirm()
        .title('מחק מסמך')
        .textContent('האם להמשיך? - מחיקת מסמך זה לא יהיה ניתן לשחזור')
        .ariaLabel('Lucky day')
        //.targetEvent(ev)
        .ok('כן, אני מאשר')
        .cancel('לא, ביטול');

      $mdDialog.show(confirm).then(function () {

        orContacts.DeleteDocument(Doc).then(function (res) {
          if (res.status) {
            orContacts.LoadDocuments(Profile);
          }
        })
      })
    }


    vm.addReferrence = function (ev, photo) {


      var confirm = $mdDialog.prompt()
        .title('אסמכתא')
        .textContent('הקש מספר אסמכתא')
        .placeholder('אסמכתא')
        .ariaLabel('Dog name')
        .initialValue(photo.reference)
        .targetEvent(ev)
        //.required(true)
        .ok('אישור')
        .cancel('ביטול');

      $mdDialog.show(confirm).then(function (result) {
        if (isNaN(parseInt(result))) {
          $mdDialog.show(
            $mdDialog.alert()
            //.parent(angular.element(document.querySelector('#popupContainer')))
              .clickOutsideToClose(true)
              .title('שגיאה')
              .textContent('ערך אסמכתא אינו תקין!')
              .ariaLabel('Alert Dialog Demo')
              .ok('סגור')
              .targetEvent(ev)
          );
        } else {
          //Profile.Receipts.sumCashPrice = parseInt(result);
          photo.reference = result;


          insuranceService.UpdateStatusPhoto(photo).then(function (res) {
            vm.proccess = false;
            // if (!res.status)
            //   item.status = old_status;
            $mdToast.show(
              $mdToast.simple()
                .textContent(res && res.status ? 'OK' : "נכשל - ייתכן ומספר אסמכתא זה קיים כבר במערכת")
                .position('top right')
                .hideDelay(3000)
            );
          })


        }
      }, function () {
//        $scope.status = 'You didn\'t name your dog.';
      });

    }

    //Unusing!
    vm.addClalitOrder = function (ev, photo) {
      var confirm = $mdDialog.prompt()
        .title('קופ"ח כללית - הזמנת רכש')
        .textContent('הקש מספר הזמנת רכש')
        .placeholder('מספר הזמנת רכש')
        .ariaLabel('Dog name')
        .initialValue(photo.orderNumber)
        .targetEvent(ev)
        //.required(true)
        .ok('אישור')
        .cancel('ביטול');

      $mdDialog.show(confirm).then(function (result) {
        if (isNaN(parseInt(result))) {
          $mdDialog.show(
            $mdDialog.alert()
            //.parent(angular.element(document.querySelector('#popupContainer')))
              .clickOutsideToClose(true)
              .title('שגיאה')
              .textContent('ערך אסמכתא אינו תקין!')
              .ariaLabel('Alert Dialog Demo')
              .ok('סגור')
              .targetEvent(ev)
          );
        } else {
          //Profile.Receipts.sumCashPrice = parseInt(result);
          photo.reference = result;


          insuranceService.UpdateStatusPhoto(photo).then(function (res) {
            vm.proccess = false;
            // if (!res.status)
            //   item.status = old_status;
            $mdToast.show(
              $mdToast.simple()
                .textContent(res && res.status ? 'OK' : "נכשל - ייתכן ומספר אסמכתא זה קיים כבר במערכת")
                .position('top right')
                .hideDelay(3000)
            );
          })


        }
      }, function () {
//        $scope.status = 'You didn\'t name your dog.';
      });

    }

    //////////
  }


})();

(function ()
{
    'use strict';

    angular
        .module('app.notes')
        .controller('NotesController', NotesController);

    /** @ngInject */
    function NotesController($document, $timeout, $scope, $mdSidenav, NotesService, LabelsService, $mdDialog)
    {
        var vm = this;

        // Data
        vm.notes = NotesService.data;
        vm.labels = LabelsService.data;
        vm.search = '';
        vm.searchToolbar = false;
        vm.filters = {
            archive: false
        };
        vm.labelFilterIds = [];
        vm.noteListType = 'notes';

        // Methods
        vm.filterChange = filterChange;
        vm.openSearchToolbar = openSearchToolbar;
        vm.closeSearchToolbar = closeSearchToolbar;
        vm.editNote = editNote;
        vm.deleteLabel = deleteLabel;
        vm.toggleSidenav = toggleSidenav;
        vm.addNewLabel = LabelsService.addLabel;

        //////////

        /**
         * Change Notes Filter
         * @param type
         */
        function filterChange(type)
        {

            vm.noteListType = type;

            if ( type === 'notes' )
            {
                vm.labelFilterIds = [];
                vm.filters = {
                    archive: false
                };
            }
            else if ( type === 'archive' )
            {
                vm.labelFilterIds = [];
                vm.filters = {
                    archive: true
                };
            }
            else if ( type === 'reminders' )
            {
                vm.labelFilterIds = [];
                vm.filters = {
                    reminder: '',
                    archive : false
                };
            }
            else if ( angular.isObject(type) )
            {
                vm.labelFilterIds = [];
                vm.labelFilterIds.push(type.id);
            }

            $mdSidenav('main-sidenav').close();

        }

        /**
         * Edit Note
         * @param ev
         * @param noteId
         */
        function editNote(ev, noteId)
        {
            $mdDialog.show({
                template           : '<md-dialog ms-scroll><ms-note-form note-type="\'edit\'" note-id="\'' + noteId + '\'"></ms-note-form></md-dialog>',
                parent             : $document.find('#notes'),
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true
            });
        }

        /**
         * Delete Label
         * @param ev
         * @param label
         */
        function deleteLabel(ev, label)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the label?')
                .htmlContent('The "' + label.name + '" label will be deleted permanently.')
                .ariaLabel('delete label')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {
                LabelsService.deleteLabel(label);
            });
        }

        /**
         * Open Search Toolbar
         */
        function openSearchToolbar()
        {
            vm.searchToolbar = true;

            $timeout(function ()
            {
                angular.element($document.find('#search-notes-input')).trigger('focus');

            });

            $document.on('keyup', escKeyEvent);
        }

        /**
         * Close Search Toolbar
         */
        function closeSearchToolbar()
        {
            $scope.$evalAsync(function ()
            {
                vm.searchToolbar = false;
                vm.search = '';
            });

            $document.off('keyup', escKeyEvent);
        }

        /**
         * Escape key event
         */
        function escKeyEvent(e)
        {
            if ( e.keyCode === 27 )
            {
                closeSearchToolbar();
            }
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };

    }

})();
(function () {
  'use strict';

  angular
    .module('app.newclient', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.newclient', {
        url: '/newclient',
        views: {
          'content@app': {
            templateUrl: 'app/main/newclient/newclient.html',
            controller: 'NewclientController as vm'
          }
        },
        resolve: {
          ConfigureDefault: function (NotesService) {
            return NotesService.getDefaultSettings();
          }

        }
      }).state('app.newclient.prescription', {url: '/:prescription'});

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/newclient');

    // Api
    msApiProvider.register('sample', ['app/data/sample/sample.json']);

    // Navigation


    msNavigationServiceProvider.saveItem('fuse.newclient', {
      title: 'קליטת פציינט',
      icon: 'icon-account-plus',
      state: 'app.newclient',
      /*stateParams: {
       'param1': 'page'
       },*/

      weight: 3
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.newclient')
    .controller('NewclientController', NewclientController);

  /** @ngInject */
  function NewclientController(orUserAccount, orContacts, ConfigureDefault, $mdDialog, $filter, $mdToast, $state, $timeout, $document) {
    var vm = this;
    vm.progressing = false;
    var settingsDefualt;
    if (ConfigureDefault) {
      settingsDefualt = ($filter('filter')(ConfigureDefault.checklist, {key: 1}, true))[0];
    }
    vm.prescription = $state.params.prescription;

    //console.log(settingsDefualt);
    vm.formWizard = {

      placeName: orUserAccount.Place.Name,
      placeId: orUserAccount.Place.PlaceId,
      BituahID: 0,

      // TZ: 54654654, //TEMP
      // Tel: '054654654',//TEMP
      // ClientName: 'Itzik gr',//TEMP
      // ClientBirthDate: new Date(),//TEMP,
      // BituahID:14,//TEMP

      photosArr: [],
      MishloahSW: settingsDefualt && settingsDefualt.checked


    }

    if ($state.params.prescription) {
      orContacts.ReferringList(undefined, vm.prescription).then(function (result) {
        vm.prescriptionData = result;
        vm.formWizard.TZ = vm.prescriptionData.tz;
        vm.formWizard.ClientBirthDate = vm.prescriptionData.birthday ? new Date(vm.prescriptionData.birthday) : undefined;
        vm.formWizard.Tel = vm.prescriptionData.phone;
        vm.formWizard.ClientName = vm.prescriptionData.fname + ' ' + vm.prescriptionData.lname;
        vm.formWizard.HafnayaDate = vm.prescriptionData.date ? new Date(vm.prescriptionData.date) : undefined;
        vm.formWizard.HafnayaNumber = vm.prescriptionData.id;
        vm.formWizard.prescriptionID = vm.prescriptionData.id
        vm.formWizard.ClientNote = '';
        if (vm.prescriptionData.comments)
          vm.formWizard.ClientNote += vm.prescriptionData.comments + '\n';
        // if (vm.prescriptionData.teeth)
        //   vm.formWizard.ClientNote += '\nשיניים:' + vm.prescriptionData.teeth;
        orContacts.GetDoctorDetails(vm.prescriptionData.doctorid).then(function (doctor) {
          vm.formWizard.BituahID = 1;
          vm.formWizard.Doctor = doctor;
        });
        orContacts.Prescription_photos().then(function (result) {
          // orContacts.CopiesOfPrescription(vm.prescriptionData.photos).then(function (result) {
          var CopiesList = result;

          var photoesSelected = vm.prescriptionData.photos.split(',');
          // console.log("CopiesList", CopiesList.length);
          // console.log("photoesSelected", photoesSelected.length);
          var oldSelect = $filter('filter')(CopiesList, {selected: true});
          oldSelect.map(function (item, idx) {
            item.selected = false;
          })
          // console.log("countsel", oldSelect.length);
          // var oldSelect2 = $filter('filter')(CopiesList, {selected: true});
          // console.log("countsel2", oldSelect2.length);

          photoesSelected.map(function (val, idx) {
            var ID = parseInt(val);
            var mainID = ID;
            if (ID > 100) {
              mainID = (parseInt(ID / 100))
            }
            var it = $filter('filter')(CopiesList, {ID: mainID}, true)[0];
            console.log(it);
            if (it) {
              it.selected = true;

            }
          });
          vm.notes_prescription = '';
          if (vm.prescriptionData.teeth)
            vm.notes_prescription += 'שיניים:' + vm.prescriptionData.teeth;
          var x = $filter('filter')(CopiesList, {group_id: '!4', selected: true});
          if (x.length)
            vm.notes_prescription += '\n' + 'צילומים: ';
          x.map(function (item) {
            vm.notes_prescription += item.name + ', ';
          })
          var ct = $filter('filter')(CopiesList, {group_id: 4, selected: true}, true);
          if (ct.length)
            vm.notes_prescription += '\n' + 'העדפות סיטי: ';
          ct.map(function (item) {
            vm.notes_prescription += item.name + ', ';
          })
          vm.formWizard.ClientNote += vm.notes_prescription;
          vm.prescriptionData.photosArr = result;

        })

      });
    }
    vm.dialog_reference = function (ev, disabled) {
      $mdDialog.show({
        controller: 'ReferenceDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/reference_dialog/reference-dialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          Client: vm.formWizard,
          Place: {},
          disabled: disabled || false
        }
      }).then(function () {
      });
    }
    vm.dialogPrescription = function (ev) {


      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element(document.querySelector('#popupContainer')))
          .clickOutsideToClose(true)
          .title('פרטי הפניה ' + vm.prescriptionData.id)
          .textContent(vm.notes_prescription)
          .ariaLabel('Alert Dialog Demo')
          .ok('סגור')
          .targetEvent(ev)
      );

    }
    vm.places = [orUserAccount.Place];
    vm.placeSelcted = orUserAccount.Place.placeId;
    var CreateNewClient = function () {
      vm.progressing = true;
      // vm.formWizard.photosArr = $filter('filter')(vm.copies, {selected: true});
      var Tbituach = $filter('filter')(vm.factorPays, {BituahID: vm.formWizard.BituahID}, true)[0];
      vm.formWizard.bituachName = (Tbituach ? Tbituach.Name : '');
      vm.formWizard.DoctorID = vm.formWizard.Doctor.DoctorID;
      vm.formWizard.Sale = vm.formWizard.Doctor.Sale;
      if (vm.formWizard.ClientBirthDate)
        vm.formWizard.ClientBirthDate = vm.formWizard.ClientBirthDate.getFullYear() + '-' + (vm.formWizard.ClientBirthDate.getMonth() + 1) + '-' + vm.formWizard.ClientBirthDate.getDate();
      orContacts.CreateNewClient(vm.formWizard).then(function () {
        $mdToast.show(
          $mdToast.simple()
            .textContent('פציינט נוסף בהצלחה')
            .position('top right')
            .hideDelay(3000)
        );
        $timeout(function () {
          $state.go('app.contacts');
        }, 1500);

      }, function (err) {
        $mdToast.show(
          $mdToast.simple()
            .textContent('שגיאה - נסה שנית')
            .position('top right')
            .hideDelay(3000)
        );
      });
//or.clients.new
    }

    orContacts.GetDoctors().then(function (doctors) {
      console.log(doctors);
      vm.doctors = doctors;
    });
    orContacts.GetFactorPays().then(function (factorPays) {
      console.log(factorPays);
      vm.factorPays = factorPays;
    });
    vm.copies = [];
    vm.standrdInsurances = true;
    vm.selectDoctor = function (doctor) {
      console.log(doctor)
      vm.formWizard.DoctorID = doctor.DoctorID;
      vm.formWizard.doctorName = doctor.Name;
      vm.formWizard.Sale = doctor.Sale;
      if (doctor.KategoriaID == 2)
        vm.formWizard.BituahID = 2;
      if (doctor.agreementID) {
        vm.formWizard.BituahID = doctor.agreementID;
        vm.standrdInsurances = false;
      } else {
        if (!vm.standrdInsurances)
          vm.formWizard.BituahID = 1;
        vm.standrdInsurances = true;
      }
      //vm.DoctorNoteIN = doctor.NoteIN
      vm.DoctorNoteOUT = doctor.NoteOUT
      LoadCopiesDoctor(doctor);

    }
    vm.resetDoctor = function () {
      vm.formWizard.DoctorID = undefined;
      vm.formWizard.doctorName = undefined;
    }

    var LoadCopiesDoctor = function (doctor) {
      if (!vm.formWizard.DoctorID)
        return;
      orContacts.LoadPhotosDoctor(doctor).then(function (copies) {
        vm.copies = copies;
      })
    }
    vm.selectedCopy = function (copy) {
      if (copy.selected) {
        if (copy.priceFor == 'agreement') {
          vm.editHasmahta(copy);
        }
      }
    }
    vm.countCopies = {count: 0};

    vm.countselected = function () {
      // console.log('ss')
      var fil = vm.copies.filter(function (copy) {
        // console.log(copy)
        return copy.selected;
      });
      vm.countCopies.count = fil.length;
      vm.sumPrice = 0;
      for (var item in fil) {
        vm.sumPrice += fil[item].fixprice;
      }

      return fil.length;
    }

    vm.editPrice = function (copy, ev) {
      //copy.fixprice -= 10;

      // Appending dialog to document.body to cover sidenav in docs app
      var confirm = $mdDialog.prompt()
        .title('עדכן מחיר לצילום ' + copy.Name)
        .textContent('מחיר קודם: ' + copy.fixprice)
        .placeholder('הזן מחיר')
        .ariaLabel('Dog name')
        .initialValue(copy.fixprice)
        .targetEvent(ev)
        //.required(true)
        .ok('אישור')
        .cancel('ביטול');

      $mdDialog.show(confirm).then(function (result) {
        if (isNaN(parseInt(result))) {
          $mdDialog.show(
            $mdDialog.alert()
            //.parent(angular.element(document.querySelector('#popupContainer')))
              .clickOutsideToClose(true)
              .title('שגיאה')
              .textContent('מחיר לא תקין! - ניתן להזין מספר בלבד')
              .ariaLabel('Alert Dialog Demo')
              .ok('סגור')
              .targetEvent(ev)
          );
        } else {
          copy.fixprice = parseInt(result);
          copy.customfixprice = true;
        }
      }, function () {
//        $scope.status = 'You didn\'t name your dog.';
      });

    }

    vm.editHasmahta = function (copy, ev) {
      //copy.fixprice -= 10;

      // Appending dialog to document.body to cover sidenav in docs app
      var confirm = $mdDialog.prompt()
        .title('הוסף מספר אסמכתא ' + copy.Name)
        //.textContent('מחיר קודם: ' + copy.fixprice)
        .placeholder('מספר אסמכתא')
        .ariaLabel('Dog name')
        //.initialValue(copy.fixprice)
        .targetEvent(ev)
        //.required(true)
        .ok('אישור')
        .cancel('ביטול');

      $mdDialog.show(confirm).then(function (result) {
        if (isNaN(parseInt(result))) {
          $mdDialog.show(
            $mdDialog.alert()
            //.parent(angular.element(document.querySelector('#popupContainer')))
              .clickOutsideToClose(true)
              .title('שגיאה')
              .textContent('מספר לא תקין! - ניתן להזין מספר בלבד')
              .ariaLabel('Alert Dialog Demo')
              .ok('סגור')
              .targetEvent(ev)
          );
        } else {
          copy.Hasmahta = parseInt(result);
        }
      }, function () {
//        $scope.status = 'You didn\'t name your dog.';
      });

    }
    vm.sendForm = CreateNewClient;
    // Data

    // Methods

    //////////
  }
})();

(function () {
  'use strict';

  angular
    .module('app.invoice', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.invoice_client', {
        url: '/invoice/:id',
        views: {
          'content@app': {
            templateUrl: 'app/main/invoice/views/modern/modern.html',
            controller: 'InvoiceController as vm'
          }
        },
        resolve: {
          Invoice: function (orContacts, $stateParams) {
            return orContacts.getInvoice($stateParams.id)//84078139 msApi.resolve('invoice@get');
          }
        },
        bodyClass: 'invoice printable'
      })
      .state('app.invoice_client.original', {
        url: '/:original'
      });

    // Translation
    //$translatePartialLoaderProvider.addPart('app/main/invoice');

    // Api
    //msApiProvider.register('invoice', ['app/data/invoice/invoice.json']);
    /*
     // Navigation
     msNavigationServiceProvider.saveItem('fuse.invoice', {
     title : 'Invoice',
     icon  : 'icon-receipt',
     weight: 4
     });

     msNavigationServiceProvider.saveItem('fuse.invoice.modern', {
     title : 'Modern',
     state : 'app.invoice_client'
     });

     msNavigationServiceProvider.saveItem('fuse.invoice.compact', {
     title : 'Compact',
     state : 'app.pages_invoice_compact'
     });
     */
  }

})();

(function () {
  'use strict';

  angular
    .module('app.invoice')
    .controller('InvoiceController', InvoiceController);

  /** @ngInject */
  function InvoiceController(Invoice, $state,$timeout) {
    var vm = this;

    // Data
    vm.invoice = Invoice.data;
    vm.invoice.original = $state.params.original == 'true';
    // Methods
    vm.print = function () {
      window.print();
    }
    $timeout(function() {
      window.print();
    },1500);

    //////////
  }
})();

(function () {
  'use strict';

  angular
    .module('app.inventories')
    .controller('InventoriesController', InventoriesController);

  /** @ngInject */
  function InventoriesController(Inventories, inventoriesService, orContacts) {

    var vm = this;
    // data
    vm.inventories = Inventories;


    vm.clientsSearch;

    vm.feilds = [
      //{key: 'ClientID', name: 'קוד לקוח'},
      {key: 'ID', name: 'מספר הזמנה'},
      {key: 'name', name: 'שם'},
      {key: 'placeName', name: 'סניף'},
      {key: 'employeeName', name: 'שם עובד'},
      {key: 'status_name', name: 'סטאטוס'},
      {key: 'stokeeperName', name: 'מחסנאי'},
      {key: 'date_created', name: 'תאריך', type: 'date'},
      {key: 'comments_place', name: 'הערות'},
      {key: 'comments_stockeeper', name: 'הערות מחסן'}

    ];
    vm.config = {
      rowClick: {
        type: 'ref',
        ui_serf: 'app.inventories_order',
        params: [{key: 'order', value: 'ID'}]
      }
    }

    vm.refresh = function (reload) {
      vm.clientsSearch = undefined;
      vm.proccess = true;
      inventoriesService.Orders(vm.search,reload).then(function () {
        vm.proccess = false;
        vm.search = '';
        vm.inventories = Inventories;
      });
      vm.isCustomSearch = false;

    }
    var intervalCheck;
    vm.typeSearch = function () {
      if (intervalCheck)
        clearTimeout(intervalCheck);
      intervalCheck = setTimeout(deepSearch, 500);
    }
    var deepSearch = function () {
      if (vm.search.length < 3 || vm.proccess)
        return;

      vm.refresh();

    }

    vm.clear = function () {
      // Refferings.splice(0, Refferings.length);
      // vm.clients = ReferringPlaceList.data;
    }
    vm.refreshAll = function () {
      vm.proccess = true;
      // orContacts.ReferringPlaceList().then(function () {
      //   vm.proccess = false;
      //   vm.clients = ReferringPlaceList.data;
      // });
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('app.insurance_report', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    $stateProvider.state('app.insurance_report', {
      url: '/insurance_report',
      views: {
        'content@app': {
          templateUrl: 'app/main/insurance_report/insurance_report.html',
          controller: 'Insurance_reportController as vm'
        }
      },
      resolve: {
        Report: function (insuranceService) {
          var dateStart = new Date();
          dateStart.setMonth(new Date().getMonth() - 1)
          var dates = {
            start: dateStart,
            end: new Date()
          };
          return insuranceService.Reportinsurance(dates);
        }

      }
    });

    // msNavigationServiceProvider.saveItem('insurance', {
    //   title: 'ביטוחים',
    //   group: true,
    //   weight: 3
    // });
    msNavigationServiceProvider.saveItem('other.reports.insurance_report', {
      title: 'דוח ביטוחים',
      icon: 'icon-nature',
      state: 'app.insurance_report',
      badge: {
        content: 2,
        color: "red"
      },
      /*stateParams: {
       'param1': 'page'
       },*/
      // translate: 'SAMPLE.CONTACTS',
      weight: 1
    });


  }

})();

(function () {
  'use strict';

  angular
    .module('app.insurance_report')
    .controller('Insurance_reportController', Insurance_reportController);

  /** @ngInject */
  function Insurance_reportController($scope, $mdSidenav, msUtils, $mdDialog, $mdToast, $timeout, $state, $filter,
                                      insuranceService, Report, orUserAccount) {

    var vm = this;
    var setBadge = function () {
      $timeout(function () {
        try {
          $("div[ms-navigation-item] a .badge").text(Report.length);
        } catch (e) {}
      }, 3000);
    }
    vm.data = Report;
    setBadge();
    vm.proccess = false;
    vm.refresh = function () {
      vm.proccess = true;
      console.log(vm.dates);
      insuranceService.Reportinsurance(vm.dates).then(function (res) {
        vm.proccess = false;
        setBadge();
      });
    }
    var STATUSES = {DEFAULT: 1, SENT: 2, CONFIRMED: 10, PAID: 100}
    var changeStatus = function (item, status) {
      var old_status = item.status;
      item.status = status;
      vm.proccess = true;
      insuranceService.UpdateStatusPhoto(item).then(function (res) {
        vm.proccess = false;
        if (!res.status)
          item.status = old_status;
        $mdToast.show(
          $mdToast.simple()
            .textContent(res && res.status ? 'OK' : "נכשל - ייתכן ומספר אסמכתא זה קיים כבר במערכת")
            .position('top right')
            .hideDelay(3000)
        );
      })
    }
    vm.setStatusSent = function (item) {
      // if (item.InsuranceID == 14) {
      //   changeStatus(item, STATUSES.SENT);
      // } else {
      if (item.InsuranceID == 14) {
        var msg = "לא ניתן לבצע שליחה ידנית בקופת חולים כללית, השליחה מתבצעת על ידי המנהל עם קבלת מספר אסמכתא סופית";
        alert(msg)
        return;
      }
      var confirm = $mdDialog.prompt()
        .title('מספר אסמכתא')
        .textContent('הקש מספר אסמכתא')
        .placeholder('הזן 0 במידה ואין אסמכתא')
        .ariaLabel('אסמכתא')
        .initialValue(item.reference)
        //.targetEvent(ev)
        //.required(true)
        .ok('אשר וסמן כנשלח')
        .cancel('ביטול');

      $mdDialog.show(confirm).then(function (result) {
        if (result) {
          item.reference = result;
          changeStatus(item, STATUSES.SENT);
        }

      }, function () {

//        $scope.status = 'You didn\'t name your dog.';
      });
      // }
    }
    vm.setStatusDefault = function (item) {
      changeStatus(item, STATUSES.DEFAULT);
    }
    vm.setStatusConfirmed = function (item) {
      changeStatus(item, STATUSES.CONFIRMED);
    }
    vm.setStatusPaid = function (item) {
      changeStatus(item, STATUSES.PAID);
    }
    vm.changeStatusfilterMode = function () {
      if (vm.statusfilterMode) {
        vm.statusfilter = {status: 1}
      } else
        vm.statusfilter = undefined;
    }
    var dateStart = new Date();
    dateStart.setMonth(new Date().getMonth() - 1)
    vm.dates = {
      start: dateStart,
      end: new Date()
    }
    vm.sortBy = 'KDate';
    vm.changeSort = function (feild) {
      vm.sortBy = feild;
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.insurance', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    $stateProvider.state('app.insurance', {
      url: '/insurance',
      views: {
        'content@app': {
          templateUrl: 'app/main/insurance/insurance.html',
          controller: 'InsuranceController as vm'
        }
      },
      resolve: {
        InsurancePrices: function ($stateParams, insuranceService) {
         return insuranceService.InsurancePrices();
        }
        // Timeline: function ($stateParams, msApi) {
        //   return msApi.resolve('profile.timeline@get');
        // },
        // About: function (msApi) {
        //   return msApi.resolve('profile.about@get');
        // },
        // PhotosVideos: function (msApi) {
        //   return msApi.resolve('profile.photosVideos@get');
        // }
      },
      bodyClass: 'profile'
    })
    ;


    // Translation
    //$translatePartialLoaderProvider.addPart('app/main/profile');

    // Api

    // Navigation
    /*msNavigationServiceProvider.saveItem('reports.insurance', {
      title: 'ביטוחים',
      icon: 'icon-account-box',
      state: 'app.insurance',
      weight: 4
    });*/
  }

})();

(function () {
  'use strict';

  angular
    .module('app.insurance')
    .controller('InsuranceController', InsuranceController);

  /** @ngInject */
  function InsuranceController(InsurancePrices, $mdToast, orContacts, $mdDialog, $document, $timeout, $filter, $state, orUserAccount) {
    var vm = this;
    vm.InsurancePrices = InsurancePrices;
    orContacts.GetFactorPays().then(function (factorPays) {
      console.log(factorPays);
      vm.factorPays = factorPays;

    });
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

/**
 * Created by itzik on 20/11/2017.
 */
(function () {
  'use strict';

  angular
    .module('app.toolbar')
    .controller('employeesEntryController', employeesEntryController);

  /** @ngInject */
  function employeesEntryController($mdDialog, $rootScope, orContacts) {
    var vm = this;
    vm.modeLabels = {ENTRY: 'כניסה', LEAVE: 'יציאה'}
    vm.entryMode = true;
    vm.date = new Date();
    if (vm.date.getHours() > 13)
      vm.entryMode = false;
    vm.status = 'העבר כרטיס עובד'
    vm.cardLeft = cardLeft;
    vm.changemode = changemode;
    var intervalCheck;
    focusAutoCard();
    function focusAutoCard() {
      setTimeout(function () {
        $("#cardEmployee").focus();
      }, 1000);
    }

    function changemode() {
      focusAutoCard();
      vm.cardauto = '';
      vm.status = 'העבר כרטיס עובד'
    }

    function cardLeft() {

      if (intervalCheck)
        clearTimeout(intervalCheck);
      intervalCheck = setTimeout(run, 500);
    }

    function run() {
      vm.status = 'בודק...';
      orContacts.EmployeeActionEntry(vm.cardauto, vm.entryMode).then(function (result) {
        console.log(result);
        if (result.status) {
          if (vm.entryMode)
            vm.status = result.data.employee.Name + ', ברוך הבא';
          else
            vm.status = 'להתראות, ' + result.data.employee.Name + '!';
        } else {
          if (result.err && result.err.code == 'ETIMEOUT')
            vm.status = 'תקלה, נא נסה שנית';
          else if (result.err && result.err.code == 'Employee entried')
            vm.status = 'לא ניתן לרשום כניסה נוספת';
          else if (result.err && result.err.code == 'Employee is not entried')
            vm.status = 'לא ניתן לרשום יציאה - חסרה כניסה';
          else if (result.err && result.err.code == 'Max employees in this place')
            vm.status = 'המשמרת מלאה כרגע בסניפך. לא ניתן לבצע כעת כניסה';

          else
            vm.status = 'כרטיס אינו מזוהה. נסה שנית';
          focusAutoCard();
          vm.cardauto = '';
        }
        $rootScope.$$phase || $rootScope.$apply();
      })
      // console.log(vm.cardauto)
      // vm.status = (vm.entryMode ? vm.modeLabels.ENTRY : vm.modeLabels.LEAVE) + ' נקלט בהצלחה ';

    }
  }
})();

/**
 * Created by itzik on 25/12/2017.
 */
(function () {
  'use strict';

  angular
    .module('app.employee_report', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.employee_report', {
        url: '/employee_report',
        views: {
          'content@app': {
            templateUrl: 'app/main/employee-report/employee-report.html',
            controller: 'employee_reportController as vm'
          }
        },
        resolve: {

        },
        bodyClass: 'invoice printable'
      });
  }

})();

/**
 * Created by itzik on 25/12/2017.
 */
(function () {
  'use strict';

  angular
    .module('app.employee_report')
    .controller('employee_reportController', employee_reportController);

  /** @ngInject */
  function employee_reportController(orContacts) {
    var vm = this;
    //vm.card = 'ף7215701051762895=20105210000049511000.';
    vm.card = '';
    // vm.card = 'ף7215701051762895%3D20105210000049511000';
    var getData = function (thisMonth) {
      if (vm.card || (vm.employee && vm.employee.card)) {
        if (!vm.employee)
          vm.employee = {};
        vm.employee.name = 'בודק...';
        if (vm.card)
          vm.employee.card = vm.card;
        vm.month = undefined;
        orContacts.EmployeeReport(vm.employee.card, thisMonth).then(function (result) {

          if (result.status)
            vm.data = result.data.data;
          if (vm.data.length) {
            vm.employee.name = vm.data[0].Name;
            vm.month = vm.data[0].TimeIN;
            vm.SumAlltime=0;
            vm.data.map(function (item) {
              if(item.TimeOut&&item.TimeIN)
              {
                var mom=getDuration(item.TimeIN,item.TimeOut);
                vm.SumAlltime=moment.duration(vm.SumAlltime + mom);
                item.sum = ((mom.hours() + ':' + mom.minutes()+ ':' + mom.seconds()));//.humanize());
              }

            })
            vm.SumAlltime = ((((vm.SumAlltime.days()*24) +vm.SumAlltime.hours()) + ':' + vm.SumAlltime.minutes()+ ':' + vm.SumAlltime.seconds()));//.humanize());
            //vm.SumAlltime =vm.SumAlltime.humanize(3);
          } else
            vm.employee = undefined;
          vm.card = '';
          focusAutoCard();
        })
      }
    }
    var getDuration = function (start, end) {
      try {
        start = new Date(start), end = new Date(end);
       // console.log(moment.duration(end - start));
        var mom = moment.duration(end - start);
        return mom;
        //return  ((mom.hours() + ':' + mom.minutes()+ ':' + mom.seconds()));//.humanize());
      } catch (e) {
        return "Cant evaluate"
      }
    };
    var intervalCheck;

    function focusAutoCard() {
      setTimeout(function () {
        $("#cardEmployeeReprt").focus();
      }, 1000);
    }

    function cardLeft() {
      if (!vm.card)
        return;
      if (intervalCheck)
        clearTimeout(intervalCheck);
      intervalCheck = setTimeout(function () {
        getData(true);
      }, 500);
    }

    // getData(true);
    // Methods
    vm.getData = getData;
    vm.cardLeft = cardLeft;
    focusAutoCard();
    vm.print = function () {
      window.print();
    }
    //////////
  }
})();

(function () {
  'use strict';

  angular
    .module('app.contacts')
    .controller('ContactsController', ContactsController);

  /** @ngInject */
  function ContactsController($scope, $mdSidenav, msUtils, $mdDialog, $mdToast, $document, $state, $filter,
                              orContacts, orClients, orUserAccount, ConfigureDefault) {

    var vm = this;
    // data
    vm.clients = orClients;
    vm.date = orContacts.dateList();

    vm.isCustomSearch = orContacts.isCustomSearch();

//function
    vm.changedate = function () {
      vm.proccess = true;
      orContacts.resolveClients(vm.date).then(function (ee) {
        vm.proccess = false;
      });
      vm.isCustomSearch = false;


    }

    vm.classStatus = function (client) {
      // if (client.ShulamSW)
      if (client.paidAll)
        return '';

      switch (client.ZulamStatus) {
        case 1://open client. (no employee)
          return 'blue-fg';
        case 2://select card - select employee.
          return 'green-fg';
        default:
          if (!client.paidAll)
            return 'red-fg';
          return '';
      }
    }
    vm.refresh = function () {
      vm.proccess = true;
      orContacts.resolveClients(vm.date, true).then(function (e) {
        vm.isCustomSearch = false;
        vm.proccess = false;
      });

    }

    vm.isOpen = false;


    // Data
    vm.default_avatar = 'assets/images/avatars/profile.jpg';
    vm.contacts;

    orContacts.GetEmployees().then(function (employees) {
      vm.employees = employees;
    });
    // Methods
    vm.getNextData = getNextData;
    vm.filterChange = filterChange;
    vm.openContactDialog = openContactDialog;
    vm.deleteContactConfirm = deleteContactConfirm;
    vm.deleteContact = deleteContact;
    vm.deleteSelectedContacts = deleteSelectedContacts;
    vm.toggleSelectContact = toggleSelectContact;
    vm.deselectContacts = deselectContacts;
    vm.selectAllContacts = selectAllContacts;
    vm.deleteContact = deleteContact;
    vm.addNewGroup = addNewGroup;
    vm.deleteGroup = deleteGroup;
    vm.toggleSidenav = toggleSidenav;
    vm.toggleInArray = msUtils.toggleInArray;
    vm.advancedSearch = advancedSearch;
    vm.showConversation = showConversation;
    vm.mergeContacts = mergeContacts;
    vm.RemoveClient = function (Profile, ev) {
      var msg;
      if (Profile.TimeOUT) {
        $mdToast.show(
          $mdToast.simple()
            .textContent('לא ניתן למחוק פציינט זה.')
            .position('bottom left')
            .hideDelay(3000)
        );
        return;
      }
      if (Profile.Receipts && Profile.Receipts.data.length) {
        $mdToast.show(
          $mdToast.simple()
            .textContent('לא ניתן למחוק פציינט לאחר קבלת תשלום.')
            .position('top right')
            .hideDelay(3000)
        );
        return;
      }
      if (!Profile.unUploadPhoto) {
        $mdToast.show(
          $mdToast.simple()
            .textContent('צילומים כבר שמורים לפציינט זה. עליך להסיר תחילה את הצילומים.')
            .position('top right')
            .hideDelay(3000)
        );
        return;
      }
      if (!Profile.ShulamSW) {
        msg = 'ללקוח - ' + Profile.ClientName + ' קיים חוב! האם למחוק בכל זאת?';
      } else {
        msg = 'ללקוח - האם למחוק את ' + Profile.ClientName + '  ?';
      }
      //if (!Profile.ShulamSW) {
      confirm = $mdDialog.confirm()
        .title('מחיקת לקוח')
        .textContent(msg)
        .ariaLabel('Lucky day')
        .targetEvent(ev)
        .ok('כן, מחק לקוח')
        .cancel('לא, ביטול');

      $mdDialog.show(confirm).then(function () {

        orContacts.removeClient(Profile).then(function (result) {
          var d = new Date();
          orContacts.resolveClients(d, true);
          console.log(result);
          $mdToast.show(
            $mdToast.simple()
              .textContent('עודכן בהצלחה')
              .position('top right')
              .hideDelay(4000)
          );
        });
        // $state.go('app.contacts');
      }, function () {
        //False
      }).finally(function () {
        confirm = undefined;
      });

      //}
    }

    vm.openImportDialog = function (ev, key) {
      $mdDialog.show({
        controller: 'importContacts',
        controllerAs: 'vm',
        templateUrl: 'app/main/apps/contacts/dialogs/import/importContacts.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          key: key
        }
      });
    }

    var settingsSearchAllPlacesDefualt;
    if (ConfigureDefault) {
      settingsSearchAllPlacesDefualt = ($filter('filter')(ConfigureDefault.checklist, {key: 2}, true))[0];
      settingsSearchAllPlacesDefualt = settingsSearchAllPlacesDefualt && settingsSearchAllPlacesDefualt.checked;
    }
    vm.Search = function (ev) {



//321321
      $mdDialog.show({
        controller: 'ContactDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/contacts/dialogs/contact/contact-dialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          client: {},
          Place: {},
          SearchAllPlaces: settingsSearchAllPlacesDefualt
        }
      }).then(function (dataSearch) {
        if (!dataSearch)
          return;
        if (!dataSearch.TZ && !dataSearch.ClientName && !dataSearch.Tel && !dataSearch.KDate && !dataSearch.KDateEnd && !dataSearch.HeshbonitID && !dataSearch.MishloachID && !dataSearch.DoctorName) {
          var message = 'לא ניתן לבצע חיפוש. השלם לפחות שדה אחת';
          $mdToast.show({
            template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
            hideDelay: 3000,
            position: 'top right',
            parent: '#content'
          });
        } else {
          vm.proccess = true;
          orContacts.searchClients(dataSearch).then(function (e) {
            vm.proccess = false;
          });
          vm.isCustomSearch = true;
        }

      });

    }
    vm.sortBy = 'KDate';
    vm.changeSort = function (feild) {
      vm.sortBy = feild;
    }
    //edit contact - navigate from report/history
    if ($state.params.id) {
      vm.header = 'פציינטים למשלוח ' + $state.params.id;
    }


    var confirm;
    var printClient = function (Profile, ev) {

      $mdDialog.show({
        controller: 'ClientDetailsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/profile/dialog/bonClient/bonClient.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          client: Profile,
          // Doctor: function () {
          //   return orContacts.GetDoctorDetails(Profile.DoctorID);
          // },
          Place: orUserAccount.Place
        }
      }).then(function (id) {
      });

    };
    var SippingDetails = function (Profile, ev) {
      /* if (!Profile.MishloahID) {
       $mdToast.show(
       $mdToast.simple()
       .textContent('אין משלוח לפציינט זה.')
       .position('bottom right')
       .hideDelay(3000)
       );
       return;
       }*/
      $mdDialog.show({
        controller: 'SippingDetailsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/profile/dialog/shippingDetails/shippingDetails.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {
          client: Profile,
          Doctor: function () {
            return orContacts.GetDoctorDetails(Profile.DoctorID);
          },
          Place: orUserAccount.Place
        }
      }).then(function (id) {

      });

    };
    var clientLeft = function (Profile, ev) {
      var msg = (Profile.ShulamSW || !Profile.PhotosPrice ? 'האם ' + Profile.ClientName + ' עזב?' : 'ללקוח - ' + Profile.ClientName + ' קיים חוב! האם לשחרר בכל זאת?');
      //if (!Profile.ShulamSW) {
      confirm = $mdDialog.confirm()
        .title('שחרור לקוח')
        .textContent(msg)
        .ariaLabel('Lucky day')
        .targetEvent(ev)
        .ok('כן, שחרר לקוח')
        .cancel('לא, אני מתחרט');

      $mdDialog.show(confirm).then(function () {
        $mdToast.show(
          $mdToast.simple()
            .textContent('עודכן בהצלחה')
            .position('top right')
            .hideDelay(4000)
        );
        Profile.ZulamStatus = 5;
        Profile.TimeOUT = new Date();
        orContacts.updateClientLeft(Profile);
      }, function () {
        //False
      }).finally(function () {
        confirm = undefined;
      });

      //}
    };
    var clientBack = function (Profile, ev) {
      var msg = 'להחזיר לקוח - ' + Profile.ClientName + '?';
      //if (!Profile.ShulamSW) {
      confirm = $mdDialog.confirm()
        .title('חזרת לקוח')
        .textContent(msg)
        .ariaLabel('Lucky day')
        .targetEvent(ev)
        .ok('כן')
        .cancel('לא');

      $mdDialog.show(confirm).then(function () {
        $mdToast.show(
          $mdToast.simple()
            .textContent('עודכן בהצלחה')
            .position('top right')
            .hideDelay(4000)
        );
        Profile.ZulamStatus = (Profile.OvedID ? 2 : 1);
        Profile.TimeOUT = undefined;// new Date();
        orContacts.updateClientLeft(Profile);
      }, function () {
        //False
      }).finally(function () {
        confirm = undefined;
      });

      //}
    };
    var updateEmployee = function (Profile, ev) {
      /*if (Profile.ZulamStatus > 2) {
       $mdToast.show(
       $mdToast.simple()
       .textContent('לא ניתן לעדכן פציינט זה.')
       .position('bottom left')
       .hideDelay(3000)
       );
       return;
       }*/

      $mdDialog.show({
        controller: 'ProfileDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/profile/dialog/register_copyrator.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: false,
        escapeToClose: false,
        locals: {
          copyrators: vm.employees,
          employee: Profile.ovedName
        }
      }).then(function (id) {
        if (id) {
          var selected = $filter('filter')(vm.employees, {OvedID: id}, true)[0];
          Profile.OvedID = selected.OvedID;
          Profile.ovedName = selected.Name;
          Profile.ZulamStatus = (Profile.ZulamStatus < 2 ? 2 : Profile.ZulamStatus);
          orContacts.updateEmployeeOnClient(Profile);
        }// vm.copyrators
        // alert(data);
      });
    }
    vm.printClient = printClient;
    vm.SippingDetails = SippingDetails;
    vm.clientLeft = clientLeft;
    vm.clientBack = clientBack;
    vm.updateEmployee = updateEmployee;

    if ($state.params.key) {

      console.log($state.params.key);
      vm.openImportDialog(this, $state.params.key);
    }
    /**
     * Change Contacts List Filter
     * @param type
     */
    function filterChange(type) {

      vm.listType = type;

      if (type === 'all') {
        vm.filterIds = null;
      }
      else if (type === 'frequent') {
        vm.filterIds = vm.user.frequentContacts;
      }
      else if (type === 'starred') {
        vm.filterIds = vm.user.starred;
      }
      else if (angular.isObject(type)) {
        vm.filterIds = type.contactIds;
      }

      vm.selectedContacts = [];

    }

    /**
     * Open new contact dialog
     *
     * @param ev
     * @param contact
     */
    function openContactDialog(ev, contact) {

      console.log("***********************");
      console.log(contact);
      $mdDialog.show({
        controller: 'ContactDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/apps/contacts/dialogs/contact/contact-dialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          Contact: contact,
          User: vm.user,
          Contacts: vm.contacts,
          Merge: false,
          IsInConversation: false,
          numContacts: undefined
        }
      });
    }

    function openContactDialogByContact() {
      var findContact;

      var contactId = $state.params.contactId;
      findContact = $filter('filter')(vm.contacts, {contact_id: contactId})[0];
      console.log(findContact);

      if (findContact)//if contact doesn't exist...
        vm.openContactDialog(this, findContact);
      else {
        bon_Contacts.searchContacts(contactId, undefined)
          .then(function (response) {
            findContact = $filter('filter')(vm.contacts, {contact_id: contactId})[0];
            vm.openContactDialog(this, findContact)
          })
          .catch(function (error) {
          });
      }

    }


    /**
     * Delete Contact Confirm Dialog
     */
    function deleteContactConfirm(contact, ev) {
      var name = '';
      if (contact.name)
        name = contact.name + ' ';
      if (contact.last_name)
        name += contact.last_name;
      if (!name || name == '')
        name = '#' + contact.contact_id;

      name += name ? contact.lastName ? contact.lastName : '' : '#' + contact.contact_id;
      //DELETE_CONFIRM_1
      var DELETE_CONFIRM_1 = $filter('translate')('GLOBAL.DELETE_CONFIRM_1');
      var DELETE_CONFIRM_2 = $filter('translate')('GLOBAL.DELETE_CONFIRM_2');
      var DELETE_CONFIRM_3 = $filter('translate')('CONTACTS.DELETE_CONFIRM_3');
      var DELETE_CONFIRM_OK = $filter('translate')('GLOBAL.OK');
      var DELETE_CONFIRM_CANCEL = $filter('translate')('GLOBAL.CANCEL');
      var confirm = $mdDialog.confirm()
        .title(DELETE_CONFIRM_1 + " ?")
        .htmlContent('<b>' + name + '</b> &nbsp' + DELETE_CONFIRM_2)
        .ariaLabel(DELETE_CONFIRM_3)
        .targetEvent(ev)
        .ok(DELETE_CONFIRM_OK)
        .cancel(DELETE_CONFIRM_CANCEL);
      $mdDialog.show(confirm).then(function () {
        bon_Contacts.removeContact(contact);
        //validateDuplicateContacts();
        vm.selectedContacts = [];
        vm.subscription.usage.contacts.sumuse--;
        // deleteContact(contact);
      });
    }


    /**
     * Delete Contact
     */
    function deleteContact(contact) {
      vm.contacts.splice(vm.contacts.indexOf(contact), 1);
    }

    /**
     * Delete Selected Contacts
     */
    function deleteSelectedContacts(ev) {
      var confirm = $mdDialog.confirm()
        .title('Are you sure want to delete the selected contacts?')
        .htmlContent('<b>' + vm.selectedContacts.length + ' selected</b>' + ' will be deleted.')
        .ariaLabel('delete contacts')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        vm.selectedContacts.forEach(function (contact) {
          deleteContact(contact);
        });

        vm.selectedContacts = [];

      });

    }

    /**
     * Toggle selected status of the contact
     *
     * @param contact
     * @param event
     */
    function toggleSelectContact(contact, event) {
      if (event) {
        event.stopPropagation();
      }

      if (vm.selectedContacts.indexOf(contact) > -1) {
        vm.selectedContacts.splice(vm.selectedContacts.indexOf(contact), 1);
      }
      else {
        vm.selectedContacts.push(contact);
      }
    }

    /**
     * Deselect contacts
     */
    function deselectContacts() {
      vm.selectedContacts = [];
    }

    /**
     * Sselect all contacts
     */
    function selectAllContacts() {
      vm.selectedContacts = $scope.filteredContacts;
    }

    /**
     *
     */
    function addNewGroup() {
      if (vm.newGroupName === '') {
        return;
      }

      var newGroup = {
        'id': msUtils.guidGenerator(),
        'name': vm.newGroupName,
        'contactIds': []
      };

      vm.user.groups.push(newGroup);
      vm.newGroupName = '';
    }

    /**
     * Delete Group
     */
    function deleteGroup(ev) {
      var group = vm.listType;

      var confirm = $mdDialog.confirm()
        .title('Are you sure want to delete the group?')
        .htmlContent('<b>' + group.name + '</b>' + ' will be deleted.')
        .ariaLabel('delete group')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {

        vm.user.groups.splice(vm.user.groups.indexOf(group), 1);

        filterChange('all');
      });

    }

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    /**
     *  get next data
     *
     */
    function getNextData() {
      if (vm.isLoadingData)
        return;

      vm.isLoadingData = true;
      bon_Contacts.nextPageContacts()
        .then(function (response) {
          vm.isLoadingData = false;
        })
        .catch(function (error) {
          vm.isLoadingData = false;
        });
    }

    function advancedSearch() {
      if (!vm.showAdvancedSearch)
        return;
      if (!vm.search)
        return;
      vm.isAdvancedSearching = true;
      bon_Contacts.searchContacts(0, vm.search)
        .then(function (response) {
          vm.isAdvancedSearching = false;
          vm.showAdvancedSearch = false;
        })
        .catch(function (error) {
          vm.isAdvancedSearching = false;
          vm.showAdvancedSearch = false;
        })

      //api with vm.search
    }

    function showConversation(contact_id) {
      bon_Contacts.getDataByContactID(contact_id);
    }

    function mergeContacts() {
      if (vm.selectedContacts.length <= 1) {
        var message = $filter('translate')('CONTACTS.ERROR_MERGE')
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
          hideDelay: 3000,
          position: 'top right',
          parent: '.main'
        });
      }
      else {
        //save contacts id's in array
        vm.arrayId = [];
        for (var i = 0; i < vm.selectedContacts.length; i++) {
          vm.arrayId.push(vm.selectedContacts[i].contact_id);
        }
        vm.selectedContacts = [];
        //api
        vm.isLoadingData = true;
        bon_Contacts.mergeContacts(vm.arrayId)
          .then(function (response) {
            vm.contact = response.data;
            vm.isLoadingData = false;
            $mdDialog.show({
              controller: 'ContactDialogController',
              controllerAs: 'vm',
              templateUrl: 'app/main/apps/contacts/dialogs/contact/contact-dialog.html',
              parent: angular.element($document.find('#content-container')),
              targetEvent: this,
              clickOutsideToClose: true,
              locals: {
                Contact: vm.contact,
                User: undefined,
                Contacts: vm.contacts,
                Merge: true,
                IsInConversation: false,
                numContacts: vm.arrayId.length
              }
            })
          })
          .catch(function (error) {
            vm.isLoadingData = false;
          });

      }
    }


  }

})();

(function () {
  'use strict';

  angular
    .module('app.calendar')
    .controller('CalendarController', CalendarController);

  /** @ngInject */
  function CalendarController(CalanderEvents, $rootScope, $mdDialog, $document, orContacts, $filter, $log) {

    //TODO
    //1. load by month.. or more
    //2. dialog view
    //3. dialog edit
    //4. save new
    //5. update
    var vm = this;
    console.log(CalanderEvents);
    vm.eventSources = [];
    // Data
    var date = new Date();
    var d = date.getDate();
    var m = date.getMonth();
    var y = date.getFullYear();

    vm.events = [
      [
        {
          id: 1,
          title: 'All Day Event',
          start: new Date(y, m, 1),
          end: null
        },
        {
          id: 2,
          title: 'Long Event',
          start: new Date(y, m, d - 5),
          end: new Date(y, m, d - 2)
        },
        {
          id: 3,
          title: 'Some Event',
          start: new Date(y, m, d - 3, 16, 0),
          end: null
        },
        {
          id: 4,
          title: 'Repeating Event',
          start: new Date(y, m, d + 4, 16, 0),
          end: null
        },
        {
          id: 5,
          title: 'Birthday Party',
          start: new Date(y, m, d + 1, 19, 0),
          end: new Date(y, m, d + 1, 22, 30)
        },
        {
          id: 6,
          title: 'All Day Event',
          start: new Date(y, m, d + 8, 16, 0),
          end: null
        },
        {
          id: 7,
          title: 'Long Event',
          start: new Date(y, m, d + 12, 16, 0),
          end: null
        },
        {
          id: 8,
          title: 'Repeating Event',
          start: new Date(y, m, d + 14, 2, 0),
          end: null
        },
        {
          id: 9,
          title: 'Repeating Event',
          start: new Date(y, m, d + 14, 4, 0),
          end: null
        },
        {
          id: 10,
          title: 'Repeating Event',
          start: new Date(y, m, d + 14, 2, 0),
          end: null
        },
        {
          id: 11,
          title: 'Repeating Event',
          start: new Date(y, m, d + 14, 4, 0),
          end: null
        },
        {
          id: 12,
          title: 'Repeating Event',
          start: new Date(y, m, d + 14, 2, 0),
          end: null
        },
        {
          id: 13,
          title: 'Repeating Event',
          start: new Date(y, m, d + 14, 4, 0),
          end: null
        },
        {
          id: 14,
          title: 'Conference',
          start: new Date(y, m, d + 17, 4, 0),
          end: null
        },
        {
          id: 15,
          title: 'Meeting',
          start: new Date(y, m, d + 22, 4, 0),
          end: new Date(y, m, d + 24, 4, 0)
        }
      ]
    ];

    vm.events[0] = CalanderEvents;
    vm.calendarUiConfig = {
      calendar: {
        editable: true,
        eventLimit: true,
        header: '',
        handleWindowResize: false,
        aspectRatio: 1,
        dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        dayNamesShort: ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'],
        viewRender: function (view) {
          vm.calendarView = view;
          vm.calendar = vm.calendarView.calendar;
          vm.currentMonthShort = vm.calendar.getDate().format('MMM');
        },
        columnFormat: {
          month: 'ddd',
          week: 'ddd D',
          day: 'ddd M'
        },
        eventClick: eventDetail,
        selectable: true,
        selectHelper: true,
        select: select
      },
      calendarA: {
        height: 450,
        editable: true,
        header: {
          left: 'month basicWeek basicDay agendaWeek agendaDay',
          center: 'title',
          right: 'today prev,next'
        },
        // eventClick: $scope.alertEventOnClick,
        // eventDrop: $scope.alertOnDrop,
        // eventResize: $scope.alertOnResize
      }
    };

    // Methods
    vm.addEvent = addEvent;
    vm.next = next;
    vm.prev = prev;

    //////////

    /**
     * Go to next on current view (week, month etc.)
     */
    function next() {
      vm.calendarView.calendar.next();
    }

    /**
     * Go to previous on current view (week, month etc.)
     */
    function prev() {
      vm.calendarView.calendar.prev();
    }

    /**
     * Show event detail
     *
     * @param calendarEvent
     * @param e
     */
    function eventDetail(calendarEvent, e) {
      console.log(calendarEvent);
      showEventDetailDialog(calendarEvent, e);
    }

    /**
     * Add new event in between selected dates
     *
     * @param start
     * @param end
     * @param e
     */
    function select(start, end, e) {
      end = new Date(start);
      showEventFormDialog('add', false, start, end, e);
    }

    /**
     * Add event
     *
     * @param e
     */
    function addEvent(e) {
      var start = new Date(),
        end = new Date();

      showEventFormDialog('add', false, start, end, e);
    }

    /**
     * Show event detail dialog
     * @param calendarEvent
     * @param e
     */
    function showEventDetailDialog(calendarEvent, e) {
      //
      orContacts.calanderEvents().then(function (events) {
        var Event = $filter('filter')(events, {id: calendarEvent.id}, true)[0];

        $mdDialog.show({
          controller: 'EventDetailDialogController',
          controllerAs: 'vm',
          templateUrl: 'app/main/calendar/dialogs/event-detail/event-detail-dialog.html',
          parent: angular.element($document.body),
          targetEvent: e,
          clickOutsideToClose: true,
          locals: {
            calendarEvent: Event,
            showEventFormDialog: showEventFormDialog,
            event: e
          }
        });
      })

    }

    /**
     * Show event add/edit form dialog
     *
     * @param type
     * @param calendarEvent
     * @param start
     * @param end
     * @param e
     */
    function showEventFormDialog(type, calendarEvent, start, end, e) {
      var dialogData = {
        type: type,
        calendarEvent: calendarEvent,
        start: start,
        end: end
      };

      $mdDialog.show({
        controller: 'EventFormDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/calendar/dialogs/event-form/event-form-dialog.html',
        parent: angular.element($document.body),
        targetEvent: e,
        clickOutsideToClose: true,
        locals: {
          dialogData: dialogData
        }
      }).then(function (response) {
        var isnew = response.type === 'add';

          orContacts.Calander_AddEvent(response.calendarEvent,response.type).then(function (res) {
            $rootScope.$$phase || $rootScope.$apply();
          });
        if (response.type === 'add') {  // Add new

        }
        else {

        }
      });
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('app.bid', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    $stateProvider.state('app.bid', {
      url: '/bid',
      views: {
        'content@app': {
          templateUrl: 'app/main/bid/bid.html',
          controller: 'Bidontroller as vm'
        }
      },
      resolve: {

      }
    })


    msNavigationServiceProvider.saveItem('bid', {
      title: 'הצעת מחיר',
      icon: 'icon-file-find',
      state: 'app.bid',
      weight: 2
    });

    // Api


  }

})();

/**
 * Created by itzik on 16/11/2017.
 */
(function () {
  'use strict';

  angular
    .module('app.bid')
    .controller('Bidontroller', BidController);

  /** @ngInject */
  function BidController() {


  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'blue-grey',
                // name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'orange',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();

(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function () {
  'use strict';

  angular
    .module('app.orHashen', [])
    .factory('orContacts', orContactsService)
    .config(config);


  /** @ngInject */
  function orContactsService($q, $rootScope, $log, msApi, $filter, msUtils, orUserAccount) {
    var _clients;
    var _employees;
    var _doctors;
    var _factorPays;
    var _isCustomSearch;
    var _calnderEvents;
    // var _lastDate = new Date('2016-06-15');
    var _lastDate = new Date();

    function resolveClients(date, reload) {
      if (_isCustomSearch)
        reload = true;
      var deferred = $q.defer();
      if (!date && _lastDate)
        date = _lastDate;
      else if (!date)
        date = new Date();
      if (_clients && _lastDate == date && (!reload))//if send new date , alwise result new data.
      {
        deferred.resolve(_clients);
      }
      else {
        _lastDate = date;
        _isCustomSearch = false;
        var strDate = _lastDate.getFullYear() + '/' + (_lastDate.getMonth() + 1) + '/' + _lastDate.getDate();

        msApi.resolve('or.clients@get', {
          date: encodeURI(strDate),
          token: orUserAccount.AccountToken.token
        }).then(function (result) {
          // console.log(result);
          if (!_clients)
            _clients = result.data;
          else {
            _clients.splice(0, _clients.length);
            msUtils.setJsonObj(_clients, result.data);
          }
          deferred.resolve(_clients)
        }, function (e) {
          Invalid_OAuth(e, deferred.resolve)
        })
      }
      return deferred.promise;
    }

    function searchClients(dataSearch) {
      var deferred = $q.defer();
      _isCustomSearch = true;
      msApi.resolve('or.clients.search@save', {
        data: dataSearch,
        token: orUserAccount.AccountToken.token
      }).then(function (result) {
        // console.log(result);

        if (!_clients)
          _clients = result.data;
        else {
          _clients.splice(0, _clients.length);
          msUtils.setJsonObj(_clients, result.data);
        }
        deferred.resolve(_clients)
      }, function () {

        deferred.resolve([{name: 'ERROR'}]);
      })

      return deferred.promise;
    }

    function updateClientDetails(client) {
      var deferred = $q.defer();

      msApi.resolve('or.clients.single@save', {
        client: client,
        token: orUserAccount.AccountToken.token
      }).then(function (result) {
        deferred.resolve(result.status);
      }, function (e) {
        Invalid_OAuth(e, deferred.resolve)
      });
      return deferred.promise;

    }

    function SendClaimToInsurance(Client) {
      var deferred = $q.defer();
      msApi.resolve('or.client.insurance_sendclaim@save', {
        client: Client,
        token: orUserAccount.AccountToken.token
      }).then(function (result) {
        deferred.resolve(result);
      }, function (e) {
        Invalid_OAuth(e, deferred.resolve)
      });
      return deferred.promise;
    }

    function loadCustomClient(id) {
      var deferred = $q.defer();
      msApi.resolve('or.clients.single@get', {
        token: orUserAccount.AccountToken.token,
        clientid: id
      }).then(function (result) {
        deferred.resolve(result.data)
      }, function () {
        deferred.resolve({name: 'ERROR'});
      })
      return deferred.promise;
    }

    function clientInsuranseStatus(Client) {
      var deferred = $q.defer();
      if (Client.unUploadPhoto) {
        deferred.resolve();
        return deferred.promise;
      }
      // if (Client.InsuranseStatus)
      //   deferred.resolve(Client.InsuranseStatus);
      msApi.resolve('or.client.insuranse_status@get', {
        token: orUserAccount.AccountToken.token,
        clientid: Client.ClientID,
        insuranceid: Client.BituahID
      }).then(function (result) {
        Client.InsuranseStatus = result.data;
        deferred.resolve(Client.InsuranseStatus);
      }, function () {
        deferred.resolve({name: 'ERROR'});
      })
      return deferred.promise;
    }

    function getProfile(id) {
      if (!id && (_clients && _clients.length)) {
        return _clients[_clients.length - 1];
      }
      var profile;
      if (_clients)
        profile = $filter('filter')(_clients, {ClientID: parseInt(id)}, true)[0];
      if (profile)
        return profile;
      return loadCustomClient(id);
    }

    function LoadPhotos(Client) {
      msApi.resolve('or.client.copies@get', {
        token: orUserAccount.AccountToken.token,
        clientid: Client.ClientID
      }).then(function (result) {

        Client.PhotosArr = result.data.data;
        Client.sumAll = result.sumAll;

      });
    }

    function LoadReceipts(Client) {
      var deferred = $q.defer();
      msApi.resolve('or.client.receipts@get', {
        token: orUserAccount.AccountToken.token,
        clientid: Client.ClientID
      }).then(function (result) {
        if (!Client.Receipts)
          Client.Receipts = {};
        msUtils.setJsonObj(Client.Receipts, result)
        //Client.Receipts = result;
        Client.Receipts.firstToPay = (Client.PhotosPrice + Client.HishtatfutPrice ) - Client.Receipts.sumAllRecepts;
        deferred.resolve(true);
      });
      return deferred.promise;
    }

    function LoadDeposits(Client) {
      var deferred = $q.defer();
      msApi.resolve('or.deposits@get', {
        token: orUserAccount.AccountToken.token,
        clientid: Client.ClientID
      }).then(function (result) {
        if (!Client.Deposits)
          Client.Deposits = [];
        msUtils.setJsonObj(Client.Deposits, result.data)
        deferred.resolve(true);
      });
      return deferred.promise;
    }

    function AddDeposits(Client, sum) {
      var Deposits = {ClientID: Client.ClientID, sum: sum};
      var deferred = $q.defer();
      postAPI('or.deposits', {
        token: orUserAccount.AccountToken.token,
        data: Deposits
      }).then(function (result) {
        if (result.status) {
          Deposits.ID = result.data.lastid;
          Client.Deposits.push(Deposits);
        }
        deferred.resolve(result.status);
      });
      return deferred.promise;
    }

    function DelDeposits(Client) {
      var deferred = $q.defer();
      postAPI('or.deposits.del', {
        token: orUserAccount.AccountToken.token,
        data: Client.Deposits[Client.Deposits.length - 1]
      }).then(function (result) {
        if (result.status) {
          Client.Deposits.splice(Client.Deposits.length - 1, 1);
        }
        deferred.resolve(result.status);
      });
      return deferred.promise;
    }

    function LoadDocuments(Client) {
      var deferred = $q.defer();
      msApi.resolve('or.client.documents@get', {
        token: orUserAccount.AccountToken.token,
        clientid: Client.ClientID
      }).then(function (result) {
        if (!Client.Documents)
          Client.Documents = [];
        msUtils.setJsonObj(Client.Documents, result.data);
        deferred.resolve(true);
      });
      return deferred.promise;
    }

    function DeleteDocument(Doc) {
      return postAPI('or.client.documents.delete', {
        token: orUserAccount.AccountToken.token,
        data: Doc
      });
      //
    }

    function LinkUrlDownloadDocument(docName) {
      //return 'http://localhost:4900/documents/download/'+docName+'?token='+orUserAccount.AccountToken.token;
      return orUserAccount.API_UPLOAD() + 'download/' + docName + '?token=' + orUserAccount.AccountToken.token;
    }

    function DownloadDocument(docName) {
      var deferred = $q.defer();
      msApi.resolve('or.client.documents.name@get', {
        token: orUserAccount.AccountToken.token,
        docname: docName
      }).then(function (result) {

        deferred.resolve(result);
      });
      return deferred.promise;
    }

    function GetEmployees() {
      var deferred = $q.defer();
      if (_employees)
        deferred.resolve(_employees);
      else {
        msApi.resolve('or.employees@get', {
          token: orUserAccount.AccountToken.token
        }).then(function (result) {
          _employees = result.data;
          deferred.resolve(_employees);
        });
      }
      return deferred.promise;
    }

    function GetDoctors(search) {
      var deferred = $q.defer();
      if (_doctors && !search)
        deferred.resolve(_doctors);
      else {
        msApi.resolve('or.doctors@get', {
          token: orUserAccount.AccountToken.token,
          search: search
        }).then(function (result) {

          if (result.status) {
            if (!_doctors) {
              _doctors = [];
              msUtils.setJsonObj(_doctors, result.data);
            } else {
              msUtils.PushIfNotExsist(_doctors, result.data, 'DoctorID');
            }
          }
          deferred.resolve(_doctors);
        }, function (e) {
          Invalid_OAuth(e, deferred.resolve)
        });
      }
      return deferred.promise;
    }

    function GetDoctorDetails(doctor_id) {
      var deferred = $q.defer();

      msApi.resolve('or.doctor.detail@get', {
        token: orUserAccount.AccountToken.token,
        doctorid: doctor_id
      }).then(function (result) {

        deferred.resolve(result.data);
      });

      return deferred.promise;
    }

    function GetFactorPays() {
      var deferred = $q.defer();
      if (_factorPays)
        deferred.resolve(_factorPays);
      else {
        msApi.resolve('or.factorPays@get', {
          token: orUserAccount.AccountToken.token
        }).then(function (result) {
          _factorPays = result.data;
          deferred.resolve(_factorPays);
        });
      }
      return deferred.promise;
    }

    function LoadPhotosDoctor(doctor, insuranceID) {
      var deferred = $q.defer();
      msApi.resolve('or.doctor.copies@get', {
        token: orUserAccount.AccountToken.token,
        doctorid: doctor.DoctorID,
        percent: doctor.Sale,
        agreementid: doctor.agreementID,
        insuranceID: insuranceID
      }).then(function (result) {
        deferred.resolve(result.data);
      });
      return deferred.promise;
    }

    function CreateNewClient(client) {
      var deferred = $q.defer();
      msApi.resolve('or.clients.new@save', {
        token: orUserAccount.AccountToken.token,
        client: client
      }).then(function (result) {
        if (result.status) {
          if (_clients) {
            _clients.push(result.client)
          }
          var da = new Date();
          resolveClients(da, true);
        }

        deferred.resolve(result.status);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    }

    function updateEmployeeOnClient(client) {
      return postAPI('or.clients.employee', {client: client, token: orUserAccount.AccountToken.token});
    }

    function updateClientLeft(client) {
      return postAPI('or.clients.left', {client: client, token: orUserAccount.AccountToken.token});
    }

    function removeClient(client) {
      return postAPI('or.clients.delete', {client: client, token: orUserAccount.AccountToken.token});
    }


    function checkCreditPermission(Receipt, number) {
      return postAPI('or.billing.invoice.permissioncredit', {
        data: {
          KabalaID: Receipt.KabalaID,
          permission: number
        },
        token: orUserAccount.AccountToken.token
      });
    }

    function checkDiscountPermission(number) {
      return postAPI('or.billing.invoice.discountpermission', {
        data: {
          permission: number
        },
        token: orUserAccount.AccountToken.token
      });
    }

    function pelecardPay(client, card) {
      var deferred = $q.defer();
      msApi.resolve('or.billing.pelecard@save', {
        token: orUserAccount.AccountToken.token,
        client: client,
        card: card
      }).then(function (result) {
        deferred.resolve({status: result, pelecard: result.result});
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    }

    function pelecardCheckPay(client, card) {
      var deferred = $q.defer();
      msApi.resolve('or.billing.pelecard.check@save', {
        token: orUserAccount.AccountToken.token,
        client: client,
        card: card
      }).then(function (result) {
        deferred.resolve({status: result, pelecard: result.result});
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    }

    function getInvoice(id) {
      return GetAPI('or.billing.invoice.customer', {id: id, token: orUserAccount.AccountToken.token});
    }

    function createInvoice(client, paymentsDetails) {
      var deferred = $q.defer();
      msApi.resolve('or.billing.invoice@save', {
        token: orUserAccount.AccountToken.token,
        client: client,
        payment: paymentsDetails
      }).then(function (result) {
        resolveClients(undefined, true);//for refreshing..
        deferred.resolve(result);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    }

    function postAPI(api, data) {
      var deferred = $q.defer();
      msApi.resolve(api + '@save', data).then(function (result) {
        deferred.resolve(result);
      }, function (err) {
        if (err.status == 401) {
          orUserAccount.LogOut();
          $rootScope.$broadcast('user:logout');
        }
        deferred.reject(err);
      });
      return deferred.promise;
    }

    function GetAPI(api, data) {
      if (!data)
        data = {};
      if (!data.token)
        data.token = orUserAccount.AccountToken.token;
      var deferred = $q.defer();
      msApi.resolve(api + '@get', data).then(function (result) {
        deferred.resolve(result);
      }, function (err) {
        if (err.status == 401) {
          orUserAccount.LogOut();
          $rootScope.$broadcast('user:logout');
        }
        deferred.reject(err);
      });
      return deferred.promise;
    }

    function EmployeeActionEntry(card, mode) {
      var modeS = (mode ? 'entry' : 'left');
      return postAPI('or.employees.entry', {token: orUserAccount.AccountToken.token, card: card, mode: modeS})
    }

    function EmployeeReport(card, thisMonth) {
      var modeS = (thisMonth == true);
      return GetAPI('or.employees.report', {token: orUserAccount.AccountToken.token, card: card, currentmonth: modeS})
    }

    function shippingReport(dates) {
      return GetAPI('or.shipping.report', {
        date: dates.start,
        dateend: dates.end,
        token: orUserAccount.AccountToken.token
      });
    }

    function deliveryNow(clients, deliver_name) {
      return postAPI('or.shipping.delivery', {
        clients: clients,
        deliver_name: deliver_name,
        place_name: orUserAccount.Place.Name,
        token: orUserAccount.AccountToken.token
      });
    }

    function shippingCertificate(ship_id) {
      return GetAPI('or.shipping.certificate', {ship_id: ship_id, token: orUserAccount.AccountToken.token});
    }

    function updateInsurance(client) {
      return postAPI('or.clients.insurance', {token: orUserAccount.AccountToken.token, client: client})

    }

    function updateCopiesAndDoctor(client) {
      //? remove... update an api
      var deferred = $q.defer();
      if (client.Doctor) {
        client.DoctorID = client.Doctor.DoctorID;
        if (client.BituahID == 1)
          client.PhotosPrice = client.countCopies.sum;
        else
          client.HovotPhotosPrice = client.countCopies.sum;
      }
      postAPI('or.clients.copies', {token: orUserAccount.AccountToken.token, client: client}).then(function (result) {
        if (result.status)
          return loadCustomClient(client.ClientID);
        else
          deferred.reject({status: false, err: 'err'});
      }).then(function (clientUpdated) {

        msUtils.setJsonObj(client, clientUpdated);
        if (_clients) {
          var profile = $filter('filter')(_clients, {ClientID: client.ClientID}, true)[0];
          if (profile) {
            msUtils.setJsonObj(profile, clientUpdated);
            deferred.resolve(profile);
          }
        } else {
          deferred.resolve(clientUpdated);
        }
      })
      return deferred.promise;


    }

    function clearContacts() {
      _clients = undefined;
      _calnderEvents = undefined;
    }

    function checkReferenceExist(number) {
      return postAPI('or.client.checkReferenceExist', {
          code: number,
            token: orUserAccount.AccountToken.token
      });
    }
    //CALANDER
    function calanderEvents() {
      //or.calander

      var deferred = $q.defer();
      if (_calnderEvents)
        deferred.resolve(_calnderEvents);
      else {
        //var strDate = _lastDate.getFullYear() + '/' + (_lastDate.getMonth() + 1) + '/' + _lastDate.getDate();

        msApi.resolve('or.calander@get', {
          token: orUserAccount.AccountToken.token
        }).then(function (result) {
          // console.log(result);

          if (!_calnderEvents)
            _calnderEvents = result.data;
          else {
            msUtils.setJsonObj(_calnderEvents, result.data);
          }
          deferred.resolve(_calnderEvents)
        }, function () {

          deferred.resolve([{name: 'ERROR'}]);
        })
      }
      return deferred.promise;
    }

    function Calander_AddEvent(item, action) {
      var deferred = $q.defer();

      var event = {
        id: item.id,
        title: item.title,
        start: item.start,
        end: item.end,
        notes: item.notes,
        phone: item.phone
      };
      msApi.resolve('or.calander@save', {
        token: orUserAccount.AccountToken.token,
        isnew: action,
        event: event
      }).then(function (result) {
        var Eitem;
        if (action == 'add')
          _calnderEvents.push(result.data);
        else if (action == 'delete') {
          Eitem = $filter('filter')(_calnderEvents, {id: event.id}, true)[0];
          if (Eitem) {
            msUtils.setJsonObj(Eitem, {title: '', start: '2000-01-01', end: '2000-01-01'});
          }
        }
        else {
          Eitem = $filter('filter')(_calnderEvents, {id: event.id}, true)[0];
          if (Eitem)
            msUtils.setJsonObj(Eitem, event);
        }
        deferred.resolve([{status: true}]);
      });

      return deferred.promise;
    }

    var _referringList = [];
    var ReferringList = function (search, id) {
      var deferred = $q.defer();
      if (!search && !id)
        deferred.resolve(_referringList);
      else {
        GetAPI('or.referringdoctors', {search: search, id: id}).then(function (result) {
          if (result.status)
            msUtils.setJsonObj(_referringList, result.data);
          deferred.resolve(_referringList);
        });
      }
      return deferred.promise;
    }
    var _referringPlaceData = {data: []};
    var ReferringPlaceList = function () {
      var deferred = $q.defer();

      GetAPI('or.referringdoctors').then(function (result) {
        if (result.status)
          msUtils.setJsonObj(_referringPlaceData.data, result.data);
        _referringPlaceData.sum = _referringPlaceData.data.length;
        _referringPlaceData.sumVisited = $filter('filter')(_referringPlaceData.data, {ClientID: ''}).length;
        deferred.resolve(_referringPlaceData);
      });
      return deferred.promise;
    }

    var _prescription_photos;

    function Prescription_photos() {
//All prescription_copies
      var deferred = $q.defer();
      if (_prescription_photos)
        deferred.resolve(_prescription_photos);
      else {
        _prescription_photos = [];
        GetAPI('or.copies_list').then(function (result) {
          if (result.status)
            msUtils.setJsonObj(_prescription_photos, result.data);
          deferred.resolve(_prescription_photos);
        });
      }
      return deferred.promise;
      //return ResolveApi('or.copies_list', _prescription_photos);
    }

    var _references_maccabi = [];

    function References(search) {
      var deferred = $q.defer();
      GetAPI('or.references',{search:search}).then(function (result) {
        msUtils.setJsonObj(_references_maccabi, result.data);
        deferred.resolve(_references_maccabi);
      })
      return deferred.promise;

    }

    /*function CopiesOfPrescription(copiesIDs) {
     return GetAPI('or.prescription_copies', {copies: copiesIDs});
     }*/
    /*
     function ResolveApi(api, mainParameter) {
     var deferred = $q.defer();
     if (mainParameter)
     deferred.resolve(mainParameter);
     else
     GetAPI(api, {token: orUserAccount.AccountToken.token}).then(function (result) {
     if (result.status) {
     mainParameter = result.data;
     }
     deferred.resolve(mainParameter);
     }, function (err) {
     deferred.resolve({});
     })
     return deferred.promise;

     }
     */
    var Invalid_OAuth = function (err, resolve) {

      if (err.status == 401) {
        orUserAccount.LogOut();
        $rootScope.$broadcast('user:logout');
      }

      resolve([{name: 'ERROR'}]);
      /*function (e) {
       if (e.status == 401)
       orUserAccount.LogOut();
       deferred.resolve([{name: 'ERROR'}]);
       }*/
    }

    // function Copiesclient(id) {
    //   var deferred = $q.defer();
    //   msApi.resolve('or.client.copies@get', {clientid: id}).then(function (result) {
    //     deferred.resolve(result.data)
    //   }, function () {
    //     deferred.resolve([]);
    //   })
    //   return deferred.promise;
    // }
    function sendDocsToEmail(client_id, tz,name, email) {
      return postAPI('or.client.files.send', {
        client_id: client_id,
        tz: tz,
        email: email,
        name: name,
        token: orUserAccount.AccountToken.token
      });
    }
    return {
      resolveClients: resolveClients,
      searchClients: searchClients,
      isCustomSearch: function () {
        return _isCustomSearch;
      },
      dateList: function () {
        if (!_lastDate)
          _lastDate = new Date();
        return _lastDate;
      },
      Profile: getProfile,
      GetEmployees: GetEmployees,
      GetDoctors: GetDoctors,
      LoadPhotos: LoadPhotos,
      LoadReceipts: LoadReceipts,
      LoadDocuments: LoadDocuments,
      clientInsuranseStatus: clientInsuranseStatus,
      DownloadDocument: DownloadDocument,
      DeleteDocument: DeleteDocument,
      LinkUrlDownloadDocument: LinkUrlDownloadDocument,
      LoadPhotosDoctor: LoadPhotosDoctor,
      GetFactorPays: GetFactorPays,
      GetDoctorDetails: GetDoctorDetails,

      CreateNewClient: CreateNewClient,
      updateClientDetails: updateClientDetails,
      updateEmployeeOnClient: updateEmployeeOnClient,
      updateClientLeft: updateClientLeft,
      removeClient: removeClient,

      pelecardPay: pelecardPay,
      pelecardCheckPay: pelecardCheckPay,
      createInvoice: createInvoice,
      getInvoice: getInvoice,
      CheckCreditPermission: checkCreditPermission,
      CheckDiscountPermission: checkDiscountPermission,

      EmployeeActionEntry: EmployeeActionEntry,
      EmployeeReport: EmployeeReport,

      ShippingReport: shippingReport,
      DeliveryNow: deliveryNow,
      ShippingCertificate: shippingCertificate,
      UpdateInsurance: updateInsurance,
      UpdateCopiesAndDoctor: updateCopiesAndDoctor,
      clearContacts: clearContacts,
      // Copiesclient: Copiesclient

      //CALANDER
      calanderEvents: calanderEvents,
      Calander_AddEvent: Calander_AddEvent,

      //Referring
      ReferringList: ReferringList,
      ReferringPlaceList: ReferringPlaceList,
      Prescription_photos: Prescription_photos,

      LoadDeposits: LoadDeposits,
      AddDeposits: AddDeposits,
      DelDeposits: DelDeposits,
      SendClaimToInsurance: SendClaimToInsurance,
      //CopiesOfPrescription:CopiesOfPrescription

      //References_maccabi
      References: References,
      sendDocsToEmail:sendDocsToEmail,

      checkReferenceExist:checkReferenceExist


    }
  }

  function config() {

  }

})();

/**
 * Created by itzik on 14/11/2017.
 */
(function () {
  'use strict';

  angular
    .module('app.orHashen')
    .factory('orUserAccount', userAccountService);

  function userAccountService($q, msApi, msUtils, $rootScope,$interval) {
    var _place = {isLoggedIn: false};
    var VersionApp = 5.487;
    var _accountToken = {};
    var intervalVersion,
      timerInterval = 1800000;

    var Login = function (userData) {
      var deferred = $q.defer();

      msApi.resolve('or.auth.login@save', userData).then(function (result) {
        if (result.status) {
          msUtils.setJsonObj(_place, result.account);
          _place.isLoggedIn = true;

          msUtils.setJsonObj(_accountToken, {token: result.token});
          saveLocal();
          intervalVersion = $interval(CheckVersion, timerInterval);
          deferred.resolve({status: result.status});
        } else {
          deferred.reject(result)
        }


      });

      return deferred.promise;

    }
    var saveLocal = function () {
      window.localStorage['PlaceAcc'] = JSON.stringify({_place: _place, _accountToken: _accountToken});
    }
    var LoadLocal = function () {
      if (window.localStorage['PlaceAcc']) {
        var JS = angular.fromJson(window.localStorage['PlaceAcc']);

        _place = JS._place;
        _accountToken = JS._accountToken;
        intervalVersion = setInterval(CheckVersion, timerInterval);
      }
    }
    var LogOut = function () {
      msUtils.setJsonObj(_place, {isLoggedIn: false});
      msUtils.setJsonObj(_accountToken, {});
      localStorage.removeItem('PlaceAcc');
      clearInterval(intervalVersion);
    }
    var CheckVersion = function () {
      if (!_accountToken.token)
        return;
      msApi.resolve('or.version@get', {token: _accountToken.token}).then(function (result) {

        if (result.version) {
          if (parseFloat(result.version) > VersionApp) {
            alert('עדכון חדש קיים למערכת! עליך לבצע ריענון ע"י לחיצה על מקש ctrl+R');
          }
        }

      }, function (err) {
        if (err.status == 401) {
          LogOut();
          $rootScope.$broadcast('user:logout');
        }

      });

    }

    LoadLocal();

    CheckVersion();
    return {
      Place: _place,
      API_UPLOAD:function () {
        // return 'http://localhost:4900/documents/'
        return 'https://or-api.azurewebsites.net/documents/'
      },
      LoggedIn: _place.isLoggedIn,
      Login: Login,
      LogOut: LogOut,
      AccountToken: _accountToken,
      VersionApp: VersionApp
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.orHashen')
    .factory('orReportsService', orReportsService);


  /** @ngInject */
  function orReportsService($q, orUserAccount, $log, msApi, $filter, msUtils) {

    var _lastDate;
    var _reportDaily = {data: {}};

    var RunReport = function (dates) {
      // if (date)
      //   _lastDate = date;
      // var strDate = _lastDate.getFullYear() + '/' + (_lastDate.getMonth() + 1) + '/' + _lastDate.getDate();

      var deferred = $q.defer();
      GetAPI('or.reports.daily', {
        start: dates.start,
        end: dates.end,
        token: orUserAccount.AccountToken.token
      }).then(function (result) {
        msUtils.setJsonObj(_reportDaily, result);
        msUtils.setJsonObj(_reportDaily.data.daily, result.data.daily);
        deferred.resolve(_reportDaily);
      }, deferred.reject)
      return deferred.promise;
    }

    var CustomerInDebt = function (dates) {
      var deferred = $q.defer();
      GetAPI('or.report.indebt', {
        token: orUserAccount.AccountToken.token,
        start: (dates ? dates.start : undefined),
        end: (dates ? dates.end : undefined)
      }).then(function (result) {
        deferred.resolve(result.data);
      }, deferred.reject);
      return deferred.promise;
    }
    var depositCustomer = function (dates) {
      var deferred = $q.defer();
      GetAPI('or.report.deposit', {
        token: orUserAccount.AccountToken.token,
        start: (dates ? dates.start : undefined),
        end: (dates ? dates.end : undefined)
      }).then(function (result) {
        deferred.resolve(result.data);
      }, deferred.reject);
      return deferred.promise;
    }
    var Alert_Reports = function ( dates) {
      var deferred = $q.defer();
      GetAPI('or.report.alert_report', {
        token: orUserAccount.AccountToken.token,
        start: (dates ? dates.start : undefined),
        end: (dates ? dates.end : undefined)
      }).then(function (result) {
        deferred.resolve(result.data);
      }, deferred.reject);
      return deferred.promise;
    }
    var All_Reports = function (ReportType, dates) {
      switch (ReportType) {
        case 'inDept':
        default:
          return CustomerInDebt(dates);
        case  'deposit':
          return depositCustomer(dates);

      }
    }

    function GetAPI(api, data) {
      var deferred = $q.defer();
      msApi.resolve(api + '@get', data).then(function (result) {
        deferred.resolve(result);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    }


    return {

      dateReport: function () {
        if (!_lastDate)
          _lastDate = new Date();
        return _lastDate;
      },
      RunReport: RunReport,
      ReportDaily: _reportDaily.data,
      All_Reports: All_Reports,
      Alert_Reports:Alert_Reports


    }
  }


})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('msUtils', msUtils);

  /** @ngInject */
  function msUtils($window,$filter) {
    // Private variables
    var mobileDetect = new MobileDetect($window.navigator.userAgent),
      browserInfo = null;
    var tax = 17;
    var service = {
      exists: exists,
      detectBrowser: detectBrowser,
      guidGenerator: guidGenerator,
      isMobile: isMobile,
      toggleInArray: toggleInArray,
      setJsonObj: setJsonObj,
      PushIfNotExsist:pushIfNotExsist,
      TAX: tax
    };

    return service;

    //////////

    /**
     * Check if item exists in a list
     *
     * @param item
     * @param list
     * @returns {boolean}
     */
    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    /**
     * Returns browser information
     * from user agent data
     *
     * Found at http://www.quirksmode.org/js/detect.html
     * but modified and updated to fit for our needs
     */
    function detectBrowser() {
      // If we already tested, do not test again
      if (browserInfo) {
        return browserInfo;
      }

      var browserData = [
        {
          string: $window.navigator.userAgent,
          subString: 'Edge',
          versionSearch: 'Edge',
          identity: 'Edge'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Chrome',
          identity: 'Chrome'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'OmniWeb',
          versionSearch: 'OmniWeb/',
          identity: 'OmniWeb'
        },
        {
          string: $window.navigator.vendor,
          subString: 'Apple',
          versionSearch: 'Version',
          identity: 'Safari'
        },
        {
          prop: $window.opera,
          identity: 'Opera'
        },
        {
          string: $window.navigator.vendor,
          subString: 'iCab',
          identity: 'iCab'
        },
        {
          string: $window.navigator.vendor,
          subString: 'KDE',
          identity: 'Konqueror'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Firefox',
          identity: 'Firefox'
        },
        {
          string: $window.navigator.vendor,
          subString: 'Camino',
          identity: 'Camino'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Netscape',
          identity: 'Netscape'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'MSIE',
          identity: 'Explorer',
          versionSearch: 'MSIE'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Trident/7',
          identity: 'Explorer',
          versionSearch: 'rv'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Gecko',
          identity: 'Mozilla',
          versionSearch: 'rv'
        },
        {
          string: $window.navigator.userAgent,
          subString: 'Mozilla',
          identity: 'Netscape',
          versionSearch: 'Mozilla'
        }
      ];

      var osData = [
        {
          string: $window.navigator.platform,
          subString: 'Win',
          identity: 'Windows'
        },
        {
          string: $window.navigator.platform,
          subString: 'Mac',
          identity: 'Mac'
        },
        {
          string: $window.navigator.platform,
          subString: 'Linux',
          identity: 'Linux'
        },
        {
          string: $window.navigator.platform,
          subString: 'iPhone',
          identity: 'iPhone'
        },
        {
          string: $window.navigator.platform,
          subString: 'iPod',
          identity: 'iPod'
        },
        {
          string: $window.navigator.platform,
          subString: 'iPad',
          identity: 'iPad'
        },
        {
          string: $window.navigator.platform,
          subString: 'Android',
          identity: 'Android'
        }
      ];

      var versionSearchString = '';

      function searchString(data) {
        for (var i = 0; i < data.length; i++) {
          var dataString = data[i].string;
          var dataProp = data[i].prop;

          versionSearchString = data[i].versionSearch || data[i].identity;

          if (dataString) {
            if (dataString.indexOf(data[i].subString) !== -1) {
              return data[i].identity;

            }
          }
          else if (dataProp) {
            return data[i].identity;
          }
        }
      }

      function searchVersion(dataString) {
        var index = dataString.indexOf(versionSearchString);

        if (index === -1) {
          return;
        }

        return parseInt(dataString.substring(index + versionSearchString.length + 1));
      }

      var browser = searchString(browserData) || 'unknown-browser';
      var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
      var os = searchString(osData) || 'unknown-os';

      // Prepare and store the object
      browser = browser.toLowerCase();
      version = browser + '-' + version;
      os = os.toLowerCase();

      browserInfo = {
        browser: browser,
        version: version,
        os: os
      };

      return browserInfo;
    }

    /**
     * Generates a globally unique id
     *
     * @returns {*}
     */
    function guidGenerator() {
      var S4 = function () {
        return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
      };
      return (S4() + S4() + S4() + S4() + S4() + S4());
    }

    /**
     * Return if current device is a
     * mobile device or not
     */
    function isMobile() {
      return mobileDetect.mobile();
    }

    /**
     * Toggle in array (push or splice)
     *
     * @param item
     * @param array
     */
    function toggleInArray(item, array) {
      if (array.indexOf(item) === -1) {
        array.push(item);
      }
      else {
        array.splice(array.indexOf(item), 1);
      }
    }

    function setJsonObj(mainObj, data) {
      if (Array.isArray(mainObj) && Array.isArray(data)) {
        mainObj.splice(0, mainObj.length);
      }
      angular.forEach(data, function (value, key) {
        if (typeof value === 'object' && value != null && key != '$promise') {

          if (mainObj[key] === undefined) {
            if (Array.isArray(value))
              mainObj[key] = [];
            else
              mainObj[key] = {};
          }
          setJsonObj(mainObj[key], value);
        }
        else if (key != '$promise')
          mainObj[key] = value;

      })
    }
    function pushIfNotExsist(mainObj, data, key) {
      if (!Array.isArray(mainObj))
        throw error("object is'nt array!");
      else {
        data.map(function (obj, index) {
          var sear=_defineProperty({}, key, obj[key]);
          var i = $filter('filter')(mainObj, sear, true)[0];
          if (!i)
            mainObj.push(obj);
        })
      }
    }

//forES5
    function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  }
}());

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');

                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');

                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');

                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');

                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();

/**
 * Created by itzik on 14/12/2017.
 */
(function () {
  'use strict';

  angular
    .module('app.orHashen')
    .factory('inventoriesService', inventoriesService);


  /** @ngInject */
  function inventoriesService($q, $log, msApi, $filter, msUtils, orUserAccount) {

    var orders_list;

    function Orders(query, reload) {
      var deferred = $q.defer();
      if (orders_list && orders_list.length && !query && !reload) {
        deferred.resolve(orders_list);
      } else {
        GetAPI('or.inventories.orders', {token: orUserAccount.AccountToken.token, query: query}).then(function (data) {
          if (data.status) {
            if (!orders_list)
              orders_list = [];
            msUtils.setJsonObj(orders_list, data.data)
          }
          deferred.resolve(orders_list);
        });
      }
      return deferred.promise;
    }

    function Tracking() {
      var deferred = $q.defer();
      GetAPI("or.inventories.tracking", {
        token: orUserAccount.AccountToken.token
      }).then(function (result) {
        deferred.resolve(result.data);
      }, deferred.reject)
      return deferred.promise;
    }
    function TrackingHistory() {
      var deferred = $q.defer();
      GetAPI("or.inventories.tracking.history", {
        token: orUserAccount.AccountToken.token
      }).then(function (result) {
        deferred.resolve(result.data);
      }, deferred.reject)
      return deferred.promise;
    }

    function UpdateTrackingData(item, user) {
      var deferred = $q.defer();
      postAPI("or.inventories.tracking", {
        token: orUserAccount.AccountToken.token,
        count: -1,
        item_id: item.item_id,
        employee_id: user.OvedID
      }).then(function (result) {
        deferred.resolve(result.data);
      }, deferred.reject)
      return deferred.promise;
    }

    function Order(orderID) {
      var deferred = $q.defer();
      if (!orders_list || !orders_list.length || !$filter('filter')(orders_list, {ID: orderID})[0]) {
        Orders(orderID).then(function () {
          var OrderItem = $filter('filter')(orders_list, {ID: orderID})[0];
          deferred.resolve(OrderItem);
        })
      } else {
        var OrderItem = $filter('filter')(orders_list, {ID: orderID})[0];
        deferred.resolve(OrderItem);
      }
      return deferred.promise;

    }

    function GetOrderDetailsForEdit(orderID) {
      var deferred = $q.defer();
      GetAPI('or.inventories.editorderdetails', {
        token: orUserAccount.AccountToken.token,
        orderid: orderID
      }).then(function (data) {

        deferred.resolve(data.data);
      });
      return deferred.promise;
    }

    function OrderDetails(orderID, reload) {
      var deferred = $q.defer();
      Order(orderID).then(function (OrderItem) {
          if (OrderItem && OrderItem.items && !reload) {
            deferred.resolve(OrderItem);
          } else if (OrderItem) {
            GetAPI('or.inventories.orderdetails', {
              token: orUserAccount.AccountToken.token,
              orderid: orderID
            }).then(function (data) {
              if (data.status) {
                if (!OrderItem.items)
                  OrderItem.items = [];
                msUtils.setJsonObj(OrderItem.items, data.data)
              }
              deferred.resolve(OrderItem);
            });
          } else {
            deferred.resolve(undefined);
          }
        }
      )


      return deferred.promise;
    }

    function SaveInventory(inventory) {
      var deferred = $q.defer();
      postAPI("or.inventories.orders", {
        token: orUserAccount.AccountToken.token,
        data: inventory
      }).then(function (result) {
        OrderDetails(inventory.ID, true);
        Orders(undefined, true);
        deferred.resolve(result.data);
      }, deferred.reject);
      return deferred.promise;

    }

    function ChangeStatusInventory(inventory, option) {
      inventory.status = 1;//Send
      inventory.status_name = "הזמנה נשלחה";//Send
      if (option && option.cancelled) {
        inventory.status = 0;
        inventory.status_name = "הזמנה בוטלה";

      } else if (option && option.removed) {
        inventory.status = -1;
        inventory.status_name = "הזמנה נמחקה";

      }
      var deferred = $q.defer();
      postAPI("or.inventories.edit_status", {
        token: orUserAccount.AccountToken.token,
        data: inventory
      }).then(function (result) {
        Orders(undefined, true);
        deferred.resolve(result);
      }, deferred.reject);
      return deferred.promise;
    }

    function GetEmployeeDetails(card_employee) {
      var deferred = $q.defer();
      GetAPI("or.employees.details", {
        token: orUserAccount.AccountToken.token,
        card: card_employee
      }).then(function (result) {
        deferred.resolve(result.data);
      }, deferred.reject);
      return deferred.promise;
    }

    var _allItems;

    function GetAllItemsProducts() {
      var deferred = $q.defer();
      if (_allItems) {
        deferred.resolve(_allItems);
      } else {
        GetAPI('or.inventories.items', {token: orUserAccount.AccountToken.token}).then(function (data) {
          if (data.status) {
            if (!_allItems)
              _allItems = [];
            msUtils.setJsonObj(_allItems, data.data)
          }
          deferred.resolve(_allItems);
        });

      }
      return deferred.promise;
    }

    function GetAPI(api, data) {
      var deferred = $q.defer();
      msApi.resolve(api + '@get', data).then(function (result) {
        deferred.resolve(result);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    }

    function postAPI(api, data) {
      var deferred = $q.defer();
      msApi.resolve(api + '@save', data).then(function (result) {
        deferred.resolve(result);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    }


    return {
      Orders: Orders,
      Order: Order,
      OrderDetails: OrderDetails,
      GetAllItemsProducts: GetAllItemsProducts,
      GetOrderDetailsForEdit: GetOrderDetailsForEdit,
      GetEmployeeDetails: GetEmployeeDetails,
      SaveInventory: SaveInventory,
      ChangeStatusInventory: ChangeStatusInventory,
      Tracking: Tracking,
      TrackingHistory: TrackingHistory,
      UpdateTrackingData: UpdateTrackingData
    }
  }
})
();

/**
 * Created by itzik on 14/12/2017.
 */
(function () {
  'use strict';

  angular
    .module('app.orHashen')
    .factory('insuranceService', InsuranceService);


  /** @ngInject */
  function InsuranceService($q, $log, msApi, $filter, msUtils, orUserAccount) {

    var _insurancePrices;
    var _listofcopies;
    var _reportPlace;

    function insurancePrices() {
      var deferred = $q.defer();
      if (_insurancePrices) {
        deferred.resolve(_insurancePrices);
      } else {
        GetAPI('or.insurance.prices', {token: orUserAccount.AccountToken.token}).then(function (data) {
          if (data.status)
            _insurancePrices = data.data;
          deferred.resolve(_insurancePrices);
        });
      }
      return deferred.promise;
    }

    function InsertPrice(copy) {
      var deferred = $q.defer();
      if (!copy) {
        deferred.reject('misiimg copy');
      } else {
        postAPI('or.insurance.prices', {token: orUserAccount.AccountToken.token, copy: copy}).then(function (data) {
          deferred.resolve(data.status);
        });
      }
      return deferred.promise;
    }

    function GetListofCopies() {
      var deferred = $q.defer();
      if (_listofcopies) {
        deferred.resolve(_listofcopies);
      } else {
        _listofcopies = [];
        deferred.resolve(_listofcopies);
        console.log('!!!!!!!!!!!!!!!!!!!!!!!')
        GetAPI('or.insurance.listofcopies', {token: orUserAccount.AccountToken.token}).then(function (data) {
          if (data.status)
            msUtils.setJsonObj(_listofcopies, data.data);
        });
      }
      return deferred.promise;
    }

    function RemoveCopie(copy) {
      var deferred = $q.defer();

      postAPI('or.insurance.prices.delete', {
        token: orUserAccount.AccountToken.token,
        copy: copy
      }).then(function (data) {

        if (data.status) {

          var x = $filter('filter')(_insurancePrices, {ID: copy.ID})[0];

          if (x) {
            x.active = false;
            x = undefined;
          }
          deferred.resolve(data);

        }
      });

      return deferred.promise;
    }

    function GetAPI(api, data) {
      var deferred = $q.defer();
      msApi.resolve(api + '@get', data).then(function (result) {
        deferred.resolve(result);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    }

    function postAPI(api, data) {
      var deferred = $q.defer();
      msApi.resolve(api + '@save', data).then(function (result) {
        deferred.resolve(result);
      }, function (err) {
        deferred.reject(err);
      });
      return deferred.promise;
    }

    var _lastDates;

    function Reportinsurance(dates) {

      if (!dates)
        dates = {start: new Date()};
      //var start=new Date(2017,11,25);
      //var  end=new Date(2018,0,1);
      var deferred = $q.defer();
      if (_reportPlace && _lastDates == dates) {
        deferred.resolve(_reportPlace);
      } else {
        _lastDates = dates;
        GetAPI('or.insurance.reportplace', {
          token: orUserAccount.AccountToken.token,
          start: (dates && dates.start ? dates.start.toDateString() : ''),
          end: (dates && dates.end ? dates.end.toDateString() : '')
        }).then(function (data) {
          if (data.status) {
            if (!_reportPlace)
              _reportPlace = [];
            msUtils.setJsonObj(_reportPlace, data.data);
          }
          deferred.resolve(_reportPlace);
        });
      }
      return deferred.promise;
    }
    function updateStatusPhoto(item) {
      var deferred = $q.defer();
      if (!item) {
        deferred.reject('misiimg copy');
      } else {
        postAPI('or.insurance.statusphoto', {
          token: orUserAccount.AccountToken.token,
          photo: item
        }).then(function (data) {
          deferred.resolve({status: data.status, err: data.err});
        });
      }
      return deferred.promise;
    }

    return {
      InsurancePrices: insurancePrices,
      InsertPrice: InsertPrice,
      GetListofCopies: GetListofCopies,
      RemoveCopie: RemoveCopie,
      Reportinsurance: Reportinsurance,
      UpdateStatusPhoto: updateStatusPhoto
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate)
    {
        return {
            restrict: 'E',
            compile : function (element, attr)
            {
                var code;
                //No attribute? code is the content
                if ( !attr.code )
                {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr)
                {

                    if ( attr.code )
                    {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code)
                    {
                        if ( code )
                        {
                            if ( shouldInterpolate )
                            {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function ()
                            {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent)
                    {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line)
                        {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line)
                        {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function () {
  'use strict';

  angular
    .module('app.core')
    .filter('customCurrency', customCurrency)
    .filter('customCurrencyWithTax', customCurrencyWithTax)
    .filter('unique', Unique);
  /** @ngInject */
  function customCurrency() {

    return function (input, symbol, place) {
      if (typeof input === 'string')
        input = parseFloat(input);

      if (isNaN(input)) {
        return input;
      } else {
        var a_symbol = symbol || ' ₪ ';
        var a_place = place === undefined ? true : place;
        if (a_place === true) {
          return (input ? input.toFixed(2) : 0) + a_symbol;
        } else {
          return a_symbol + ' ' + input;
        }
      }

    }
  }

  function customCurrencyWithTax(msUtils) {
    var TAX = msUtils.TAX / 100 + 1;
    return function (input, symbol, place) {
      if (typeof input === 'string')
        input = parseFloat(input);

      if (isNaN(input)) {
        return input;
      } else {
        var a_symbol = symbol || ' ₪ ';
        var a_place = place === undefined ? true : place;
        input = input * TAX;
        if (a_place === true) {
          return (input ? input.toFixed(2) : 0) + a_symbol;
        } else {
          return a_symbol + ' ' + input;
        }
      }

    }
  }


  // we will return a function which will take in a collection
  // and a keyname
  function Unique() {
    return function (collection, keyname) {
      var output = [],
        keys = [];

      // we utilize angular's foreach function
      // this takes in our original collection and an iterator function
      angular.forEach(collection, function (item) {
        // we check to see whether our object exists
        var key = item[keyname];
        // if it's not already part of our keys array
        if (keys.indexOf(key) === -1) {
          // add it to our keys array
          keys.push(key);
          // push this item to our final output array
          output.push(item);
        }
      });
      // return our array which should be devoid of
      // any duplicates
      return output;
    }
  }


})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();

(function () {
  'use strict';

  angular
    .module('app.toolbar')
    .controller('ToolbarController', ToolbarController);

  /** @ngInject */
  function ToolbarController($rootScope, $q, $state, $timeout, $mdSidenav, $translate, $mdToast, msNavigationService, $mdDialog, $document, PlaceAccount, VersionApp, orUserAccount, msApi) {
    var vm = this;

    if (!PlaceAccount.isLoggedIn) {
      $state.go('app.pages_auth_login-v2');
      return;
    }
    $rootScope.$on('user:logout', function () {
      $state.go('app.pages_auth_login-v2');
    });
    vm.placeName = PlaceAccount.Name;
    vm.PlaceAccount = PlaceAccount;
    vm.version = VersionApp;
    // Data
    $rootScope.global = {
      search: ''
    };
    vm.employeeEntryDialog = function (ev) {
      $mdDialog.show({
        controller: 'employeesEntryController',
        controllerAs: 'vm',
        templateUrl: 'app/main/employees/entry_dialog.html',
        parent: angular.element($document.find('#content-container')),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        locals: {}
      }).then(function (id) {

      });
    }
    vm.bodyEl = angular.element('body');
    vm.userStatusOptions = [
      {
        'title': 'Online',
        'icon': 'icon-checkbox-marked-circle',
        'color': '#4CAF50'
      },
      {
        'title': 'Away',
        'icon': 'icon-clock',
        'color': '#FFC107'
      },
      {
        'title': 'Do not Disturb',
        'icon': 'icon-minus-circle',
        'color': '#F44336'
      },
      {
        'title': 'Invisible',
        'icon': 'icon-checkbox-blank-circle-outline',
        'color': '#BDBDBD'
      },
      {
        'title': 'Offline',
        'icon': 'icon-checkbox-blank-circle-outline',
        'color': '#616161'
      }
    ];
    vm.languages = {
      en: {
        'title': 'English',
        'translation': 'TOOLBAR.ENGLISH',
        'code': 'en',
        'flag': 'us'
      },
      es: {
        'title': 'Spanish',
        'translation': 'TOOLBAR.SPANISH',
        'code': 'es',
        'flag': 'es'
      },
      tr: {
        'title': 'Turkish',
        'translation': 'TOOLBAR.TURKISH',
        'code': 'tr',
        'flag': 'tr'
      }
    };

    // Methods
    vm.toggleSidenav = toggleSidenav;
    vm.logout = logout;
    vm.changeLanguage = changeLanguage;
    vm.setUserStatus = setUserStatus;
    vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
    vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
    vm.search = search;
    vm.searchResultClick = searchResultClick;
    vm.showLastSMS = showLastSMS;

    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      // Select the first status as a default
      vm.userStatus = vm.userStatusOptions[0];

      // Get the selected language directly from angular-translate module setting
      vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
    }


    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    /**
     * Sets User Status
     * @param status
     */
    function setUserStatus(status) {
      vm.userStatus = status;
    }

    /**
     * Logout Function
     */
    function logout() {
      // Do logout here..
    }

    /**
     * Change Language
     */
    function changeLanguage(lang) {
      vm.selectedLanguage = lang;

      /**
       * Show temporary message if user selects a language other than English
       *
       * angular-translate module will try to load language specific json files
       * as soon as you change the language. And because we don't have them, there
       * will be a lot of errors in the page potentially breaking couple functions
       * of the template.
       *
       * To prevent that from happening, we added a simple "return;" statement at the
       * end of this if block. If you have all the translation files, remove this if
       * block and the translations should work without any problems.
       */
      if (lang.code !== 'en') {
        var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
          hideDelay: 7000,
          position: 'top right',
          parent: '#content'
        });

        return;
      }

      // Change the language
      $translate.use(lang.code);
    }

    /**
     * Toggle horizontal mobile menu
     */
    function toggleHorizontalMobileMenu() {
      vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
    }

    /**
     * Toggle msNavigation folded
     */
    function toggleMsNavigationFolded() {
      msNavigationService.toggleFolded();
    }

    /**
     * Search action
     *
     * @param query
     * @returns {Promise}
     */
    function search(query) {
      var navigation = [],
        flatNavigation = msNavigationService.getFlatNavigation(),
        deferred = $q.defer();

      // Iterate through the navigation array and
      // make sure it doesn't have any groups or
      // none ui-sref items
      for (var x = 0; x < flatNavigation.length; x++) {
        if (flatNavigation[x].uisref) {
          navigation.push(flatNavigation[x]);
        }
      }

      // If there is a query, filter the navigation;
      // otherwise we will return the entire navigation
      // list. Not exactly a good thing to do but it's
      // for demo purposes.
      if (query) {
        navigation = navigation.filter(function (item) {
          if (angular.lowercase(item.title).search(angular.lowercase(query)) > -1) {
            return true;
          }
        });
      }

      // Fake service delay
      $timeout(function () {
        deferred.resolve(navigation);
      }, 1000);

      return deferred.promise;
    }

    /**
     * Search result click action
     *
     * @param item
     */
    function searchResultClick(item) {
      // If item has a link
      if (item.uisref) {
        // If there are state params,
        // use them...
        if (item.stateParams) {
          $state.go(item.state, item.stateParams);
        }
        else {
          $state.go(item.state);
        }
      }
    }

    function showLastSMS() {
      vm.smsProccess=true;
      msApi.resolve('or.smsin@get', {
        token: orUserAccount.AccountToken.token
      }).then(function (result) {
        // alert(result)
        vm.smsProccess=false;
        console.log(result);
        if (!result.status) {
          alertDialog('שגיאה', 'ארעה תקלה בקבלת מסרון')
        }
        else if (!result.data.length) {
          alertDialog('SMS', 'לא נמצאו מסרונים')
        }
        else {
          alertDialog(result.data[0].date, result.data[0].message)
        }
      })


    }

    function alertDialog(title, msg) {
      $mdDialog.show(
        $mdDialog.alert()
        //.parent(angular.element(document.querySelector('#popupContainer')))
          .clickOutsideToClose(true)
          .title(title)
          .textContent(msg)
          .ariaLabel('Alert Dialog Demo')
          .ok('סגור')
        //.targetEvent(ev)
      ).then();
    }
  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function () {
  'use strict';

  angular
    .module('app.navigation')
    .controller('NavigationController', NavigationController);

  /** @ngInject */
  function NavigationController($scope) {
    var vm = this;

    // Data
    vm.bodyEl = angular.element('body');
    vm.folded = false;
    vm.msScrollOptions = {
      suppressScrollX: true
    };

    // Methods
    vm.toggleMsNavigationFolded = toggleMsNavigationFolded;


    //////////

    /**
     * Toggle folded status
     */
    function toggleMsNavigationFolded() {
      vm.folded = !vm.folded;
    }

    // Close the mobile menu on $stateChangeSuccess
    $scope.$on('$stateChangeSuccess', function () {
      vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
    });

  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('app.core')
    .config(config);

  /** @ngInject */
  function config($ariaProvider, $logProvider, msScrollConfigProvider, $translateProvider, fuseConfigProvider, $mdDialogProvider) {
    // Enable debug logging
    $logProvider.debugEnabled(false);

    // angular-translate configuration
    $translateProvider.useLoader('$translatePartialLoader', {
      urlTemplate: '{part}/i18n/{lang}.json'
    });
    $translateProvider.preferredLanguage('en');
    $translateProvider.useSanitizeValueStrategy('sanitize');

    /*eslint-disable */

        // ng-aria configuration
  /*    debugger
    *  - **ariaHidden** – `{boolean}` – Enables/disables aria-hidden tags
    *  - **ariaChecked** – `{boolean}` – Enables/disables aria-checked tags
    *  - **ariaReadonly** – `{boolean}` – Enables/disables aria-readonly tags
    *  - **ariaDisabled** – `{boolean}` – Enables/disables aria-disabled tags
    *  - **ariaRequired** – `{boolean}` – Enables/disables aria-required tags
    *  - **ariaInvalid** – `{boolean}` – Enables/disables aria-invalid tags
    *  - **ariaValue** – `{boolean}` – Enables/disables aria-valuemin, aria-valuemax and aria-valuenow tags
    *  - **tabindex** – `{boolean}` – Enables/disables tabindex tags
*/
      $ariaProvider.config({
            tabindex: false,
          ariaChecked:true
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration

        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state)
    {
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();
(function () {
  'use strict';

  angular
    .module('fuse')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {
    $locationProvider.html5Mode(true);


    /**
     * Layout Style Switcher
     *
     * This code is here for demonstration purposes.
     * If you don't need to switch between the layout
     * styles like in the demo, you can set one manually by
     * typing the template urls into the `State definitions`
     * area and remove this code
     */
      // Inject $cookies
    var $cookies;

    angular.injector(['ngCookies']).invoke([
      '$cookies', function (_$cookies) {
        $cookies = _$cookies;
      }
    ]);
    var placeor = $cookies.get('placeorlogin');
    if (placeor && placeor == 'or147852369or')
      $urlRouterProvider.otherwise('/contacts');
    else {
      $urlRouterProvider.otherwise('/pages/auth/lock');
      //$cookies.put('placeorlogin', 'or147852369or');
    }
    // Get active layout
    var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

    var layouts = {
      verticalNavigation: {
        main: 'app/core/layouts/vertical-navigation.html',
        toolbar: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
        navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
      },
      verticalNavigationFullwidthToolbar: {
        main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
        toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
        navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
      },
      verticalNavigationFullwidthToolbar2: {
        main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
        toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
        navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
      },
      horizontalNavigation: {
        main: 'app/core/layouts/horizontal-navigation.html',
        toolbar: 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
        navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
      },
      contentOnly: {
        main: 'app/core/layouts/content-only.html',
        toolbar: '',
        navigation: ''
      },
      contentWithToolbar: {
        main: 'app/core/layouts/content-with-toolbar.html',
        toolbar: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
        navigation: ''
      }
    };
    // END - Layout Style Switcher

    // State definitions
    $stateProvider
      .state('app', {
        abstract: true,
        views: {
          'main@': {
            templateUrl: layouts[layoutStyle].main,
            controller: 'MainController as vm'
          },
          'toolbar@app': {
            templateUrl: layouts[layoutStyle].toolbar,
            controller: 'ToolbarController as vm'
          },
          'navigation@app': {
            templateUrl: layouts[layoutStyle].navigation,
            controller: 'NavigationController as vm'
          },
          'quickPanel@app': {
            templateUrl: 'app/quick-panel/quick-panel.html',
            controller: 'QuickPanelController as vm'
          }
        }, resolve: {
          PlaceAccount: function (orUserAccount) {
            return orUserAccount.Place;
          },
          VersionApp: function (orUserAccount) {
            return orUserAccount.VersionApp;
          }
        }
      });
  }

})();

(function () {
  'use strict';

  angular
    .module('fuse')
    .controller('IndexController', IndexController);

  /** @ngInject */
  function IndexController(fuseTheming) {
    var vm = this;

    // Data
    vm.themes = fuseTheming.themes;
    vm.loaderService = {isLoading: false};
    //////////
  }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse');
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config(vcRecaptchaServiceProvider,$mdDateLocaleProvider)
    {
        // Put your custom configurations here
      vcRecaptchaServiceProvider.setDefaults({
        key: '6LeMhjoUAAAAAPAjsbXglYrwqVexxrBy6dk9D-3J',
        lang:'he'
      });

      $mdDateLocaleProvider.formatDate = function(date) {
        return moment(date).format('DD/MM/YYYY');
      };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        // api.sample = $resource(api.baseUrl + 'sample/sample.json');

        return api;
    }

})();
(function () {
  'use strict';

  angular
    .module('app.support', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    $stateProvider.state('app.support', {
      url: '/support',
      views: {
        'content@app': {
          templateUrl: 'app/main/support/support.html'
        }
      },
      resolve: {}
    })

    msNavigationServiceProvider.saveItem('others', {
      title : 'תמיכה',
      group : true,
      weight: 4
    });
    msNavigationServiceProvider.saveItem('others.support', {
      title: 'טופס תמיכה',
      icon: 'icon-cog',
      state: 'app.support',
      weight: 1
    });

    // Api


  }

})();

(function () {
  'use strict';

  angular
    .module('app.docs', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

    $stateProvider.state('app.docs', {
      url: '/docs',
      views: {
        'content@app': {
          templateUrl: 'app/main/docs/docs.html'
        }
      },
      resolve: {}
    })


    msNavigationServiceProvider.saveItem('others.docs', {
      title: 'עזרה',
      icon: 'icon-file-document',
      state: 'app.docs',
      weight: 1
    });

    // Api


  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages', [
            'app.pages.auth.login-v2',
            'app.pages.auth.lock'
            // 'app.pages.error-404',
            // 'app.pages.error-500',
            // 'app.pages.invoice',
            // 'app.pages.maintenance',
            // 'app.pages.search',
            // 'app.pages.timeline'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        // msNavigationServiceProvider.saveItem('pages', {
        //     title : 'PAGES',
        //     group : true,
        //     weight: 2
        // });
    }
})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"QUICKPANEL.CHAT\">CHAT</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" \nng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</span></md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div id=\"content-container\" flex \nlayout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex>\n</md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/bid/bid.html","<div id=\"bid\" class=\"page-layout simple tabbed\"><div class=\"fheader header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-text\">הצעת מחיר</span></div></div></div><div class=\"content\" flex=\"\"><div\n class=\"content m-32\" flex layout=\"row\" layout-align=\"end center\"><div layout=\"row\" flex><div class=\"about m-32\" \nlayout=\"column\" flex=\"100\"><div class=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\"><div class=\"title dir-rtl\">חיפוש והצעת מחיר</div></header><div class=\"content dir-rtl\">\n<ms-prices-doctors copies=\"vm.copies\" bituah-id=\"1\" hide-select=\"true\" doctor=\"vm.doctor\" \ncount-copies=\"vm.countCopies\"></ms-prices-doctors></div></div></div></div></div></div></div>");
$templateCache.put("app/main/calendar/calendar.html","<div id=\"calendar\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header\" \nng-class=\"vm.currentMonthShort\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-top\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span \nclass=\"logo-text\">לוח שנה</span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Search\" translate translate-attr-aria-label=\"CALENDAR.SEARCH\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><md-tooltip><span translate=\"CALENDAR.SEARCH\">Search</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.today()\" aria-label=\"Today\" translate \ntranslate-attr-aria-label=\"CALENDAR.TODAY\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.TODAY\">Today</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.changeView(\'agendaDay\')\" aria-label=\"Day\" translate translate-attr-aria-label=\"CALENDAR.DAY\">\n<md-icon md-font-icon=\"icon-view-day\"></md-icon><md-tooltip><span translate=\"CALENDAR.DAY\">Day</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaWeek\')\" aria-label=\"Week\" \ntranslate translate-attr-aria-label=\"CALENDAR.WEEK\"><md-icon md-font-icon=\"icon-view-week\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.WEEK\">Week</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.changeView(\'month\')\" aria-label=\"Month\" translate translate-attr-aria-label=\"CALENDAR.MONTH\">\n<md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span translate=\"CALENDAR.MONTH\">Month</span>\n</md-tooltip></md-button></div></div><div class=\"header-bottom\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button arrow\" ng-click=\"vm.calendar.prev()\" aria-label=\"Previous\" translate \ntranslate-attr-aria-label=\"CALENDAR.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><div \nclass=\"title\">{{vm.calendarView.title}}</div><md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.next()\" \naria-label=\"Next\" translate translate-attr-aria-label=\"CALENDAR.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\">\n</md-icon></md-button></div></div><md-button class=\"add-event-button md-fab md-warn\" ng-click=\"vm.addEvent($event)\" \naria-label=\"Add event\" translate translate-attr-aria-label=\"CALENDAR.ADD_EVENT\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button></div><div class=\"content\"><div id=\"calendarView\" ui-calendar=\"vm.calendarUiConfig.calendar\" \nng-model=\"vm.events\" calendar=\"main\"></div></div></div>");
$templateCache.put("app/main/contacts/contacts.html","<div id=\"contacts\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"column\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon>\n</span>&nbsp; <span class=\"logo-text\">{{(vm.header?vm.header:\'פציינטים\')}} </span><span hide show-gt-md \nclass=\"logo-text\" ng-hide=\"vm.isCustomSearch\">&nbsp; ליום: {{vm.date|date}}</span> <span hide show-gt-md \nclass=\"logo-text\" ng-show=\"vm.isCustomSearch\">&nbsp;(חיפוש)</span></div><div class=\"mt-16\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-raised md-accent\" ng-click=\"vm.Search(event)\"><md-icon \nmd-font-icon=\"icon-account-search\"></md-icon>חיפוש לקוח</md-button><md-button class=\"md-raised md-primary\" \nui-sref=\"app.contacts\" ng-click=\"vm.refresh()\"><md-icon ng-hide=\"vm.header\" md-font-icon=\"icon-refresh\"></md-icon>\n<md-icon ng-show=\"vm.header\" md-font-icon=\"icon-account-multiple\"></md-icon>{{(vm.header?\'הצג הכל\':\'רענן\')}}\n</md-button></div></div><div layout=\"row\" layout-align=\"center center\" class=\"headerclients\"><md-datepicker \nng-model=\"vm.date\" md-placeholder=\"Enter date\" md-open-on-focus md-is-open=\"this.isOpen\" ng-change=\"vm.changedate()\">\n</md-datepicker></div><div hide show-gt-xs class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\">\n<md-input-container md-no-float class=\"m-0\"><input id=\"search\" ng-change=\"vm.showAdvancedSearch=true\" type=\"text\" \nng-model=\"vm.search\" placeholder=\"חיפוש\"></md-input-container></div></div><md-progress-linear ng-show=\"vm.proccess\" \nmd-mode=\"Indeterminate\" class=\"md-primary\"></md-progress-linear><div class=\"content scrollable\" flex layout=\"row\" \nlayout-align=\"start start\"><div class=\"main\" flex ms-scroll id=\"contactslist\"><md-list class=\"contacts-list\"><table \nng-show=\"vm.clients.length\" dir=\"rtl\" class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><a \nng-click=\"vm.changeSort(\'ClientName\')\">שם</a></span></div></th><th hide show-gt-xs class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\"><a ng-click=\"vm.changeSort(\'KDate\')\">תאריך</a></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><a ng-click=\"vm.changeSort(\'TimeIN\')\">\nזמן כניסה</a></span></div></th><th hide show-gt-xs class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\"><a ng-click=\"vm.changeSort(\'TimeOUT\')\">זמן יציאה</a></span></div></th><th hide show-gt-md \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><a \nng-click=\"vm.changeSort(\'PhotosListClient\')\">צילומים</a></span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\"><a ng-click=\"vm.changeSort(\'doctorName\')\">שם רופא</a></span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><a ng-click=\"vm.changeSort(\'sumPay\')\">\nמחיר</a></span></div></th><th hide show-gt-md class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\"><a ng-click=\"vm.changeSort(\'bituachName\')\">גורם משלם</a></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><a ng-click=\"vm.changeSort(\'ovedName\')\">\nמצלם</a></span></div></th><th hide show-gt-md class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\"><a ng-click=\"vm.changeSort(\'placeName\')\">סניף</a></span></div></th><th hide show-gt-xs \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><a ng-click=\"vm.changeSort(\'ClientNote\')\">\nהערות</a></span></div></th><th hide show-gt-xs>פעולות</th></tr></thead><tbody ng-show=\"waiters.length\"><tr \nclass=\"title\"><td colspan=\"9\" class=\"text-bold bg-gray\">ממתינים - {{waiters.length}}</td></tr><tr \nui-sref=\"app.profile({id:client.ClientID})\" class=\"blue-fg\" \nng-repeat=\"client in vm.clients |orderBy:ClientID:true |filter:vm.search|filter:{ZulamStatus:1}|filter:query as waiters track by $index \">\n<td><md-icon md-font-icon=\"icon-numeric-{{waiters.length-$index}}-box-outline\"></md-icon>{{ client.ClientName}}</td><td\n hide show-gt-xs>{{ client.KDate|date:\'dd/MM/yy\'}}</td><td>{{ client.TimeIN|date:\'HH:mm\'}}</td><td hide show-gt-xs>\n{{ client.TimeOUT|date:\'HH:mm\'}}</td><td hide show-gt-md><span class=\"text-truncate\">{{ client.PhotosListClient}}\n</span></td><td>{{ client.doctorName}}</td><td>{{ client.sumPay||client.PhotosPrice| customCurrency}}<span \nng-hide=\"true\">OLD: {{ client.PhotosPrice}}</span></td><td hide show-gt-md>{{ client.bituachName}}</td><td>\n{{ client.ovedName}}</td><td hide show-gt-md>{{ client.placeName}}</td><td hide show-gt-xs><span class=\"text-truncate\" \ntitle=\"{{ client.ClientNote}}\">{{ client.ClientNote}}</span></td><td hide show-gt-xs><md-menu><md-button \nclass=\"md-icon-button\" aria-label=\"More\" translate translate-attr-aria-label=\"CONTACTS.MORE\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" ng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"vm.printClient(client, ev)\"><md-icon md-font-icon=\"icon-printer\"></md-icon>הדפס\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.SippingDetails(client, ev)\"><md-icon \nmd-font-icon=\"icon-shopping\"></md-icon>פרטי רופא/משלוח</md-button></md-menu-item><md-divider></md-divider>\n<md-menu-item><md-button ng-disabled=\"client.ZulamStatus==5\" ng-click=\"vm.updateEmployee(client, ev)\"><md-icon \nmd-font-icon=\"icon-worker\"></md-icon>עדכון מצלם</md-button></md-menu-item><md-menu-item \nng-show=\"client.ZulamStatus==5\"><md-button ng-click=\"vm.clientBack(client, ev)\"><md-icon \nmd-font-icon=\"icon-open-in-app\"></md-icon>חזר</md-button></md-menu-item><md-menu-item ng-hide=\"client.ZulamStatus==5\">\n<md-button ng-click=\"vm.clientLeft(client, ev)\"><md-icon md-font-icon=\"icon-exit-to-app\"></md-icon>עזב</md-button>\n</md-menu-item><md-divider></md-divider><md-menu-item><md-button ng-disabled=\"client.isClosed\" class=\"red-fg\" \nng-click=\"vm.RemoveClient(client, ev)\"><md-icon md-font-icon=\"icon-cancel\" class=\"red-fg\"></md-icon>מחק</md-button>\n</md-menu-item></md-menu-content></md-menu></td></tr></tbody><tbody ng-show=\"zilumNow.length\"><tr class=\"title\"><td \ncolspan=\"9\" class=\"text-bold bg-gray\">בצילום - {{zilumNow.length}}</td></tr><tr \nui-sref=\"app.profile({id:client.ClientID})\" class=\"green-fg\" \nng-repeat=\"client in vm.clients|filter:vm.search|filter:{ZulamStatus:2}|filter:query as zilumNow\"><td>\n{{ client.ClientName}}</td><td hide show-gt-xs>{{ client.KDate|date:\'dd/MM/yy\'}}</td><td>\n{{ client.TimeIN|date:\'HH:mm\'}}</td><td hide show-gt-xs>{{ client.TimeOUT|date:\'HH:mm\'}}</td><td hide show-gt-md><span \nclass=\"text-truncate\">{{ client.PhotosListClient}}</span></td><td>{{ client.doctorName}}</td><td>\n{{ client.sumPay||client.PhotosPrice| customCurrency}}<span ng-hide=\"true\">OLD: {{ client.PhotosPrice}}</span></td><td \nhide show-gt-md>{{ client.bituachName}}</td><td>{{ client.ovedName}}</td><td hide show-gt-md>{{ client.placeName}}</td>\n<td hide show-gt-xs><span class=\"text-truncate\" title=\"{{ client.ClientNote}}\">{{ client.ClientNote}}</span></td><td \nhide show-gt-xs><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"CONTACTS.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdOpenMenu($event)\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.printClient(client, ev)\">\n<md-icon md-font-icon=\"icon-printer\"></md-icon>הדפס</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.SippingDetails(client, ev)\"><md-icon md-font-icon=\"icon-shopping\"></md-icon>פרטי רופא/משלוח</md-button>\n</md-menu-item><md-divider></md-divider><md-menu-item><md-button ng-disabled=\"client.ZulamStatus==5\" \nng-click=\"vm.updateEmployee(client, ev)\"><md-icon md-font-icon=\"icon-worker\"></md-icon>עדכון מצלם</md-button>\n</md-menu-item><md-menu-item ng-show=\"client.ZulamStatus==5\"><md-button ng-click=\"vm.clientBack(client, ev)\"><md-icon \nmd-font-icon=\"icon-open-in-app\"></md-icon>חזר</md-button></md-menu-item><md-menu-item ng-hide=\"client.ZulamStatus==5\">\n<md-button ng-click=\"vm.clientLeft(client, ev)\"><md-icon md-font-icon=\"icon-exit-to-app\"></md-icon>עזב</md-button>\n</md-menu-item><md-divider></md-divider><md-menu-item><md-button ng-disabled=\"client.isClosed\" class=\"red-fg\" \nng-click=\"vm.RemoveClient(client, ev)\"><md-icon md-font-icon=\"icon-cancel\" class=\"red-fg\"></md-icon>מחק</md-button>\n</md-menu-item></md-menu-content></md-menu></td></tr></tbody><tbody ng-show=\"left.length\"><tr class=\"title\"><td \ncolspan=\"9\" class=\"text-bold bg-gray\">עזבו - {{left.length}}</td></tr><tr ui-sref=\"app.profile({id:client.ClientID})\" \nng-class=\"vm.classStatus(client)\" \nng-repeat=\"client in vm.clients|orderBy :vm.sortBy|filter:vm.search|filter:{ZulamStatus:5}|filter:query as left\"><td>\n<span ng-if=\"client.unUploadPhoto\"><md-icon md-font-icon=\"icon-alert\" class=\"red-fg\"></md-icon><md-tooltip>\n{{client.unUploadPhoto}} צילומים טרם הועלו</md-tooltip></span>{{ client.ClientName}}</td><td hide show-gt-xs>\n{{ client.KDate|date:\'dd/MM/yy\'}}</td><td>{{ client.TimeIN|date:\'HH:mm\'}}</td><td hide show-gt-xs>\n{{ client.TimeOUT|date:\'HH:mm\'}}</td><td hide show-gt-md><span class=\"text-truncate\">{{ client.PhotosListClient}}\n</span></td><td>{{ client.doctorName}}</td><td>{{ client.sumPay||client.PhotosPrice| customCurrency}}<span \nng-hide=\"true\">OLD: {{ client.PhotosPrice}}</span></td><td hide show-gt-md>{{ client.bituachName}}</td><td>\n{{ client.ovedName}}</td><td hide show-gt-md>{{ client.placeName}}</td><td hide show-gt-xs><span class=\"text-truncate\" \ntitle=\"{{ client.ClientNote}}\">{{ client.ClientNote}}</span></td><td hide show-gt-xs><md-menu><md-button \nclass=\"md-icon-button\" aria-label=\"More\" translate translate-attr-aria-label=\"CONTACTS.MORE\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" ng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"vm.printClient(client, ev)\"><md-icon md-font-icon=\"icon-printer\"></md-icon>הדפס\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.SippingDetails(client, ev)\"><md-icon \nmd-font-icon=\"icon-shopping\"></md-icon>פרטי רופא/משלוח</md-button></md-menu-item><md-divider></md-divider>\n<md-menu-item><md-button ng-disabled=\"client.ZulamStatus==5\" ng-click=\"vm.updateEmployee(client, ev)\"><md-icon \nmd-font-icon=\"icon-worker\"></md-icon>עדכון מצלם</md-button></md-menu-item><md-menu-item \nng-show=\"client.ZulamStatus==5\"><md-button ng-click=\"vm.clientBack(client, ev)\"><md-icon \nmd-font-icon=\"icon-open-in-app\"></md-icon>חזר</md-button></md-menu-item><md-menu-item ng-hide=\"client.ZulamStatus==5\">\n<md-button ng-click=\"vm.clientLeft(client, ev)\"><md-icon md-font-icon=\"icon-exit-to-app\"></md-icon>עזב</md-button>\n</md-menu-item></md-menu-content></md-menu></td></tr></tbody></table><div ng-show=\"!vm.clients.length\"><div \nclass=\"content\"><div class=\"info-line md-title dir-rtl\" layout=\"row\" layout-align=\"center center\" flex><div \nclass=\"info-line md-title dir-rtl\" layout=\"column\" layout-align=\"center center\" flex><div>אין פציינטים</div><div>\n<md-icon md-font-icon=\"icon-close\" class=\"s200\"></md-icon></div><md-button class=\"md-accent\" ui-sref=\"app.newclient\">\nהוסף לקוח כעת<md-icon md-font-icon=\"icon-account-plus\"></md-icon></md-button></div></div></div></div></md-list>\n<md-list-item class=\"no-results md-white-bg\" ng-show=\"filteredContacts.length === 0\"><p>אין תוצאות</p></md-list-item>\n</div></div><div id=\"add-contact-button\"><md-button class=\"md-fab md-accent md-icon-button\" ui-sref=\"app.newclient\" \naria-label=\"add contact\" translate translate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon></md-button></div></div>");
$templateCache.put("app/main/docs/docs.html","<iframe src=\"https://docs.google.com/document/d/1pl9184YOj5BQmf3hzfzm-FD_ExXOzbk12rHunx2WKEA/edit?usp=sharing\" \nonload=\"this.width=screen.width;this.height=screen.height\" width=\"760\" height=\"1000\" frameborder=\"0\" marginheight=\"0\" \nmarginwidth=\"0\">טוען...</iframe>");
$templateCache.put("app/main/employee-report/employee-report.html","<div id=\"contacts\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"column\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon>\n</span>&nbsp; <span class=\"logo-text\" ng-show=\"vm.employee\">{{vm.employee.name}}</span> <span class=\"logo-text\" \nng-show=\"vm.month\">&nbsp; דוח לחודש {{vm.month|date:\'MMMM\'}}</span> <span class=\"logo-text\" ng-hide=\"vm.employee\">\nהקש או העבר מספר עובד בתיבה משמאל</span></div><div class=\"mt-16\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised md-accent\" ng-disabled=\"!vm.employee\" ng-click=\"vm.getData(true)\"><md-icon \nmd-font-icon=\"icon-account-search\"></md-icon>חודש נוכחי</md-button><md-button class=\"md-raised md-accent\" \nng-disabled=\"!vm.employee\" ng-click=\"vm.getData(false)\"><md-icon md-font-icon=\"icon-account-search\"></md-icon>חודש קודם\n</md-button></div></div><div hide show-gt-xs class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\">\n<md-input-container md-no-float class=\"m-0\"><input id=\"cardEmployeeReprt\" ng-keypress=\"vm.cardLeft()\" ng-minlength=\"2\" \nrequired type=\"text\" ng-model=\"vm.card\" placeholder=\"העבר כאן כרטיס עובד\"></md-input-container></div></div>\n<md-progress-linear ng-show=\"vm.isAdvancedSearching||vm.isLoadingData\" md-mode=\"Indeterminate\" class=\"md-primary\">\n</md-progress-linear><div class=\"content scrollable\" flex layout=\"row\" layout-align=\"start start\"><div class=\"main\" \nflex ms-scroll id=\"contactslist\"><md-list class=\"contacts-list\"><div>\nהערה: נוכחות עד ה-10/3/18 מוצגים בהפרש של שעתיים קדימה - ואינו משפיע על חישוב סך שעות העבודה</div><table \nng-show=\"vm.data.length\" dir=\"rtl\" class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead>\n<tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><a \nng-click=\"vm.changeSort(\'ClientName\')\">שם</a></span></div></th><th hide show-gt-xs class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\"><a ng-click=\"vm.changeSort(\'KDate\')\">תאריך</a></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><a ng-click=\"vm.changeSort(\'KDate\')\">\nזמן כניסה</a></span></div></th><th hide show-gt-xs class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\"><a ng-click=\"vm.changeSort(\'TimeOUT\')\">זמן יציאה</a></span></div></th><th hide show-gt-xs \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><a ng-click=\"vm.changeSort(\'TimeOUT\')\">\nזמן שהייה</a></span></div></th></tr></thead><tbody><tr \nng-repeat=\"item in vm.data |orderBy :vm.sortBy |filter:query as waiters track by $index \"><td>{{ item.Name}}</td><td \nhide show-gt-xs>{{ item.TimeIN|date:\'EEEE \'}} - {{ item.TimeIN|date:\'dd/MM/yy\'}}</td><td hide show-gt-xs>\n{{ item.TimeIN|date:\'HH:mm\'}}</td><td hide show-gt-xs>{{ item.TimeOut|date:\'HH:mm\'}}</td><td hide show-gt-xs>\n{{ item.sum}}</td></tr></tbody><tfoot><td colspan=\"4\">&nbsp;</td><td>{{vm.SumAlltime}}</td></tfoot></table><div \nng-show=\"!vm.data.length\"><div class=\"content\"><div class=\"info-line md-title dir-rtl\" layout=\"row\" \nlayout-align=\"center center\" flex><div class=\"info-line md-title dir-rtl\" layout=\"column\" layout-align=\"center center\" \nflex><div>נא להעביר כרטיס עובד</div><div><md-icon md-font-icon=\"icon-close\" class=\"s200\"></md-icon></div></div></div>\n</div></div></md-list></div></div></div>");
$templateCache.put("app/main/employees/entry_dialog.html","<md-dialog id=\"dialogEmployees\" class=\"register_copyrator\" aria-label=\"New Task\"><div \nclass=\"profile-box latest-activity md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"end center\"><div class=\"title\">כניסת ויציאת עובדים</div></header><div class=\"content dir-rtl p-8\" \nlayout=\"row\" flex layout-wrap><div class=\"\" layout=\"column\" flex=\"\" layout-align=\"start start\"><div layout=\"row\" flex>\n<md-switch ng-change=\"vm.changemode()\" ng-model=\"vm.entryMode\">כניסה/יציאה</md-switch><div class=\"time\" flex=\"50\">\n{{vm.date | date:\'HH:mm:ss\'}}</div></div><ms-widget class=\"h-300 ms-widget ng-isolate-scope\" layout=\"column\" \nflex=\"100\"><ms-widget-front class=\"p-16 teal-bg white-fg\" layout=\"row\" flex=\"\"><div layout=\"column\" \nlayout-align=\"center center\" flex=\"\"><div class=\"md-display-3 pb-8\"><span ng-show=\"vm.entryMode\">\n{{vm.modeLabels.ENTRY}}</span> <span ng-hide=\"vm.entryMode\">{{vm.modeLabels.LEAVE}}</span></div><div \nclass=\"h3 font-weight-500\">{{vm.status}}</div></div><div class=\"background-image-center\"><md-icon \nmd-font-icon=\"icon-credit-card\" class=\"s256 faint-text md-default-theme md-font\" role=\"img\" \naria-label=\"icon-file-document\"></md-icon></div></ms-widget-front></ms-widget><div layout=\"column\" class=\"mt-20\" flex>\n<div layout=\"row\" flex layout-align=\"center center\"></div><div ng-hide=\"vm.manual\" layout=\"row\"><input type=\"text\" \nid=\"cardEmployee\" ng-model=\"vm.cardauto\" class=\"white-fg\" ng-keypress=\"vm.cardLeft()\" placeholder=\"\" required></div>\n</div></div></div></div></md-dialog>");
$templateCache.put("app/main/insurance/insurance.html","<div id=\"insurance\" class=\"page-layout simple tabbed\"><div class=\"fheader header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-text\">ביטוחים</span></div></div></div><div class=\"content\" flex><md-tabs \nmd-dynamic-height><md-tab ng-repeat=\"ins in vm.factorPays|filter:{active:true}\"><md-tab-label><span>{{ins.Name}}</span>\n</md-tab-label><md-tab-body><md-content class=\"details-tab\"><or-insurance data=\"vm.InsurancePrices\" \ninsurance-id=\"ins.BituahID\"></or-insurance></md-content></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/inventories/inventories.html","<div id=\"inventories\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" flex \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" flex=\"70\" layout-align=\"space-between\"><div \nclass=\"title\">מלאי והזמנות</div></div><div hide show-gt-xs class=\"search-input-wrapper\" layout=\"row\" \nlayout-align=\"start center\"><md-input-container md-no-float class=\"m-0\"><input id=\"search\" ng-change=\"vm.typeSearch()\" \ntype=\"text\" ng-model=\"vm.search\" placeholder=\"חפש מספר הזמנה\"></md-input-container></div></div><md-progress-linear \nng-show=\"vm.proccess\" md-mode=\"Indeterminate\" class=\"md-primary\"></md-progress-linear><div class=\"content scrollable\" \nflex layout=\"row\" layout-align=\"start start\"><div class=\"main\" flex ms-scroll id=\"contactslist\"><div \nclass=\"widget-group\" ng-if=\"false\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget class=\"h-140\" layout=\"column\" \nflex=\"100\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex><div layout=\"row\" \nlayout-align=\"space-between center\" flex><div class=\"md-display-2 pb-8 md-default-theme\"><span ng-show=\"vm.proccess\">\nמחפש...</span> <span ng-hide=\"vm.proccess\">{{(vm.search?\'לא נמצא\':\'איתור הזמנה\')}}</span></div><div \nclass=\"h3 font-weight-500\"><md-input-container><input placeholder=\"הקש מספר הזמנה\" ng-change=\"vm.typeSearch()\" \nng-model=\"vm.search\"></md-input-container></div></div></ms-widget-front></ms-widget></div><md-list \nclass=\"contacts-list\"><table-report config=\"vm.config\" feilds=\"vm.feilds\" data=\"vm.inventories\" order-default=\"-KDate\" \nfilter-input=\"vm.search\"></table-report><div ng-show=\"vm.inventories.length\" layout-align=\"center center\" layout=\"row\" \nflex><md-button class=\"md-accent md-raised\" ng-disabled=\"vm.proccess\" ng-click=\"vm.refresh(true)\">רענן</md-button>\n</div><ms-widget ng-hide=\"vm.inventories.length\" class=\"h-300\" layout=\"column\" flex><ms-widget-front \nclass=\"p-16 white-bg\" layout=\"row\" flex><div layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"md-display-3 pb-8 md-default-theme\"><span ng-show=\"vm.proccess\">מחפש...</span> <span ng-hide=\"vm.proccess\">\n{{(vm.search?\'לא נמצא\':\'איתור הפניה\')}}</span></div><div class=\"h3 font-weight-500\"><md-input-container><input \nplaceholder=\"הקש שם או מספר הפנייה\" ng-change=\"vm.typeSearch()\" ng-model=\"vm.search\"></md-input-container></div></div>\n</ms-widget-front></ms-widget></md-list><md-list-item class=\"no-results md-white-bg\" \nng-show=\"filteredContacts.length === 0\"><p>אין תוצאות</p></md-list-item></div></div></div>");
$templateCache.put("app/main/insurance_report/insurance_report.html","<div id=\"Insurance_report\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-box\" class=\"s24\">\n</md-icon></span>&nbsp; <span class=\"logo-text\">דוח ביטוחים</span></div></div><div hide show-gt-xs \nclass=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><md-switch ng-model=\"vm.statusfilterMode\" \nng-change=\"vm.changeStatusfilterMode()\" aria-label=\"Switch 2\" class=\"md-accent\">&nbsp; הצג לא נשלחו בלבד&nbsp;\n</md-switch></div><div hide show-gt-xs class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\">\n<md-input-container md-no-float class=\"m-0\"><input id=\"search\" ng-change=\"vm.showAdvancedSearch=true\" type=\"text\" \nng-model=\"vm.search\" placeholder=\"חיפוש\"></md-input-container></div></div><md-progress-linear ng-show=\"vm.proccess\" \nmd-mode=\"Indeterminate\" class=\"md-primary\"></md-progress-linear><div class=\"content scrollable\" flex layout=\"row\" \nlayout-align=\"start start\"><div class=\"main\" flex id=\"contactslist\"><or-date-between-buttons mode=\"\'MONTH\'\" \ndates=\"vm.dates\" on-change=\"vm.refresh()\"></or-date-between-buttons><md-divider></md-divider><table ng-if=\"false\" \nng-show=\"vm.data.length\" dir=\"rtl\" class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead>\n<tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><a \nng-click=\"vm.changeSort(\'ClientName\')\">שם</a></span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\"><a ng-click=\"vm.changeSort(\'TZ\')\">ת.ז.</a></span></div></th><th hide show-gt-xs \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><a ng-click=\"vm.changeSort(\'KDate\')\">תאריך\n</a></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><a \nng-click=\"vm.changeSort(\'DoctorName\')\">רופא</a></span></div></th><th hide show-gt-md class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\"><a ng-click=\"vm.changeSort(\'InsuranceName\')\">חברה\\ביטוח</a></span>\n</div></th><th hide show-gt-md class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><a \nng-click=\"vm.changeSort(\'PhotosList\')\">צילום</a></span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\"><a ng-click=\"vm.changeSort(\'doctorName\')\">השתתפות</a></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><a ng-click=\"vm.changeSort(\'sumPay\')\">\nאסמכתא</a></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><a \nng-click=\"vm.changeSort(\'HafnayaNumber\')\">הפניה</a></span></div></th><th hide show-gt-xs>פעולות</th></tr></thead>\n<tbody><tr ng-class=\"{\'red-fg\':item.status===1,\'green-fg\':item.status===10}\" \nng-repeat=\"item in vm.data |orderBy :vm.sortBy |filter:vm.search|filter:vm.statusfilter|filter:query as waiters track by $index \">\n<td><a ui-sref=\"app.profile({id:item.ClientID})\">{{ item.ClientName}}</a></td><td>{{ item.TZ}}</td><td hide show-gt-xs>\n{{ item.KDate|date:\'dd/MM/yy\'}}</td><td>{{ item.DoctorName}}</td><td hide show-gt-md><span class=\"text-truncate\">\n{{ item.InsuranceName}}</span></td><td hide show-gt-md><span class=\"text-truncate\">{{ item.PhotoName}}</span></td><td \nhide show-gt-xs>{{ item.Deductible}}</td><td hide show-gt-xs>{{ item.reference}}</td><td hide show-gt-xs>\n{{ item.HafnayaNumber}}</td><td><md-menu ng-show=\"true\"><md-button aria-label=\"More\" class=\"md-accent\" \nng-disabled=\"item.status>2\" ng-click=\"$mdOpenMenu($event)\"><span ng-if=\"item.status==1\">לא נשלח</span> <span \nng-if=\"item.status==2\">נשלח</span> <span ng-if=\"item.status==10\">אושר</span> <span ng-if=\"item.status==20\">בבירור\n</span> <span ng-if=\"item.status==30\">מחלוקת</span> <span ng-if=\"item.status==40\">סירוב</span></md-button>\n<md-menu-content width=\"3\"><md-menu-item ng-if=\"item.status==1\"><md-button ng-click=\"vm.setStatusSent(item)\"><md-icon \nmd-font-icon=\"icon-send\"></md-icon>נשלח</md-button></md-menu-item><md-menu-item><md-button \nng-disabled=\"item.status!=2\" ng-click=\"vm.setStatusDefault(item)\"><md-icon md-font-icon=\"icon-cancel\"></md-icon>\nבטל שליחה</md-button></md-menu-item><md-divider></md-divider><md-menu-item><md-button ng-disabled=\"item.status!=2\" \nng-click=\"vm.setStatusConfirmed(item)\"><md-icon md-font-icon=\"icon-check-bookmark\"></md-icon>אושר</md-button>\n</md-menu-item><md-menu-item><md-button ng-disabled=\"item.status!=10\" ng-click=\"vm.setStatusPaid(item)\"><md-icon \nmd-font-icon=\"icon-cash-usd\"></md-icon>התקבל</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody>\n</table><md-tabs ng-if=\"true\" md-dynamic-height><md-tab ng-repeat=\"it in vm.data|unique:\'InsuranceID\'\"><md-tab-label>\n<span>{{it.InsuranceName}}</span></md-tab-label><md-tab-body><md-content class=\"details-tab\"><table \nng-show=\"vm.data.length\" dir=\"rtl\" class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead>\n<tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><a \nng-click=\"vm.changeSort(\'ClientName\')\">שם</a></span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\"><a ng-click=\"vm.changeSort(\'TZ\')\">ת.ז.</a></span></div></th><th hide show-gt-xs \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><a ng-click=\"vm.changeSort(\'KDate\')\">תאריך\n</a></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><a \nng-click=\"vm.changeSort(\'DoctorName\')\">רופא</a></span></div></th><th hide show-gt-md class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\"><a ng-click=\"vm.changeSort(\'InsuranceName\')\">חברה\\ביטוח</a></span>\n</div></th><th hide show-gt-md class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><a \nng-click=\"vm.changeSort(\'PhotosList\')\">צילום</a></span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\"><a ng-click=\"vm.changeSort(\'doctorName\')\">השתתפות</a></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><a ng-click=\"vm.changeSort(\'sumPay\')\">\nאסמכתא</a></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><a \nng-click=\"vm.changeSort(\'HafnayaNumber\')\">הפניה</a></span></div></th><th class=\"secondary-text\" \nng-show=\"it.InsuranceID==14\"><div class=\"table-header\"><span class=\"column-title\"><a \nng-click=\"vm.changeSort(\'orderNumber\')\">מס רכש</a></span></div></th><th hide show-gt-xs>פעולות</th></tr></thead><tbody>\n<tr ng-class=\"{\'red-fg\':item.status===1&&item.reference!=\'מושלם\'&&!item.orderNumber,\'green-fg\':item.status===10}\" \nng-repeat=\"item in vm.data |orderBy :vm.sortBy |filter:vm.search|filter:vm.statusfilter|filter:{InsuranceID:it.InsuranceID}:true|filter:query as waiters track by $index \">\n<td><a ui-sref=\"app.profile({id:item.ClientID})\">{{ item.ClientName}}</a></td><td>{{ item.TZ}}</td><td hide show-gt-xs>\n{{ item.KDate|date:\'dd/MM/yy\'}}</td><td>{{ item.DoctorName}}</td><td hide show-gt-md><span class=\"text-truncate\">\n{{ item.InsuranceName}}</span></td><td hide show-gt-md><span class=\"text-truncate\">{{ item.PhotoName}}</span></td><td \nhide show-gt-xs>{{ item.Deductible}}</td><td hide show-gt-xs>{{ item.reference}}</td><td hide show-gt-xs>\n{{ item.HafnayaNumber}}</td><td hide show-gt-xs ng-show=\"it.InsuranceID==14\">{{ item.orderNumber}}</td><td><md-menu \nng-show=\"true\"><md-button aria-label=\"More\" class=\"md-accent\" ng-disabled=\"item.status>2\" \nng-click=\"$mdOpenMenu($event)\"><span ng-if=\"item.status==1\">לא נשלח</span> <span ng-if=\"item.status==2\">נשלח</span> \n<span ng-if=\"item.status==10\">אושר</span> <span ng-if=\"item.status==20\">בבירור</span> <span ng-if=\"item.status==30\">\nמחלוקת</span> <span ng-if=\"item.status==40\">סירוב</span></md-button><md-menu-content width=\"3\"><md-menu-item \nng-if=\"item.status==1\"><md-button ng-click=\"vm.setStatusSent(item)\"><md-icon md-font-icon=\"icon-send\"></md-icon>נשלח\n</md-button></md-menu-item><md-menu-item><md-button ng-disabled=\"item.status!=2\" ng-click=\"vm.setStatusDefault(item)\">\n<md-icon md-font-icon=\"icon-cancel\"></md-icon>בטל שליחה</md-button></md-menu-item><md-divider></md-divider>\n<md-menu-item><md-button ng-disabled=\"item.status!=2\" ng-click=\"vm.setStatusConfirmed(item)\"><md-icon \nmd-font-icon=\"icon-check-bookmark\"></md-icon>אושר</md-button></md-menu-item><md-menu-item><md-button \nng-disabled=\"item.status!=10\" ng-click=\"vm.setStatusPaid(item)\"><md-icon md-font-icon=\"icon-cash-usd\"></md-icon>התקבל\n</md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table></md-content></md-tab-body></md-tab>\n</md-tabs><div ng-show=\"vm.data.length\"><h1 class=\"center-block text-right\">!שים/י לב<br>\nלאחר שליחת הצילומים יש ללחוץ על כפתור הפעולות (\"לא נשלח\" כברירת מחדל) ולשנות מצב ל\"נשלח\". לצורך פעולה זו תתבקש/י להכניס מספר אסמכתא. במידה ואין, נא להקיש 0\n</h1></div><md-list class=\"contacts-list\"><div ng-show=\"!vm.data.length\"><div class=\"content\"><div \nclass=\"info-line md-title dir-rtl\" layout=\"row\" layout-align=\"center center\" flex><div \nclass=\"info-line md-title dir-rtl\" layout=\"column\" layout-align=\"center center\" flex><div>אין ביטוחים</div><div>\n<md-icon md-font-icon=\"icon-close\" class=\"s200\"></md-icon></div></div></div></div></div></md-list><md-list-item \nclass=\"no-results md-white-bg\" ng-show=\"filteredContacts.length === 0\"><p>אין תוצאות</p></md-list-item></div></div>\n</div>");
$templateCache.put("app/main/newclient/newclient.html","<div id=\"newclient\" class=\"page-layout blank\" layout=\"row\" ms-scroll layout-align=\"center start\"><div flex=\"100\" \nflex-gt-sm=\"100\" flex-gt-md=\"70\" class=\"md-whiteframe-8dp white-bg\"><div layout=\"row\" layout-align=\"center center\" \nflex ng-show=\"vm.prescription\" class=\"font-size-20\"><span ng-hide=\"vm.prescriptionData\">טוען פרטים... אנא המתן</span> \n<span ng-show=\"vm.prescriptionData\">קליטת פציינט מתוך <a href=\"#\" ng-click=\"vm.dialogPrescription(event)\">\nהפנייה {{vm.prescription}}</a> (לחץ לקבלת פרטים)</span></div><ms-form-wizard flex><md-tabs md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\">פרטים אישיים</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep1\" id=\"formNewClient\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"TZ\" \nng-pattern=\"/^[0-9]*$/\" ng-minlength=\"6\" ng-maxlength=\"9\" ng-model=\"vm.formWizard.TZ\" placeholder=\"מס זהות\" required>\n<div ng-messages=\"wizardStep1.TZ.$error\" ng-show=\"wizardStep1.TZ.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span>ערך אינו תקין</span></div><div ng-message=\"minlength\">מספר זהות חייב להכיל בין 6 ל 9 תוים</div><div \nng-message=\"maxlength\">מספר זהות חייב להכיל בין 6 ל 9 תוים</div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"date\" name=\"ClientBirthDate\" ng-model=\"vm.formWizard.ClientBirthDate\" \nplaceholder=\"תאריך לידה\"><div ng-messages=\"wizardStep1.ClientBirthDate.$error\" \nng-show=\"wizardStep1.ClientBirthDate.$touched\" role=\"alert\"><div ng-message=\"required\"><span>ערך אינו תקין</span></div>\n</div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"text\" ng-minlength=\"3\" name=\"ClientName\" ng-model=\"vm.formWizard.ClientName\" \nplaceholder=\"שם פציינט\" required><div ng-messages=\"wizardStep1.ClientName.$error\" \nng-show=\"wizardStep1.ClientName.$touched\" role=\"alert\"><div ng-message=\"required\"><span>שדה חובה</span></div><div \nng-message=\"minlength\">הקש מינימום 3 תוים</div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"text\" name=\"placeName\" ng-model=\"vm.formWizard.placeName\" value=\"בני ברק 4\" \nplaceholder=\"סניף\" ng-disabled=\"true\" required></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"Tel\" ng-model=\"vm.formWizard.Tel\" \nplaceholder=\"טלפון\" ng-minlength=\"8\" ng-maxlength=\"12\" ng-pattern=\"/^[0-9,-]*$/\" required><div \nng-messages=\"wizardStep1.Tel.$error\" ng-show=\"wizardStep1.Tel.$touched\" role=\"alert\"><div ng-message=\"required\"><span>\nשדה חובה</span></div><div ng-message=\"minlength\">ערך לא תקין</div><div ng-message=\"maxlength\">ערך לא תקין</div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><textarea placeholder=\"הערות לפציינט\" cols=\"40\" rows=\"4\" \nname=\"ClientNote\" ng-maxlength=\"250\" ng-model=\"vm.formWizard.ClientNote\"></textarea><div \nng-messages=\"wizardStep1.ClientNote.$error\" ng-show=\"wizardStep1.ClientNote.$touched\" role=\"alert\"><div \nng-message=\"minlength\">ערך לא תקין</div><div ng-message=\"maxlength\">מקסימום 250 תוים</div></div></md-input-container>\n</div></div><div flex layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex class=\"md-block\"><input type=\"date\" \nname=\"cardholder\" ng-model=\"vm.formWizard.HafnayaDate\" placeholder=\"תאריך הפנייה\"></md-input-container>\n<md-input-container flex class=\"md-block\"><input type=\"text\" ng-disabled=\"false\" name=\"cardholder\" \nng-model=\"vm.formWizard.HafnayaNumber\" placeholder=\"מס\' הפנייה\"><md-button class=\"btn-link md-accent\" \nng-disabled=\"false\" ng-click=\"vm.dialog_reference(e)\">הוסף הפניה</md-button></md-input-container><md-input-container \nflex class=\"md-block\"><input type=\"text\" name=\"cardholder\" ng-model=\"vm.formWizard.MithareName\" placeholder=\"מתחרה\">\n</md-input-container></div><label>משלוח</label><md-checkbox ng-model=\"vm.formWizard.MishloahSW\"></md-checkbox></form>\n</md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\">רופא מפנה</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep2\" ms-form-wizard-form novalidate><ms-prices-doctors copies=\"vm.formWizard.photosArr\" \nclient=\"vm.formWizard\" doctor=\"vm.formWizard.Doctor\" bituah-id=\"vm.formWizard.BituahID\" \nstandrd-insurances=\"vm.standrdInsurances\" count-copies=\"vm.formWizard.countCopies\"></ms-prices-doctors><input \nng-hide=\"true\" type=\"text\" required ng-model=\"vm.formWizard.Doctor.DoctorID\"></form></md-tab-body></md-tab><md-tab \nng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid \"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span\n class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep4.$invalid\">3</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep4.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\">שונות</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" \nms-form-wizard-form novalidate><div layout=\"column\" class=\"m-40 fs-20\" layout-align=\"center center\"><div>\nפציינט: {{vm.formWizard.ClientName}}</div><div>רופא: {{vm.formWizard.Doctor.Name}}</div><md-divider></md-divider><div>\nצילומים:</div><div ng-repeat=\"c in vm.formWizard.photosArr\">{{c.Name}} - {{(c.fixprice+c.Deductible)|customCurrency }}\n</div><div ng-show=\"vm.formWizard.MishloahSW\">כולל משלוח</div><div ng-show=\"vm.progressing\"><div layout=\"column\" \nlayout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular></md-progress-circular></div></div><div \nng-if=\"vm.formWizard.BituahID==20||vm.formWizard.BituahID==21||vm.formWizard.BituahID==22\"><md-input-container flex \nclass=\"md-block\"><input type=\"text\" name=\"BituahID\" ng-disabled=\"false\" ng-pattern=\"/^[0-9,-]*$/\" ng-minlength=\"9\" \nng-maxlength=\"14\" ng-required=\"vm.formWizard.BituahID==20||vm.formWizard.BituahID==21||vm.formWizard.BituahID==22\" \nng-model=\"vm.formWizard.HafnayaNumber\" placeholder=\" מס\' הפנייה קופת חולים\"><md-button class=\"btn-link md-accent\" \nng-click=\"vm.dialog_reference(e,true)\">הוסף הפניה</md-button><div ng-messages=\"wizardStep3.BituahID.$error\" \nng-show=\"wizardStep3.BituahID.$touched\" role=\"alert\"><div ng-message=\"required\"><span>חובה להזין מס\' הפנייה של קופ\"ח\n</span></div><div ng-message=\"pattern\">מס\' הפניה שגוי</div><div ng-message=\"minlength\">מס הפנייה קצר מידי</div><div \nng-message=\"maxlength\">מס הפנייה ארוך מידי</div></div></md-input-container></div></div></form></md-tab-body></md-tab>\n</md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">הקודם</md-button>\n<div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\">הבא</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"vm.sendForm();\" ng-show=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.formsIncomplete()||vm.progressing\">\nאישור</md-button></div></ms-form-wizard></div></div>");
$templateCache.put("app/main/notes/notes.html","<div id=\"notes\" class=\"\" layout=\"column\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" ms-scroll \nmd-component-id=\"main-sidenav\" ms-sidenav-helper ng-include=\"\'app/main/notes/sidenavs/main/main-sidenav.html\'\">\n</md-sidenav><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" aria-label=\"Toggle sidenav\" translate \ntranslate-attr-aria-label=\"NOTES.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button>\n<div class=\"main-title\" layout=\"row\" layout-align=\"start center\"><md-icon class=\"logo-icon mr-8\" \nmd-font-icon=\"icon-lightbulb\"></md-icon><span class=\"title\" ng-if=\"vm.noteListType === \'notes\'\" \ntranslate=\"NOTES.NOTES\">Notes</span> <span class=\"title\" ng-if=\"vm.noteListType === \'reminders\'\" \ntranslate=\"NOTES.REMINDERS\">Reminders</span> <span class=\"title\" ng-if=\"vm.noteListType === \'archive\'\" \ntranslate=\"NOTES.ARCHIVE\">Archive</span> <span class=\"title\" ng-if=\"vm.noteListType.name\">{{vm.noteListType.name}}\n</span> <span ng-if=\"filteredNotes.length\" class=\"pl-8 white-text secondary-text notes-count\">\n({{filteredNotes.length}})</span></div></div><div flex></div><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.openSearchToolbar()\" aria-label=\"open search toolbar\" translate \ntranslate-attr-aria-label=\"NOTES.OPEN_SEARCH_TOOLBAR\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon\"></md-icon>\n</md-button></div><div ng-show=\"vm.searchToolbar\" \nclass=\"md-toolbar-tools search-toolbar animate-slide-down md-accent-bg\" layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeSearchToolbar()\" translate translate-attr-aria-label=\"NOTES.CLOSE\" \naria-label=\"close\"><md-icon md-font-icon=\"icon-close\" class=\"mr-8\"></md-icon></md-button><input \nid=\"search-notes-input\" placeholder=\"Search notes\" type=\"text\" ng-model=\"vm.search\" translate \ntranslate-attr-placeholder=\"NOTES.SEARCH_NOTES\" ng-model-options=\"{\'debounce\': 200}\" flex></div></md-toolbar>\n<md-content ms-scroll flex><ms-new-note ng-hide=\"vm.noteListType === \'archive\'\" class=\"md-whiteframe-2dp\">\n</ms-new-note><ms-masonry class=\"notes\" options=\'{\"columnCount\":5}\'><ms-masonry-item class=\"note\" \nng-repeat=\"note in vm.notes | filter:vm.search | filter:vm.filters | filterByPropIds:\'labels\':vm.labelFilterIds |  orderBy: \'time\':true | filter:query as filteredNotes track by note.id \" \nms-note-item=\"note\" ng-click=\"vm.editNote($event, note.id)\"></ms-masonry-item></ms-masonry><div \nclass=\"no-results text-center\" ng-if=\"filteredNotes.length === 0 &&  vm.search === \'\'\"><div class=\"message\" \nng-if=\"vm.noteListType === \'notes\'\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-lightbulb\"></md-icon><div \nclass=\"message-text\" translate=\"NOTES.NO_NOTES_YET\">No notes yet...</div></div><div class=\"message\" \nng-if=\"vm.noteListType === \'reminders\'\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-bell\"></md-icon><div \nclass=\"message-text\" translate=\"NOTES.NO_NOTES_WITH_REMINDERS\">No notes with reminders</div></div><div class=\"message\" \nng-if=\"vm.noteListType === \'archive\'\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-archive\"></md-icon><div \nclass=\"message-text\" translate=\"NOTES.NO_ARCHIVED_NOTES\">No archived Notes</div></div><div class=\"message\" \nng-if=\"vm.noteListType.name\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-label\"></md-icon><div \nclass=\"message-text\" translate=\"NOTES.NO_NOTES_WITH_THIS_LABEL\">No notes with this label</div></div></div><div \nclass=\"no-results text-center\" ng-if=\"filteredNotes.length === 0 &&  vm.search !== \'\'\"><div class=\"message\"><md-icon \nclass=\"message-icon s96\" md-font-icon=\"icon-lightbulb\"></md-icon><div class=\"message-text\" \ntranslate=\"NOTES.NO_RESULTS\">No results...</div></div></div></md-content></div>");
$templateCache.put("app/main/profile/profile.html","<div id=\"profile\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div class=\"user-info\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><img \nclass=\"profile-image avatar huge\" src=\"assets/images/avatars/katherine.jpg\"><div layout=\"column\"><div \nclass=\"name black-fg\">{{vm.profile.ClientName}}</div><div class=\"black-fg\">{{vm.profile.KDate|date}}</div></div></div>\n<div class=\"actions\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-primary\" ng-click=\"vm.refresh()\">\n<md-icon md-font-icon=\"icon-refresh\"></md-icon>רענן</md-button><md-button class=\"md-raised md-accent\" \nng-click=\"vm.clientLeft(event)\" ng-hide=\"vm.profile.ZulamStatus==5\" translate-attr-aria-label=\"PROFILE.SEND_MESSAGE\">\nשחרר לקוח</md-button><md-button class=\"md-raised md-accent\" ng-click=\"vm.AcceptVisit(event)\" \nng-show=\"vm.profile.ZulamStatus==5\" translate-attr-aria-label=\"PROFILE.SEND_MESSAGE\">אישור ביקור</md-button><md-button \nclass=\"md-raised md-primary\" ng-click=\"vm.RemoveClient(event)\" ng-hide=\"vm.profile.isClosed\" \ntranslate-attr-aria-label=\"PROFILE.SEND_MESSAGE\">מחק לקוח</md-button></div></div><div class=\"content\" flex><md-tabs \nmd-dynamic-height><md-tab><md-tab-label><span>פרטים אישיים</span></md-tab-label><md-tab-body><md-content \nclass=\"details-tab\" ng-include=\"\'app/main/profile/tabs/details/details.html\'\"></md-content></md-tab-body></md-tab>\n<md-tab><md-tab-label><span>קופה ותשלומים</span></md-tab-label><md-tab-body><md-content class=\"billing-tab\" \nng-include=\"\'app/main/profile/tabs/billing/billing.html\'\"></md-content></md-tab-body></md-tab><md-tab ng-if=\"true\">\n<md-tab-label><span>צילומים ומסמכים<md-icon md-font-icon=\"icon-alert\" \nng-if=\"vm.profile.ZulamStatus==5 &&vm.profile.unUploadPhoto\" class=\"red-fg\"></md-icon></span></md-tab-label>\n<md-tab-body><md-content class=\"billing-tab\" ng-include=\"\'app/main/profile/tabs/photos/photos.html\'\"></md-content>\n</md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/referring/referring.html","<div id=\"referring\" class=\"orhashen page-layout blank\" layout=\"row\" ms-scroll layout-align=\"center center\"><div \nclass=\"invoice-container\" flex=\"100\" flex-gt-md=\"70\" flex-gt-sm=\"80\" layout-align=\"center center\"><div \nclass=\"card md-whiteframe-8dp\" layout=\"column\" flex><div class=\"content\" flex><div layout=\"row\" \nclass=\"seller md-whiteframe-1dp0\" flex layout-align=\"center start\"><div layout=\"column\" flex=\"50\"><div \nclass=\"content text-right mt-16\"><div class=\"info-line\"><div class=\"title\">פרטי רופא / מרפאה</div><div class=\"info\">\n{{vm.Referring.DoctorName}}</div><div class=\"info\">{{vm.Referring.Address}}</div><div class=\"info\">{{vm.doctor.Tel1}}\n</div><div class=\"info\">{{vm.doctor.Email1}}</div></div></div></div><div layout=\"column\" flex=\"50\"><div class=\"logo\" \nflex=\"100\" layout=\"row\" layout-align=\"center start\"><img src=\"/assets/images/logos/or.jpg\"></div></div></div>\n<md-divider></md-divider><div layout=\"row\" class=\"seller\" flex layout-align=\"center center\"><div \nclass=\"md-display-1 pt-8 red-fg\">הפנייה {{vm.Referring.id}}</div></div><div layout=\"row\" \nclass=\"seller md-whiteframe-1dp0\" flex layout-align=\"start center\"><div layout=\"column\" flex><div \nclass=\"content text-right mt-16\"><div class=\"info-line\"><div class=\"title\">פרטי פציינט</div><div class=\"info\"><md-icon \nmd-font-icon=\"icon-account\"></md-icon>{{vm.Referring.fname}} {{vm.Referring.lname}}</div><div class=\"info\" \nng-show=\"vm.Referring.tz\"><md-icon md-font-icon=\"icon-folder-account\"></md-icon>ת.ז. {{vm.Referring.tz}}</div><div \nclass=\"info\" ng-show=\"vm.Referring.phone\"><md-icon md-font-icon=\"icon-phone\"></md-icon>{{vm.Referring.phone}}</div><div\n class=\"info\" ng-show=\"vm.Referring.birthday\"><md-icon md-font-icon=\"icon-calendar\"></md-icon>{{vm.Referring.birthday}}\n</div></div></div><div ng-hide=\"true\" class=\"content text-right mt-16\"><div class=\"info-line\"><div class=\"title\">שם\n</div><div class=\"info ng-binding\">{{vm.Referring.fname}} {{vm.Referring.lname}}</div></div><div class=\"info-line\" \nng-show=\"vm.Referring.tz\"><div class=\"title\">מס. זהות</div><div class=\"info ng-binding\">{{vm.Referring.tz}}</div></div>\n<div class=\"info-line\" ng-show=\"vm.Referring.phone\"><div class=\"title\">טלפון</div><div class=\"info ng-binding\">\n{{vm.Referring.phone}}</div></div><div class=\"info-line\" ng-show=\"vm.Referring.birthday\"><div class=\"title\">ת. לידה\n</div><div class=\"info ng-binding\">{{vm.Referring.birthday|date}}</div></div></div></div></div><md-divider>\n</md-divider><div layout=\"row\" class=\"seller md-whiteframe-1dp0\" flex layout-align=\"start center\"><div layout=\"column\" \nflex><div class=\"content text-right mt-16\"><div class=\"info-line\"><div class=\"title\">צילומים מבוקשים</div><div \nclass=\"info\" ng-repeat=\"c in vm.Copies|filter:{group_id:\'!4\'}\" ng-show=\"c.selected\"><md-icon \nmd-font-icon=\"icon-filmstrip\"></md-icon>[ {{c.name_en}}] {{c.name}} <span ng-show=\"c.option\">( {{c.option}} )</span>\n</div></div><div class=\"info-line\" ng-show=\"qr.length\"><div class=\"title\">העדפות CT</div><div class=\"info\" \nng-repeat=\"c in vm.Copies|filter:{group_id:\'4\',selected:true}|filter: query as qr\"><md-icon \nmd-font-icon=\"icon-checked\"></md-icon>{{c.name}} <span ng-show=\"c.option\">( {{c.option}} )</span></div></div></div>\n</div></div><md-divider></md-divider><div layout=\"row\" class=\"seller md-whiteframe-1dp0\" flex \nlayout-align=\"start center\"><div layout=\"column\" flex><div class=\"content text-right mt-16\"><div class=\"info-line\"><div\n class=\"title\">איזור שיניים</div><div class=\"info\"><md-icon md-font-icon=\"icon-blur\"></md-icon>{{vm.Referring.teeth}}\n</div></div></div></div></div><md-divider></md-divider><div layout=\"row\" class=\"seller md-whiteframe-1dp0\" flex \nlayout-align=\"start center\"><div layout=\"column\" flex><div class=\"content text-right mt-16\"><div class=\"info-line\"><div\n class=\"title\">הערות</div><div class=\"info\"><md-icon md-font-icon=\"icon-note-outline\"></md-icon>\n{{vm.Referring.comments}}</div><div class=\"info\"><md-icon md-font-icon=\"icon-not-equal\"></md-icon>\n{{vm.doctor.comments}}</div></div></div></div></div></div><footer><md-button class=\"pr md-button md-accent md-raised\" \nng-click=\"vm.print()\">הדפס</md-button></footer></div><div class=\"page-break\"></div></div></div>");
$templateCache.put("app/main/reference_dialog/reference-dialog.html","<md-dialog class=\"reference-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-primary md-tall tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">איתור והוספת הפניות קופת חולים</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name font-size-15 dir-rtl\">\nהפנייה עבור פציינט: {{vm.client.ClientName}}</div></div></div></md-toolbar><md-dialog-content ms-scroll \nclass=\"ng-form\" name=\"dialogForm\"><md-input-container class=\"md-icon-float md-block mb-40\"><md-button \nng-disabled=\"vm.disabledOptions&&vm.client.BituahID!=20\" type=\"submit\" class=\"send-button md-raised font-size-12\" \nng-class=\"{\'md-accent\':vm.client.BituahID==20}\" ng-click=\"vm.client.BituahID=20\">מכבי</md-button><md-button \nng-disabled=\"vm.disabledOptions&&vm.client.BituahID!=14\" type=\"submit\" class=\"send-button md-raised font-size-12\" \nng-class=\"{\'md-accent\':vm.client.BituahID==14}\" ng-click=\"vm.client.BituahID=14\">כללית</md-button><md-button \nng-disabled=\"vm.disabledOptions&&vm.client.BituahID!=21\" type=\"submit\" class=\"send-button md-raised font-size-12\" \nng-class=\"{\'md-accent\':vm.client.BituahID==21}\" ng-click=\"vm.client.BituahID=21\">מאוחדת</md-button>\n</md-input-container><md-input-container class=\"md-icon-float md-block\"><label flex=\"50\">שם פציינט</label><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><input autocomplete=\"off\" name=\"clientname\" \nng-model=\"vm.client.ClientName\" type=\"text\"><div ng-messages=\"dialogForm.clientname.$error\"><div \nng-message=\"minlength\">הקש לפחות 5 תוים</div></div></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon><label>מס הפניה</label><input required placeholder=\"PO\" \nng-model=\"vm.client.HafnayaNumber\" type=\"text\" ng-disabled=\"false&&vm.client.BituahID==20\"><div \nng-messages=\"dialogForm.phone.$error\"><span ng-message=\"pattern\">מספר שגוי</span></div></md-input-container><p \nng-show=\"vm.client.BituahID==20\" class=\"dir-rtl\">בקרוב - הפניות דיגיטליות מסונכרנות למערכות מכבי ללא צורך בהקלדה</p>\n<div ng-if=\"false&& vm.client.BituahID==20\"><div ng-if=\"!vm.byNumber\" layout=\"row\" layout-align=\"center center\">\n<md-button class=\"md-accent\" ng-click=\"vm.byNumber=!vm.byNumber\">איתור הפניות מכבי לפי מספר</md-button></div><div \nng-if=\"vm.byNumber\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent\" \nng-click=\"vm.byNumber=!vm.byNumber\">איתור הפניות מכבי לפי שם</md-button></div><md-input-container ng-if=\"vm.byNumber\" \nclass=\"md-icon-float md-block\"><label flex=\"50\">חפש מספר הפניה</label><md-icon md-font-icon=\"icon-human-child\" \nclass=\"name\"></md-icon><input name=\"doctor\" ng-model=\"vm.hafnayaSearch\" placeholder=\"PO\" type=\"text\" ng-minlength=\"3\">\n<div ng-messages=\"dialogForm.doctor.$error\"><div ng-message=\"minlength\">הקש לפחות 3 תוים</div></div>\n</md-input-container><div layout=\"row\" class=\"md-block\" layout-align=\"start start\"><md-input-container flex \nclass=\"md-block m-8 mt-2\"><md-list-item flex layout-align=\"start start\" ng-click=\"vm.selectItem(hafnaya)\" \nng-class=\"{\'itemSelected\':hafnaya.reference_id==vm.client.HafnayaNumber,\'red-fg\':hafnaya.expired}\" \nng-repeat=\"hafnaya in vm.referenceList|   filter: (vm.byNumber? vm.hafnayaSearch:\'\') |filterMultyWords: (vm.byNumber?\'\':{name: vm.client.ClientName }) | limitTo :10|  filter: query as queryFil \">\n<md-icon flex=\"10\" md-font-icon=\"icon-human-child\" class=\"name\"></md-icon><div flex=\"40\">{{hafnaya.reference_id}}</div>\n<div flex=\"50\">{{hafnaya.name}}</div></md-list-item><md-list-item class=\"dir-rtl\" ng-hide=\"queryFil.length\">\nלא נמצאו הפניות</md-list-item></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-if=\"!vm.newContact\" ng-click=\"vm.submit()\" class=\"send-button md-accent md-raised font-size-12 saveBtn\" \nng-disabled=\"!vm.client.HafnayaNumber\" aria-label=\"SAVE\">אשר</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/reffering-list/reffering-list.html","<div id=\"reffering-list\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" flex \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" flex=\"70\" layout-align=\"space-between\"><div \nclass=\"title\">הפניות רופא</div></div><div hide show-gt-xs class=\"search-input-wrapper\" layout=\"row\" \nlayout-align=\"start center\"><md-input-container md-no-float class=\"m-0\"><input id=\"search\" ng-change=\"vm.typeSearch()\" \ntype=\"text\" ng-model=\"vm.search\" placeholder=\"הקש שם או מספר הפנייה\"></md-input-container></div></div>\n<md-progress-linear ng-show=\"vm.proccess\" md-mode=\"Indeterminate\" class=\"md-primary\"></md-progress-linear><div \nclass=\"content scrollable\" flex layout=\"row\" layout-align=\"start start\"><div class=\"main\" flex ms-scroll \nid=\"contactslist\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget class=\"h-140\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex=\"\">\n<button class=\"md-icon-button md-button md-default-theme md-ink-ripple\" ng-click=\"vm.refreshAll()\" type=\"button\">\n<md-icon md-font-icon=\"icon-refresh\" role=\"img\" aria-hidden=\"true\"></md-icon><md-tooltip>רענן נתונים</md-tooltip>\n</button><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex=\"\"><div \nclass=\"md-display-1 pb-8 ng-binding\">{{vm.ReferringPlaceList.sumVisited}}</div><div \nclass=\"font-weight-500 secondary-text\">הפניות שמומשו</div></div></ms-widget-front></ms-widget><ms-widget class=\"h-140\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex=\"\">\n<div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex=\"\"><div class=\"md-display-1 pb-8 ng-binding\">\n{{vm.ReferringPlaceList.sum}}</div><div class=\"font-weight-500 secondary-text\">הפניות בחודש האחרון</div></div>\n</ms-widget-front></ms-widget><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\">\n<ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex><div layout=\"row\" layout-align=\"space-between center\" flex>\n<div class=\"md-display-2 pb-8 md-default-theme\"><span ng-show=\"vm.proccess\">מחפש...</span> <span ng-hide=\"vm.proccess\">\n{{(vm.search?\'לא נמצא\':\'איתור הפניה\')}}</span></div><div class=\"h3 font-weight-500\"><md-input-container><input \nplaceholder=\"הקש שם או מספר הפנייה\" ng-change=\"vm.typeSearch()\" ng-model=\"vm.search\"></md-input-container></div></div>\n</ms-widget-front></ms-widget></div><md-list class=\"contacts-list\"><table-report config=\"vm.config\" feilds=\"vm.feilds\" \ndata=\"vm.clients\" editfeilds=\"true\" order-default=\"-KDate\" filter-input=\"vm.search\"></table-report><div \nng-show=\"vm.clients.length\" layout-align=\"center center\" layout=\"row\" flex><md-button class=\"md-accent md-raised\" \nng-click=\"vm.clear()\">הצג הכל</md-button></div><ms-widget ng-hide=\"vm.clients.length\" class=\"h-300\" layout=\"column\" \nflex><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex><div layout=\"column\" layout-align=\"center center\" flex>\n<div class=\"md-display-3 pb-8 md-default-theme\"><span ng-show=\"vm.proccess\">מחפש...</span> <span ng-hide=\"vm.proccess\">\n{{(vm.search?\'לא נמצא\':\'איתור הפניה\')}}</span></div><div class=\"h3 font-weight-500\"><md-input-container><input \nplaceholder=\"הקש שם או מספר הפנייה\" ng-change=\"vm.typeSearch()\" ng-model=\"vm.search\"></md-input-container></div></div>\n</ms-widget-front></ms-widget></md-list><md-list-item class=\"no-results md-white-bg\" \nng-show=\"filteredContacts.length === 0\"><p>אין תוצאות</p></md-list-item></div></div></div>");
$templateCache.put("app/main/reports/reports.html","<div id=\"reports\" class=\"or-header page-layout simple tabbed\"><div class=\"fheader header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-text\">דוח יומי</span><or-date-between-buttons dates=\"vm.dates\" \non-change=\"vm.ChangeDateReport()\" today-yesterday-only=\"true\"></or-date-between-buttons></div></div></div>\n<md-progress-linear ng-show=\"vm.proccess\" md-mode=\"Indeterminate\" class=\"md-primary\"></md-progress-linear><div \nclass=\"content\" flex=\"\"><md-content class=\"details-tab\" ng-include=\"\'app/main/reports/daily/daily.html\'\"></md-content>\n</div></div>");
$templateCache.put("app/main/reports_multy_view/reports_multy_view.html","<div id=\"reports_multy_view\" class=\"reports_view or-header page-layout simple left-sidenav inner-sidenav\"><div \nclass=\"header smallheader md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon\n md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span>&nbsp; <span class=\"logo-text\">התראות - נא לטפל!</span>\n</div></div><div hide show-gt-xs class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"></div></div>\n<md-progress-linear ng-show=\"vm.proccess\" md-mode=\"Indeterminate\" class=\"md-primary\"></md-progress-linear><div \nclass=\"content scrollable\" flex layout=\"row\" layout-align=\"start start\" ms-scroll=\"\"><div class=\"content\" flex=\"\" \nlayout=\"row\"></div><div flex=\"\" layout=\"row\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap>\n<div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-input-container \nmd-no-float class=\"m-0\"><input id=\"search\" type=\"text\" ng-model=\"vm.search\" placeholder=\"חיפוש\"></md-input-container>\n</div><div class=\"pv-8 h3\">{{vm.strDate}}</div><or-date-between-buttons dates=\"vm.dates\" custom-range=\"vm.range\" \nmode=\"\'CUSTOM\'\" on-change=\"vm.refresh()\"></or-date-between-buttons></div><div ng-show=\"vm.proccess\" layout=\"row\" \nlayout-align=\"center center\" layout-wrap><h1><center>טוען.... אנא המתן</center></h1></div><h1 ng-show=\"vm.all_is_good\" \nlayout-align=\"center center\" class=\"green-fg\"><center>הכל נראה מצויין - כל הכבוד!</center></h1><div \nng-repeat=\"report in vm.Reports\" ng-show=\"report.data.length\" layout=\"row\" layout-align=\"start start\" layout-wrap><p \nclass=\"ml-50\">{{report.name}}</p><div class=\"p-16\" layout=\"row\" flex=\"100\"><table-report ng-if=\"report.data.length\" \nflex feilds=\"report.config.feilds\" data=\"report.data\" editfeilds=\"report.config.edit\" config=\"report.config.config\" \nfilter-input=\"vm.search\" order-default=\"Name\"></table-report></div></div></ms-widget-front></ms-widget></div><div flex \nid=\"\"></div></div></div>");
$templateCache.put("app/main/sample/sample.html","<h1>{{vm.helloText}}</h1>");
$templateCache.put("app/main/reports_view/reports_view.html","<div id=\"reports_view\" class=\"reports_view or-header page-layout simple left-sidenav inner-sidenav\"><div \nclass=\"header smallheader md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon\n md-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span>&nbsp; <span class=\"logo-text\">{{vm.Report.title}}</span>\n</div></div><div hide show-gt-xs class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"></div></div>\n<md-progress-linear ng-show=\"vm.proccess\" md-mode=\"Indeterminate\" class=\"md-primary\"></md-progress-linear><div \nclass=\"content scrollable\" flex layout=\"row\" layout-align=\"start start\" ms-scroll=\"\"><div class=\"content\" flex=\"\" \nlayout=\"row\"></div><div flex=\"\" layout=\"row\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap>\n<div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-input-container \nmd-no-float class=\"m-0\"><input id=\"search\" type=\"text\" ng-model=\"vm.search\" placeholder=\"חיפוש\"></md-input-container>\n</div><div class=\"pv-8 h3\">{{vm.strDate}}</div><or-date-between-buttons dates=\"vm.dates\" custom-range=\"vm.range\" \non-change=\"vm.refresh()\"></or-date-between-buttons></div><div layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"p-16\" layout=\"row\" flex=\"100\"><table-report flex feilds=\"vm.table.feilds\" data=\"vm.table.data\" \neditfeilds=\"vm.table.edit\" config=\"vm.table.config\" on-edit-item=\"vm.editItem\" on-insert-item=\"vm.addEmployee\" \non-remove-item=\"vm.removeEmployee\" filter-input=\"vm.search\" order-default=\"Name\"></table-report></div></div>\n</ms-widget-front></ms-widget></div><div flex id=\"\"></div></div></div>");
$templateCache.put("app/main/shipping/shipping.html","<div id=\"shipping\" class=\"page-layout simple tabbed\"><div class=\"fheader header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-text\">דוח משלוחים - {{vm.currentDate|date}} <span ng-show=\"vm.endDate\">\nעד {{vm.endDate|date}}</span></span></div></div></div><md-progress-linear ng-show=\"vm.proccess\" \nmd-mode=\"Indeterminate\" class=\"md-primary\"></md-progress-linear><div class=\"content\" layout=\"row\" flex=\"100\">\n<or-date-between-buttons dates=\"vm.dates\" on-change=\"vm.refresh()\"></or-date-between-buttons></div><div \nclass=\"content\" layout=\"row\"><div flex layout=\"row\" layout-wrap><div flex=\"100\" flex-gt-sm=\"50\"><div flex \nclass=\"details-tab\" ng-include=\"\'app/main/shipping/before/before.html\'\"></div></div><div flex=\"100\" flex-gt-sm=\"50\">\n<div flex class=\"details-tab\" ng-include=\"\'app/main/shipping/after/after.html\'\"></div></div></div></div></div>");
$templateCache.put("app/main/support/support.html","<iframe \nsrc=\"https://docs.google.com/forms/d/e/1FAIpQLSdNoB21gLp4HWp-yI21r9Z1Lqn1_UL0bc8cucRhKhZaxKXU5A/viewform?embedded=true\" \nonload=\"this.width=screen.width;this.height=screen.height\" width=\"760\" height=\"1000\" frameborder=\"0\" marginheight=\"0\" \nmarginwidth=\"0\">טוען...</iframe>");
$templateCache.put("app/core/directives/date-between-buttons/date-between-buttons.html","<div class=\"content\" layout=\"row\" flex=\"100\"><div ng-repeat=\"mode in vm.MODESDATE\"><md-button class=\"md-accent\" \nng-disabled=\"mode.disable\" ng-click=\"vm.selectMode(mode,event)\" ng-class=\"{\'md-raised\':vm.classActiveMode(mode.key)}\">\n{{mode.value}}</md-button></div></div>");
$templateCache.put("app/core/directives/image-viewer/image-viewer.html","<div class=\"image-viewer\"><div style=\"padding:10px\"><md-button id=\"girardir\" class=\"md-raised md-primary\" \nng-disabled=\"noImage\"><span class=\"glyphicon glyphicon-menu-left\"></span> סובב שמאלה</md-button><md-button \nid=\"giraresq\" class=\"md-raised md-primary\" ng-disabled=\"noImage\">סובב ימינה <span \nclass=\"glyphicon glyphicon-menu-right\"></span></md-button><md-button id=\"zoomIn\" class=\"md-raised md-primary\" \nng-disabled=\"noImage\"><span class=\"glyphicon glyphicon-zoom-in\"></span> הגדל</md-button><md-button id=\"zoomOut\" \nclass=\"md-raised md-primary\" ng-disabled=\"noImage\"><span class=\"glyphicon glyphicon-zoom-out\"></span> הקטן</md-button>\n<md-button id=\"carregar\" class=\"md-raised md-warn\" ng-disabled=\"noImage\"><span class=\"fa fa-arrow-left\"></span> איפוס\n</md-button><a href=\"{{image}}&download=t\" target=\"_blank\" download=\"\" class=\"md-raised md-accent\" \nng-disabled=\"noImage\"><span class=\"fa fa-arrow-left\"></span> הורד תמונה</a></div><div id=\"image-zoom\" \nstyle=\"padding:10px\"><h2 class=\"text-center text-danger\" id=\"error-message\">Image Not Available</h2><ms-widget \nid=\"image-viewr-loader-message\" class=\"h-300\" layout=\"column\" flex><ms-widget-front class=\"p-16 grey-bg white-fg\" \nlayout=\"row\" flex><div layout=\"column\" layout-align=\"center center\" flex><div class=\"md-display-3 pb-8\">אנא המתן</div>\n</div><div class=\"background-image-center\"><md-icon md-font-icon=\"icon-filmstrip-off\" class=\"s256 faint-text\">\n</md-icon></div></ms-widget-front></ms-widget><canvas id=\"canvas\" height=\"650\" data-girar=\"0\" \nstyle=\"display:none; border:1px solid #000;z-index:555555;cursor:grab\">sdsd</canvas><iframe id=\"image-viewr-pdf-file\" \nwidth=\"100\" height=\"650\" style=\"display:none\"></iframe><img ng-src=\"{{image}}\" id=\"image\" style=\"display:none\"></div>\n</div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-prices-doctors/ms-prices-doctors.html","<div layout=\"column\" ng-if=\"!vm.copmiesMode\" flex layout-align=\"end center\"><md-progress-linear ng-show=\"vm.proccess\" \nmd-mode=\"Indeterminate\" class=\"md-primary\"></md-progress-linear><div layout=\"row\" flex layout-align=\"end center\">\n<md-input-container flex=\"50\" class=\"md-block m-8 mt-2\"><label>גורם משלם</label><md-select \nng-change=\"vm.selectInsurance()\" ng-model=\"vm.formWizard.BituahID\" ng-disabled=\"!vm.standrdInsurances\" \nmd-on-open=\"vm.focusSearch()\"><md-select-header class=\"demo-select-header\"><input ng-model=\"searchselect\" \nid=\"s_search\" type=\"text\" placeholder=\"הקש ערך לחיפוש\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nclass=\"demo-header-searchbox md-text\"></md-select-header><md-option ng-value=\"0\">בחר גורם משלם</md-option><md-option \nng-repeat=\"factor in vm.factorPays|filter:searchselect |filter:{isInsurances:vm.standrdInsurances} \" \nng-value=\"factor.BituahID\">{{factor.Name}}</md-option></md-select></md-input-container><input ng-hide=\"true\" \ntype=\"text\" required ng-model=\"vm.formWizard.DoctorID\"><md-input-container flex=\"50\" class=\"md-block m-8 mt-2\"><label>\nסניף</label><md-select ng-model=\"vm.placeSelcted\" ng-disabled=\"true\"><md-option><em>None</em></md-option><md-option \nng-repeat=\"place in vm.places\" ng-value=\"place.placeId\">{{place.Name}}</md-option></md-select></md-input-container>\n</div><div ng-hide=\"vm.formWizard.DoctorID||(!vm.formWizard.BituahID)\" layout=\"column\" flex layout-gt-lg=\"row\" \nclass=\"mt-30\"><md-input-container flex=\"70\" class=\"md-block\"><label>\nהקלד שם רופא לחיפוש, לבחירת רופא יש ללחוץ על השם הרצוי</label><input type=\"text\" ng-model=\"vm.search\" \nng-change=\"vm.searchDoctor()\"></md-input-container><div class=\"list mt-30\" layout=\"column\" flex=\"30\"><center><h1 \nng-hide=\"!vm.doctors.length||queryFil.length\">אין תוצאות</h1><div ng-hide=\"vm.doctors.length\">טוען רשימת רופאים....\n</div></center><md-list-item flex layout-align=\"start start\" ng-click=\"vm.selectDoctor(doctor)\" \nng-repeat=\"doctor in vm.doctors|  filterMultyWords: {Name:vm.search}  | limitTo :10|  filter: query as queryFil \"><p \nflex layout-align=\"end end\" class=\"text-truncate\">{{ doctor.Name }} - {{ doctor.Address }}</p></md-list-item></div>\n</div><div ng-show=\"vm.formWizard.DoctorID\" class=\"info-line md-title dir-rtl mt-30\" layout=\"column\" \nlayout-align=\"center center\" flex><div class=\"md-title mb-32 dir-rtl s100\" flex=\"50\">\n{{vm.formWizard.doctorName||\'לא נבחר רופא\'}}</div><div><md-icon md-font-icon=\"icon-account-box\" class=\"s150\"></md-icon>\n</div><md-button class=\"md-accent md-raised\" ng-click=\"vm.copmiesMode=true\">אנא המתן...</md-button><md-button \nclass=\"md-accent\" ng-click=\"vm.resetDoctor()\">בחר רופא אחר<md-icon md-font-icon=\"icon-account-plus\"></md-icon>\n</md-button></div></div><div ng-if=\"vm.copmiesMode\" class=\"profile-box groups md-whiteframe-1dp\" layout=\"column\"><div \nclass=\"content\"><form novalidate><input ng-model=\"vm.countCopies.count\" type=\"number\" required min=\"1\" ng-hide=\"true\">\n<div ng-hide=\"vm.copies.length\">טוען....</div><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"cardholder\" ng-model=\"vm.searchcopies\" placeholder=\"חיפוש צילום\"></md-input-container><div \nng-show=\"vm.copies.length\" class=\"white-bg md-whiteframe-4dp list max-height-400\"><div layout=\"row\" flex><md-switch \nng-disabled=\"bituahId==1\" ng-model=\"vm.agreementOnly\">מציג צילומים בהסכם בלבד: {{(vm.agreementOnly?\'\':\'כבוי\')}}<md-icon\n ng-class=\"{\'red-fg\':!vm.agreementOnly}\" ng-hide=\"bituahId==1\" md-font-icon=\"icon-alert\" \nng-click=\"vm.alertAgreementInfo($event)\"><md-tooltip>לחץ עלי</md-tooltip></md-icon></md-switch></div><table \nid=\"copiesDoctor\" dir=\"rtl\" class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">שם צילום</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מחיר</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">סוג תשלום</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">מחיר סופי</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">בחר</span></div></th></tr></thead><tbody>\n<tr \nng-repeat=\"copy in vm.copies|filter:vm.searchcopies|filter:{priceFor:(vm.agreementOnly?\'agreement\':undefined)}|orderBy :\'Name\'\" \nng-if=\"copy.PhotoListID\"><td class=\"text-truncate\" ng-class=\"\">{{ copy.Name }}</td><td>\n{{ copy.basePrice |customCurrency}}</td><td><span>{{vm.PriceForStr(copy)}}</span></td><td ng-hide=\"copy.editMode\" \nng-class=\"{\'green-fg\':copy.Deductible||copy.customfixprice}\">{{copy.Deductible|| copy.fixprice |customCurrency}}</td>\n<td ng-if=\"copy.editMode\"><md-input-container><input ng-model=\"copy.fixprice \"></md-input-container></td><td><md-menu>\n<md-button class=\"md-icon-button\" aria-label=\"More\" ng-disabled=\"vm.hideSelect\" ng-click=\"$mdOpenMenu($event)\"><md-icon\n md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-disabled=\"copy.priceFor==\'agreement\'&&(!copy.Deductible||copy.InsuranceAccept)\" ng-click=\"vm.editPrice(copy,event)\">\n<md-icon md-font-icon=\"icon-table-edit\"></md-icon>ערוך מחיר</md-button></md-menu-item><md-menu-item><md-button \nng-disabled=\"copy.priceFor!=\'agreement\'\" ng-click=\"vm.editDeductible(copy, event)\"><md-icon \nmd-font-icon=\"icon-eyedropper\"></md-icon>השתתפות עצמית</md-button></md-menu-item><md-menu-item><md-button \nng-disabled=\"copy.fixprice==copy.main_fixprice\" ng-click=\"vm.cancelDiscount(copy)\"><md-icon md-font-icon=\"icon-cancel\">\n</md-icon>בטל הנחה</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.AddReferrer(copy)\"><md-icon \nmd-font-icon=\"icon-nature\"></md-icon>אסמכתא</md-button></md-menu-item></md-menu-content></md-menu><md-checkbox \nng-hide=\"vm.hideSelect\" ng-model=\"copy.selected\" ng-change=\"vm.selectedCopy(copy)\"></md-checkbox></td></tr></tbody>\n</table></div></form></div><footer layout=\"column\" flex class=\"dir-rtl mb-8\" layout-align=\"space-between center\"><div \nlayout=\"row\" flex layout-align=\"end center\"><div layout=\"column\" flex=\"\"><div layout=\"row\" flex><span>\nרופא/ה: {{vm.formWizard.doctorName}}</span>&nbsp; <span>% {{vm.formWizard.Sale}}</span></div><div layout=\"row\" flex>\n<span>גורם משלם: {{vm.formWizard.BituahName}}</span>&nbsp;</div></div><div layout=\"column\" flex=\"\"><md-button \nclass=\"md-accent\" ng-click=\"vm.resetDoctor()\">לחץ כאן לשינוי<md-icon md-font-icon=\"icon-account-plus\"></md-icon>\n</md-button></div><div layout=\"column\" flex=\"\"><md-button class=\"md-accent\" ng-click=\"vm.printDetails(doctor,event)\">\nהדפס פרטי רופא<md-icon md-font-icon=\"icon-printer\"></md-icon></md-button></div></div></footer><footer layout=\"row\" \nng-hide=\"vm.hideSelect\" class=\"dir-rtl mb-8\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"end center\"><span>{{vm.countselected()}} צילומים נבחרו. לתשלום: {{client.sumAll.topay|customCurrency}}\n</span></div></footer><footer layout=\"row\" ng-if=\"vm.DoctorNoteOUT\" class=\"dir-rtl\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end center\"><span>{{vm.DoctorNoteOUT}}</span></div>\n</footer></div>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div layout=\"row\" layout-align=\"start center\" flex><div \nclass=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" ms-scroll \nng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/or-insurance/or-insurance.html","<div layout=\"column\" flex layout-align=\"end center\"><table dir=\"rtl\" class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th hide show-gt-xs class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\"><a ng-click=\"vm.changeSort(\'mkt\')\">מק\"ט</a></span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\"><a ng-click=\"vm.changeSort(\'Name\')\">שם</a></span></div></th><th hide \nshow-gt-xs class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><a \nng-click=\"vm.changeSort(\'sum\')\">סכום</a></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\"><a ng-click=\"vm.changeSort(\'sumInclude\')\">כולל מע\"מ</a></span></div></th><th hide show-gt-xs \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><a ng-click=\"vm.changeSort(\'deductible\')\">\nהשתתפות</a></span></div></th><th hide show-gt-xs class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\"><a ng-click=\"vm.changeSort(\'dateCreated\')\">תאריך רישום</a></span></div></th><th hide show-gt-md \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"><a ng-click=\"vm.changeSort(\'Comment\')\">\nהערות</a></span></div></th><th hide show-gt-xs>פעולות</th></tr></thead><tbody><tr \nng-repeat=\"co in vm.data |orderBy :vm.sortBy |filter:vm.search|filter:{InsuranceID:vm.insuranceId}:true|filter:query as waiters track by $index \">\n<td hide show-gt-xs>{{ co.mkt}}</td><td>{{ co.Name}}</td><td hide show-gt-xs>{{ co.sum|customCurrency}}</td><td>\n{{ co.sumInclude|customCurrency}}</td><td>{{ co.deductible|customCurrency}}</td><td hide show-gt-xs>\n{{ co.dateCreated|date}}</td><td hide show-gt-md>{{ co.Comment}}</td><td hide show-gt-xs><md-menu><md-button \nclass=\"md-icon-button\" aria-label=\"More\"><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdOpenMenu($event)\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-disabled=\"true\" ng-click=\"\"><md-icon \nmd-font-icon=\"icon-cancel\"></md-icon>הפוך ללא פעיל</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.remove(co)\"><md-icon md-font-icon=\"icon-cancel\"></md-icon>מחק</md-button></md-menu-item></md-menu-content>\n</md-menu></td></tr></tbody></table><h1><md-button ng-click=\"vm.add()\" class=\"md-primary md-raised\">הוסף</md-button>\n</h1></div>");
$templateCache.put("app/core/directives/or-table-report/table-report.html","<div class=\"table-report-directive\" layout=\"column\" flex layout-align=\"end center\"><table ng-show=\"data.length\" \ndir=\"rtl\" class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"hide-excel\"><th \ncolspan=\"{{(editfeilds?feilds.length+1:feilds.length)}}\" align=\"rigth\" class=\"hide-excel\"><md-button export-to-excel \ndata=\"data\" class=\"md-accent\"><md-icon md-font-icon=\"icon-file-excel\"></md-icon>הורד נתונים</md-button><md-button \nng-show=\"onInsertItem\" class=\"md-accent\" ng-click=\"vm.editItem($event,{},true)\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon>הוסף</md-button></th></thead><thead><th ng-repeat=\"feild in feilds\" \nng-if=\"!feild.hide_in_places\" ng-show=\"$mdMedia(feild.show)\" class=\"secondary-text\"><div class=\"table-header\" \nlayout=\"row\"><span class=\"column-title\"><a ng-click=\"vm.changeSort(feild.key)\">{{feild.name}}</a></span><md-menu \nng-if=\"feild.filter\" class=\"hide-excel\"><a class=\"md-accent-fg\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nng-hide=\"feild.filtered\" class=\"font-size-20\" md-font-icon=\"icon-filter-outline m-0 p-0\"></md-icon><md-icon \nng-show=\"feild.filtered\" class=\"font-size-20\" md-font-icon=\"icon-filter-remove-outline m-0 p-0\"></md-icon></a>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.setFilter(feild.key,\'\')\">הכל</md-button>\n</md-menu-item><md-menu-item ng-repeat=\"val in waiters|unique:feild.key\"><md-button \nng-click=\"vm.setFilter(feild.key,val[feild.key])\">{{ val[feild.key]}}</md-button></md-menu-item></md-menu-content>\n</md-menu></div></th><th hide show-gt-xs ng-if=\"editfeilds\">&nbsp;</th><tr></tr></thead><tbody><tr class=\"rowItem\" \niditem=\"$index\" ng-click=\"(config.rowClickFunction||config.rowClick?vm.clickRow(item):vm.editItem(event,item))\" \nng-repeat=\"item in data|orderBy:orderDefault |orTableFilter:vm.filterParams|filter:filterInput|filter:filterCustom:true|filter: query as waiters track by $index \">\n<td ng-repeat=\"feild in feilds\" ng-show=\"!feild.hide_in_places&&$mdMedia(feild.show)\"><span \nng-if=\"feild.type==\'customCurrency\'\">{{ item[feild.key]|customCurrency}}</span> <span ng-if=\"feild.type==\'date\'\">\n{{ item[feild.key]|date:\'dd/MM/yyyy\'}}</span> <span ng-if=\"feild.type==\'bool\'\"><md-icon ng-if=\"item[feild.key]\" \nmd-font-icon=\"icon-check-circle\"></md-icon><md-icon ng-if=\"!item[feild.key]\" md-font-icon=\"icon-close-circle\">\n</md-icon></span><span ng-if=\"feild.type==\'icon\'\"><md-icon \nng-hide=\"feild.showNull&&item[feild.key]||(feild.hideNull&&!item[feild.key])\" ng-class=\"feild.class\" \nmd-font-icon=\"{{feild.icon}}\"></md-icon></span><span ng-if=\"!feild.type\">{{ item[feild.key]}}</span></td><td hide \nshow-gt-xs ng-if=\"editfeilds\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" class=\"s-8\" ng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content \nwidth=\"3\" class=\"hide-excel\"><md-menu-item><md-button ng-click=\"vm.editItem(ev,item)\"><md-icon \nmd-font-icon=\"icon-account\"></md-icon>ערוך</md-button></md-menu-item><md-menu-item ng-if=\"onRemoveItem\"><md-button \nng-click=\"onRemoveItem(item)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>הסר</md-button></md-menu-item>\n</md-menu-content></md-menu></td></tr></tbody><tfoot ng-hide=\"config.hideFotter\"><th align=\"rigth\" \nng-repeat=\"feild in feilds\" ng-show=\"$mdMedia(feild.show)\"><span ng-if=\"feild.type==\'customCurrency\'\">\n{{waiters|sumByKey:feild.key|customCurrency}}</span> <span ng-if=\"feild.type!=\'customCurrency\'\">\n{{($index==0?\' רשומות: \'+waiters.length:\'&nbsp;\')}}</span></th><th hide show-gt-xs ng-if=\"editfeilds\">&nbsp;</th>\n</tfoot></table><div ng-hide=\"data.length\">אין נתונים</div></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><img src=\"/assets/images/logos/logo-or.png\" style=\"width: 50px\"> \n<span class=\"logo-text\">אור השן</span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide \nshow-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" \nfolded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/main/dialogs/date/date.html","<md-dialog><md-dialog-content><md-content layout=\"column\"><header class=\"md-primary-bg\" layout=\"row\" \nlayout-align=\"end center\"><div class=\"title\">בחר תאריך</div></header><md-content layout=\"column\"><md-input-container>\n<input type=\"date\" ng-model=\" vm.date \"></md-input-container></md-content><div layout=\"row\" flex><md-button \nclass=\"md-raised\" ng-click=\"vm.close()\">סגור</md-button></div></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/main/inventories/table-dialog/table-dialog.html","<md-dialog id=\"dialogEmployees\" class=\"\" aria-label=\"New Task\"><div \nclass=\"profile-box latest-activity md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"end center\"><div class=\"title\">{{vm.title}}</div></header><div class=\"content dir-rtl p-8\" layout=\"row\" \nflex layout-wrap><div class=\"\" layout=\"column\" flex=\"\" layout-align=\"start start\"><div layout=\"row\" flex>\n{{vm.subTitle}}</div><ms-widget class=\"h-300 ms-widget ng-isolate-scope\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"p-16\" layout=\"row\" flex=\"\"><div layout=\"column\" layout-align=\"center center\" flex=\"\"><table-report \nconfig=\"vm.config\" feilds=\"vm.feilds\" data=\"vm.data\" order-default=\"-KDate\" filter-input=\"vm.search\"></table-report>\n</div></ms-widget-front></ms-widget><div layout=\"column\" class=\"mt-20\" flex><md-button class=\"md-primary md-raised\" \nng-click=\"vm.close()\">סגור</md-button></div></div></div></div></md-dialog>");
$templateCache.put("app/main/inventories/order/inventories_order.html","<div id=\"inventories_order\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" \nflex layout=\"row\" layout-align=\"space-between\"><div layout=\"row\" flex=\"70\" layout-align=\"space-between\"><div \nlayout=\"column\" flex><div class=\"title\">הזמנה #{{vm.order.ID}}</div><div class=\"\">\n{{vm.order.name}} - {{vm.order.placeName}} - {{vm.order.date_created|date}}</div></div></div><div hide show-gt-xs \nclass=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><md-input-container md-no-float class=\"m-0\">\n<input id=\"search\" type=\"text\" ng-model=\"vm.search\" placeholder=\"חיפוש\"></md-input-container></div></div>\n<md-progress-linear ng-show=\"vm.proccess\" md-mode=\"Indeterminate\" class=\"md-primary\"></md-progress-linear><div \nclass=\"content white-bg\" flex layout=\"row\" layout-align=\"\" layout-fill><div><md-button class=\"md-primary md-raised\" \nng-disabled=\"vm.order.status>=2||vm.order.status<0\" ui-sref=\"app.inventories_edit_order({order:vm.order.ID})\"><md-icon \nmd-font-icon=\"icon-run\"></md-icon>{{vm.order.status>=2?\'הזמנה נשלחה\':\'ערוך הזמנה\'}}</md-button></div><div><md-button \nclass=\"md-primary md-raised\" ng-disabled=\"vm.proccess\" ng-show=\"vm.order.status==0\" ng-click=\"vm.sendOrder()\"><md-icon \nmd-font-icon=\"icon-cloud-upload\"></md-icon>{{vm.proccess?\"מעדכן נתונים...\":\"שלח הזמנה למחסן\"}}</md-button><md-button \nclass=\"md-warn md-raised\" ng-disabled=\"vm.proccess\" ng-show=\"vm.order.status==1\" ng-click=\"vm.sendOrder(true)\"><md-icon\n md-font-icon=\"icon-cancel\"></md-icon>{{vm.proccess?\"שולח נתונים...\":\"בטל הזמנה\"}}</md-button></div><div \nng-if=\"vm.order.comments_place\" class=\"p-5\" layout-align=\"end start\">{{vm.order.comments_place}}</div><strong \nclass=\"p-5\" layout-align=\"end start\">{{vm.order.status_name}}</strong></div><div class=\"content scrollable\" flex \nlayout=\"row\" layout-align=\"start start\"><div class=\"main\" flex ms-scroll id=\"contactslist\"><md-list \nclass=\"contacts-list\"><table-report config=\"vm.config\" feilds=\"vm.feilds\" data=\"vm.order.items\" order-default=\"-KDate\" \nfilter-input=\"vm.search\"></table-report><div ng-show=\"vm.inventories.length\" layout-align=\"center center\" layout=\"row\" \nflex><md-button class=\"md-accent md-raised\" ng-click=\"vm.clear()\">הצג הכל</md-button></div></md-list><md-list-item \nclass=\"no-results md-white-bg\" ng-show=\"filteredContacts.length === 0\"><p>אין תוצאות</p></md-list-item></div></div>\n</div>");
$templateCache.put("app/main/inventories/edit_order/edit_order.html","<div id=\"inventories_order_edit\" class=\"page-layout simple left-sidenav inner-sidenav\"><div \nclass=\"header md-accent-bg\" flex layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" flex=\"70\" \nlayout-align=\"space-between\"><div layout=\"column\" flex><div class=\"title\" ng-if=\"!vm.order.ID\">צור הזמנה חדשה</div><div\n class=\"title\" ng-if=\"vm.order.ID\">הזמנה #{{vm.order.ID}}</div><div class=\"\">\n{{vm.order.name}} - {{vm.order.date_created|date}}</div></div></div><div hide show-gt-xs class=\"search-input-wrapper\" \nlayout=\"row\" layout-align=\"start center\"><md-input-container md-no-float class=\"m-0\"><input id=\"search\" type=\"text\" \nng-model=\"vm.search\" placeholder=\"חיפוש\"></md-input-container></div></div><md-progress-linear ng-show=\"vm.proccess\" \nmd-mode=\"Indeterminate\" class=\"md-primary\"></md-progress-linear><div class=\"content scrollable\" flex layout=\"row\" \nlayout-align=\"start start\"><div class=\"main\" flex ms-scroll id=\"contactslist\"><md-list class=\"contacts-list\"><div \nclass=\"form-wrapper md-whiteframe-1dp m-5\" flex><form class=\"md-inline-form\" flex><div layout=\"row\" flex>\n<md-input-container><label>שם עובד</label><input readonly=\"readonly\" ng-model=\"vm.order.name\"></md-input-container>\n<md-input-container flex><label>הערות הסניף</label><textarea placeholder=\"הערות\" ng-model=\"vm.order.comments_place\">\n</textarea></md-input-container><md-button class=\"md-primary md-raised\" ng-click=\"vm.auth_user()\" \nng-hide=\"vm.EmployeeAuth\">בצע זיהוי</md-button></div></form></div><br><div layout=\"row\" flex><div flex=\"80\">\n<md-input-container flex><label>חיפוש</label><input type=\"text\" placeholder=\"חפש פריט\" ng-model=\"vm.search_item\">\n</md-input-container></div><div flex layout-align=\"start\"><md-button \nng-disabled=\"!vm.EmployeeAuth||vm.proccess||!vm.order.name\" class=\"md-accent md-raised\" ng-click=\"vm.SaveInventory()\">\n<md-icon md-font-icon=\"icon-content-save\"></md-icon>{{vm.proccess?\'עובד....\':\'שמור הזמנה\'}}</md-button></div></div>\n<table dir=\"rtl\" class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead class=\"hide-excel\">\n<th colspan=\"{{(vm.items.length+1)}}\" align=\"rigth\" class=\"text-right hide-excel\"></th></thead><thead><th \nclass=\"secondary-text\"><div class=\"table-header column-title\" layout=\"row\">קוד מוצר</div></th><th \nclass=\"secondary-text\"><div class=\"table-header column-title\" layout=\"row\">שם מוצר</div></th><th \nclass=\"secondary-text\"><div class=\"table-header column-title\" layout=\"row\">כמות באריזה</div></th><th \nclass=\"secondary-text\"><div class=\"table-header column-title\" layout=\"row\">ספק</div></th><th class=\"secondary-text\">\n<div class=\"table-header column-title\" layout=\"row\">כמות</div></th><th class=\"secondary-text\"><div \nclass=\"table-header column-title\" layout=\"row\">הערות</div></th><th class=\"secondary-text\"><div \nclass=\"table-header column-title\" layout=\"row\">הסר</div></th><tr></tr></thead><tbody><tr ng-if=\"!vm.order.name\"><td \ncolspan=\"6\"><div class=\"title\">{{vm.proccess?\'מחפש....\':\'הכנס מספר עובד\'}}</div></td></tr><tr ng-show=\"vm.order.name\" \nclass=\"rowItem\" iditem=\"$index\" \nng-repeat=\"item in vm.items|orderBy:name|filter:vm.search_item|filter: query as waiters track by $index \"><td \nclass=\"pb-0\">{{item.ID}}</td><td class=\"pb-0\">{{item.name}}</td><td class=\"pb-0\">{{item.count_in_package}}</td><td \nclass=\"pb-0\">{{item.supplierName}}</td><td class=\"pb-0\"><md-button \nng-disabled=\"!vm.EmployeeAuth||!(item.count<item.max_per_order)\" class=\"md-accent btn-mini m-0\" \nng-click=\"vm.Add(item)\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-input-container \nstyle=\"padding:0; margin:0\"><md-input><input readonly=\"readonly\" type=\"number\" ng-model=\"item.count\"></md-input>\n</md-input-container><md-button ng-disabled=\"!vm.EmployeeAuth||!(item.count>item.min_per_order)\" \nclass=\"md-accent btn-mini m-0\" ng-click=\"vm.Sub(item)\"><md-icon md-font-icon=\"icon-minus\"></md-icon></md-button></td>\n<td class=\"pb-0\"><md-input><input type=\"text\" placeholder=\"הערות\" ng-model=\"item.note\"></md-input></td><td \nclass=\"pb-0\"><md-button ng-disabled=\"!vm.EmployeeAuth||!item.count\" class=\"md-warn btn-mini m-0\" \nng-click=\"vm.Remove(item)\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon></md-button></td></tr></tbody><tfoot \nng-hide=\"config.hideFotter\"><th class=\"text-right\" align=\"rigth\" colspan=\"{{vm.items.length}}\"><span>\n{{(true?\' רשומות: \'+waiters.length:\'&nbsp;\')}}</span></th></tfoot></table><md-button \nng-disabled=\"!vm.EmployeeAuth||vm.proccess||!vm.order.name\" class=\"md-accent md-raised\" ng-click=\"vm.SaveInventory()\">\n<md-icon md-font-icon=\"icon-content-save\"></md-icon>{{vm.proccess?\'עובד....\':\'שמור הזמנה\'}}</md-button><md-button \nng-disabled=\"!vm.EmployeeAuth||!vm.order.name\" class=\"md-warn md-raised\" ng-click=\"vm.CancelInventory()\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon>מחיקת הזמנה</md-button></md-list><md-list-item \nclass=\"no-results md-white-bg\" ng-show=\"filteredContacts.length === 0\"><p>אין תוצאות</p></md-list-item></div></div>\n</div>");
$templateCache.put("app/main/inventories/tracking/tracking.html","<div id=\"tracking_inventories\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" \nflex layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" flex=\"70\" layout-align=\"space-between\"><div \nclass=\"title\">מעקב מלאי</div></div><div hide show-gt-xs class=\"search-input-wrapper\" layout=\"row\" \nlayout-align=\"start center\"><md-input-container md-no-float class=\"m-0\"><input id=\"search\" type=\"text\" \nng-model=\"vm.search\" placeholder=\"חיפוש\"></md-input-container></div></div><md-progress-linear ng-show=\"vm.proccess\" \nmd-mode=\"Indeterminate\" class=\"md-primary\"></md-progress-linear><div class=\"content scrollable\" flex layout=\"row\" \nlayout-align=\"start start\"><div class=\"main\" flex ms-scroll id=\"contactslist\"><md-list class=\"contacts-list\">\n<table-report config=\"vm.config\" feilds=\"vm.feilds\" data=\"vm.inventories_tracking\" order-default=\"-KDate\" \nfilter-input=\"vm.search\"></table-report><div ng-show=\"vm.inventories_tracking.length\" layout-align=\"center center\" \nlayout=\"row\" flex><md-button class=\"md-accent md-raised\" ng-disabled=\"vm.proccess\" ng-click=\"vm.refresh(true)\">רענן\n</md-button><md-button class=\"md-primary md-raised\" ng-disabled=\"vm.proccess\" ng-click=\"vm.showHistory()\">הצג היסטוריה\n</md-button></div><ms-widget ng-hide=\"vm.inventories_tracking.length\" class=\"h-300\" layout=\"column\" flex>\n<ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex><div layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"md-display-3 pb-8 md-default-theme\"><span ng-show=\"vm.proccess\">מחפש...</span> <span ng-hide=\"vm.proccess\">\n{{(vm.search?\'לא נמצא\':\'איתור הפניה\')}}</span></div><div class=\"h3 font-weight-500\"><h1>אין מלאי זמין</h1></div></div>\n</ms-widget-front></ms-widget></md-list><md-list-item class=\"no-results md-white-bg\" \nng-show=\"filteredContacts.length === 0\"><p>אין תוצאות</p></md-list-item></div></div></div>");
$templateCache.put("app/main/pages/coming-soon/coming-soon.html","<div id=\"coming-soon\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"coming-soon-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"coming-soon-form\" class=\"md-whiteframe-8dp\"><div class=\"top\"><div\n class=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"COMINGSOON.TITLE\">\nHey! Thank you for checking out our app.</div><div class=\"subtitle\" translate=\"COMINGSOON.SUBTITLE\">\nIt’s not quite ready yet, but we are working hard and it will be ready in approximately:</div><timer \nend-time=\"vm.endTime\" layout=\"row\" layout-wrap><div flex-xs=\"50\"><div class=\"value\">{{days}}</div><div class=\"type\" \ntranslate=\"COMINGSOON.DAYS\">days</div></div><div flex-xs=\"50\"><div class=\"value\">{{hours}}</div><div class=\"type\" \ntranslate=\"COMINGSOON.HOURS\">hours</div></div><div flex-xs=\"50\"><div class=\"value\">{{minutes}}</div><div class=\"type\" \ntranslate=\"COMINGSOON.MINUTES\">minutes</div></div><div flex-xs=\"50\"><div class=\"value\">{{seconds}}</div><div \nclass=\"type\" translate=\"COMINGSOON.SECONDS\">seconds</div></div></timer></div><form><div class=\"message\" \ntranslate=\"COMINGSOON.MESSAGE\">\nIf you would like to be notified when the app is ready, you can subscribe to our e-mail list.</div><md-input-container \nflex md-no-float><input type=\"email\" placeholder=\"Email address\" translate \ntranslate-attr-placeholder=\"COMINGSOON.EMAIL_ADRESS\"></md-input-container><md-button class=\"md-raised md-accent\" \naria-label=\"SUBSCRIBE\" translate=\"COMINGSOON.SUBSCRIBE\" translate-attr-aria-label=\"COMINGSOON.SUBSCRIBE\">SUBSCRIBE\n</md-button></form></div></div></div>");
$templateCache.put("app/main/pages/maintenance/maintenance.html","<div id=\"maintenance\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"maintenance-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"maintenance-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"MAINTENANCE.TITLE\">\nClosed for scheduled maintenance!</div><div class=\"subtitle\" translate=\"MAINTENANCE.SUBTITLE\">\nWe\'re sorry for the inconvenience.<br>Please check back later.</div></div></div></div>");
$templateCache.put("app/main/pages/search/search.html","<div id=\"search\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input class=\"search-input\" ng-model=\"vm.search\" \ntype=\"text\" placeholder=\"Search..\" translate translate-attr-placeholder=\"SEARCH.SEARCH\" flex></div><md-menu \nclass=\"search-settings\" md-position-mode=\"target-right target\"><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Search settings\" translate translate-attr-aria-label=\"SEARCH.SEARCH_SETTINGS\">\n<md-icon md-menu-origin md-menu-align-target md-font-icon=\"icon-cog\" class=\"icon s16\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.dummyFunction()\"><md-icon md-font-icon=\"icon-cog\">\n</md-icon><span translate=\"SEARCH.SETTINGS_1\">Settings 1</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.dummyFunction()\"><md-icon md-font-icon=\"icon-cog\"></md-icon><span translate=\"SEARCH.SETTINGS_2\">Settings 2\n</span></md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"content\" flex><md-tabs \nmd-dynamic-height><md-tab label=\"Classic\"><md-content class=\"classic-tab\" \nng-include=\"\'app/main/pages/search/tabs/classic/classic.html\'\"></md-content></md-tab><md-tab label=\"Emails\"><md-content\n class=\"emails-tab\" ng-include=\"\'app/main/pages/search/tabs/emails/emails.html\'\"></md-content></md-tab><md-tab \nlabel=\"Users\"><md-content class=\"users-tab\" ng-include=\"\'app/main/pages/search/tabs/users/users.html\'\"></md-content>\n</md-tab><md-tab label=\"Contacts\"><md-content class=\"contacts-tab\" \nng-include=\"\'app/main/pages/search/tabs/contacts/contacts.html\'\"></md-content></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/timeline/timeline-left.html","<div id=\"timeline\" class=\"timeline-left\" ms-timeline=\"vm.timelineOptions\" ms-timeline-load-more=\"vm.loadNextPage()\">\n<div ms-timeline-item layout=\"column\" layout-align=\"center center\" layout-gt-md=\"row\" \nlayout-align-gt-md=\"center start\" ng-repeat=\"timelineItem in vm.timeline\"><div \nclass=\"timeline-point md-accent-bg md-whiteframe-2dp\"><md-icon md-font-icon=\"{{timelineItem.icon}}\"></md-icon></div>\n<div class=\"timeline-detail\" flex=\"50\"><div class=\"time\">{{timelineItem.time}}</div><div class=\"event\">\n{{timelineItem.event}}</div></div><div class=\"timeline-card\" layout=\"row\" flex=\"50\"><ms-card \ntemplate=\"timelineItem.card.template\" ng-model=\"timelineItem.card\"></ms-card></div></div></div>");
$templateCache.put("app/main/pages/timeline/timeline-right.html","<div id=\"timeline\" class=\"timeline-right\" ms-timeline=\"vm.timelineOptions\" ms-timeline-load-more=\"vm.loadNextPage()\">\n<div ms-timeline-item layout=\"column\" layout-align=\"center center\" layout-gt-md=\"row\" \nlayout-align-gt-md=\"center start\" ng-repeat=\"timelineItem in vm.timeline\"><div \nclass=\"timeline-point md-accent-bg md-whiteframe-2dp\"><md-icon md-font-icon=\"{{timelineItem.icon}}\"></md-icon></div>\n<div class=\"timeline-detail\" flex=\"50\"><div class=\"time\">{{timelineItem.time}}</div><div class=\"event\">\n{{timelineItem.event}}</div></div><div class=\"timeline-card\" layout=\"row\" flex=\"50\"><ms-card \ntemplate=\"timelineItem.card.template\" ng-model=\"timelineItem.card\"></ms-card></div></div></div>");
$templateCache.put("app/main/pages/timeline/timeline.html","<div id=\"timeline\" ms-timeline=\"vm.timelineOptions\" ms-timeline-load-more=\"vm.loadNextPage()\"><div ms-timeline-item \nlayout=\"column\" layout-align=\"center center\" layout-gt-md=\"row\" layout-align-gt-md=\"center start\" \nng-repeat=\"timelineItem in vm.timeline\"><div class=\"timeline-point md-accent-bg md-whiteframe-2dp\"><md-icon \nmd-font-icon=\"{{timelineItem.icon}}\"></md-icon></div><div class=\"timeline-detail\" flex=\"50\"><div class=\"time\">\n{{timelineItem.time}}</div><div class=\"event\">{{timelineItem.event}}</div></div><div class=\"timeline-card\" \nlayout=\"row\" flex=\"50\"><ms-card template=\"timelineItem.card.template\" ng-model=\"timelineItem.card\"></ms-card></div>\n</div></div>");
$templateCache.put("app/main/profile/dialog/register_copyrator.html","<md-dialog class=\"register_copyrator\" aria-label=\"New Task\"><div class=\"profile-box latest-activity md-whiteframe-1dp\" \nlayout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" layout-align=\"end center\"><md-button class=\"\" \nng-click=\"vm.cancel()\" translate-attr-aria-label=\"PROFILE.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-close\" \nclass=\"icon\" ng-click=\"vm.removeCheck(check,$index)\"></md-icon></md-button><div flex=\"90\" class=\"title dir-rtl\">\nשם המצלם</div></header><div class=\"content dir-rtl\" layout=\"row\" flex layout-wrap><div class=\"activity\" layout=\"row\" \nflex=\"\" layout-align=\"start start\"><div layout=\"row\" flex><div class=\"m-8 profile-box\" flex><div layout=\"row\" \nclass=\"m-8\" flex><md-input-container layout=\"row\" flex><input type=\"text\" ng-model=\"vm.search\" \nplaceholder=\"הקש שם מצלם\"></md-input-container></div><div layout=\"row\" layout-align=\"center center\" \nng-hide=\"vm.search.length\"><center><h2 flex>הקש שם מצלם</h2></center></div><md-list ng-show=\"vm.search.length\" flex \nms-scroll><md-list-item ng-repeat=\"copyrator in vm.copyrators| filter:vm.search|limitTo:6|orderBy:\'Name\'\" \nng-click=\"vm.selectEmployee(copyrator.OvedID, $event)\" class=\"noright\"><img alt=\"{{ copyrator.Name }}\" \nng-src=\"assets/images/avatars/profile.jpg\" class=\"md-avatar\"><p>{{ copyrator.Name }}</p></md-list-item></md-list></div>\n</div></div></div></div></md-dialog>");
$templateCache.put("app/main/reports/daily/daily.html","<div id=\"dailyreport\" class=\"page-layout simple\"><div class=\"content m-32\" flex layout=\"row\" layout-align=\"end center\">\n<div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"70\" flex-gt-md=\"50\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div \nclass=\"title dir-rtl\">דוח לתאריך: {{vm.dates.start|date}}: <span ng-show=\"vm.dates.end\">- {{vm.dates.end|date}}</span>\n {{vm.place.Name}} ({{vm.place.PlaceID}})</div></header><header class=\"md-accent-bga\" layout=\"row\" \nlayout-align=\"end center\"><div class=\"title dir-rtl\" flex>פירוט הכנסות</div></header><div class=\"content dir-rtl\"><div \nlayout=\"row\" flex><div flex=\"50\">ס\"ה מזומן</div><div flex=\"50\">{{(vm.report.CashPrice ||0)| customCurrency}}</div>\n</div><div layout=\"row\" flex><div flex=\"50\">ס\"ה שיקים</div><div flex=\"50\">\n{{(vm.report.BankChekPrice ||0)| customCurrency}}</div></div><div layout=\"row\" flex><div flex=\"50\">ס\"ה אשראי</div><div \nflex=\"50\">{{(vm.report.CreditCardPrice ||0) | customCurrency}}</div></div></div><footer layout=\"row\" class=\"dir-rtl\" \nlayout-align=\"space-between center\"><div layout=\"row\" class=\"md-title\" flex><div flex=\"50\">סך נתקבל</div><div \nflex=\"50\">{{vm.report.sumAll||0 | customCurrency}}</div></div></footer><div class=\"content dir-rtl\"><div layout=\"row\" \nflex><div flex=\"50\">פציינטים שצולמו {{(vm.dates.end?\'\':\'היום\')}}</div><div flex=\"50\">\n{{(vm.report.countCopiesClients||0)}}</div></div><div layout=\"row\" flex><div flex=\"50\">\nחשבוניות לפציינטים שצולמו {{(vm.dates.end?\'\':\'היום\')}}</div><div flex=\"50\">{{(vm.report.countInvClientsFromToday||0)}}\n</div></div><div layout=\"row\" flex><div flex=\"50\">חשבוניות לפציינטים מתאריך אחר</div><div flex=\"50\">\n{{vm.report.countInvFromOtherDay||0}}</div></div><footer layout=\"row\" flex><div flex>פירוט לפי תאריך קבלת פציינטים\n</div></footer><div flex layout=\"column\" class=\"dir-rtl\" ng-repeat=\"day in vm.report.daily\"><div layout=\"row\" flex \nlayout-align=\"center space-between\"><div flex=\"25\" class=\"font-weight-700\">{{(day.dateCl)| date}}</div><div flex=\"25\">\nמזומן: {{(day.CashPrice ||0)| customCurrency}}</div><div flex=\"25\">שיקים: {{(day.BankChekPrice ||0)| customCurrency}}\n</div><div flex=\"25\">אשראי: {{(day.CreditCardPrice ||0) | customCurrency}}</div></div></div><footer layout=\"row\" flex>\n<div flex=\"50\">ס\"ה חשבוניות {{(vm.dates.end?\'\':\'היום\')}}</div><div flex=\"50\">{{(vm.report.countInvClients||0)}}</div>\n</footer><footer class=\"dir-rtl\" layout=\"row\"><md-button flex ng-click=\"vm.printDaily()\" \nclass=\"post-button md-accent md-raised\" aria-label=\"POST\">הדפס דוח</md-button></footer></div></div></div></div></div>");
$templateCache.put("app/main/shipping/after/after.html","<div id=\"shippinaftergreport\" class=\"page-layout simple\"><div class=\"content m-32\" flex layout=\"row\" \nlayout-align=\"end center\"><div class=\"about\" layout=\"column\" flex><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div \nclass=\"title dir-rtl\">משלוחים שיצאו</div></header><header class=\"md-accent-bga\" layout=\"row\" layout-align=\"end center\">\n<div class=\"title dir-rtl\" flex>פירוט משלוחים שיצאו</div></header><div class=\"content dir-rtl\"><md-input-container>\n<input placeholder=\"חיפוש\" ng-model=\"vm.afterSearch\"></md-input-container><table dir=\"rtl\" class=\"0simple text-rigth\">\n<tr class=\"text-right\"><th>תאריך</th><th>סניף</th><th>שם שליח</th><th>מספר משלוח</th><th>הדפס</th></tr><tbody><tr><td \ncolspan=\"6\"><md-divider></md-divider></td></tr><tr class=\"text-right\" \nng-repeat=\"sh in vm.Reports.Shipped|filter:vm.afterSearch\"><td class=\"text-right\">{{sh.SentAt|date}}</td><td \nclass=\"text-right\">{{sh.SenderName}}</td><td class=\"text-right\">{{sh.ReceiverName}}</td><td class=\"text-right\"><a \nui-sref=\"app.contacts.shipping({id:sh.ID})\">#{{sh.MishloahID}}</a></td><td class=\"text-right\"><a href=\"#\" \nng-click=\"vm.showCertificateShipping(sh.ID)\">הצג</a></td></tr><tr class=\"text-right\" \nng-hide=\"vm.Reports.Shipped.length\"><td colspan=\"4\">אין משלוחים בתאריך זה</td></tr></tbody></table></div><footer \nlayout=\"row\" class=\"dir-rtl\" layout-align=\"space-between center\"><div layout=\"row\" class=\"md-title\" flex><div \nflex=\"50\">סך משלוחים</div><div flex=\"50\">{{vm.Reports.Shipped.length}}</div></div></footer><footer class=\"dir-rtl\" \nlayout=\"row\"><div>&nbsp;</div></footer></div></div></div></div>");
$templateCache.put("app/main/shipping/before/before.html","<div id=\"shippingreport\" class=\"page-layout simple\"><div class=\"content m-32\" flex layout=\"row\" \nlayout-align=\"end center\"><div class=\"about\" layout=\"column\" flex><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div \nclass=\"title dir-rtl\">משלוחים ממתינים</div></header><header class=\"md-accent-bga\" layout=\"row\" \nlayout-align=\"end center\"><div class=\"title dir-rtl\" flex>\nפירוט משלוחים ממתינים - סמן את הרשומה הרצויה לצורך ביצוע משלוח עכשיו</div></header><div class=\"content dir-rtl\">\n<md-input-container><input placeholder=\"חיפוש\" ng-model=\"vm.beforeSearch\"></md-input-container><table dir=\"rtl\" \nclass=\"0simple text-rigth\"><tr class=\"text-right\"><th>בחר</th><th>תאריך</th><th>שם פציינט</th><th>שם רופא</th><th>הערות\n</th></tr><tbody><tr><td colspan=\"6\"><md-divider></md-divider></td></tr><tr class=\"text-right\" \nng-repeat=\"sh in vm.Reports.Shipping|filter:vm.beforeSearch\"><td><md-checkbox ng-model=\"sh.selected\"></md-checkbox>\n</td><td class=\"text-right\">{{sh.KDate|date}}</td><td class=\"text-right\">{{sh.ClientName}}</td><td class=\"text-right\">\n{{sh.doctorName}}</td><td class=\"text-right\">{{sh.ClientNote}}</td></tr><tr class=\"text-right\" \nng-hide=\"vm.Reports.Shipping.length\"><td colspan=\"6\">אין משלוחים בתאריך זה</td></tr></tbody></table></div><footer \nlayout=\"row\" class=\"dir-rtl\" layout-align=\"space-between center\"><div layout=\"row\" class=\"md-title\" flex><div \nflex=\"50\">סך משלוחים ממתינים</div><div flex=\"50\">{{vm.Reports.Shipping.length}}</div></div></footer><footer \nclass=\"dir-rtl\" layout=\"row\"><md-button ng-disabled=\"!vm.filterSelected()\" flex ng-click=\"vm.DialogDelivery(event)\" \nclass=\"post-button md-accent md-raised\" aria-label=\"POST\">שלח {{vm.filterSelected()}} מסומנים</md-button></footer>\n</div></div></div></div>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\" layout=\"column\" layout-align=\"start start\"><div class=\"secondary-text\">\n<div>{{vm.date | date:\'EEEE\'}}</div><div layout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> \n<span class=\"md-subhead\">th</span> <span>{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list>\n<md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span>\n</md-subheader><md-list-item class=\"md-2-line\" ng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div \nclass=\"md-list-item-text\"><h3>{{event.title}}</h3><p>{{event.detail}}</p></div></md-list-item></md-list><md-divider>\n</md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader>\n<md-list-item class=\"md-2-line\" ng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\">\n<h3>{{note.title}}</h3><p>{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list>\n<md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader>\n<md-list-item><h3 translate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.notify\" aria-label=\"Notifications\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item><md-list-item><h3 \ntranslate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.cloud\" \naria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch class=\"md-secondary md-warn\" \nng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form>\n</div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div layout=\"column\" layout-align=\"space-between stretch\" class=\"h-128\"><div class=\"top-row\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"navigation-toggle\" \nhide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular>\n<ms-shortcuts></ms-shortcuts><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button \nclass=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div><div class=\"bottom-row\"><div id=\"horizontal-navigation\" ui-view=\"navigation\"></div>\n</div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><md-button ng-disabled=\"true\" class=\"\">V {{vm.version}}\n</md-button><div class=\"toolbar-separator\"></div><md-button ng-disabled=\"false\" ui-sref=\"app.support\" class=\"\"><md-icon\n md-font-icon=\"icon-question-mark-circle\"></md-icon>לתמיכה טכנית</md-button></div><div layout=\"row\" \nlayout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" \nclass=\"md-accent\" md-diameter=\"32\"></md-progress-circular><md-button class=\"user-button\" \nui-sref=\"app.reports_multy_view.alerts\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"username\" hide show-gt-sm>הצג התראות</span><md-icon md-font-icon=\"icon-alert\" class=\"icon s16\" hide-xs>\n</md-icon></div></md-button><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide show-gt-sm>סניף {{vm.placeName}}</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content width=\"3\">\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button \nng-disabled=\"false\" ng-click=\"vm.employeeEntryDialog(event)\">כניסה / יציאה</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.employee_report\"><md-icon md-font-icon=\"icon-alarm-multiple\" class=\"icon\"></md-icon>\n<md-button>דוח נוכחות</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon \nmd-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button ng-disabled=\"true\">Inbox</md-button></md-menu-item>\n<md-menu-item class=\"md-indent\" ng-if=\"vm.PlaceAccount.permission.insurance\"><md-icon md-font-icon=\"icon-bank\" \nclass=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\">ביטוחים\n</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\"><md-icon md-font-icon=\"icon-bank\" \nclass=\"icon\"></md-icon><md-button ui-sref=\"app.insurance\">מחירון צילומים</md-button></md-menu-item></md-menu-content>\n</md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_auth_login-v2.logout({logout:1})\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon>\n<md-button ng-click=\"vm.logout()\">התנתק</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div \nclass=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-button class=\"language-button\" ng-click=\"vm.showLastSMS()\" aria-label=\"SMS\"><div layout=\"row\" \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-message-text-outline\" class=\"icon\"></md-icon><span \nclass=\"iso\">{{vm.smsProccess?\'המתן...\':\'SMS\'}}</span></div></md-button><div class=\"toolbar-separator\"></div><md-menu \nid=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" ng-disabled=\"true\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div></div></div>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/core/directives/date-between-buttons/date/date.html","<md-dialog><md-dialog-content><md-content layout=\"column\"><div>בחר חודש מהרשימה או הקש טווח תאריכים</div><md-select \nng-model=\"vm.re_select\" ng-change=\"vm.changeMonth()\"><md-option ng-value=\"0\">טווח תאריכים מותאם</md-option><md-option \nng-repeat=\"op in vm.range\" ng-value=\"op.id\">{{op.name}}</md-option></md-select><div flex layout=\"row\"><md-content \nlayout=\"column\" layout-align=\"end end\"><label>מתאריך</label><md-input-container><input ng-disabled=\"vm.re_select\" \ntype=\"date\" ng-model=\"vm.date\"></md-input-container></md-content></div><div flex layout=\"row\"><md-content \nlayout=\"column\" layout-align=\"end end\"><label>עד תאריך</label><md-input-container><input ng-disabled=\"vm.re_select\" \ntype=\"date\" placeholder=\"עד תאריך\" ng-model=\"vm.dateend\"></md-input-container></md-content></div><div layout=\"row\" \nflex><md-button class=\"md-raised\" ng-click=\"vm.close()\">סגור</md-button></div></md-content></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/or-table-report/dialog/edit-dialog.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-primary md-tall0 tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{(vm.isNew?\'הוסף\':\'עריכה\')}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll class=\"ng-form\" name=\"dialogForm\"><div ng-repeat=\"feild in vm.keys\">\n<md-input-container ng-hide=\"feild.select\" class=\"md-icon-float md-block\"><label flex=\"50\">{{feild.name}}</label>\n<md-icon md-font-icon=\"{{feild.icon}}\" class=\"name\"></md-icon><input name=\"{{feild.key}}\" \nng-model=\"vm.item[feild.key]\" type=\"{{feild.type||\'text\'}}\" ng-required=\"feild.required\" \nng-minlength=\"feild.minlength\" ng-maxlength=\"feild.maxlength\" ng-min=\"vm.item[feild.min]|| feild.min\" \nng-max=\"vm.item[feild.max]||feild.max\" ng-disabled=\"feild.readOnly\"></md-input-container><div ng-if=\"feild.select\">\n<label flex=\"50\">{{feild.name}}</label><md-icon md-font-icon=\"{{feild.icon}}\" class=\"name\"></md-icon><md-select \nng-model=\"vm.item[feild.key]\"><md-option ng-repeat=\"opt in feild.select.data\" value=\"{{opt[feild.select.key]}}\">\n{{opt[feild.select.value]}}</md-option></md-select></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-if=\"!vm.newContact\" ng-click=\"vm.submit()\" class=\"send-button md-accent md-raised font-size-12 saveBtn\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine\" aria-label=\"SAVE\">אישור</md-button></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-if=\"vm.AllowRemove\" class=\"md-icon-button\" aria-label=\"More\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s-8\" ng-click=\"vm.remove()\"></md-icon></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/contacts/dialogs/contact/contact-dialog.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-primary md-tall tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">איתור פציינט</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name font-size-15\">\nניתן לחפש לפי אחת או יותר מהשדות שבטופס</div></div></div></md-toolbar><md-dialog-content ms-scroll class=\"ng-form\" \nname=\"dialogForm\"><md-input-container class=\"md-icon-float md-block\"><label flex=\"50\">ת.ז</label><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><input name=\"tz\" ng-model=\"vm.contact.TZ\" type=\"text\" \nng-pattern=\"/^[0-9]*$/\" ng-minlength=\"5\" ng-maxlength=\"10\" md-autofocus><div ng-messages=\"dialogForm.tz.$error\"><span \nng-message=\"pattern\">מספר זהות אינו תקין</span><div ng-message=\"minlength\">מספר זהות חייב להכיל לפחות 5 תוים</div><div \nng-message=\"maxlength\">מספר זהות חייב להכיל מקסימום 9 תוים</div></div></md-input-container><md-input-container \nclass=\"md-icon-float md-block\"><label flex=\"50\">שם פציינט</label><md-icon md-font-icon=\"icon-account\" class=\"name\">\n</md-icon><input name=\"clientname\" ng-model=\"vm.contact.ClientName\" type=\"text\" ng-minlength=\"5\"><div \nng-messages=\"dialogForm.clientname.$error\"><div ng-message=\"minlength\">הקש לפחות 5 תוים</div></div>\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-phone\"></md-icon><label>טלפון\n</label><input name=\"phone\" ng-model=\"vm.contact.Tel\" type=\"tel\" \nng-pattern=\"/\\(?([0-9]{3})\\)?([ .-]?)([0-9]{3})\\2([0-9]{3})/\"><div ng-messages=\"dialogForm.phone.$error\"><span \nng-message=\"pattern\">טלפון שגוי</span></div></md-input-container><div ng-if=\"!vm.allFields\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent\" ng-click=\"vm.allFields = true\">אפשרויות נוספות</md-button>\n</div><div ng-if=\"vm.allFields\"><div layout=\"row\" class=\"md-block\" layout-align=\"start start\"><md-input-container \nflex=\"50\" class=\"md-block\"><label>עד לתאריך</label><md-icon md-font-icon=\"icon-calendar\"></md-icon><input \nname=\"kdateend\" ng-model=\"vm.contact.KDateEnd\" type=\"date\"><div ng-messages=\"dialogForm.kdateend.$error\"><span \nng-message=\"pattern\">תאריך אינו תקין</span></div></md-input-container><md-input-container flex=\"50\" class=\"md-block\">\n<label>מתאריך</label><input name=\"kdate\" ng-model=\"vm.contact.KDate\" type=\"date\"><div \nng-messages=\"dialogForm.kdate.$error\"><span ng-message=\"pattern\">תאריך אינו תקין</span></div></md-input-container>\n</div><md-input-container class=\"md-icon-float md-block\"><label flex=\"50\">שם רופא</label><md-icon \nmd-font-icon=\"icon-human-child\" class=\"name\"></md-icon><input name=\"doctor\" ng-model=\"vm.contact.DoctorName\" \ntype=\"text\" ng-minlength=\"5\"><div ng-messages=\"dialogForm.doctor.$error\"><div ng-message=\"minlength\">הקש לפחות 5 תוים\n</div></div></md-input-container><div layout=\"row\" class=\"md-block\" layout-align=\"start start\"><md-input-container \nflex=\"50\" class=\"md-icon-float md-block\"><label flex=\"50\">מספר חשבונית</label><md-icon md-font-icon=\"icon-receipt\" \nclass=\"name\"></md-icon><input name=\"invoice\" ng-model=\"vm.contact.HeshbonitID\" type=\"text\" ng-pattern=\"/^[0-9]*$/\" \nng-minlength=\"4\" ng-maxlength=\"8\"><div ng-messages=\"dialogForm.invoice.$error\"><span ng-message=\"pattern\">\nמספר חשבונית אינו תקין</span><div ng-message=\"minlength\">מספר חשבונית חייב להכיל לפחות 4 תוים</div><div \nng-message=\"maxlength\">מספר חשבונית חייב להכיל מקסימום 8 תוים</div></div></md-input-container><md-input-container \nflex=\"50\"><label>מספר משלוח</label><md-icon md-font-icon=\"icon-wallet-travel\"></md-icon><input name=\"shipping\" \nng-model=\"vm.contact.MishloachID\" type=\"text\" ng-pattern=\"/^[0-9]*$/\" ng-minlength=\"4\" ng-maxlength=\"10\"><div \nng-messages=\"dialogForm.shipping.$error\"><span ng-message=\"pattern\">מספר משלוח אינו תקין</span><div \nng-message=\"minlength\">מספר משלוח חייב להכיל לפחות 4 תוים</div><div ng-message=\"maxlength\">\nמספר משלוח חייב להכיל מקסימום 10 תוים</div></div></md-input-container></div><md-checkbox \nng-model=\"vm.contact.allPlaces\">חפש בכל הסניפים</md-checkbox><div ng-if=\"vm.allFields\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent\" ng-click=\"vm.allFields = false\">הסתר</md-button></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-if=\"!vm.newContact\" ng-click=\"vm.submit()\" \nclass=\"send-button md-accent md-raised font-size-12 saveBtn\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine\" aria-label=\"SAVE\">חפש</md-button></div></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/contacts/dialogs/import/importContacts.html","<md-dialog id=\"importContacts\"><form class=\"md-inline-form\"><md-toolbar class=\"md-primary md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Import Contacts</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content><div ng-show=\"vm.step==\'load\'\"><span class=\"secondary-text hide show-gt-sm\">\nChoose a method to import your contacts</span><div class=\"widget-group p-16\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget class=\"h-150 widget\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"p-16 white-bg white-fg\" \nlayout=\"row\" flex=\"100\"><div class=\"background-image-center cursor\"><ng-csv-import content=\"vm.content\" material \nmd-button-class=\"white-bg p-0\" md-button-title=\"Browse\" header=\"true\" separator=\"vm.seperator\" result=\"vm.resultCsv\" \ncallback=\"vm.initFields\"></ng-csv-import></div></ms-widget-front></ms-widget><ms-widget class=\"h-150 widget\" \nlayout=\"column\" flex=\"100\"><ms-widget-front class=\"p-16 white-bg white-fg\" layout=\"row\" flex=\"100\" \nng-class=\"{\'disableWidget\':!vm.isZoho}\"><div class=\"added\" ng-show=\"!vm.isZoho\"><span>N/A</span></div><div \nclass=\"background-image-center cursor\" ng-click=\"vm.isZoho?vm.importContacts(\'zoho\'):vm.toastNotIntegrate(\'zoho\')\"><img\n ng-src=\"assets/images/crm/zoho.png\"></div></ms-widget-front></ms-widget><ms-widget class=\"h-150 widget\" \nlayout=\"column\" flex=\"100\"><ms-widget-front class=\"p-16 white-bg white-fg\" layout=\"row\" flex=\"100\" \nng-class=\"{\'disableWidget\':!vm.shopName}\" ng-click=\"!vm.shopName?vm.toastNotIntegrate(\'shopify\'):\'\';\"><a \nng-href=\"{{vm.getShopifyUrl()}}\"><div class=\"added\" ng-show=\"!vm.shopName\"><span>N/A</span></div><div \nclass=\"background-image-center cursor\"><img ng-src=\"assets/images/crm/shopify.png\"></div></a></ms-widget-front>\n</ms-widget></div><div layout=\"row\" layout-align=\"center center\" class=\"m-16\"><md-progress-circular \nclass=\"md-hue-3 md-accent\" md-diameter=\"50\" layout-align=\"center center\" ng-show=\"vm.resultCsv&&vm.isLoading\">\n</md-progress-circular></div><div layout=\"row\" layout-align=\"center center\" class=\"m-16\" flex><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.step=\'fields\'\" ng-disabled=\"!vm.fields\" ng-show=\"vm.isIntegration==false;\">\nnext</md-button><md-button class=\"md-raised md-accent\" ng-click=\"vm.step=\'validate\'\" ng-show=\"vm.isIntegration==true\" \nng-disabled=\"!vm.contactsArray.length\">next</md-button></div></div><div ng-show=\"vm.step==\'fields\'&&!vm.isLoading\" \nlayout=\"column\"><span class=\"secondary-text p-8 pb-32\">\nPlease match the columns in your upload list to Bontact contacts list</span><div layout-gt-sm=\"row\" \nlayout-align=\"space-between center\" layout=\"column\"><span class=\"hide show-gt-sm p-32\">Contacts\'s <strong>email\n</strong> will be imported from -> </span><span class=\"hide-gt-sm\">Contacts\'s <strong>email</strong>\n will be imported from</span><md-select placeholder=\"select one\" ng-model=\"vm.fielsConvert.emailField\" name=\"email\" \nng-change=\"vm.initContactsArray()\" class=\"mb-16 mt-8\"><md-option ng-repeat=\"field in vm.fields\">{{field}}</md-option>\n</md-select></div><md-divider></md-divider><div layout-gt-sm=\"row\" layout-align=\"space-between center\" layout=\"column\">\n<span class=\"hide show-gt-sm p-32\">Contacts\'s <strong>first name</strong> will be imported from -> </span><span \nclass=\"hide-gt-sm pt-8\">Contacts\'s <strong>first name</strong> will be imported from</span><md-select \nplaceholder=\"select one\" ng-model=\"vm.fielsConvert.fnameField\" name=\"name\" ng-change=\"vm.initContactsArray()\" \nclass=\"mb-16 mt-8\"><md-option ng-repeat=\"field in vm.fields\">{{field}}</md-option><md-option ng-value=\"\">select one\n</md-option></md-select></div><md-divider></md-divider><div layout-gt-sm=\"row\" layout-align=\"space-between center\" \nlayout=\"column\"><span class=\"hide show-gt-sm p-32\">Contacts\'s <strong>last name </strong>will be imported from -> \n</span><span class=\"hide-gt-sm pt-8\">Contacts\'s <strong>last name </strong>will be imported from</span><md-select \nplaceholder=\"select one\" ng-model=\"vm.fielsConvert.lnameField\" name=\"lname\" ng-change=\"vm.initContactsArray()\" \nclass=\"mb-16 mt-8\"><md-option ng-repeat=\"field in vm.fields\">{{field}}</md-option><md-option ng-value=\"\">select one\n</md-option></md-select></div><md-divider></md-divider><div layout-gt-sm=\"row\" layout-align=\"space-between center\" \nlayout=\"column\"><span class=\"hide show-gt-sm p-32\">Contacts\'s <strong>phone</strong> will be imported from -> </span>\n<span class=\"hide-gt-sm pt-8\">Contacts\'s <strong>phone</strong> will be imported from</span><md-select \nplaceholder=\"select one\" ng-model=\"vm.fielsConvert.phoneField\" name=\"phone\" ng-change=\"vm.initContactsArray()\" \nclass=\"mb-16 mt-8\"><md-option ng-repeat=\"field in vm.fields\">{{field}}</md-option><md-option ng-value=\"\">select one\n</md-option></md-select></div><md-divider></md-divider><div layout-gt-sm=\"row\" layout-align=\"space-between center\" \nlayout=\"column\"><span class=\"hide show-gt-sm p-32\">Contacts\'s <strong>notes</strong> will be imported from -> </span>\n<span class=\"hide-gt-sm pt-8\">Contacts\'s <strong>notes</strong> will be imported from</span><md-select \nplaceholder=\"select one\" ng-model=\"vm.fielsConvert.notesField\" name=\"notes\" ng-change=\"vm.initContactsArray()\" \nclass=\"mb-16 mt-8\"><md-option ng-repeat=\"field in vm.fields\">{{field}}</md-option><md-option ng-value=\"\">select one\n</md-option></md-select></div><md-divider></md-divider><div layout=\"row\" layout-align=\"center center\" class=\"m-16\" \nflex><md-button class=\"md-raised md-accent\" ng-click=\"vm.step=\'load\'\">back</md-button><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.step=\'validate\';vm.validateData()\" ng-disabled=\"!vm.contactsArray.length\">next\n</md-button></div></div><div layout=\"row\" layout-align=\"center center\" ng-show=\"vm.step==\'validate\'&&!vm.isLoading\">\n<span class=\"secondary-text\">Validate result : {{vm.sumValid}} Valid contact {{vm.sumNotValid}} Not valid</span></div>\n<div ng-show=\"vm.step==\'validate\'&&!vm.isLoading\"><table class=\"simple contactsTable\"><thead><tr><th \nstyle=\"border:none;padding: 0;position: absolute;width: 5px\"></th><th class=\"p-8\"><span>Email</span></th><th \nclass=\"p-8 hide show-gt-sm\"><span>First name</span></th><th class=\"p-8 hide show-gt-sm\"><span>Last name</span></th><th \nclass=\"p-8 hide show-gt-sm\"><span>Phone</span></th><th class=\"p-8 hide show-gt-sm\"><span>Notes</span></th></tr></thead>\n<tbody><tr ng-repeat=\"item in (vm.contactsArray.length?vm.contactsArray:vm.contactsDemo)\" \nng-class=\"{\'red-fg\':vm.step==\'validate\'&&!item.status}\" ng-disabled=\"vm.step==\'validate\'\"><td><md-checkbox \nng-model=\"item.isAdd\" style=\"margin:0\" ng-disabled=\"item.status==false\"></md-checkbox></td><td>\n{{item.email|limitTo : 20}} <span ng-show=\"!item.email\" translate=\"CONTACTS.NOT_PROVIDED\" class=\"notProvided\" \nng-class=\"{\'red-fg\':vm.step==\'validate\'&&!item.status}\"></span></td><td class=\"hide show-gt-sm\">\n{{item.name|limitTo : 20}} <span ng-show=\"!item.name\" translate=\"CONTACTS.NOT_PROVIDED\" class=\"notProvided\" \nng-class=\"{\'red-fg\':vm.step==\'validate\'&&!item.status}\"></span></td><td class=\"hide show-gt-sm\">\n{{item.last_name|limitTo : 20}} <span ng-show=\"!item.last_name\" translate=\"CONTACTS.NOT_PROVIDED\" class=\"notProvided\" \nng-class=\"{\'red-fg\':vm.step==\'validate\'&&!item.status}\"></span></td><td class=\"hide show-gt-sm\">\n{{item.phone|limitTo : 20}} <span ng-show=\"!item.phone\" translate=\"CONTACTS.NOT_PROVIDED\" class=\"notProvided\" \nng-class=\"{\'red-fg\':vm.step==\'validate\'&&!item.status}\"></span></td><td class=\"hide show-gt-sm\">\n{{item.notes|limitTo : 20}} <span ng-show=\"!item.notes\" translate=\"CONTACTS.NOT_PROVIDED\" class=\"notProvided\" \nng-class=\"{\'red-fg\':vm.step==\'validate\'&&!item.status}\"></span></td></tr></tbody></table><div ng-show=\"!vm.isLoading\" \nlayout=\"row\" layout-align=\"center center\" class=\"m-16\" flex><md-button class=\"md-raised md-accent\" \nng-click=\"vm.step=vm.isIntegration?\'load\':\'fields\'\">back</md-button><md-button class=\"md-raised md-accent\" \nng-click=\"vm.addContacts()\" ng-disabled=\"!vm.getSumValid()\" ng-show=\"vm.step==\'validate\'\"><span \nclass=\"hide show-gt-sm\">Click to add {{vm.getSumValid()}} contact</span> <span class=\"hide-gt-sm\">submit</span>\n</md-button></div></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/calendar/dialogs/event-detail/event-detail-dialog.html","<md-dialog class=\"event-detail-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\"><span class=\"title\">{{vm.calendarEvent.title}}</span> <span flex></span><md-button \nclass=\"edit-event-button md-fab md-warn\" ng-click=\"vm.editEvent(vm.calendarEvent)\" aria-label=\"Edit event\" translate \ntranslate-attr-aria-label=\"CALENDAR.EDIT_EVENT\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"event-details\" layout=\"column\"><div class=\"event-detail-row\" \nlayout=\"row\" layout-align=\"start start\"><md-icon md-font-icon=\"icon-clock\"></md-icon><div layout=\"column\" flex><span \nclass=\"h4\">{{vm.calendarEvent.start.format(\'dddd DD/MM/YY\')}}</span> <span class=\"h4\">\n{{vm.calendarEvent.start.format(\'h:mm a\')}} <span ng-if=\"vm.calendarEvent.end\">-</span>\n {{vm.calendarEvent.end.format(\'h:mm a\')}}</span> <span class=\"secondary-text\">\n{{vm.calendarEvent.repeat || \'Does not repeat\'}}</span></div></div><div class=\"event-detail-row\" layout=\"row\" \nlayout-align=\"start start\"><md-icon md-font-icon=\"icon-bell-ring-outline\"></md-icon><div layout=\"column\" flex><span \nclass=\"h4\">{{vm.calendarEvent.notes}}</span></div></div><div class=\"event-detail-row\" layout=\"row\" \nlayout-align=\"start start\"><md-icon md-font-icon=\"icon-phone\"></md-icon><div layout=\"column\" flex><span class=\"h4\">\n{{vm.calendarEvent.phone}}</span></div></div><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start start\">\n<md-icon md-font-icon=\"icon-map-marker\"></md-icon><div layout=\"column\" flex><span class=\"h4\">{{vm.placeName}}</span>\n</div></div><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-account\"></md-icon><div layout=\"row\" flex><img src=\"assets/images/avatars/alice.jpg\" class=\"avatar\" \nalt=\"alice\"></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/contacts/sidenavs/main/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><img ng-src=\"{{vm.user.avatar}}\" \nclass=\"md-avatar avatar mr-16\" alt=\"{{vm.user.name}}\"> <span class=\"font-weight-500 font-size-14\">{{vm.user.name}}\n</span></div><md-divider></md-divider><div ms-scroll class=\"content\"><md-list><md-list-item \nng-click=\"vm.filterChange(\'all\')\" ng-class=\"{\'selected\':vm.listType ===\'all\'}\"><p translate=\"CONTACTS.ALL_CONTACTS\">\nAll contacts</p></md-list-item><md-list-item ng-click=\"vm.filterChange(\'frequent\')\" \nng-class=\"{\'selected\':vm.listType ===\'frequent\'}\"><p translate=\"CONTACTS.FREQUENTLY_CONTACTED\">Frequently contacted</p>\n</md-list-item><md-list-item ng-click=\"vm.filterChange(\'starred\')\" ng-class=\"{\'selected\':vm.listType ===\'starred\'}\"><p \ntranslate=\"CONTACTS.STARRED_CONTACTS\">Starred contacts</p></md-list-item><md-divider></md-divider><md-subheader \nclass=\"md-no-sticky\">Groups</md-subheader><md-list-item ng-if=\"vm.user.groups\" ng-repeat=\"group in vm.user.groups\" \nng-click=\"vm.filterChange(group)\" ng-class=\"{\'selected\':vm.listType.name === group.name}\"><p class=\"pl-8\">\n{{group.name}}</p></md-list-item><md-list-item class=\"new-group-form\" ng-show=\"newListForm.$visible\"><p class=\"pl-8\" \neditable-text=\"vm.newGroupName\" e-form=\"newListForm\" onaftersave=\"vm.addNewGroup()\"></p></md-list-item><md-list-item \nclass=\"\" ng-click=\"newListForm.$show()\" ng-hide=\"newListForm.$visible\"><p class=\"pl-8 md-accent-fg\" \ntranslate=\"CONTACTS.NEW_GROUP\">New Group</p></md-list-item></md-list></div>");
$templateCache.put("app/main/calendar/dialogs/event-form/event-form-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-block\"><label>שם</label><input name=\"title\" ng-model=\"vm.calendarEvent.title\" required md-autofocus><div \nng-messages=\"eventForm.title.$error\" ng-show=\"eventForm.title.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"CALENDAR.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div></md-input-container><div \nlayout=\"row\" class=\"date-row\"><md-button class=\"md-primary md-raised text-right\"><span \nmoment-picker=\"vm.calendarEvent.start\" start-view=\"day\" format=\"llll\">\n{{ vm.calendarEvent.start || \'Click here to select a date\' }}</span> : התחלה</md-button></div><div layout=\"row\" \nclass=\"date-row mb-15\"><md-button class=\"md-primary md-raised text-right\"><span moment-picker=\"vm.calendarEvent.end\" \nstart-view=\"day\" format=\"llll\">{{ vm.calendarEvent.end || \'Click here to select a date\' }}</span>: סיום</md-button>\n</div><md-input-container class=\"md-block\" flex><label>טלפון</label><input ng-model=\"vm.calendarEvent.phone\">\n</md-input-container><md-input-container flex class=\"md-block textarea-container\"><label>הערות</label><textarea \nng-model=\"vm.calendarEvent.notes\" md-maxlength=\"250\" max-rows=\"4\"></textarea></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button ng-click=\"vm.saveEvent()\" \nclass=\"save-button md-accent md-raised\" aria-label=\"SAVE\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\">שמור\n</md-button><md-button ng-disabled=\"!vm.calendarEvent.id\" ng-click=\"vm.deleteEvent()\" class=\"md-icon-button\" \naria-label=\"Delete\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip>מחק</md-tooltip></md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/invoice/views/modern/modern.html","<div id=\"invoice\" class=\"orhashen page-layout blank\" layout=\"row\" ms-scroll><div ng-hide=\"vm.isEnglish\" \nclass=\"invoice-container\" flex=\"100\" flex-gt-md=\"50\"><div class=\"card md-whiteframe-8dp\" layout=\"column\" flex>\n<md-button class=\"pr md-button md-accent md-raised\" ng-click=\"vm.print()\">הדפס</md-button><md-button \nclass=\"pr md-button\" ng-click=\"vm.isEnglish=true\">עבור לאנגלית</md-button><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between start\"><div class=\"ids\" layout=\"column\"><div layout=\"row\" class=\"seller\" flex \nlayout-align=\"start center\"><div class=\"logo\" flex=\"100\" layout=\"row\" layout-align=\"center center\"><img \nsrc=\"/assets/images/logos/or.jpg\"></div></div><div layout=\"row\" class=\"seller\" flex layout-align=\"end center\"><div \nclass=\"detail text-right mt-16\"><div class=\"title\">{{vm.invoice.hevra}}</div><div ng-if=\"vm.invoice.OsekMurshe\" \nclass=\"address\">{{vm.invoice.OsekMurshe}}</div><div ng-if=\"vm.invoice.Address\" class=\"address\">{{vm.invoice.Address}}\n</div><div ng-if=\"vm.invoice.Tel\" class=\"phone\"><span>טלפון </span>: {{vm.invoice.Tel}}</div><div \nng-if=\"vm.invoice.email\" class=\"email\"><span translate=\"INVOICE.EMAIL\">Email</span>: {{vm.invoice.email}}</div><div>\nתאריך: {{vm.invoice.KDate|date:\'dd/MM/yyyy\'}}</div></div></div><md-divider></md-divider><table dir=\"rtl\" \nclass=\"summary\"><tr class=\"code\"><td colspan=\"2\" class=\"label\" ng-hide=\"vm.invoice.refund\">חשבונית מס/קבלה</td><td \ncolspan=\"2\" class=\"label\" ng-show=\"vm.invoice.refund\">חשבונית זיכוי</td></tr><tr class=\"code\"><td class=\"label red-fg\">\n{{vm.invoice.KabalaID}}</td><td class=\"value\">{{(vm.invoice.original?\'מקור\':\'העתק\')}}</td></tr><tr class=\"code\"><td \nclass=\"label\">לכבוד</td><td class=\"value\">{{vm.invoice.ClientName}}</td></tr></table></div></div><div class=\"content\">\n<table dir=\"rtl\" class=\"simple invoice-table-footer\"><tbody><tr><th colspan=\"2\" class=\"text-right\">צילום</th></tr><tr \nng-repeat=\"service in vm.invoice.PhotosListArr\"><td colspan=\"2\"><div class=\"text-right title\">{{service}}</div></td>\n</tr><tr><td colspan=\"2\"><md-divider></md-divider></td></tr><tr class=\"subtotal\"><td class=\"text-right\">סך הכל</td><td \nclass=\"text-right\" ng-hide=\"vm.invoice.refund\">{{vm.invoice.hTotal -vm.invoice.MaamSum| customCurrency}}</td><td \nclass=\"text-right\" ng-show=\"vm.invoice.refund\">{{vm.invoice.refund.sumAll -vm.invoice.MaamSum| customCurrency}}</td>\n</tr><tr class=\"tax\"><td class=\"text-right\">מע\"מ ({{vm.invoice.Maam}}%)</td><td class=\"text-right\">\n{{vm.invoice.MaamSum| customCurrency}}</td></tr><tr><td colspan=\"2\"><md-divider></md-divider></td></tr><tr class=\"\"><td\n class=\"text-right\">שולם:</td><td>&nbsp;</td></tr><tr class=\"\" ng-if=\"vm.invoice.CashPrice\"><td class=\"text-right\">\nמזומן</td><td class=\"text-right\">{{vm.invoice.CashPrice | customCurrency}}</td></tr><tr class=\"\" \nng-if=\"vm.invoice.BankChekPrice1\"><td class=\"text-right\">שיק {{vm.invoice.BankChekNumber1}}</td><td class=\"text-right\">\n{{vm.invoice.BankChekPrice1|customCurrency}}</td></tr><tr class=\"\" ng-if=\"vm.invoice.BankChekPrice2\"><td \nclass=\"text-right\">שיק {{vm.invoice.BankChekNumber2}}</td><td class=\"text-right\">\n{{vm.invoice.BankChekPrice2|customCurrency}}</td></tr><tr class=\"\" ng-if=\"vm.invoice.BankChekPrice3\"><td \nclass=\"text-right\">שיק {{vm.invoice.BankChekNumber3}}</td><td class=\"text-right\">\n{{vm.invoice.BankChekPrice3|customCurrency}}</td></tr><tr class=\"\" ng-if=\"vm.invoice.BankChekPrice4\"><td \nclass=\"text-right\">שיק {{vm.invoice.BankChekNumber4}}</td><td class=\"text-right\">\n{{vm.invoice.BankChekPrice4|customCurrency}}</td></tr><tr class=\"\" ng-if=\"vm.invoice.CreditCardPrice\"><td \nclass=\"text-right\">אשראי ( <span ng-if=\"vm.invoice.CreditCardPaymants>1\">ב- {{vm.invoice.CreditCardPaymants}} תשלומים\n</span> <span ng-if=\"vm.invoice.CreditCardPaymants==1\">תשלום 1</span> )</td><td class=\"text-right\">\n{{vm.invoice.CreditCardPrice|customCurrency}}</td></tr><tr class=\"\" ng-if=\"vm.invoice.CreditCardPrice\"><td \nclass=\"text-right\">כרטיס: {{ vm.invoice.CreditCardNumber|limitTo:\'-4\'}}****</td><td class=\"dir-ltr\"></td></tr><tr \nclass=\"total\"><td class=\"text-right\">סך הכל</td><td class=\"text-right\" ng-hide=\"vm.invoice.refund\">\n{{vm.invoice.hTotal | customCurrency}}</td><td class=\"text-right\" ng-show=\"vm.invoice.refund\">\n{{vm.invoice.refund.sumAll | customCurrency}}</td></tr></tbody></table></div><div class=\"footer\"><div \nclass=\"note text-right\">{{vm.invoice.Message1}}</div><div class=\"note text-right\">{{vm.invoice.Message2}}</div><div \nlayout=\"row\" layout-align=\"end start\"><div class=\"small-note text-right\">חתימת הלקוח</div></div></div></div><div \nclass=\"page-break\"></div><div class=\"card md-whiteframe-8dp\" layout=\"column\" flex ng-if=\"vm.invoice.CreditCardPrice\">\n<div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div class=\"ids\" layout=\"column\"><div layout=\"row\" \nclass=\"seller\" flex layout-align=\"end center\"><div class=\"detail text-right mt-16\"><div class=\"title\">\n{{vm.invoice.hevra}}</div><div ng-if=\"vm.invoice.OsekMurshe\" class=\"address\">{{vm.invoice.OsekMurshe}}</div><div \nng-if=\"vm.invoice.Address\" class=\"address\">{{vm.invoice.Address}}</div><div ng-if=\"vm.invoice.Tel\" class=\"phone\"><span>\nטלפון </span>: {{vm.invoice.Tel}}</div><div ng-if=\"vm.invoice.email\" class=\"email\"><span translate=\"INVOICE.EMAIL\">\nEmail</span>: {{vm.invoice.email}}</div></div></div><md-divider></md-divider><table dir=\"rtl\" class=\"summary\"><tr \nclass=\"code\"><td colspan=\"2\" class=\"label\">שובר עסקה</td></tr><tr><td class=\"label\">תאריך/שעה</td><td class=\"value\">\n{{vm.invoice.KTime|date:\'dd/MM/yyyy HH:mm:ss\':\'+2\'}}</td></tr><tr><td class=\"label\">אישור:</td><td class=\"value\">\n{{vm.invoice.CreditCardOK_Number}}</td></tr><tr><td class=\"label\">שם פציינט</td><td class=\"value\">\n{{vm.invoice.ClientName}}</td></tr></table></div></div><div class=\"content\"><table dir=\"rtl\" \nclass=\"simple invoice-table-footer\"><tbody><tr><th colspan=\"2\" class=\"text-right\">צילום</th></tr><tr \nng-repeat=\"service in vm.invoice.PhotosListArr\"><td colspan=\"2\"><div class=\"text-right title\">{{service}}</div></td>\n</tr><tr><td colspan=\"2\"><md-divider></md-divider></td></tr><tr class=\"subtotal\"><td class=\"text-right\">סך הכל</td><td \nclass=\"text-right\" ng-hide=\"vm.invoice.refund\">{{vm.invoice.hTotal -vm.invoice.MaamSum| customCurrency}}</td><td \nclass=\"text-right\" ng-show=\"vm.invoice.refund\">{{vm.invoice.refund.sumAll -vm.invoice.MaamSum| customCurrency}}</td>\n</tr><tr class=\"tax\"><td class=\"text-right\">מע\"מ ({{vm.invoice.Maam}}%)</td><td class=\"text-right\">\n{{vm.invoice.MaamSum| customCurrency}}</td></tr><tr><td colspan=\"2\"><md-divider></md-divider></td></tr><tr class=\"\"><td\n class=\"text-right\">שולם:</td><td>&nbsp;</td></tr><tr class=\"\" ng-if=\"vm.invoice.CreditCardPrice\"><td \nclass=\"text-right\">אשראי ( <span ng-if=\"vm.invoice.CreditCardPaymants>1\">ב- {{vm.invoice.CreditCardPaymants}} תשלומים\n</span> <span ng-if=\"vm.invoice.CreditCardPaymants==1\">תשלום אחד</span> )</td><td class=\"text-right\">\n{{vm.invoice.CreditCardPrice|customCurrency}}</td></tr><tr class=\"total\"><td class=\"text-right\">סך הכל</td><td \nclass=\"text-right\" ng-hide=\"vm.invoice.refund\">{{vm.invoice.hTotal | customCurrency}}</td><td class=\"text-right\" \nng-show=\"vm.invoice.refund\">{{vm.invoice.refund.sumAll | customCurrency}}</td></tr></tbody></table></div><div \nclass=\"footer\"><div layout=\"row\" layout-align=\"end start\"><div class=\"small-note text-right\" \nstyle=\"border-bottom: solid 1px; width: 100%\">:חתימת הלקוח</div></div><div layout=\"row\" layout-align=\"end start\"><div \nclass=\"small-note text-right\"></div></div></div></div></div><div ng-show=\"vm.isEnglish\" class=\"invoice-container\" \nflex=\"100\" flex-gt-md=\"50\"><div class=\"card md-whiteframe-8dp\" layout=\"column\" flex><md-button \nclass=\"pr md-button md-accent md-raised\" ng-click=\"vm.print()\">Print</md-button><md-button class=\"pr md-button\" \nng-click=\"vm.isEnglish=false\">עבור לעברית</md-button><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between start\"><div class=\"ids\" layout=\"column\"><div layout=\"row\" class=\"seller\" flex \nlayout-align=\"start center\"><div class=\"logo\" flex=\"100\" layout=\"row\" layout-align=\"center center\"><img \nsrc=\"/assets/images/logos/or.jpg\"></div></div><div layout=\"row\" class=\"seller\" flex layout-align=\"end center\"><div \nclass=\"detail text-right mt-16\"><div class=\"title\">{{vm.invoice.hevra}}</div><div ng-if=\"vm.invoice.OsekMurshe\" \nclass=\"address\">{{vm.invoice.OsekMurshe}}</div><div ng-if=\"vm.invoice.Address\" class=\"address\">{{vm.invoice.Address}}\n</div><div ng-if=\"vm.invoice.Tel\" class=\"phone\"><span>phone </span>: {{vm.invoice.Tel}}</div><div \nng-if=\"vm.invoice.email\" class=\"email\"><span translate=\"INVOICE.EMAIL\">Email</span>: {{vm.invoice.email}}</div></div>\n</div><md-divider></md-divider><table dir=\"ltr\" class=\"summary\"><tr class=\"code\"><td colspan=\"1\" align=\"left\" \nclass=\"label text-left\">Invoice</td><td colspan=\"1\" align=\"left\" class=\"label\">&nbsp;</td></tr><tr class=\"code\"><td \nclass=\"label red-fg text-left\" align=\"left\">{{vm.invoice.KabalaID}}</td><td class=\"value\" align=\"left\">\n{{(vm.invoice.original?\'Orginal\':\'Copy\')}}</td></tr><tr><td class=\"label\">Date</td><td class=\"value\">\n{{vm.invoice.KDate|date}}</td></tr><tr><td class=\"label\">To</td><td class=\"value\">{{vm.invoice.ClientName}}</td></tr>\n</table></div></div><div class=\"content\"><table dir=\"ltr\" class=\"simple invoice-table-footer\"><tbody><tr><th \ncolspan=\"2\">Copies</th></tr><tr ng-repeat=\"service in vm.invoice.PhotosListArr\"><td colspan=\"2\"><div \nclass=\"text-right title\">{{service}}</div></td></tr><tr><td colspan=\"2\"><md-divider></md-divider></td></tr><tr \nclass=\"subtotal\"><td>Sum all</td><td>{{vm.invoice.hTotal -vm.invoice.MaamSum| customCurrency}}</td></tr><tr \nclass=\"tax\"><td>VAT ({{vm.invoice.Maam}}%)</td><td>{{vm.invoice.MaamSum| customCurrency}}</td></tr><tr><td colspan=\"2\">\n<md-divider></md-divider></td></tr><tr class=\"\"><td>Paid:</td><td>&nbsp;</td></tr><tr class=\"\" \nng-if=\"vm.invoice.CashPrice\"><td>Cash</td><td>{{vm.invoice.CashPrice | customCurrency}}</td></tr><tr class=\"\" \nng-if=\"vm.invoice.BankChekPrice1\"><td>Check {{vm.invoice.BankChekNumber1}}</td><td>\n{{vm.invoice.BankChekPrice1|customCurrency}}</td></tr><tr class=\"\" ng-if=\"vm.invoice.BankChekPrice2\"><td>\nCheck {{vm.invoice.BankChekNumber2}}</td><td>{{vm.invoice.BankChekPrice2|customCurrency}}</td></tr><tr class=\"\" \nng-if=\"vm.invoice.BankChekPrice3\"><td>Check {{vm.invoice.BankChekNumber3}}</td><td>\n{{vm.invoice.BankChekPrice3|customCurrency}}</td></tr><tr class=\"\" ng-if=\"vm.invoice.BankChekPrice4\"><td>\nCheck {{vm.invoice.BankChekNumber4}}</td><td>{{vm.invoice.BankChekPrice4|customCurrency}}</td></tr><tr class=\"\" \nng-if=\"vm.invoice.CreditCardPrice\"><td>Credit</td><td>{{vm.invoice.CreditCardPrice|customCurrency}}</td></tr><tr \nclass=\"total\"><td>Sum all</td><td>{{vm.invoice.hTotal | customCurrency}}</td></tr></tbody></table></div><div \nclass=\"footer\"><div class=\"note text-right\">{{vm.invoice.Message1}}</div><div class=\"note text-right\">\n{{vm.invoice.Message2}}</div><div ng-hide=\"true\" layout=\"row\" layout-align=\"end start\"><div \nclass=\"small-note text-right\">________________________</div><div class=\"small-note text-right\">חתימת הלקוח</div></div>\n</div></div><div class=\"page-break\"></div></div></div>");
$templateCache.put("app/main/invoice/views/compact/compact.html","<div id=\"invoice\" class=\"compact page-layout blank\" layout=\"row\" ms-scroll><div class=\"invoice-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\"><div class=\"invoice-date\">{{vm.invoice.date}}</div><div \nlayout=\"row\" layout-align=\"space-between stretch\"><div class=\"client\"><div class=\"invoice-number\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"title\" translate=\"INVOICE.INVOICE\">INVOICE</span> <span class=\"number\">\n{{vm.invoice.number}}</span></div><div class=\"due-date\" layout=\"row\" layout-align=\"start center\"><span class=\"title\" \ntranslate=\"INVOICE.DUE_DATE\">DUE DATE</span> <span class=\"date\">{{vm.invoice.dueDate}}</span></div><div class=\"info\">\n<div class=\"title\">{{vm.invoice.client.title}}</div><div ng-if=\"vm.invoice.client.address\" class=\"address\">\n{{vm.invoice.client.address}}</div><div ng-if=\"vm.invoice.client.phone\" class=\"phone\">{{vm.invoice.client.phone}}</div>\n<div ng-if=\"vm.invoice.client.email\" class=\"email\">{{vm.invoice.client.email}}</div><div \nng-if=\"vm.invoice.client.website\" class=\"website\">{{vm.invoice.client.website}}</div></div></div><div \nclass=\"issuer md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"center center\"><span>F</span></div><div class=\"info\"><div class=\"title\">{{vm.invoice.from.title}}</div>\n<div ng-if=\"vm.invoice.from.address\" class=\"address\">{{vm.invoice.from.address}}</div><div \nng-if=\"vm.invoice.from.phone\" class=\"phone\">{{vm.invoice.from.phone}}</div><div ng-if=\"vm.invoice.from.email\" \nclass=\"email\">{{vm.invoice.from.email}}</div><div ng-if=\"vm.invoice.from.website\" class=\"website\">\n{{vm.invoice.from.website}}</div></div></div></div></div><div class=\"content\"><table class=\"simple invoice-table\">\n<thead><th translate=\"INVOICE.SERVICE\">SERVICE</th><th translate=\"INVOICE.UNIT\">UNIT</th><th class=\"text-right\" \ntranslate=\"INVOICE.UNIT_PRICE\">UNIT PRICE</th><th class=\"text-right\" translate=\"INVOICE.QUANTITY\">QUANTITY</th><th \nclass=\"text-right\" translate=\"INVOICE.TOTAL\">TOTAL</th></thead><tbody><tr ng-repeat=\"service in vm.invoice.services\">\n<td><div class=\"title\">{{service.title}}</div></td><td>{{service.unit}}</td><td class=\"text-right\">\n{{service.unitPrice | currency}}</td><td class=\"text-right\">{{service.quantity}}</td><td class=\"text-right\">\n{{service.total | currency}}</td></tr><tr ng-repeat=\"service in vm.invoice.services\"><td><div class=\"title\">\n{{service.title}}</div></td><td>{{service.unit}}</td><td class=\"text-right\">{{service.unitPrice | currency}}</td><td \nclass=\"text-right\">{{service.quantity}}</td><td class=\"text-right\">{{service.total | currency}}</td></tr></tbody>\n</table><table class=\"simple invoice-table-footer\"><tbody><tr class=\"subtotal\"><td translate=\"INVOICE.SUBTOTAL\">\nSUBTOTAL</td><td>{{vm.invoice.subtotal | currency}}</td></tr><tr class=\"tax\"><td translate=\"INVOICE.TAX\">TAX</td><td>\n{{vm.invoice.tax | currency}}</td></tr><tr class=\"discount\"><td translate=\"INVOICE.DISCOUNT\">DISCOUNT</td><td>\n-{{vm.invoice.discount | currency}}</td></tr><tr class=\"total\"><td translate=\"INVOICE.TOTAL\">TOTAL</td><td>\n{{vm.invoice.total | currency}}</td></tr></tbody></table></div><div class=\"footer\"><div class=\"note\" \ntranslate=\"INVOICE.NOTE\">Please pay within 15 days. Thank you for your business.</div><div layout=\"row\" \nlayout-align=\"start start\"><div class=\"logo md-accent-bg\" layout=\"row\" layout-align=\"center center\"><div>F</div></div>\n<div class=\"small-note\" translate=\"INVOICE.SMALL_NOTE\">\nIn condimentum malesuada efficitur. Mauris volutpat placerat auctor. Ut ac congue dolor. Quisque scelerisque lacus sed feugiat fermentum. Cras aliquet facilisis pellentesque. Nunc hendrerit quam at leo commodo, a suscipit tellus dapibus. Etiam at felis volutpat est mollis lacinia. Mauris placerat sem sit amet velit mollis, in porttitor ex finibus. Proin eu nibh id libero tincidunt lacinia et eget eros.\n</div></div></div></div><div class=\"page-break\"></div></div></div>");
$templateCache.put("app/main/notes/directives/ms-note-item/ms-note-item.html","<md-card ng-class=\"MsNoteItem.note.color\"><img ng-if=\"MsNoteItem.note.image\" class=\"md-card-image\" \nng-src=\"{{MsNoteItem.note.image}}\"><md-card-content><md-card-title ng-if=\"MsNoteItem.note.title\"><md-card-title-text>\n{{MsNoteItem.note.title}}</md-card-title-text></md-card-title><md-description ng-if=\"MsNoteItem.note.description\">\n<span>{{MsNoteItem.note.description}}</span></md-description><div ng-if=\"MsNoteItem.note.checklist.length > 0\" \nclass=\"checklist\"><div class=\"checklist-item\" ng-repeat=\"checkItem in  MsNoteItem.note.checklist\" layout=\"row\" \nlayout-align=\"start center\"><md-checkbox ng-model=\"checkItem.checked\" \nng-click=\"$event.preventDefault();$event.stopPropagation()\" aria-label=\"{{checkItem.text}}\"></md-checkbox><span \nclass=\"text-truncate\" ng-class=\"{\'text-strike md-secondary-text\':checkItem.checked}\" flex>{{checkItem.text}}</span>\n</div></div><div class=\"labels\" ng-if=\"MsNoteItem.note.labels.length > 0\" layout=\"row\" layout-wrap \nlayout-align=\"end start\"><div class=\"label\" ng-repeat=\"labelId in MsNoteItem.note.labels\" \nng-click=\"$event.preventDefault();$event.stopPropagation();vm.filterChange(vm.labels.getById(labelId))\" \nng-class=\"vm.labels.getById(labelId).color\">{{vm.labels.getById(labelId).name}}</div></div><div \nng-if=\"vm.noteListType ===\'reminders\' && MsNoteItem.note.reminder\" class=\"reminder secondary-text text-right\"><md-icon \nmd-font-icon=\"icon-bell\" class=\"s16 mr-8\"></md-icon><span>{{MsNoteItem.note.reminder | altDate}}</span></div>\n</md-card-content></md-card>");
$templateCache.put("app/main/notes/directives/ms-new-note/ms-new-note.html","<ms-note-form note-type=\"\'new\'\"></ms-note-form><div ms-new-note-button class=\"new-note-button\"><span \ntranslate=\"NOTES.TAKE_A_NOTE\">Take a note..</span></div>");
$templateCache.put("app/main/notes/directives/ms-note-form/ms-note-form.html","<form ng-submit=\"MsNoteForm.submit()\" ng-class=\"MsNoteForm.note.color\"><div ng-if=\"MsNoteForm.note.image\" \nclass=\"image-wrapper\"><img class=\"md-card-image\" ng-src=\"{{MsNoteForm.note.image}}\"><md-button \nclass=\"md-fab md-mini delete-image-button\" ng-click=\"MsNoteForm.deleteImage()\" aria-label=\"delete image\" translate \ntranslate-attr-aria-label=\"NOTES.DELETE_IMAGE\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div><input \ntype=\"text\" class=\"note-title-input\" placeholder=\"כותרת\" ng-model=\"MsNoteForm.note.title\" \nng-class=\"MsNoteForm.note.color\"><md-input-container md-no-float ng-class=\"MsNoteForm.note.color\"><textarea \ntype=\"text\" class=\"note-description-textarea\" placeholder=\"Take a note..\" translate \ntranslate-attr-placeholder=\"NOTES.TAKE_A_NOTE\" ng-model=\"MsNoteForm.note.description\">\n    </textarea>\n</md-input-container><md-list class=\"checklist\" ng-if=\"MsNoteForm.note.checklist.length > 0\"><md-divider></md-divider>\n<md-list-item ng-repeat=\"item in MsNoteForm.note.checklist\"><md-checkbox ng-model=\"item.checked\" \naria-label=\"toggle check\"></md-checkbox><p ng-class=\"{\'text-strike md-secondary-text\':item.checked}\">{{item.text}}</p>\n<md-icon ng-click=\"$event.preventDefault();$event.stopPropagation();MsNoteForm.deleteCheckItem(item)\" \nclass=\"md-secondary\" md-font-icon=\"icon-close-circle\" aria-label=\"remove\"></md-icon><md-divider></md-divider>\n</md-list-item></md-list><div class=\"checklist-form\" \nng-if=\"MsNoteForm.note.checklist.length > 0 || MsNoteForm.checkListForm\" layout=\"row\" layout-align=\"space-between end\">\n<md-input-container class=\"\" md-no-float flex><input id=\"new-checklist-item-input\" type=\"text\" placeholder=\"List item\" \nng-model=\"MsNoteForm.newCheckListItem\" \nng-keydown=\"$event.keyCode === 13 ? $event.preventDefault() + MsNoteForm.addChecklistItem():\'\';\"></md-input-container>\n<md-button class=\"md-icon-button\" ng-click=\"MsNoteForm.addChecklistItem()\" aria-label=\"add\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"labels\" ng-if=\"MsNoteForm.note.labels.length > 0\" \nlayout=\"row\" layout-wrap layout-align=\"end start\"><div class=\"label\" ng-repeat=\"labelId in MsNoteForm.note.labels\" \nng-class=\"MsNoteForm.labels.getById(labelId).color\">{{MsNoteForm.labels.getById(labelId).name}}</div></div><div \nng-if=\"MsNoteForm.type ===\'edit\'\" class=\"date text-right p-16\">{{MsNoteForm.note.time | altDate}}</div><div \nclass=\"footer\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"actions\" layout=\"row\" layout-align=\"center center\" layout-wrap><div \nid=\"image-uploader\" flow-init=\"MsNoteForm.ngFlowOptions\" flow-name=\"MsNoteForm.ngFlow.flow\" \nflow-files-submitted=\"MsNoteForm.upload()\" flow-file-success=\"MsNoteForm.imageSuccess($file, $message)\" \nflow-complete=\"MsNoteForm.uploadComplete()\" flow-file-added=\"!!{svg:1,png:1,gif:1,jpg:1,jpeg:1}[$file.getExtension()]\">\n<md-button flow-btn class=\"add-img-button md-icon-button\" aria-label=\"Add image\" translate \ntranslate-attr-aria-label=\"NOTES.ADD_IMAGE\"><md-icon md-font-icon=\"icon-file-image-box\" class=\"s20\"></md-icon>\n</md-button></div><md-button class=\"md-icon-button\" aria-label=\"checklist\" ng-click=\"MsNoteForm.checklistFormToggle()\">\n<md-icon md-font-icon=\"icon-checkbox-multiple-marked\" class=\"s20\"></md-icon></md-button><md-menu class=\"label-menu\">\n<md-button class=\"md-icon-button\" aria-label=\"Label\" translate translate-attr-aria-label=\"NOTES.LABEL\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-origin md-font-icon=\"icon-label\" class=\"s20\"></md-icon></md-button>\n<md-menu-content class=\"notes-labels-menu-content\" width=\"4\" ms-scroll><md-menu-item><md-input-container \nclass=\"no-errors-spacer\" md-no-float><input placeholder=\"Search labels...\" type=\"text\" \nng-model=\"MsNoteForm.labelSearchText\" autocomplete=\"off\" translate-attr-palceholder=\"NOTES.SEARCH_LABELS\">\n</md-input-container></md-menu-item><md-menu-item class=\"label\" \nng-repeat=\"label in MsNoteForm.labels | filter: MsNoteForm.labelSearchText\"><md-button class=\"label-toggle-button\" \nmd-prevent-menu-close ng-class=\"label.color\" ng-click=\"MsNoteForm.toggleInArray(label.id, MsNoteForm.note.labels)\" \naria-label=\"Toggle Label\" translate translate-attr-aria-label=\"NOTES.TOGGLE_LABEL\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex><span>{{label.name}}</span> <i \nng-if=\"MsNoteForm.exists(label.id, MsNoteForm.note.labels)\" class=\"icon-check s16\"></i></div></md-button>\n</md-menu-item></md-menu-content></md-menu><md-button class=\"md-icon-button\" ng-click=\"MsNoteForm.toggleArchive()\" \naria-label=\"archive\"><md-icon md-font-icon=\"icon-archive\" class=\"s20\"></md-icon></md-button><ms-material-color-picker \nng-model=\"MsNoteForm.note.color\"><md-button class=\"md-icon-button\" aria-label=\"color\"><md-icon \nmd-font-icon=\"icon-palette\" class=\"s20\"></md-icon></md-button></ms-material-color-picker><md-datepicker \nclass=\"reminder\" ng-model=\"MsNoteForm.note.reminder\" md-placeholder=\"Add reminder\" ms-datepicker-fix></md-datepicker>\n</div><div layout=\"row\" layout-align=\"end center\"><md-button ng-if=\"MsNoteForm.type ===\'edit\'\" \nng-click=\"MsNoteForm.deleteNote()\" class=\"md-icon-button\" aria-label=\"delete note\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon></md-button><md-button ng-if=\"MsNoteForm.type ===\'edit\'\" type=\"submit\" translate=\"NOTES.SAVE\" \nng-disabled=\"MsNoteForm.isNotValid()\">Save</md-button><md-button ng-if=\"MsNoteForm.type ===\'new\'\" type=\"submit\" \ntranslate=\"NOTES.ADD\" ng-disabled=\"MsNoteForm.isNotValid()\">Add</md-button></div></div></form>");
$templateCache.put("app/main/notes/sidenavs/main/main-sidenav.html","<div ms-scroll class=\"content\"><md-list><md-list-item ng-click=\"vm.filterChange(\'notes\')\" \nng-class=\"{\'selected\':vm.listType ===\'notes\'}\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-lightbulb\" class=\"mr-16\"></md-icon><span translate=\"NOTES.NOTES\">Notes</span></div></md-list-item>\n<md-list-item ng-click=\"vm.filterChange(\'reminders\')\" ng-class=\"{\'selected\':vm.listType ===\'reminders\'}\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-bell\" class=\"mr-16\"></md-icon><span \ntranslate=\"NOTES.REMINDERS\">Reminders</span></div></md-list-item><md-divider></md-divider><md-subheader \nclass=\"md-no-sticky\"><span translate=\"NOTES.LABELS\">Labels</span></md-subheader><md-list-item \nng-repeat=\"label in vm.labels\" ng-class=\"{\'selected\':vm.noteListType.name === label.name}\" class=\"label\" layout=\"row\" \nlayout-align=\"start center\" flex><ms-material-color-picker ng-model=\"label.color\"><md-icon class=\"mr-16\" \nmd-font-icon=\"icon-label\" ng-style=\"{color:$selectedColor.bgColorValue}\"></md-icon></ms-material-color-picker><span \nclass=\"label-name text-transclude\" flex ng-hide=\"editLabelForm.$visible\" ng-click=\"vm.filterChange(label)\">\n{{label.name}} </span><span flex editable-text=\"label.name\" e-form=\"editLabelForm\" ng-show=\"editLabelForm.$visible\">\n{{label.name}}</span><md-button class=\"md-icon-button\" ng-hide=\"editLabelForm.$visible\" \nng-click=\"editLabelForm.$show()\" aria-label=\"edit label\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-hide=\"editLabelForm.$visible\" \nng-click=\"vm.deleteLabel($event, label)\" aria-label=\"delete label\"><md-icon md-font-icon=\"icon-delete\" class=\"s16\">\n</md-icon></md-button></md-list-item><md-list-item class=\"new-label-form\" ng-show=\"newLabelForm.$visible\"><p \neditable-text=\"vm.newLabel.name\" e-form=\"newLabelForm\" onaftersave=\"vm.addNewLabel(vm.newLabel)\"></p></md-list-item>\n<md-list-item class=\"\" ng-click=\"newLabelForm.$show()\" ng-hide=\"newLabelForm.$visible\"><p class=\"md-accent-fg\" \ntranslate=\"NOTES.NEW_LABEL\">New Label</p></md-list-item><md-divider></md-divider><md-list-item \nng-click=\"vm.filterChange(\'archive\')\" ng-class=\"{\'selected\':vm.listType ===\'archive\'}\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-archive\" class=\"mr-16\"></md-icon><span \ntranslate=\"NOTES.ARCHIVE\">Archive</span></div></md-list-item></md-list></div>");
$templateCache.put("app/main/pages/auth/lock/lock.html","<div id=\"lock\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"lock-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"lock-form\" class=\"md-whiteframe-8dp\"><div layout=\"row\" \nlayout-align=\"start center\" layout-sm=\"column\" layout-align-sm=\"center center\"><div class=\"avatar-container\"><img \nclass=\"avatar big\" src=\"assets/images/avatars/katherine.jpg\"><md-icon md-font-icon=\"icon-lock\" \nclass=\"md-warn-fg s36 md-hue-2\"></md-icon></div><div flex layout=\"column\" layout-align=\"start\" \nlayout-align-sm=\"center center\"><div class=\"title\">הגישה חסומה</div><div class=\"subtitle\">נא פנה למנהל מחשוב</div>\n</div></div></div></div></div>");
$templateCache.put("app/main/pages/auth/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>F\n</span></div><div class=\"title\" translate=\"LOGIN.TITLE\">Log in to your account</div><form name=\"loginForm\" novalidate>\n<md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" \nplaceholder=\"Email\" translate translate-attr-placeholder=\"LOGIN.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" \nplaceholder=\"Password\" translate translate-attr-placeholder=\"LOGIN.PASSWORD\" required><div \nng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><md-checkbox \nclass=\"remember-me\" ng-model=\"data.cb1\" aria-label=\"Remember Me\"><span translate=\"LOGIN.REMEMBER_ME\">Remember Me</span>\n</md-checkbox><a ui-sref=\"app.pages_auth_forgot-password\" class=\"forgot-password md-accent-color\" \ntranslate=\"LOGIN.FORGOT_PASSWORD\">Forgot Password?</a></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" \ntranslate=\"LOGIN.LOG_IN\" translate-attr-aria-label=\"LOGIN.LOG_IN\">LOG IN</md-button></form><div class=\"separator\"><span\n class=\"text\" translate=\"LOGIN.OR\">OR</span></div><md-button class=\"md-raised google\"><div layout=\"row\" \nlayout-align=\"center center\"><span><md-icon md-font-icon=\"icon-google-plus\" class=\"s16\"></md-icon><span \ntranslate=\"LOGIN.WITH_GOOGLE\">Log in with Google</span></span></div></md-button><md-button class=\"md-raised facebook\">\n<div layout=\"row\" layout-align=\"center center\"><span><md-icon md-font-icon=\"icon-facebook\" class=\"s16\"></md-icon><span \ntranslate=\"LOGIN.WITH_FACEBOOK\">Log in with Facebook</span></span></div></md-button><div class=\"register\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"LOGIN.DONT_HAVE_ACCOUNT\">\nDon\'t have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_register\" translate=\"LOGIN.CREATE_ACCOUNT\">\nCreate an account</a></div></div></div></div>");
$templateCache.put("app/main/pages/auth/login-v2/login-v2.html","<div id=\"login-v2\" layout=\"row\" layout-align=\"start\"><div id=\"login-v2-intro\" flex hide show-gt-sm><div class=\"logo\">\n<img src=\"/assets/images/logos/logo-or.png\"></div><div class=\"title\" translate=\"LOGIN_V2.INTRO_TITLE\">\nWelcome to the FUSE!</div><div class=\"description\" translate=\"LOGIN_V2.INTRO_DESCRIPTION\">\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ullamcorper nisl erat, vel convallis elit fermentum pellentesque. Sed mollis velit facilisis facilisis viverra.\n</div></div><div id=\"login-v2-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div \nid=\"login-v2-form\"><div class=\"logo\" hide-gt-sm><img src=\"/assets/images/logos/logo-or.png\"></div><div class=\"title\" \ntranslate=\"LOGIN_V2.TITLE\">Log in to your account</div><div class=\"description\" translate=\"LOGIN_V2.DESCRIPTION\">\nSed mollis velit facilisis facilisis viverra</div><div class=\"description red-fg\">{{vm.error}}</div><form \nname=\"loginForm\" novalidate ng-submit=\"vm.login()\"><md-input-container class=\"md-block\" md-no-float><input type=\"text\" \nname=\"place\" ng-model=\"vm.form.place\" placeholder=\"סניף\" required><div ng-messages=\"loginForm.place.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>שדה חובה</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.form.pass\" \nplaceholder=\"סיסמא\" required><div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>שדה חובה</span></div></div></md-input-container><div class=\"g-recaptcha\" vc-recaptcha \nng-model=\"vm.form.gRecaptchaResponse\"></div><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine||vm.proccess\" translate=\"LOGIN_V2.LOG_IN\" \ntranslate-attr-aria-label=\"LOGIN_V2.LOG_IN\">LOG IN</md-button></form><md-progress-linear ng-show=\"vm.proccess\" \nmd-mode=\"Indeterminate\" class=\"md-primary\"></md-progress-linear></div></div></div>");
$templateCache.put("app/main/pages/errors/404/error-404.html","<div id=\"error-404\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR404.CODE\">404</div><div class=\"message\" \ntranslate=\"ERROR404.MESSAGE\">Sorry but we couldn’t find the page you are looking for</div><div \nclass=\"search md-whiteframe-1dp\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon s24\"></md-icon><input ng-model=\"vm.search\" type=\"text\" placeholder=\"Search for anything\" translate \ntranslate-attr-placeholder=\"ERROR404.SEARCH\" flex></div><a class=\"back-link md-accent-color\" href=\"/\" \ntranslate=\"ERROR404.GO_BACK\">Go back to dashboard</a></div></div>");
$templateCache.put("app/main/pages/errors/500/error-500.html","<div id=\"error-500\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR500.CODE\">500</div><div class=\"message\" \ntranslate=\"ERROR500.MESSAGE\">Well, you broke the internet!</div><div class=\"sub-message\" \ntranslate=\"ERROR500.SUBMESSAGE\">Just kidding, looks like we have an internal issue, please try again in couple minutes\n</div><a class=\"report-link md-accent-color\" href=\"/\" translate=\"ERROR500.REPORT\">Report this problem</a></div></div>");
$templateCache.put("app/main/profile/dialog/bonClient/bonClient.html","<md-dialog><md-dialog-content><md-content layout=\"column\"><div id=\"invoice\" class=\"orhashen page-layout blank\" \nlayout=\"row\" ms-scroll><div class=\"invoice-container\" flex=\"100\"><div class=\"card md-whiteframe-8dp\" layout=\"column\" \nflex><md-button class=\"pr md-button md-accent md-raised\" ng-click=\"vm.print()\">הדפס</md-button><div class=\"header\" \nlayout=\"row\" layout-align=\"space-between start\"><div class=\"ids\" layout=\"column\"><div layout=\"row\" class=\"seller\" flex \nlayout-align=\"start center\"><div class=\"logo\" flex=\"100\" layout=\"row\" layout-align=\"center center\"><img \nsrc=\"/assets/images/logos/or.jpg\"></div></div><div layout=\"row\" class=\"seller\" flex layout-align=\"end center\"><div \nflex=\"\" class=\"detail text-right mt-16\"><div class=\"title\" flex>{{vm.dateNow|date:\'dd/MM/yy HH:mm\'}}</div><div \nclass=\"title font-size-16\">שם: {{vm.client.ClientName}}</div><div class=\"title\">תז: {{vm.client.TZ}}</div><div \nclass=\"title\">טלפון: {{vm.client.Tel}}</div><div class=\"title\">ת. לידה: {{vm.client.ClientBirthDate|date:\'dd/MM/yy\' }}\n</div><div class=\"title\">גורם משלם: {{vm.client.bituachName}}</div></div></div><md-divider></md-divider><div \nlayout=\"row\" class=\"seller\" flex layout-align=\"end center\"><div flex=\"\" class=\"detail text-right mt-16\"><div \nclass=\"title\">רופא: {{vm.client.doctorName}}</div><div ng-show=\"vm.client.doctorEmail\" class=\"title font-weight-800\">\n{{vm.client.doctorEmail}}</div><div class=\"title font-size-10\">{{vm.client.NoteOUT}}</div></div></div><md-divider>\n</md-divider><div layout=\"row\" class=\"seller\" flex layout-align=\"end center\"><div flex=\"\" \nclass=\"detail text-right mt-16\"><div class=\"title\">תאריך צילום: {{vm.client.KDate|date:\'dd/MM/yyyy\'}}</div><div \nclass=\"title\" ng-repeat=\"photo in vm.client.PhotosArr\">{{photo.Name}}</div></div></div><md-divider></md-divider><div \nlayout=\"row\" class=\"seller\" flex layout-align=\"end center\"><div flex=\"\" class=\"detail text-right mt-16\"><div \nclass=\"title\">:לתשלום<br>{{vm.client.PhotosPrice|customCurrency}}</div></div></div><md-divider></md-divider><div \nlayout=\"row\" class=\"seller\" flex layout-align=\"end center\"><div flex=\"\" class=\"detail text-right mt-16\"><div \nclass=\"title\">הערות: {{vm.client.ClientNote}}</div></div></div></div></div></div><div class=\"page-break\"></div></div>\n</div></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/main/profile/dialog/acceptVisit/acceptVisit.html","<md-dialog><md-dialog-content><md-content layout=\"column\"><div id=\"invoice\" class=\"orhashen page-layout blank\" \nlayout=\"row\" ms-scroll><div class=\"invoice-container\" flex=\"100\"><div class=\"card md-whiteframe-8dp\" layout=\"column\" \nflex><md-button class=\"pr md-button md-accent md-raised\" ng-click=\"vm.print()\">הדפס</md-button><div class=\"header\" \nlayout=\"row\" layout-align=\"space-between start\"><div class=\"ids\" layout=\"column\"><div layout=\"row\" class=\"seller\" flex \nlayout-align=\"start center\"><div class=\"logo\" flex=\"100\" layout=\"row\" layout-align=\"center center\"><img \nsrc=\"/assets/images/logos/or.jpg\"></div></div><div layout=\"row\" class=\"seller\" flex layout-align=\"end center\"><div \nclass=\"detail text-right mt-16\"><div class=\"title\">סניף: {{vm.place.Name}}</div><div class=\"title\" \nng-if=\"vm.place.Tel\">טל: {{vm.place.Tel}}</div><div class=\"title\">כתובת: {{vm.place.PlaceName}}</div><div \nclass=\"title\">{{vm.dateNow|date}}</div><div ng-if=\"vm.invoice.email\" class=\"email\"><span translate=\"INVOICE.EMAIL\">\nEmail</span>: {{vm.invoice.email}}</div></div></div><md-divider></md-divider><table dir=\"rtl\" class=\"summary\"><tr \nclass=\"code\"><td colspan=\"2\" class=\"label\">אישור ביקור</td></tr><tr class=\"code\"><td colspan=\"2\" class=\"value\">\nלכל המעוניין</td></tr><tr><td colspan=\"2\" class=\"value\">הרינו לאשר כי <span>{{vm.client.ClientName}}</span>\n ביקר במכוננו לצורך צילומי שיניים</td></tr><tr><td colspan=\"2\" class=\"value\">בתאריך <span>{{vm.client.KDate|date}}\n</span></td></tr><tr><td colspan=\"2\" class=\"value\">בין השעות <span>{{vm.client.TimeIN|date:\'HH:mm\'}}</span> - <span>\n{{vm.client.TimeOUT|date:\'HH:mm\'}}</span></td></tr></table></div></div><div class=\"content\"><table dir=\"rtl\" \nclass=\"simple invoice-table-footer\"><tbody><tr class=\"total\"><td class=\"text-right\">בכבוד רב,<br>\nאור השן - סניף {{vm.place.Name}}</td></tr></tbody></table></div></div><div class=\"page-break\"></div></div></div>\n</md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/main/profile/dialog/checks/checks.html","<md-dialog class=\"checksdialog\" aria-label=\"New Task\"><form name=\"formChecks\" novalidate><div \nclass=\"profile-box latest-activity md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"end center\"><div class=\"title\">הזן פרטי שיקים</div></header><div class=\"content dir-rtl\" layout=\"row\" \nflex layout-wrap><div class=\"activity\" layout=\"row\" flex=\"\" layout-align=\"start start\"><div layout=\"row\" flex><div \nlayout=\"row\" class=\"m-8\" layout-gt-xs=\"row\" flex><md-content class=\"timeline-tab mt-20 p-8\"><div layout=\"row\" \nng-repeat=\"check in vm.checksArr\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input \ntype=\"date\" name=\"date\" ng-model=\"check.date\" placeholder=\"סכום\" required><div ng-messages=\"formChecks.date.$error\" \nng-show=\"formChecks.date.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Firstname field is required.</span>\n</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"firstname\" \nng-model=\"check.bank\" ng-pattern=\"/^[0-9]*$/\" ng-minlength=\"2\" ng-maxlength=\"3\" placeholder=\"בנק\" required><div \nng-messages=\"formChecks.bank.$error\" ng-show=\"wizardStep1.firstname.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span>Firstname field is required.</span></div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"text\" name=\"firstname\" ng-model=\"check.branch\" ng-pattern=\"/^[0-9]*$/\" ng-minlength=\"1\" \nng-maxlength=\"3\" placeholder=\"סניף\" required><div ng-messages=\"wizardStep1.firstname.$error\" \nng-show=\"wizardStep1.firstname.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Firstname field is required.\n</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nname=\"firstname\" ng-model=\"check.account\" ng-pattern=\"/^[0-9]*$/\" ng-minlength=\"3\" ng-maxlength=\"15\" \nplaceholder=\"חשבון\" required><div ng-messages=\"wizardStep1.firstname.$error\" ng-show=\"wizardStep1.firstname.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Firstname field is required.</span></div></div></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"firstname\" ng-model=\"check.number\" \nng-pattern=\"/^[0-9]*$/\" ng-minlength=\"5\" ng-maxlength=\"15\" placeholder=\"מספר שיק\" required><div \nng-messages=\"wizardStep1.firstname.$error\" ng-show=\"wizardStep1.firstname.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Firstname field is required.</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"firstname\" ng-model=\"check.amount\" \nng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" ng-minlength=\"1\" ng-maxlength=\"10\" placeholder=\"סכום\" required><div \nng-messages=\"wizardStep1.firstname.$error\" ng-show=\"wizardStep1.firstname.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Firstname field is required.</span></div></div></md-input-container><md-input-container \nflex=\"20\" flex-gt-xs=\"20\"><div aria-label=\"Eat cake\" ng-if=\"$index!=0\"><md-tooltip>הסר</md-tooltip><md-icon \nmd-font-icon=\"icon-close\" class=\"icon\" ng-click=\"vm.removeCheck(check,$index)\"></md-icon></div></md-input-container>\n</div><div><md-button ng-disabled=\"vm.checksArr.length>=4||formChecks.$invalid\" ng-click=\"vm.addCheck()\" \nclass=\"post-button md-accent md-raised\" aria-label=\"POST\">הוסף שיק נוסף<md-icon md-font-icon=\"icon-plus\" class=\"icon\">\n</md-icon></md-button></div></md-content></div></div></div></div><div layout=\"row\" flex><md-button \nclass=\"md-raised md-primary\" ng-disabled=\"formChecks.$invalid\" ng-click=\"vm.closeDialog()\" \ntranslate-attr-aria-label=\"PROFILE.SEND_MESSAGE\">אישור</md-button><md-button class=\"md-raised md-primary\" \nng-click=\"vm.cancel()\" translate-attr-aria-label=\"PROFILE.SEND_MESSAGE\">ביטול</md-button></div></div></form>\n</md-dialog>");
$templateCache.put("app/main/profile/dialog/creditcard/creditcard.html","<md-dialog class=\"register_copyrator\" aria-label=\"New Task\"><div class=\"profile-box latest-activity md-whiteframe-1dp\" \nlayout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" layout-align=\"end center\"><div class=\"title\">חיוב בכ. אשראי\n</div></header><div class=\"content dir-rtl p-8\" layout=\"row\" flex layout-wrap><div class=\"\" layout=\"row\" flex=\"\" \nlayout-align=\"start start\"><div layout=\"column\" class=\"mt-20\" flex><div layout=\"row\" flex layout-align=\"center center\" \nng-hide=\"vm.editamount||vm.allowReset\"><md-button class=\"md-raised md-primary mt-16\" ng-click=\"vm.editamount=true\" \ntranslate-attr-aria-label=\"PROFILE.SEND_MESSAGE\">\n{{(vm.IsRefund?\'זיכוי\':\'חיוב\')}} {{vm.sumByCredit}} ש\"ח ב {{vm.paymentsNumber}} תשלומים. לחץ לשינוי</md-button></div>\n<div layout=\"column\" flex layout-align=\"center center\" ng-show=\"vm.editamount\"><div layout=\"row\" flex \nlayout-align=\"center center\"><md-input-container flex=\"60\"><input type=\"text\" ng-model=\"vm.sumByCredit\" \nplaceholder=\"סכום\" required></md-input-container><md-input-container flex=\"40\"><input type=\"number\" min=\"1\" max=\"6\" \nng-model=\"vm.paymentsNumber\" placeholder=\"מספר תשלומים\" required></md-input-container></div><div layout=\"row\" flex \nlayout-align=\"center center\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.updateAmount(event)\" \ntranslate-attr-aria-label=\"PROFILE.SEND_MESSAGE\">עדכן</md-button></div></div><div layout=\"column\" \nng-hide=\"vm.editamount||vm.manual\" flex layout-align=\"center center\" class=\"dir-ltr\"><h1>{{vm.strstatus}}</h1><div \nlayout=\"row\" ng-hide=\"vm.allowReset\" flex layout-align=\"center center\"><md-button class=\"md-raised md-accent\" \nng-disabled=\"!vm.smartActive\" ng-click=\"vm.smartPay(event)\">שלח חיוב למסוף</md-button></div></div><div layout=\"row\" \nng-show=\"vm.allowReset\" flex layout-align=\"center center\" class=\"dir-rtl\">לסליקה נוספת לחץ על \"המשך לסליקה נוספת\".<br>\nאם אינך רואה חשבונית לעסקה זו לחץ על הפקת חשבונית. (זהירות! אם אינך בטוח - מומלץ לרענן תחילה את הדף)</div><div \nlayout=\"row\" ng-show=\"vm.allowReset\" flex layout-align=\"center center\" class=\"dir-ltr\"><div class=\"m-8\"><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.reset()\">העבר כרטיס שנית\\ בצע סליקה נוספת</md-button></div></div><md-divider>\n</md-divider><div layout=\"row\" ng-show=\"vm.allowReset\" flex layout-align=\"center center\" class=\"dir-ltr\"><p \nclass=\"red-fg dir-rtl\">במידה וטרם הופקה חשבונית</p></div><div layout=\"row\" ng-show=\"vm.allowReset\" flex \nlayout-align=\"center center\" class=\"dir-ltr\"><div class=\"m-8\" ng-show=\"vm.allowcreateinvoice\"><md-button \nclass=\"md-warn md-raised\" ng-click=\"vm.continueAndClose()\">הפק חשבונית על עסקה זו</md-button></div><div class=\"m-8\" \nng-hide=\"vm.allowcreateinvoice\"><a ng-click=\"vm.allowcreateinvoice=true\">לחץ כאן להפקת חשבונית על עסקה זו</a></div>\n</div><div layout=\"row\" ng-show=\"vm.allowReset\" flex layout-align=\"center center\" class=\"dir-ltr\"><p \nclass=\"red-fg dir-rtl\">אנא וודא\\י שלא הופקה כבר חשבונית</p></div><div ng-if=\"false\" layout=\"row\"><input type=\"text\" \nid=\"cardAuto\" ng-model=\"vm.cardauto\" class=\"white-fg\" ng-keypress=\"vm.cardLeft()\" placeholder=\"\" required></div><div \nlayout=\"column\" flex layout-align=\"center center\" ng-show=\"vm.manual\"><form name=\"manualCard\" novalidate><div \nlayout=\"row\" flex=\"100\"><md-input-container flex><input type=\"text\" ng-model=\"vm.card.number\" ng-pattern=\"/^[0-9]*$/\" \nng-minlength=\"8\" ng-maxlength=\"17\" placeholder=\"מספר כרטיס\" required></md-input-container></div><div layout=\"row\" flex>\n<md-input-container flex=\"30\"><input type=\"number\" min=\"1\" max=\"12\" ng-model=\"vm.card.expired.month\" \nplaceholder=\"תוקף חודש\" required></md-input-container><md-input-container flex=\"30\"><input type=\"number\" \nmin=\"{{vm.year}}\" max=\"{{(vm.year+7)}}\" ng-model=\"vm.card.expired.year\" placeholder=\"תוקף שנה\" required>\n</md-input-container><md-input-container flex=\"30\"><input type=\"text\" ng-model=\"vm.card.cvv\" placeholder=\"3 ספרות CVV\" \nrequired></md-input-container></div><div layout=\"row\" flex><md-input-container flex=\"100\"><input type=\"text\" \nng-model=\"vm.card.tz\" placeholder=\"מס זהות\" required></md-input-container></div><div layout=\"row\" flex \nlayout-align=\"center center\"><md-button class=\"md-raised md-warn\" ng-click=\"vm.manualPay()\" \nng-disabled=\"manualCard.$invalid||vm.statusOK||vm.proccessManual\" translate-attr-aria-label=\"PROFILE.SEND_MESSAGE\">\nחייב עכשיו</md-button></div></form></div></div></div></div><div layout=\"row\" flex><md-button \nclass=\"md-raised md-primary\" ng-click=\"vm.closeDialog()\" ng-disabled=\"!vm.statusOK\" \ntranslate-attr-aria-label=\"PROFILE.SEND_MESSAGE\">אישור</md-button><md-button class=\"md-raised md-primary\" \nng-click=\"vm.cancel()\" ng-disabled=\"vm.statusOK&&!vm.allowReset\" translate-attr-aria-label=\"PROFILE.SEND_MESSAGE\">ביטול\n</md-button><div layout=\"row\" layout-align=\"start center\" class=\"m-8\" ng-hide=\"vm.statusOK||vm.allowReset\"><a href=\"#\" \nng-click=\"vm.manual=!vm.manual\">{{(vm.manual?\'סליקה אוטומטית\':\'הזנה ידנית\')}}</a></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"m-8\" ng-hide=\"vm.statusOK||vm.allowReset\"><a href=\"#\" class=\"red-fg\" \nng-click=\"vm.pelecardCheckPayAndClose()\">בדוק סליקה קודמת</a></div></div></div></md-dialog>");
$templateCache.put("app/main/profile/dialog/document/document.html","<md-dialog class=\"docShow\"><md-dialog-content flex><md-content flex layout=\"column\"><div flex=\"100\"><image-viewer \nsrc=\"{{vm.filesrc}}\"></image-viewer></div><div>ניתן לשנות גודל ע\"י שינוי גלגלת העכבר</div></md-content>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/profile/dialog/editCopies/editCopies.html","<md-dialog class=\"checksdialog\" aria-label=\"New Task\" flex=\"\"><form name=\"formChecks\" novalidate><div \nclass=\"profile-box latest-activity md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"end center\"><div class=\"title\">עריכת פרטי צילום</div></header><div class=\"content dir-rtl\" layout=\"row\" \nlayout-wrap><ms-prices-doctors copies=\"vm.copies\" doctor=\"vm.doctor\" count-copies=\"vm.countCopies\"></ms-prices-doctors>\n</div><footer class=\"dir-rtl m-8\" layout-align=\"space-between center\"><md-button class=\"md-accent md-raised\" \nng-disabled=\"!vm.copies.length\" ng-click=\"vm.updateDoctorPrices()\">שמור</md-button><md-button class=\"md-raised\" \nng-click=\"vm.close()\">ביטול</md-button></footer></div></form></md-dialog>");
$templateCache.put("app/main/profile/dialog/shippingDetails/shippingDetails.html","<md-dialog><md-dialog-content><md-content layout=\"column\"><div id=\"invoice\" class=\"orhashen page-layout blank\" \nlayout=\"row\" ng-if=\"!vm.multy\" ms-scroll><div class=\"invoice-container\" flex=\"100\"><div class=\"card md-whiteframe-8dp\" \nlayout=\"column\" flex><md-button class=\"pr md-button md-accent md-raised\" ng-click=\"vm.print()\">הדפס</md-button><div \nclass=\"header\" layout=\"row\" layout-align=\"space-between start\"><div class=\"ids\" layout=\"column\"><div layout=\"row\" \nclass=\"seller\" flex layout-align=\"start center\"><div class=\"logo\" flex=\"100\" layout=\"row\" layout-align=\"center center\">\n<img src=\"/assets/images/logos/or.jpg\"></div></div><div layout=\"row\" class=\"seller\" flex layout-align=\"end center\"><div\n flex=\"50\" class=\"\" layout-align=\"start start\"><div class=\"label\">משלוח</div><div class=\"label\">\n{{vm.client.MishloahID}}</div></div><div flex=\"50\" class=\"detail text-right mt-16\"><div class=\"title\">\nסניף: {{vm.place.Name}}</div><div class=\"title\" ng-if=\"vm.place.Tel\">טל: {{vm.place.Tel}}</div><div class=\"title\">\nכתובת: {{vm.place.PlaceName}}</div><div class=\"title\">{{vm.dateNow|date:\'dd/MM/yyyy\'}}</div><div \nng-if=\"vm.invoice.email\" class=\"email\"><span translate=\"INVOICE.EMAIL\">Email</span>: {{vm.invoice.email}}</div></div>\n</div><md-divider></md-divider><div layout=\"row\" class=\"seller\" flex layout-align=\"end center\"><div flex=\"\" \nclass=\"detail text-right mt-16\"><div class=\"title font-size-20\">לכבוד: {{vm.doctor.Name}}</div><div class=\"title\">\nכתובת: {{vm.doctor.Address}} {{vm.doctor.city}}</div><div class=\"title\" ng-if=\"vm.doctor.Tel1\">טל: {{vm.doctor.Tel1}}\n</div><div class=\"title\" ng-if=\"vm.doctor.Tel2\">{{vm.doctor.Tel2}}</div><div class=\"title\" ng-if=\"vm.doctor.Pel1\">\n{{vm.doctor.Pel1}}</div><div class=\"title\" ng-if=\"vm.doctor.Pel2\">{{vm.doctor.Pel2}}</div><div \nclass=\"title font-weight-800\" ng-if=\"vm.doctor.Email1\">{{vm.doctor.Email1}}</div><div class=\"title\" \nng-if=\"vm.doctor.Email2\">{{vm.doctor.Email2}}</div></div></div><md-divider></md-divider><div layout=\"row\" \nclass=\"seller\" flex layout-align=\"end center\"><div flex=\"\" class=\"detail text-right mt-16\"><div class=\"title\">\nתאריך צילום: {{vm.client.KDate|date:\'dd/MM/yyyy\'}}</div><div class=\"title\">שם פציינט: {{vm.client.ClientName}}</div>\n</div></div><md-divider></md-divider><div layout=\"row\" class=\"seller\" flex layout-align=\"end center\"><div flex=\"\" \nclass=\"detail text-right mt-16\">שם/חתימת המקבל ____________________</div></div></div></div></div><div \nclass=\"page-break\"></div></div></div><div id=\"invoice\" class=\"orhashen page-layout blank\" layout=\"row\" \nng-if=\"vm.multy\" ms-scroll><div class=\"invoice-container\" flex=\"100\"><div class=\"card md-whiteframe-8dp\" \nlayout=\"column\" flex><md-button class=\"pr md-button md-accent md-raised\" ng-click=\"vm.print()\">הדפס</md-button><div \nclass=\"header\" layout=\"row\" layout-align=\"space-between start\" ng-repeat=\"item in vm.data\"><div class=\"pagebreak\">\n</div><div class=\"ids\" layout=\"column\"><div layout=\"row\" class=\"seller\" flex layout-align=\"start center\"><div \nclass=\"logo\" flex=\"100\" layout=\"row\" layout-align=\"center center\"><img src=\"/assets/images/logos/or.jpg\"></div></div>\n<div layout=\"row\" class=\"seller\" flex layout-align=\"end center\"><div flex=\"50\" class=\"\" layout-align=\"start start\"><div\n class=\"label\">משלוח</div><div class=\"label\">{{item.MishloahID}}</div></div><div flex=\"50\" \nclass=\"detail text-right mt-16\"><div class=\"title\">סניף: {{vm.place.Name}}</div><div class=\"title\" \nng-if=\"vm.place.Tel\">טל: {{vm.place.Tel}}</div><div class=\"title\">כתובת: {{vm.place.PlaceName}}</div><div \nclass=\"title\">{{vm.dateNow|date:\'dd/MM/yyyy\'}}</div><div ng-if=\"vm.invoice.email\" class=\"email\"><span \ntranslate=\"INVOICE.EMAIL\">Email</span>: {{vm.invoice.email}}</div></div></div><md-divider></md-divider><div \nlayout=\"row\" class=\"seller\" flex layout-align=\"end center\"><div flex=\"\" class=\"detail text-right mt-16\"><div \nclass=\"title font-size-20\">לכבוד: {{item.Name}}</div><div class=\"title\">כתובת: {{item.Address}} {{item.city}}</div><div\n class=\"title\" ng-if=\"item.Tel1\">טל: {{item.Tel1}}</div><div class=\"title\" ng-if=\"item.Tel2\">{{item.Tel2}}</div><div \nclass=\"title\" ng-if=\"item.Pel1\">{{item.Pel1}}</div><div class=\"title\" ng-if=\"item.Pel2\">{{item.Pel2}}</div><div \nclass=\"title font-weight-800\" ng-if=\"item.Email1\">{{item.Email1}}</div><div class=\"title\" ng-if=\"item.Email2\">\n{{item.Email2}}</div></div></div><md-divider></md-divider><div layout=\"row\" class=\"seller\" flex \nlayout-align=\"end center\"><div flex=\"\" class=\"detail text-right mt-16\"><div class=\"title\">\nתאריך צילום: {{item.KDate|date:\'dd/MM/yyyy\'}}</div><div class=\"title\">שם פציינט: {{item.ClientName}}</div></div></div>\n<md-divider></md-divider><div layout=\"row\" class=\"seller\" flex layout-align=\"end center\"><div flex=\"\" \nclass=\"detail text-right mt-16\">שם/חתימת המקבל ____________________</div></div></div></div></div><div \nclass=\"page-break\"></div></div></div></md-content></md-dialog-content></md-dialog>");
$templateCache.put("app/main/profile/dialog/upload/upload.html","<md-dialog><md-dialog-content><div class=\"content\" layout=\"row\" flex><md-select layout=\"row\" flex \nng-model=\"vm.photoID\"><md-option ng-value=\"0\">בחר סוג צילום או מסמך</md-option><md-option \nng-repeat=\"ph in vm.profile.PhotosArr|filter:{mustUpload:true}\" ng-value=\"ph.PhotoID\">{{ph.Name}}</md-option><md-option\n ng-value=\"-1\">הפנייה</md-option><md-option ng-value=\"-2\">אחר</md-option></md-select></div><div \nclass=\"upload-content groups md-whiteframe-1dp\" layout=\"column\" flex><ms-widget ng-show=\"vm.photoID\" \nclass=\"h-300 drop-box\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" flex ngf-select=\"vm.upload($files)\" \nngf-drop=\"vm.upload($files)\" class=\"drop-box\" ngf-multiple=\"true\" \nngf-drag-over-class=\"{accept:\'dragover\', reject:\'dragover-err\', pattern:\'image/jpg,image/jpeg,image/png,application/pdf application/zip,application/octet-stream,application/x-zip-compressed,multipart/x-zip\'}\" \nngf-accept=\"\'image/jpg,image/jpeg,image/png,application/pdf,application/zip,application/octet-stream,application/x-zip-compressed,multipart/x-zip\'\" \nngf-max-size=\"600MB\" ngf-validate=\"{size: {max: \'600MB\', min: \'10B\'}}\" ngf-run-all-validations=\"true\" \nngf-pattern=\"\'image/jpg,image/jpeg,image/png,application/pdf,application/zip,application/octet-stream,application/x-zip-compressed,multipart/x-zip\'\" \nngf-validate-fn=\"vm.validate($file)\" ngf-drag-over-class=\"\'dragover\'\"><ms-widget-front \nclass=\"p-16 grey-bg white-fg ms-widget-front\" layout=\"row\" flex=\"\"><div layout=\"column\" layout-align=\"center center\" \nflex=\"\"><div class=\"md-display-3 pb-8 ng-binding\" ng-hide=\"vm.uploadProccess||vm.error_image\">העלאת קובץ</div><div \nclass=\"md-display-3 pb-8 ng-binding red-fg\" ng-show=\"vm.error_image\">קובץ שגוי</div><div \nclass=\"md-display-3 pb-8 ng-binding\" ng-show=\"vm.uploadProccess\">{{vm.uploadProccess}}</div><div \nclass=\"h3 font-weight-500 ng-binding red-fg\" ng-show=\"vm.error_image\">שם הקובץ חייב להכיל את שם הפציינט או ת.ז</div>\n<div class=\"h3 font-weight-500 ng-binding\">לחץ כאן או גרור לכאן מסמך חדש</div></div><div \nclass=\"background-image-center\"><md-icon md-font-icon=\"icon-file-document\" class=\"s256 faint-text md-default-theme\" \nrole=\"img\" aria-label=\"icon-filmstrip\"></md-icon></div></ms-widget-front></ms-widget><ms-widget ng-hide=\"vm.photoID\" \nclass=\"h-300 drop-box\" layout=\"column\" flex><ms-widget-front class=\"p-16 blue-grey-bg white-fg ms-widget-front\" \nlayout=\"row\" flex=\"\"><div layout=\"column\" layout-align=\"center center\" flex=\"\"><div \nclass=\"md-display-3 pb-8 ng-binding\">העלאת קובץ</div><div class=\"h3 font-weight-500 ng-binding\">\nבחר סוג צילום/מסמך להעלאה</div></div><div class=\"background-image-center\"><md-icon md-font-icon=\"icon-arrow-up\" \nclass=\"s256 faint-text md-default-theme\" role=\"img\" aria-label=\"icon-filmstrip\"></md-icon></div></ms-widget-front>\n</ms-widget></div><div layout=\"row\" layout-align=\"center center\" class=\"md-display-1 pb-8 text-right\">\n!נא להעלות קבצים באיכות גבוהה</div><div layout=\"row\" layout-align=\"center center\" class=\"md-display-1 pb-8 text-right\">\njpg,png,pdf</div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/profile/tabs/billing/billing.html","<div layout=\"row\" flex layout-wrap class=\"dir-rtl\"><div class=\"about-sidebar\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"35\"><div class=\"profile-box friends md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title dir-rtl\" flex>מצב חשבון</div>\n</header><div class=\"content dir-rtl\" layout=\"column\" layout-wrap><div layout=\"row\" flex><div flex=\"50\">סך הכל</div>\n<div flex=\"50\">{{vm.profile.sumAll.topay| customCurrency}}</div></div><div layout=\"row\" flex \nng-show=\"vm.profile.sumAll.insuranceprice\"><div flex=\"50\"><a href=\"#\" ng-click=\"vm.depositDialog($event)\" \nclass=\"md-accent\"><md-icon class=\"orange-fg\" md-font-icon=\"icon-folder-lock\"></md-icon><md-tooltip>קבלת פיקדון\n</md-tooltip></a>{{vm.profile.bituachName}}</div><div flex=\"50\">{{\'***** \' }}</div></div><div layout=\"row\" flex \nng-repeat=\"receipt in vm.profile.Receipts.data\"><div flex=\"40\"><a href=\"#\" \nui-sref=\"app.invoice_client.original({id:receipt.KabalaID,original:\'f\'})\">חשבונית <span \nng-if=\"receipt.kNote.trim()==\'זיכוי\'\">זיכוי</span> {{receipt.KabalaID}}</a></div><div flex=\"40\">\n{{receipt.sumAll | customCurrency}}</div><div flex=\"40\"><a href=\"#\" ng-if=\"receipt.kNote.trim()!=\'זיכוי\'\" \nng-click=\"vm.RefundStatus(receipt)\">זיכוי חשבונית</a></div></div></div><footer class=\"dir-rtl\"><div layout=\"row\" \nclass=\"md-title\" flex><div flex=\"50\">סך לתשלום</div><div flex=\"50\">{{vm.profile.sumAll.topay| customCurrency}}</div>\n</div></footer></div><div class=\"profile-box groups md-whiteframe-1dp\" layout=\"column\" \nng-show=\"vm.profile.Receipts.data.length\"><header class=\"md-accent-bg\" layout=\"row\" layout-align=\"end center\"><div \nclass=\"title dir-rtl\" flex>פירוט תשלומים - חשבוניות קודמות</div></header><div class=\"content dir-rtl\"><div \nlayout=\"row\" flex><div flex=\"50\">ס\"ה מזומן</div><div flex=\"50\">\n{{(vm.profile.Receipts.sumCashPrice ||0)| customCurrency}}</div></div><div layout=\"row\" flex><div flex=\"50\">ס\"ה שיקים\n</div><div flex=\"50\">{{(vm.profile.Receipts.sumChekPrice ||0)| customCurrency}}</div></div><div layout=\"row\" flex><div \nflex=\"50\">ס\"ה אשראי</div><div flex=\"50\">{{(vm.profile.Receipts.sumCreditCardPrice||0) | customCurrency}}</div></div>\n</div><footer layout=\"row\" class=\"dir-rtl\" layout-align=\"space-between center\"><div layout=\"row\" class=\"md-title\" flex>\n<div flex=\"50\">סך נתקבל</div><div flex=\"50\">{{vm.profile.Receipts.sumAllRecepts | customCurrency}}</div></div></footer>\n<footer layout=\"row\" class=\"dir-rtl\" layout-align=\"space-between center\"><div layout=\"row\" class=\"md-title\" flex><div \nflex=\"50\">יתרת חוב</div><div flex=\"50\">\n{{((vm.profile.sumAll.topay)-vm.profile.Receipts.sumAllRecepts) | customCurrency}}</div></div></footer></div><div \nclass=\"profile-box groups md-whiteframe-1dp\" layout=\"column\" ng-show=\"vm.profile.Deposits.length\"><header \nclass=\"md-accent-bg\" layout=\"row\" layout-align=\"end center\"><div class=\"title dir-rtl\" flex>פקדונות</div></header><div \nclass=\"content dir-rtl\"><div layout=\"row\" ng-repeat=\"dep in vm.profile.Deposits\" flex><div flex=\"50\">סכום</div><div \nflex=\"50\">{{(dep.sum)| customCurrency}}</div></div></div><footer layout=\"row\" class=\"dir-rtl\" \nlayout-align=\"space-between center\"><div layout=\"row\" class=\"md-title\" flex><div flex=\"50\"><md-button \nclass=\"md-primary\" ng-click=\"vm.depositCancelDialog($event)\">שחרר פיקדון אחרון</md-button></div></div></footer></div>\n</div><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"65\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button ng-if=\"vm.refund\" \nclass=\"md-raised\" aria-label=\"insert photo\" ng-click=\"vm.RefundStatus()\"><md-icon md-font-icon=\"icon-backburger\">\n</md-icon>חזור</md-button></div><div class=\"title dir-rtl\">קבלת תשלום</div></header><div class=\"content\">\n<md-progress-linear ng-show=\"vm.proccess\" md-mode=\"Indeterminate\" class=\"md-primary\"></md-progress-linear><div \nclass=\"info-line md-title dir-rtl\" ng-if=\"vm.profile.paidAll\" layout=\"row\" layout-align=\"center center\" flex><div \nclass=\"info-line md-title dir-rtl\" layout=\"column\" layout-align=\"center center\" flex><div ng-if=\"!vm.refund\">שולם הכל\n</div><div ng-if=\"vm.refund\">קבלת זיכוי - חשבונית {{vm.payments.RefundKabalaID}}</div><div ng-if=\"!vm.refund\"><md-icon \nmd-font-icon=\"icon-check\" class=\"s96\"></md-icon></div></div></div><div class=\"info-line md-title dir-rtl\" \nng-if=\"!vm.profile.paidAll&&(vm.profile.sumAll.topay)<=vm.profile.Receipts.sumAllRecepts\" layout=\"row\" \nlayout-align=\"center center\" flex><div class=\"info-line md-title dir-rtl\" layout=\"column\" layout-align=\"center center\" \nflex><div>לא לתשלום</div><div><md-icon md-font-icon=\"icon-close\" class=\"s96\"></md-icon></div></div></div><div \nng-hide=\"true\">paidAll: {{vm.profile.paidAll}}<br>isClosed: {{vm.profile.isClosed}}<br>\nShulamSW: {{vm.profile.ShulamSW}}<br>sumAllRecepts::{{vm.profile.Receipts.sumAllRecepts}}<br>\nfirstToPay:{{vm.profile.Receipts.firstToPay}}<br>\nsumAllRecepts:--{{vm.profile.sumAll.topay-vm.profile.Receipts.sumAllRecepts}}</div><div \nng-if=\"(!vm.profile.paidAll||vm.refund)&&(vm.profile.Receipts.sumAllRecepts>0||vm.profile.sumAll.topay>0)\" \nlayout=\"row\" flex><md-button layout=\"column\" flex ng-disabled=\"vm.anotherPlace\" ng-click=\"vm.openCashDialog()\" \nclass=\"post-button md-accent md-raised pt-8\" aria-label=\"POST\"><img src=\"assets/images/etc/money.png\"> מזומן\n</md-button><md-button layout=\"column\" flex ng-disabled=\"vm.anotherPlace\" ng-click=\"vm.openChecksDialog()\" \nclass=\"post-button md-accent md-raised pt-8\" aria-label=\"POST\"><img src=\"assets/images/etc/check.png\"> שיק</md-button>\n<md-button layout=\"column\" flex ng-disabled=\"vm.anotherPlace\" ng-click=\"vm.openCreditCardDialog()\" \nclass=\"post-button md-accent md-raised pt-8\" aria-label=\"POST\"><img src=\"assets/images/etc/visa.png\"> אשראי</md-button>\n</div></div><header class=\"md-accent-bga\" layout=\"row\" layout-align=\"end center\"><div class=\"title dir-rtl\" flex>\nפירוט תשלומים</div></header><div class=\"content dir-rtl\"><div layout=\"row\" flex><div flex=\"50\">ס\"ה מזומן</div><div \nflex=\"50\">{{(vm.payments.sumCashPrice ||0)| customCurrency}}</div></div><div layout=\"row\" flex><div flex=\"50\">ס\"ה שיקים\n</div><div flex=\"50\">{{(vm.payments.sumChekPrice ||0)| customCurrency}}</div></div><div layout=\"row\" flex><div \nflex=\"50\">ס\"ה אשראי</div><div flex=\"50\">{{(vm.payments.sumCreditCardPrice||0) | customCurrency}}</div></div></div>\n<footer layout=\"row\" class=\"dir-rtl\" layout-align=\"space-between center\"><div layout=\"row\" class=\"md-title\" flex><div \nflex=\"50\" ng-show=\"vm.refund\">סך לזיכוי</div><div flex=\"50\" ng-hide=\"vm.refund\">סך נתקבל</div><div flex=\"50\">\n{{vm.payments.sumAllRecepts||0 | customCurrency}}</div></div></footer><footer layout=\"row\" class=\"dir-rtl\" \nlayout-align=\"space-between center\"><div layout=\"row\" class=\"md-title\" flex><div flex=\"50\">יתרת חוב</div><div \nflex=\"50\">{{(vm.profile.sumAll.topay-vm.profile.Receipts.sumAllRecepts-vm.payments.sumAllRecepts)|customCurrency}}\n</div></div></footer><footer class=\"dir-rtl\" layout=\"row\"><md-button flex ng-click=\"vm.createInvoice()\" \nng-disabled=\"vm.proccess||!vm.payments.sumAllRecepts||vm.anotherPlace\" class=\"post-button md-accent md-raised\" \naria-label=\"POST\">{{(vm.proccess?\'אנא המתן...\':\'אישור והפקת חשבונית\')}}</md-button></footer></div></div></div>");
$templateCache.put("app/main/profile/tabs/details/details.html","<div layout=\"column\" layout-gt-md=\"row\" flex layout-wrap><div class=\"timeline\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"55\" flex-gt-md=\"65\" flex-order=\"2\" flex-order-gt-sm=\"1\"><div ng-hide=\"vm.editCopyMode\" \nclass=\"profile-box latest-activity md-whiteframe-1dp\" layout=\"column\"><form novalidate name=\"clientForm\"><header \nclass=\"md-accent-bg\" layout=\"row\" layout-align=\"end center\"><div class=\"title\">פרטי פציינט</div><md-button \nclass=\"md-icon-button\" aria-label=\"add location\" ng-click=\"vm.editProfileClick(event)\"><md-icon \nmd-font-icon=\"icon-table-edit\"></md-icon><md-tooltip><span>ערוך</span></md-tooltip></md-button></header><div \nclass=\"form content dir-rtl\" flex><div layout=\"column\" class=\"m-8\" layout-gt-xs=\"row\" flex><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"tz\" ng-disabled=\"!vm.editprofile\" ng-model=\"vm.profile.TZ\" \nng-pattern=\"/^[0-9]*$/\" ng-minlength=\"6\" ng-maxlength=\"9\" placeholder=\"מס זהות\"><div ng-messages=\"tz.$error\" \nng-show=\"tz.$touched\" role=\"alert\"><div ng-message=\"minlength\">מספר זהות חייב להכיל בין 6 ל 9 תוים</div><div \nng-message=\"maxlength\">מספר זהות חייב להכיל בין 6 ל 9 תוים</div></div></md-input-container><md-input-container><input \ntype=\"date\" name=\"birthdate\" ng-disabled=\"!vm.editprofile\" ng-model=\"vm.profile.ClientBirthDate\" \nplaceholder=\"תאריך לידה\"><div ng-messages=\"clientForm.birthdate.$error\" ng-show=\"clientForm.birthdate.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>שדה חובה</span></div></div></md-input-container></div><div \nlayout=\"column\" class=\"m-8\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nname=\"firstname\" ng-disabled=\"!vm.editprofile\" ng-model=\"vm.profile.ClientName\" placeholder=\"שם פציינט\" required><div \nng-messages=\"clientForm.firstname.$error\" ng-show=\"clientForm.firstname.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>שדה חובה</span></div></div></md-input-container><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"text\" name=\"firstname\" ng-model=\"vm.profile.placeName\" placeholder=\"סניף\" \nng-disabled=\"true\" required></md-input-container></div><div layout=\"column\" class=\"m-8\" layout-gt-xs=\"row\" flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"firstname\" ng-disabled=\"!vm.editprofile\" \nng-model=\"vm.profile.Tel\" placeholder=\"טלפון\" required></md-input-container></div><div layout=\"column\" class=\"m-8\" \nlayout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"ClientNote\" \nng-maxlength=\"250\" ng-disabled=\"!vm.editprofile\" ng-model=\"vm.profile.ClientNote\" placeholder=\"הערות\"><div \nng-messages=\"clientForm.ClientNote.$error\" role=\"alert\"><div ng-message=\"maxlength\">מקסימום 250 תוים</div></div>\n</md-input-container><label>משלוח</label><md-checkbox ng-disabled=\"!vm.editprofile\" ng-model=\"vm.profile.MishloahSW\">\n</md-checkbox></div><md-button layout=\"row\" layout-align=\"center center\" class=\"md-accent\" ng-show=\"vm.editprofile\" \nng-click=\"vm.moredetails=!vm.moredetails\">הצג/הסתר פרטים נוספים</md-button><div \nng-show=\"vm.editprofile && vm.moredetails\" flex layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex \nclass=\"md-block\"><input type=\"date\" name=\"cardholder\" ng-model=\"vm.profile.HafnayaDate\" placeholder=\"תאריך הפנייה\">\n</md-input-container><md-input-container flex class=\"md-block\"><input type=\"text\" name=\"cardholder\" \nng-model=\"vm.profile.HafnayaNumber\" placeholder=\"מס\' פנייה\"></md-input-container><md-input-container flex \nclass=\"md-block\"><input type=\"text\" name=\"cardholder\" ng-model=\"vm.profile.MithareName\" placeholder=\"מתחרה\">\n</md-input-container></div></div><footer layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" aria-label=\"insert photo\" translate \nng-click=\"vm.printDetails(event)\" translate-attr-aria-label=\"PROFILE.INSERT_PHOTO\"><md-icon \nmd-font-icon=\"icon-printer\"></md-icon><md-tooltip><span>הדפס</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"add person\" translate ng-click=\"vm.editProfileClick(event)\" \ntranslate-attr-aria-label=\"PROFILE.ADD_PERSON\"><md-icon md-font-icon=\"icon-tooltip-edit\"></md-icon><md-tooltip><span>\nעריכת פרטים</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"add location\" translate \nng-click=\"vm.SippingDetails(event)\" translate-attr-aria-label=\"PROFILE.LOCATION\"><md-icon \nmd-font-icon=\"icon-wallet-travel\"></md-icon><md-tooltip><span>פרטי משלוח</span></md-tooltip></md-button></div>\n<md-button ng-click=\"vm.updateClientDetails()\" class=\"post-button md-accent md-raised\" aria-label=\"POST\" \nng-disabled=\"clientForm.$invalid || clientForm.$pristine ||!vm.editprofile\">שמור</md-button></footer></form></div><form\n ng-show=\"vm.editCopyMode\" name=\"formChecks\" flex layout=\"row\" novalidate><div \nclass=\"profile-box latest-activity md-whiteframe-1dp\" flex=\"\" layout=\"column\"><header class=\"md-accent-bg\" \nlayout=\"row\" layout-align=\"end center\"><div class=\"title\">עריכת פרטי צילום</div></header><div \nclass=\"content p-0 dir-rtl\" layout=\"row\" layout-wrap><ms-prices-doctors client=\"vm.profile\" \ncopies=\"vm.profile.PhotosArr\" bituah-id=\"vm.profile.BituahID\" doctor=\"vm.profile.Doctor\" \ncount-copies=\"vm.profile.countCopies\"></ms-prices-doctors></div><footer class=\"dir-rtl m-8\" \nlayout-align=\"space-between center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"!vm.profile.PhotosArr.length\" \nng-click=\"vm.UpdateCopiesAndDoctor()\">שמור</md-button><md-button class=\"md-raised\" ng-click=\"vm.closeCopyMode()\">ביטול\n</md-button></footer></div></form><md-divider></md-divider></div><div class=\"timeline-sidebar\" layout=\"column\" \nflex=\"100\" flex-gt-sm=\"45\" flex-gt-md=\"35\" flex-order=\"1\" flex-order-gt-sm=\"2\"><div \nclass=\"profile-box latest-activity md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"end center\"><div class=\"title\">הערות לפציינט</div></header><div class=\"content dir-rtl\" layout=\"row\" \nlayout-wrap><div class=\"activities\"><div class=\"activity\" layout=\"row\" layout-align=\"start start\"><div layout=\"column\">\n<div class=\"md-accent-color\"><b>{{vm.profile.Doctor.Name||vm.profile.doctorName}}</b></div><div \nclass=\"username md-accent-color\">{{vm.profile.NoteOUT}}</div><md-divider ng-show=\"vm.profile.ClientNote\"></md-divider>\n<div class=\"username md-accent-color\">{{vm.profile.ClientNote}}</div></div></div></div></div><footer \nng-if=\"vm.profile.BituahID>2\"><div layout=\"row\" layout-align=\"end center\"><span>מבוטח ע\"י {{vm.profile.bituachName}}\n</span></div></footer><footer ng-if=\"vm.profile.BituahID>2\" layout=\"row\" class=\"dir-rtl\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end center\"><b>סטטוס ביטוח:</b>&nbsp; <span \nng-if=\"vm.profile.ZulamStatus==5 &&vm.profile.unUploadPhoto\">ממתין להעלאת כל הצילומים למערכת</span> <span \nng-if=\"vm.profile.InsuranseStatus\" ng-class=\"{\'red-fg\':vm.profile.InsuranseStatus.statusCode!=200}\">\n{{vm.profile.InsuranseStatus.msg}}</span></div><div ng-if=\"vm.profile.InsuranseStatus\" layout=\"row\" \nlayout-align=\"end center\"><md-button ng-disabled=\"vm.proccess\" class=\"md-accent md-raised\" \nng-click=\"vm.sendToInsuranse(event)\">{{vm.proccess?\"שולח. אנא המתן...\":\"שלח כעת\"}}</md-button></div></footer></div><div\n class=\"profile-box groups md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"end center\"><div class=\"title\">צילומי פציינט</div></header><div class=\"content\"><div class=\"group\" \nng-repeat=\"photo in vm.profile.PhotosArr\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" flex \nlayout-align=\"start center\"><img flex=\"70\" ng-src=\"/assets/images/copies/1.png\" class=\"logo photo-img\" \nalt=\"{{photo.Name}}\"><md-button ng-if=\"photo.InsuranceID>2\" class=\"md-icon-button\" aria-label=\"add location\" \nng-click=\"vm.addReferrence($event,photo)\"><md-icon md-font-icon=\"icon-tooltip-edit\" \nng-class=\"{\'red-fg\':!photo.reference}\"></md-icon><md-tooltip><span>עדכן אסמכתא</span></md-tooltip></md-button>\n<md-button ng-if=\"photo.InsuranceID==14\" class=\"md-icon-button\" aria-label=\"add location\"><md-icon \nmd-font-icon=\"icon-barcode\" ng-class=\"{\'red-fg\':!photo.orderNumber}\"></md-icon><md-tooltip><span>\n{{photo.orderNumber||\"חסר הזמנת רכש\"}}</span></md-tooltip></md-button><div flex class=\"m-10 dir-rtl\"><div class=\"name\">\n{{photo.Name}}</div><div class=\"category\">{{(photo.InsuranceID>2?\'ביטוח\':\'\')}} <span \nng-if=\"photo.InsuranceID>2&&photo.Deductible\">{{photo.Deductible|customCurrency}} ה\"ע</span> <span \nng-if=\"photo.InsuranceID>2&&!photo.Deductible\">לא לתשלום</span> <span ng-if=\"photo.InsuranceID<2\">\n{{(photo.Deductible||photo.fixprice||0)|customCurrency}}</span></div></div></div></div></div><footer layout=\"row\" \nclass=\"dir-rtl\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end center\"><span>\nמצלמ/ת: {{vm.profile.ovedName||\'לא נבחר מצלם/ת\'}}</span></div><md-button class=\"md-icon-button\" \naria-label=\"add location\" ng-click=\"vm.openDialogEmployee($event)\"><md-icon md-font-icon=\"icon-table-edit\"></md-icon>\n<md-tooltip><span>ערוך</span></md-tooltip></md-button></footer><footer layout=\"row\" class=\"dir-rtl\" \nlayout-align=\"space-between center\" ng-if=\"vm.isCurrentDay||vm.adminstatus\"><div layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-click=\"vm.editCopies(event)\">ערוך צילומים\n</md-button></div></footer></div></div></div>");
$templateCache.put("app/main/profile/tabs/photos/photos.html","<div layout=\"row\" flex layout-wrap><ms-widget ng-repeat=\"doc in vm.profile.Documents\" \nng-click=\"vm.OpenDocument(event,doc)\" class=\"h-300\" layout=\"column\" flex flex-gt-xs=\"50\" flex-gt-md=\"25\">\n<ms-widget-front class=\"p-16 blue-grey-bg white-fg\" layout=\"row\" flex><div class=\"ph-8 pv-16 h-55 pos-abs\" \nlayout=\"row\" layout-align=\"space-between center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.deleteDocument(doc);$event.stopPropagation();\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip>\nמחק מסמך</md-tooltip></md-button></div><div layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"md-display-1 pb-8\">{{doc.name}}</div><div class=\"h3 font-weight-500\">{{doc.date|date}}</div></div><div \nclass=\"background-image-center\"><md-icon ng-show=\"doc.PhotoID\" md-font-icon=\"icon-filmstrip\" class=\"s256 faint-text\">\n</md-icon><md-icon ng-hide=\"doc.PhotoID\" md-font-icon=\"icon-file-document\" class=\"s256 faint-text\"></md-icon></div>\n</ms-widget-front></ms-widget><ms-widget ng-show=\"vm.profile.Documents.length\" ng-click=\"vm.OpenUploadDialog()\" \nclass=\"h-300\" layout=\"column\" flex flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 grey-bg white-fg\" \nlayout=\"row\" flex><div layout=\"column\" layout-align=\"center center\" flex><div class=\"md-display-1 pb-8\">הוסף</div><div \nclass=\"h3 font-weight-500\">לחץ להוספת צילום/מסמך חדש</div></div><div class=\"background-image-center\"><md-icon \nmd-font-icon=\"icon-cloud-upload\" class=\"s256 faint-text\"></md-icon></div></ms-widget-front></ms-widget><ms-widget \nng-show=\"vm.profile.Documents.length\" ng-click=\"vm.sendDocsToEmail()\" class=\"h-300\" layout=\"column\" flex \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 red-bg white-fg\" layout=\"row\" flex><div layout=\"column\" \nlayout-align=\"center center\" flex><div class=\"md-display-1 pb-8\">שלח</div><div class=\"h3 font-weight-500\">\nשלח צילומים לרופא</div></div><div class=\"background-image-center\"><md-icon md-font-icon=\"icon-email\" \nclass=\"s256 faint-text\"></md-icon></div></ms-widget-front></ms-widget><ms-widget ng-hide=\"vm.profile.Documents.length\" \nclass=\"h-300\" layout=\"column\" flex><ms-widget-front class=\"p-16 grey-bg white-fg\" layout=\"row\" flex><div \nlayout=\"column\" layout-align=\"center center\" flex><div class=\"md-display-3 pb-8\">אין צילומים/מסמכים</div><div \nng-show=\"vm.profile.unUploadPhoto\" class=\"md-display-1 pb-8\"><md-icon \nmd-font-icon=\"icon-numeric-{{vm.profile.unUploadPhoto}}-box-outline\"></md-icon>צילומים ממתינים להעלאה</div><div \nclass=\"h3ס font-weight-500\"><md-button class=\"md-accent md-raised\" ng-click=\"vm.OpenUploadDialog()\">הוסף +</md-button>\n</div></div><div class=\"background-image-center\"><md-icon md-font-icon=\"icon-filmstrip-off\" class=\"s256 faint-text\">\n</md-icon></div></ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/profile/tabs/photos-videos/photos-videos.html","<div class=\"photos-videos\"><img src=\"/assets/demo/card.png\"> <img src=\"/assets/demo/2.png\"> <img \nsrc=\"/assets/demo/3.png\"> <img src=\"/assets/demo/4.png\"> <img src=\"/assets/demo/5.png\"><div class=\"period\" \ndata-ng-repeat=\"period in vm.photosVideos\"><div class=\"period-title\"><span class=\"name\">{{period.name}}</span> <span \nclass=\"info\">{{period.info}}</span></div><div class=\"period-media\" layout=\"row\" layout-wrap><div class=\"media\" \nng-repeat=\"media in period.media\"><img class=\"preview\" ng-src=\"{{media.preview}}\" title=\"{{media.title}}\"><div \nclass=\"title\">{{media.title}}</div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/or-insurance/dialog/copy/copy-dialog.html","<md-dialog id=\"NewInsuDialog\" class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-primary md-tall tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nהוספת צילום ביטוח</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name font-size-15\">ביטוח - {{vm.copy.InsuranceID}}\n</div></div></div></md-toolbar><md-dialog-content ms-scroll class=\"ng-form\" name=\"dialogForm\"><md-input-container \nclass=\"md-icon-float md-block mb-30\"><label flex=\"50\">שם צילום</label><md-icon md-font-icon=\"icon-account\" \nclass=\"name\"></md-icon><md-select ng-model=\"vm.copy.CopyID\"><md-option class=\"price-md-option\" \nng-repeat=\"c in vm.ListCopys|orderBy :\'Name\'\" ng-value=\"c.PhotoListID\">{{c.Name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-icon-float md-block\"><label flex=\"50\">מק\"ט</label><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><input name=\"sum\" ng-model=\"vm.copy.mkt\" type=\"text\" required \nng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\"><div ng-messages=\"dialogForm.sum.$error\"><div ng-message=\"minlength\">\nהקש לפחות 5 תוים</div></div></md-input-container><md-input-container class=\"md-icon-float md-block\"><label flex=\"50\">\nמחיר</label><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><input name=\"sum\" ng-model=\"vm.copy.sum\" \ntype=\"text\" ng-keyup=\"vm.sumupdate()\" required ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\"><div \nng-messages=\"dialogForm.sum.$error\"><div ng-message=\"minlength\">הקש לפחות 5 תוים</div></div></md-input-container>\n<md-input-container class=\"md-icon-float md-block\"><label flex=\"50\">מחיר כולל מע\"מ</label><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><input name=\"sumInclude\" ng-keyup=\"vm.sumupdate(true)\" \nng-model=\"vm.copy.sumInclude\" type=\"text\" required ng-minlength=\"1\"><div ng-messages=\"dialogForm.sumInclude.$error\">\n<div ng-message=\"required\">חובה</div></div></md-input-container><md-input-container class=\"md-icon-float md-block\">\n<label flex=\"50\">השתתפות עצמית</label><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><input \nname=\"deductible\" ng-model=\"vm.copy.deductible\" required type=\"text\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" \nng-minlength=\"1\" ng-maxlength=\"5\"><div ng-messages=\"dialogForm.deductible.$error\"><div ng-message=\"required\">חובה</div>\n</div></md-input-container><md-input-container class=\"md-icon-float md-block\"><label flex=\"50\">הערות</label><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><input name=\"deductible\" ng-model=\"vm.copy.Comment\" type=\"text\">\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.submit()\" \nclass=\"send-button md-accent md-raised font-size-12 saveBtn\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine\" aria-label=\"SAVE\">הוסף</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\">\n{{step.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div>\n</md-button></div></div><div class=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/pages/invoice/views/compact/compact.html","<div id=\"invoice\" class=\"compact page-layout blank\" layout=\"row\" ms-scroll><div class=\"invoice-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\"><div class=\"invoice-date\">{{vm.invoice.date}}</div><div \nlayout=\"row\" layout-align=\"space-between stretch\"><div class=\"client\"><div class=\"invoice-number\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"title\" translate=\"INVOICE.INVOICE\">INVOICE</span> <span class=\"number\">\n{{vm.invoice.number}}</span></div><div class=\"due-date\" layout=\"row\" layout-align=\"start center\"><span class=\"title\" \ntranslate=\"INVOICE.DUE_DATE\">DUE DATE</span> <span class=\"date\">{{vm.invoice.dueDate}}</span></div><div class=\"info\">\n<div class=\"title\">{{vm.invoice.client.title}}</div><div ng-if=\"vm.invoice.client.address\" class=\"address\">\n{{vm.invoice.client.address}}</div><div ng-if=\"vm.invoice.client.phone\" class=\"phone\">{{vm.invoice.client.phone}}</div>\n<div ng-if=\"vm.invoice.client.email\" class=\"email\">{{vm.invoice.client.email}}</div><div \nng-if=\"vm.invoice.client.website\" class=\"website\">{{vm.invoice.client.website}}</div></div></div><div \nclass=\"issuer md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"center center\"><span>F</span></div><div class=\"info\"><div class=\"title\">{{vm.invoice.from.title}}</div>\n<div ng-if=\"vm.invoice.from.address\" class=\"address\">{{vm.invoice.from.address}}</div><div \nng-if=\"vm.invoice.from.phone\" class=\"phone\">{{vm.invoice.from.phone}}</div><div ng-if=\"vm.invoice.from.email\" \nclass=\"email\">{{vm.invoice.from.email}}</div><div ng-if=\"vm.invoice.from.website\" class=\"website\">\n{{vm.invoice.from.website}}</div></div></div></div></div><div class=\"content\"><table class=\"simple invoice-table\">\n<thead><th translate=\"INVOICE.SERVICE\">SERVICE</th><th translate=\"INVOICE.UNIT\">UNIT</th><th class=\"text-right\" \ntranslate=\"INVOICE.UNIT_PRICE\">UNIT PRICE</th><th class=\"text-right\" translate=\"INVOICE.QUANTITY\">QUANTITY</th><th \nclass=\"text-right\" translate=\"INVOICE.TOTAL\">TOTAL</th></thead><tbody><tr ng-repeat=\"service in vm.invoice.services\">\n<td><div class=\"title\">{{service.title}}</div></td><td>{{service.unit}}</td><td class=\"text-right\">\n{{service.unitPrice | currency}}</td><td class=\"text-right\">{{service.quantity}}</td><td class=\"text-right\">\n{{service.total | currency}}</td></tr><tr ng-repeat=\"service in vm.invoice.services\"><td><div class=\"title\">\n{{service.title}}</div></td><td>{{service.unit}}</td><td class=\"text-right\">{{service.unitPrice | currency}}</td><td \nclass=\"text-right\">{{service.quantity}}</td><td class=\"text-right\">{{service.total | currency}}</td></tr></tbody>\n</table><table class=\"simple invoice-table-footer\"><tbody><tr class=\"subtotal\"><td translate=\"INVOICE.SUBTOTAL\">\nSUBTOTAL</td><td>{{vm.invoice.subtotal | currency}}</td></tr><tr class=\"tax\"><td translate=\"INVOICE.TAX\">TAX</td><td>\n{{vm.invoice.tax | currency}}</td></tr><tr class=\"discount\"><td translate=\"INVOICE.DISCOUNT\">DISCOUNT</td><td>\n-{{vm.invoice.discount | currency}}</td></tr><tr class=\"total\"><td translate=\"INVOICE.TOTAL\">TOTAL</td><td>\n{{vm.invoice.total | currency}}</td></tr></tbody></table></div><div class=\"footer\"><div class=\"note\" \ntranslate=\"INVOICE.NOTE\">Please pay within 15 days. Thank you for your business.</div><div layout=\"row\" \nlayout-align=\"start start\"><div class=\"logo md-accent-bg\" layout=\"row\" layout-align=\"center center\"><div>F</div></div>\n<div class=\"small-note\" translate=\"INVOICE.SMALL_NOTE\">\nIn condimentum malesuada efficitur. Mauris volutpat placerat auctor. Ut ac congue dolor. Quisque scelerisque lacus sed feugiat fermentum. Cras aliquet facilisis pellentesque. Nunc hendrerit quam at leo commodo, a suscipit tellus dapibus. Etiam at felis volutpat est mollis lacinia. Mauris placerat sem sit amet velit mollis, in porttitor ex finibus. Proin eu nibh id libero tincidunt lacinia et eget eros.\n</div></div></div></div><div class=\"page-break\"></div></div></div>");
$templateCache.put("app/main/pages/invoice/views/modern/modern.html","<div id=\"invoice\" class=\"modern page-layout blank\" layout=\"row\" ms-scroll><div class=\"invoice-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div class=\"ids\" \nlayout=\"column\"><div layout=\"row\" class=\"seller\" layout-align=\"start center\"><div class=\"logo md-accent-bg\" \nlayout=\"row\" layout-align=\"center center\"><div>F</div></div><div class=\"divider\"></div><div class=\"detail\"><div \nclass=\"title\">{{vm.invoice.from.title}}</div><div ng-if=\"vm.invoice.from.address\" class=\"address\">\n{{vm.invoice.from.address}}</div><div ng-if=\"vm.invoice.from.phone\" class=\"phone\"><span translate=\"INVOICE.PHONE\">Phone\n</span>: {{vm.invoice.from.phone}}</div><div ng-if=\"vm.invoice.from.email\" class=\"email\"><span \ntranslate=\"INVOICE.EMAIL\">Email</span>: {{vm.invoice.from.email}}</div><div ng-if=\"vm.invoice.from.website\" \nclass=\"website\"><span translate=\"INVOICE.WEB\">Web</span>: {{vm.invoice.from.website}}</div></div></div><div \nlayout=\"row\" class=\"client\" layout-align=\"start center\"><div class=\"label\" layout=\"row\" layout-align=\"end center\"><div \ntranslate=\"INVOICE.CLIENT\">CLIENT</div></div><div class=\"divider\"></div><div class=\"detail\"><div class=\"title\">\n{{vm.invoice.client.title}}</div><div ng-if=\"vm.invoice.client.address\" class=\"address\">{{vm.invoice.client.address}}\n</div><div ng-if=\"vm.invoice.client.phone\" class=\"phone\"><span translate=\"INVOICE.PHONE\">Phone</span>\n: {{vm.invoice.client.phone}}</div><div ng-if=\"vm.invoice.client.email\" class=\"email\"><span translate=\"INVOICE.EMAIL\">\nEmail</span>: {{vm.invoice.client.email}}</div><div ng-if=\"vm.invoice.client.website\" class=\"website\"><span \ntranslate=\"INVOICE.WEB\">Web</span>: {{vm.invoice.client.website}}</div></div></div></div><table class=\"summary\"><tr \nclass=\"code\"><td class=\"label\" translate=\"INVOICE.INVOICE\">INVOICE</td><td class=\"value\">{{vm.invoice.number}}</td>\n</tr><tr><td class=\"label\" translate=\"INVOICE.INVOICE_DATE\">INVOICE DATE</td><td class=\"value\">{{vm.invoice.date}}</td>\n</tr><tr><td class=\"label\" translate=\"INVOICE.DUE_DATE\">DUE DATE</td><td class=\"value\">{{vm.invoice.dueDate}}</td></tr>\n<tr><td class=\"label\" translate=\"INVOICE.TOTAL_DUE\">TOTAL DUE</td><td class=\"value\">{{vm.invoice.total | currency}}\n</td></tr></table></div><div class=\"content\"><table class=\"simple invoice-table\"><thead><th \ntranslate=\"INVOICE.SERVICE\">SERVICE</th><th translate=\"INVOICE.UNIT\">UNIT</th><th class=\"text-right\" \ntranslate=\"INVOICE.UNIT_PRICE\">UNIT PRICE</th><th class=\"text-right\" translate=\"INVOICE.QUANTITY\">QUANTITY</th><th \nclass=\"text-right\" translate=\"INVOICE.TOTAL\">TOTAL</th></thead><tbody><tr ng-repeat=\"service in vm.invoice.services\">\n<td><div class=\"title\">{{service.title}}</div><div class=\"detail\">{{service.detail}}</div></td><td>{{service.unit}}\n</td><td class=\"text-right\">{{service.unitPrice | currency}}</td><td class=\"text-right\">{{service.quantity}}</td><td \nclass=\"text-right\">{{service.total | currency}}</td></tr></tbody></table><table class=\"simple invoice-table-footer\">\n<tbody><tr class=\"subtotal\"><td translate=\"INVOICE.SUBTOTAL\">SUBTOTAL</td><td>{{vm.invoice.subtotal | currency}}</td>\n</tr><tr class=\"tax\"><td translate=\"INVOICE.TAX\">TAX</td><td>{{vm.invoice.tax | currency}}</td></tr><tr \nclass=\"discount\"><td translate=\"INVOICE.DISCOUNT\">DISCOUNT</td><td>-{{vm.invoice.discount | currency}}</td></tr><tr \nclass=\"total\"><td translate=\"INVOICE.TOTAL\">TOTAL</td><td>{{vm.invoice.total | currency}}</td></tr></tbody></table>\n</div><div class=\"footer\"><div class=\"note\" translate=\"INVOICE.NOTE\">\nPlease pay within 15 days. Thank you for your business.</div><div layout=\"row\" layout-align=\"start start\"><div \nclass=\"logo md-accent-bg\" layout=\"row\" layout-align=\"center center\"><div>F</div></div><div class=\"small-note\" \ntranslate=\"INVOICE.SMALL_NOTE\">\nIn condimentum malesuada efficitur. Mauris volutpat placerat auctor. Ut ac congue dolor. Quisque scelerisque lacus sed feugiat fermentum. Cras aliquet facilisis pellentesque. Nunc hendrerit quam at leo commodo, a suscipit tellus dapibus. Etiam at felis volutpat est mollis lacinia. Mauris placerat sem sit amet velit mollis, in porttitor ex finibus. Proin eu nibh id libero tincidunt lacinia et eget eros.\n</div></div></div></div><div class=\"page-break\"></div></div></div>");
$templateCache.put("app/main/pages/search/tabs/classic/classic.html","<div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" \nlayout-align-xs=\"start start\"><span class=\"result-count h3 secondary-text\"><span>54</span> <span \ntranslate=\"SEARCH.RESULTS\">Results</span></span><div class=\"pager\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"secondary-text\"><span translate=\"SEARCH.RESULTS\">Results</span> <span>:</span> </span><span class=\"page-info\">\n<span>1</span> <span>-</span> <span>10</span> <span translate=\"SEARCH.OF\">of</span> <span>100</span></span><md-button \nclass=\"md-icon-button\" aria-label=\"previous page\" translate translate-attr-aria-label=\"SEARCH.PREVIOUS_PAGE\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" \ntranslate translate-attr-aria-label=\"SEARCH.NEXT_PAGE\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon>\n</md-button></div></div><div class=\"results\"><div class=\"result-item\" ng-repeat=\"item in vm.classic\"><div \nclass=\"title\">{{item.title}}</div><div class=\"url\">{{item.url}}</div><div class=\"excerpt\">{{item.excerpt}}</div></div>\n</div><div class=\"simple-pagination\"><md-button class=\"pagination-item disabled\" md-no-ink ng-href=\"#\" \naria-label=\"Go to previous page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"pagination-item active\" md-no-ink ng-href=\"#\" \naria-label=\"Go to page 1\"><span>1</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 2\" hide-xs><span>2</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 3\" hide-xs><span>3</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 4\" hide-xs><span>4</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 5\" hide-xs><span>5</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 6\" hide-xs><span>6</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 7\" hide-xs><span>7</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 8\" hide-xs><span>8</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 9\" hide-xs><span>9</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 10\" hide-xs><span>10</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to next page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/search/tabs/contacts/contacts.html","<div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" \nlayout-align-xs=\"start start\"><div><span class=\"md-title\" translate=\"SEARCH.CONTACTS\">Contacts</span> <span \nclass=\"secondary-text\"><span>13</span> <span translate=\"SEARCH.RESULTS\">Results</span></span></div><div class=\"pager\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"secondary-text\"><span translate=\"SEARCH.RESULTS\">Results</span> \n<span>:</span> </span><span class=\"page-info\"><span>1</span> <span>-</span> <span>10</span> <span \ntranslate=\"SEARCH.OF\">of</span> <span>100</span></span><md-button class=\"md-icon-button\" aria-label=\"previous page\" \ntranslate translate-attr-aria-label=\"SEARCH.PREVIOUS_PAGE\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" translate \ntranslate-attr-aria-label=\"SEARCH.NEXT_PAGE\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>\n</div><table class=\"results simple clickable\" ms-responsive-table><thead><tr><th></th><th translate=\"SEARCH.NAME\">Name\n</th><th translate=\"SEARCH.POSITION\">Position</th><th translate=\"SEARCH.PHONE\">Phone</th><th translate=\"SEARCH.EMAIL\">\nEmail</th></tr></thead><tbody><tr class=\"result-item\" ng-repeat=\"contact in vm.contacts\"><td \nclass=\"text-left avatar-cell\" ng-if=\"contact.avatar\"><img class=\"avatar\" alt=\"{{contact.name}}\" \nng-src=\"{{contact.avatar}}\"></td><td class=\"text-left avatar-cell\" ng-if=\"!contact.avatar\"><div class=\"avatar\" \nms-random-class=\"vm.colors\">{{contact.name[0]}}</div></td><td class=\"name\">{{contact.name}}</td><td class=\"position\">\n{{contact.position}}</td><td class=\"phone\">{{contact.phone}}</td><td class=\"email\">{{contact.email}}</td></tr></tbody>\n</table><div class=\"simple-pagination\"><md-button class=\"pagination-item disabled\" md-no-ink ng-href=\"#\" \naria-label=\"Go to previous page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"pagination-item active\" md-no-ink ng-href=\"#\" \naria-label=\"Go to page 1\"><span>1</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 2\" hide-xs><span>2</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 3\" hide-xs><span>3</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 4\" hide-xs><span>4</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 5\" hide-xs><span>5</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 6\" hide-xs><span>6</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 7\" hide-xs><span>7</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 8\" hide-xs><span>8</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 9\" hide-xs><span>9</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 10\" hide-xs><span>10</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to next page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/search/tabs/emails/emails.html","<div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" \nlayout-align-xs=\"start start\"><div><span class=\"md-title\" translate=\"SEARCH.EMAILS\">E-Mails</span> <span \nclass=\"secondary-text\"><span>87</span> <span translate=\"SEARCH.RESULTS\">Results</span></span></div><div class=\"pager\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"secondary-text\"><span translate=\"SEARCH.RESULTS\">Results</span> \n<span>:</span> </span><span class=\"page-info\"><span>1</span> <span>-</span> <span>10</span> <span \ntranslate=\"SEARCH.OF\">of</span> <span>100</span></span><md-button class=\"md-icon-button\" aria-label=\"previous page\" \ntranslate translate-attr-aria-label=\"SEARCH.PREVIOUS_PAGE\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" translate \ntranslate-attr-aria-label=\"SEARCH.NEXT_PAGE\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>\n</div><div class=\"results\"><div class=\"result-item {{mail.status}}\" ng-repeat=\"mail in vm.mails | filter: vm.search\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start center\"><img class=\"avatar\" ng-if=\"mail.from.avatar\" \nalt=\"{{mail.from.name}}\" ng-src=\"{{mail.from.avatar}}\"><div class=\"avatar\" ng-if=\"!mail.from.avatar\" \nms-random-class=\"vm.colors\">{{mail.from.name[0]}}</div><div class=\"info\" flex layout=\"column\"><div \nclass=\"name text-truncate\">{{mail.from.name}}</div><div class=\"subject secondary-text text-truncate\">{{mail.subject}}\n</div><div class=\"message secondary-text text-truncate\">{{mail.message | htmlToPlaintext}}</div></div><div \nlayout=\"column\" layout-align=\"center end\"><div class=\"time secondary-text\">{{mail.time}}</div></div></div></div></div>\n<div class=\"simple-pagination\"><md-button class=\"pagination-item disabled\" md-no-ink ng-href=\"#\" \naria-label=\"Go to previous page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"pagination-item active\" md-no-ink ng-href=\"#\" \naria-label=\"Go to page 1\"><span>1</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 2\" hide-xs><span>2</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 3\" hide-xs><span>3</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 4\" hide-xs><span>4</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 5\" hide-xs><span>5</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 6\" hide-xs><span>6</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 7\" hide-xs><span>7</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 8\" hide-xs><span>8</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 9\" hide-xs><span>9</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 10\" hide-xs><span>10</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to next page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/search/tabs/users/users.html","<div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" \nlayout-align-xs=\"start start\"><div><span class=\"md-title\" translate=\"SEARCH.USERS\">Users</span> <span \nclass=\"secondary-text\"><span>87</span> <span translate=\"SEARCH.RESULTS\">Results</span></span></div><div class=\"pager\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"secondary-text\"><span translate=\"SEARCH.RESULTS\">Results</span> \n<span>:</span> </span><span class=\"page-info\"><span>1</span> <span>-</span> <span>10</span> <span \ntranslate=\"SEARCH.OF\">of</span> <span>100</span></span><md-button class=\"md-icon-button\" aria-label=\"previous page\" \ntranslate translate-attr-aria-label=\"SEARCH.PREVIOUS_PAGE\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" translate \ntranslate-attr-aria-label=\"SEARCH.NEXT_PAGE\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>\n</div><table class=\"results simple clickable\" ms-responsive-table><thead><tr><th translate=\"SEARCH.NAME\">Name</th><th \ntranslate=\"SEARCH.POSITION\">Position</th><th translate=\"SEARCH.OFFICE\">Office</th><th class=\"text-right\" \ntranslate=\"SEARCH.AGE\">Age</th><th class=\"text-right\" translate=\"SEARCH.START_DATE\">Start Date</th><th \nclass=\"text-right\" translate=\"SEARCH.SALARY\">Salary</th><th class=\"text-left\" translate=\"SEARCH.EMAIL\">Email</th></tr>\n</thead><tbody><tr class=\"result-item user\" ng-repeat=\"user in vm.users\"><td class=\"name\">{{user.name}}</td><td \nclass=\"position\">{{user.position}}</td><td class=\"office\">{{user.office}}</td><td class=\"age text-right\">{{user.age}}\n</td><td class=\"start-date text-right\">{{user.startDate}}</td><td class=\"salary text-right\">{{user.salary | currency}}\n</td><td class=\"email text-left\">{{user.email}}</td></tr></tbody></table><div class=\"simple-pagination\"><md-button \nclass=\"pagination-item disabled\" md-no-ink ng-href=\"#\" aria-label=\"Go to previous page\" translate \ntranslate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button>\n<md-button class=\"pagination-item active\" md-no-ink ng-href=\"#\" aria-label=\"Go to page 1\"><span>1</span></md-button>\n<md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 2\" hide-xs><span>2</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 3\" hide-xs><span>3</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 4\" hide-xs><span>4</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 5\" hide-xs><span>5</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 6\" hide-xs><span>6</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 7\" hide-xs><span>7</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 8\" hide-xs><span>8</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 9\" hide-xs><span>9</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 10\" hide-xs><span>10</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to next page\" translate \ntranslate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" layout=\"row\" layout-align=\"start center\"><div class=\"step\" \nlayout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">\nOptional</div></div></md-button><div class=\"ms-stepper-step-content\" ng-transclude></div><div \nclass=\"ms-stepper-controls\" layout=\"row\" layout-align=\"start center\" \nng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button class=\"md-accent md-raised\" \nng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");}]);